webpackJsonp([0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// The browser platform with a compiler
	// Application is using dynamic bootstrapping wit JIT (Just-In-Time) compiler
	var platform_browser_dynamic_1 = __webpack_require__(1);
	// The app module
	var AppModule_1 = __webpack_require__(23);
	// Combine and launch the module
	platform_browser_dynamic_1.platformBrowserDynamic().bootstrapModule(AppModule_1.AppModule);


/***/ }),

/***/ 23:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var platform_browser_1 = __webpack_require__(21);
	var core_2 = __webpack_require__(24);
	var user_1 = __webpack_require__(211);
	var AppComponent_1 = __webpack_require__(412);
	var AppRouting_1 = __webpack_require__(428);
	// Modules
	var BusAttendanceModule_1 = __webpack_require__(429);
	var ChildrenListModule_1 = __webpack_require__(753);
	// Service
	var BusServices_1 = __webpack_require__(431);
	var ChildrenServices_1 = __webpack_require__(696);
	var LocationServices_1 = __webpack_require__(702);
	var AppModule = (function () {
	    function AppModule() {
	    }
	    return AppModule;
	}());
	AppModule = __decorate([
	    core_1.NgModule({
	        imports: [
	            platform_browser_1.BrowserModule,
	            core_2.CoreModule,
	            user_1.UserModule,
	            BusAttendanceModule_1.BusAttendanceModule,
	            ChildrenListModule_1.ChildrenListModule,
	            AppRouting_1.routing
	        ],
	        declarations: [
	            AppComponent_1.AppComponent,
	        ],
	        providers: [
	            BusServices_1.BusServices,
	            ChildrenServices_1.ChildrenServices,
	            LocationServices_1.LocationServices
	        ],
	        bootstrap: [
	            AppComponent_1.AppComponent,
	        ]
	    })
	], AppModule);
	exports.AppModule = AppModule;


/***/ }),

/***/ 24:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(25));


/***/ }),

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	// Shared Modules
	var common_1 = __webpack_require__(22);
	var router_1 = __webpack_require__(26);
	// Shared Services
	var services_1 = __webpack_require__(58);
	// Components
	var FooterComponent_1 = __webpack_require__(74);
	var MainMenuComponent_1 = __webpack_require__(80);
	var TopMenuComponent_1 = __webpack_require__(89);
	var MenuHoverDirective_1 = __webpack_require__(92);
	var AdminHeaderComponent_1 = __webpack_require__(93);
	var AdminHeaderAuthComponent_1 = __webpack_require__(99);
	var AdminSidebarComponent_1 = __webpack_require__(102);
	// Services
	var AdminService_1 = __webpack_require__(84);
	var services_2 = __webpack_require__(123);
	var HolidayService_1 = __webpack_require__(83);
	// import { HolidayService } from '../../../holiday/services/HolidayService';
	var core_2 = __webpack_require__(103);
	var ClickOutsideDirective_1 = __webpack_require__(124);
	var primeng_1 = __webpack_require__(138);
	var forms_1 = __webpack_require__(147);
	var CoreModule = (function () {
	    function CoreModule(parentModule) {
	        // Guard to make sure that the CoreModule will be loaded one time only in the AppModule
	        if (parentModule) {
	            throw new Error('CoreModule is already loaded. Import it in the AppModule only.');
	        }
	    }
	    return CoreModule;
	}());
	CoreModule = __decorate([
	    core_1.NgModule({
	        imports: [
	            common_1.CommonModule,
	            router_1.RouterModule,
	            forms_1.FormsModule,
	            core_2.TranslateModule,
	            primeng_1.DialogModule,
	            primeng_1.GrowlModule
	        ],
	        declarations: [
	            FooterComponent_1.FooterComponent,
	            MainMenuComponent_1.MainMenuComponent,
	            TopMenuComponent_1.TopMenuComponent,
	            MenuHoverDirective_1.MenuHoverDirective,
	            ClickOutsideDirective_1.ClickOutsideDirective,
	            AdminHeaderComponent_1.AdminHeaderComponent,
	            AdminHeaderAuthComponent_1.AdminHeaderAuthComponent,
	            AdminSidebarComponent_1.AdminSidebarComponent
	        ],
	        providers: [
	            // Services
	            services_1.SettingService,
	            services_1.ApiService,
	            services_1.LocalStorageService,
	            services_1.SessionStorageService,
	            services_1.FileService,
	            services_1.CatalogService,
	            services_1.StudentService,
	            services_1.MenuService,
	            AdminService_1.AdminService,
	            services_1.LocalNetworkService,
	            services_2.SessionService,
	            HolidayService_1.HolidayService
	        ],
	        exports: [
	            FooterComponent_1.FooterComponent,
	            MainMenuComponent_1.MainMenuComponent,
	            TopMenuComponent_1.TopMenuComponent,
	            MenuHoverDirective_1.MenuHoverDirective,
	            AdminHeaderComponent_1.AdminHeaderComponent,
	            AdminHeaderAuthComponent_1.AdminHeaderAuthComponent,
	            AdminSidebarComponent_1.AdminSidebarComponent
	        ]
	    })
	    /**
	     * The CoreModule which will define the modules, components & directives that will
	     * be called only onetime in the main AppModule when the app loads. Do not import
	     * the CoreModule more than one time.
	     */
	    ,
	    __param(0, core_1.Optional()), __param(0, core_1.SkipSelf()),
	    __metadata("design:paramtypes", [CoreModule])
	], CoreModule);
	exports.CoreModule = CoreModule;


/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(59));
	__export(__webpack_require__(61));
	__export(__webpack_require__(67));
	__export(__webpack_require__(68));
	__export(__webpack_require__(62));
	__export(__webpack_require__(69));
	__export(__webpack_require__(66));
	__export(__webpack_require__(70));
	__export(__webpack_require__(73));


/***/ }),

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var Observable_1 = __webpack_require__(7);
	var http_1 = __webpack_require__(60);
	var ApiService = (function () {
	    function ApiService(http) {
	        this.http = http;
	    }
	    /**
	     * Get Method to get data from Api Endpoint
	     * @param requestUrl - string
	     * @return Observable<Type>
	     */
	    ApiService.prototype.get = function (requestUrl) {
	        var options = new http_1.RequestOptions({ withCredentials: true });
	        return this.http.get(requestUrl, options)
	            .map(this.extractData)
	            .catch(this.handleError);
	    };
	    /**
	     * Get Method to get data from Api Endpoint - Use to export pdf
	     * @param requestUrl - string
	     * @return Observable<Type>
	     */
	    ApiService.prototype.getFile = function (requestUrl) {
	        var options = new http_1.RequestOptions({
	            withCredentials: true,
	        });
	        return this.http.get(requestUrl, options)
	            .map(function (response) {
	            var body = JSON.parse(response['_body']);
	            return body.buffer.data;
	        })
	            .catch(this.handleError);
	    };
	    /**
	 * Get Method to get data from Api Endpoint
	 * @param requestUrl - string
	 * @return Observable<Type>
	 */
	    ApiService.prototype.getToThirdParty = function (requestUrl) {
	        return this.http.get(requestUrl)
	            .map(function (res) { return res.json(); })
	            .catch(this.handleError);
	    };
	    /**
	     * Post Method to post data from Api Endpoint
	     * @param requestUrl - string
	     * @return Observable<Type>
	     */
	    ApiService.prototype.post = function (requestUrl, data) {
	        var headers;
	        if (!(data instanceof FormData)) {
	            headers = new http_1.Headers({ 'Content-Type': 'application/json' });
	        }
	        var options = new http_1.RequestOptions({
	            headers: headers,
	            withCredentials: true
	        });
	        return this.http.post(requestUrl, data, options)
	            .map(this.extractData)
	            .catch(this.handleError);
	    };
	    /**
	     * Put Method to post data to Api Endpoint
	     * @param requestUrl - string
	     * @return Observable<Type>
	     */
	    ApiService.prototype.put = function (requestUrl, data) {
	        var headers;
	        if (!(data instanceof FormData)) {
	            headers = new http_1.Headers({ 'Content-Type': 'application/json' });
	        }
	        var options = new http_1.RequestOptions({
	            headers: headers,
	            withCredentials: true
	        });
	        return this.http.put(requestUrl, data, options)
	            .map(this.extractData)
	            .catch(this.handleError);
	    };
	    /**
	     * Patch Method to update data through Api Endpoint
	     * @param requestUrl: string
	     * @return Observable<Type>
	     */
	    ApiService.prototype.patch = function (requestUrl, data) {
	        var headers;
	        if (!(data instanceof FormData)) {
	            headers = new http_1.Headers({ 'Content-Type': 'application/json' });
	        }
	        var options = new http_1.RequestOptions({
	            method: http_1.RequestMethod.Patch,
	            headers: headers,
	            withCredentials: true
	        });
	        return this.http.patch(requestUrl, data, options)
	            .map(this.extractData)
	            .catch(this.handleError);
	    };
	    /**
	     * Delete Method to remove the data through Api Endpoint
	     * @param requestUrl: string
	     * @return Observable<Type>
	     */
	    ApiService.prototype.delete = function (requestUrl) {
	        var options = new http_1.RequestOptions({ withCredentials: true });
	        return this.http.delete(requestUrl, options)
	            .catch(this.handleError);
	    };
	    /**
	     * Delete Method to remove the data through Api Endpoint
	     * @param requestUrl: string
	     * @return Observable<Type>
	     */
	    ApiService.prototype.deletePost = function (requestUrl, data) {
	        var headers;
	        if (!(data instanceof FormData)) {
	            headers = new http_1.Headers({ 'Content-Type': 'application/json' });
	        }
	        var options = new http_1.RequestOptions({
	            method: http_1.RequestMethod.Delete,
	            headers: headers,
	            withCredentials: true
	        });
	        return this.http.post(requestUrl, data, options)
	            .map(this.extractData)
	            .catch(this.handleError);
	    };
	    /**
	     * Extract Response data from Request Response
	     * @param res: Response
	     * @return JSON data
	     */
	    ApiService.prototype.extractData = function (res) {
	        var body;
	        var contentType = res.headers.get("content-type");
	        // If response has content type "application/json"
	        // then parse the body
	        if (contentType && contentType.indexOf('application/json') !== -1) {
	            try {
	                body = res.json();
	            }
	            catch (error) {
	                body = {};
	            }
	        }
	        else {
	            body = res.text();
	        }
	        return body;
	    };
	    /**
	     * Handle Error returned from Request Response
	     * @param error: any
	     * @return Observable<error>
	     */
	    ApiService.prototype.handleError = function (error) {
	        // In a real world app, we might use a remote logging infrastructure
	        // We'd also dig deeper into the error to get a better message
	        var errMsg = (error.message) ? error.message :
	            error.status ? error.status + " - " + error.statusText : 'Server error';
	        // console.log(errMsg); // log to console instead
	        return Observable_1.Observable.throw(error);
	    };
	    return ApiService;
	}());
	ApiService = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [http_1.Http])
	], ApiService);
	exports.ApiService = ApiService;


/***/ }),

/***/ 61:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	var Observable_1 = __webpack_require__(7);
	// Services
	var ApiService_1 = __webpack_require__(59);
	var SettingService_1 = __webpack_require__(62);
	var FileService_1 = __webpack_require__(66);
	var CatalogService = (function () {
	    function CatalogService(apiService, settingService, fileService) {
	        this.apiService = apiService;
	        this.settingService = settingService;
	        this.fileService = fileService;
	        this.fullCampusUrl = '/included-campuses';
	        this.campusUrl = '/campuses';
	        this.homeroomUrl = '/homerooms';
	        this.schoolyearUrl = '/school-years';
	        this.yearGroupUrl = '/yearGroups';
	        this.yearLevelUrl = '/year-levels';
	        this.semesterUrl = '/semesters';
	        this.gradeClassUrl = '/gradeClasses';
	        this.termUrl = '/terms';
	        this.periodUrl = '/asa-periods';
	        this.apiUrl = '';
	        this.apiUrl = this.settingService.getSetting('api_service_domain');
	    }
	    /**
	     * Get campus items
	     * @returns {Observable<Campus[]>} Array list of Campus class
	     */
	    CatalogService.prototype.getCampuses = function () {
	        var requestUrl = this.apiUrl + this.campusUrl;
	        return this.apiService.get(requestUrl);
	    };
	    /**
	     * Get full campus item with contain yearlevels and homerooms.
	     * @returns {Observable<CampusFullItem[]>} Array list of CampusFullItem class
	     */
	    CatalogService.prototype.getCampusesFullItems = function () {
	        var requestUrl = this.apiUrl + this.fullCampusUrl;
	        return this.apiService.get(requestUrl);
	    };
	    /**
	     * Get homerooms
	     * @returns {Observable<gradeClass[]>} Array list of gradeClass class
	     */
	    CatalogService.prototype.getHomerooms = function () {
	        var requestUrl = this.apiUrl + this.homeroomUrl;
	        return this.apiService.get(requestUrl);
	    };
	    /**
	     * Get school years
	     * @returns {Observable<Schoolyear[]>} Array list of Schoolyear class
	     */
	    CatalogService.prototype.getSchoolyears = function () {
	        var requestUrl = this.apiUrl + this.schoolyearUrl;
	        return this.apiService.get(requestUrl);
	    };
	    /**
	     * Get year levels
	     * @returns {Observable<YearGroup[]>} Array list of YearGroup class
	     */
	    CatalogService.prototype.getYearLevels = function () {
	        var requestUrl = this.apiUrl + this.yearLevelUrl;
	        return this.apiService.get(requestUrl);
	    };
	    CatalogService.prototype.getSemesters = function () {
	        var requestUrl = this.apiUrl + this.semesterUrl;
	        return this.apiService.get(requestUrl);
	    };
	    /**
	     * Handle Promise errors
	     * @returns {String} Message error
	     */
	    CatalogService.prototype.handleError = function (error) {
	        return Promise.reject(error.message || error);
	    };
	    /**
	     * Get Year Groups
	     * @returns {Observable<YearGroup[]>} Array list of YearGroup class
	     */
	    CatalogService.prototype.getYearGroups = function () {
	        var requestUrl = this.apiUrl + this.yearGroupUrl;
	        return this.apiService.get(requestUrl);
	    };
	    CatalogService.prototype.getTerms = function () {
	        var requestUrl = this.apiUrl + this.termUrl;
	        return this.apiService.get(requestUrl);
	    };
	    /**
	     * Get grade_classes
	     * @returns {Observable<gradeClass[]>} Array list of gradeClass class
	     */
	    CatalogService.prototype.getGradeClasses = function () {
	        var requestUrl = this.apiUrl + this.gradeClassUrl;
	        return this.apiService.get(requestUrl);
	    };
	    CatalogService.prototype.getPeriodByTermId = function (termId) {
	        var requestUrl = this.apiUrl + this.periodUrl + '?term_id=' + termId;
	        return this.apiService.get(requestUrl);
	    };
	    CatalogService.prototype.gePeriodByCurrentTerm = function () {
	        var _this = this;
	        return this.getTerms()
	            .map(function (termList) { return _.filter(termList, function (o) { return o.is_current; })[0].id; })
	            .switchMap(function (currentTermId) { return currentTermId ? _this.getPeriodByTermId(currentTermId) : Observable_1.Observable.of(null); });
	    };
	    CatalogService.prototype.getPeriods = function () {
	        var requestUrl = this.apiUrl + this.periodUrl;
	        return this.apiService.get(requestUrl);
	    };
	    return CatalogService;
	}());
	CatalogService = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [ApiService_1.ApiService,
	        SettingService_1.SettingService,
	        FileService_1.FileService])
	], CatalogService);
	exports.CatalogService = CatalogService;


/***/ }),

/***/ 62:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	// Setting configuration
	var Setting_1 = __webpack_require__(63);
	// Lodash
	var _ = __webpack_require__(64);
	var SettingService = (function () {
	    function SettingService() {
	    }
	    /**
	     * Find in the setting list the setting that has
	     * the id matched with settingId input
	     * @param {string} settingId - the id of the setting
	     * @return {string} - the setting value or empty string
	     */
	    SettingService.prototype.getSetting = function (settingId) {
	        var result = _.find(Setting_1.SETTINGS, { 'id': settingId });
	        return result ? result.value : '';
	    };
	    return SettingService;
	}());
	SettingService = __decorate([
	    core_1.Injectable()
	], SettingService);
	exports.SettingService = SettingService;


/***/ }),

/***/ 63:
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Setting = (function () {
	    function Setting() {
	    }
	    return Setting;
	}());
	exports.Setting = Setting;
	exports.SETTINGS = [
	    {
	        id: 'api_service_domain',
	        value: '/api'
	    }
	];


/***/ }),

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	// Import Setting Service and User, Credential Model
	var SettingService_1 = __webpack_require__(62);
	var ApiService_1 = __webpack_require__(59);
	var FileService = (function () {
	    function FileService(settingService, apiService) {
	        this.settingService = settingService;
	        this.apiService = apiService;
	        this.fileUrl = '/files';
	        this.apiUrl = '';
	        this.apiUrl = this.settingService.getSetting('api_service_domain');
	    }
	    FileService.prototype.uploadFile = function (data) {
	        var requestUrl = this.apiUrl + this.fileUrl;
	        return this.apiService.post(requestUrl, data);
	    };
	    FileService.prototype.getFile = function (fileId) {
	        return this.apiUrl + this.fileUrl + '/' + fileId;
	    };
	    return FileService;
	}());
	FileService = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [SettingService_1.SettingService,
	        ApiService_1.ApiService])
	], FileService);
	exports.FileService = FileService;


/***/ }),

/***/ 67:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var LocalStorageService = (function () {
	    function LocalStorageService() {
	    }
	    LocalStorageService.prototype.getData = function (key) {
	        var text = window.localStorage.getItem(key);
	        return JSON.parse(text);
	    };
	    LocalStorageService.prototype.setData = function (key, data) {
	        var text = JSON.stringify(data);
	        try {
	            window.localStorage.setItem(key, text);
	            return true;
	        }
	        catch (error) {
	            console.log("Cannot set local storage data:");
	            console.log(data);
	            return false;
	        }
	    };
	    LocalStorageService.prototype.removeData = function (key) {
	        try {
	            window.localStorage.removeItem(key);
	            return true;
	        }
	        catch (error) {
	            console.log("Cannot remove local storage data. Data key: " + key);
	            return false;
	        }
	    };
	    return LocalStorageService;
	}());
	LocalStorageService = __decorate([
	    core_1.Injectable()
	], LocalStorageService);
	exports.LocalStorageService = LocalStorageService;


/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var SessionStorageService = (function () {
	    function SessionStorageService() {
	    }
	    SessionStorageService.prototype.getData = function (key) {
	        var text = window.sessionStorage.getItem(key);
	        return text ? JSON.parse(text) : '';
	    };
	    SessionStorageService.prototype.setData = function (key, data) {
	        var text = JSON.stringify(data);
	        try {
	            window.sessionStorage.setItem(key, text);
	            return true;
	        }
	        catch (error) {
	            console.log("Cannot set local storage data:");
	            console.log(data);
	            return false;
	        }
	    };
	    SessionStorageService.prototype.removeData = function (key) {
	        try {
	            window.sessionStorage.removeItem(key);
	            return true;
	        }
	        catch (error) {
	            console.log("Cannot remove local storage data. Data key: " + key);
	            return false;
	        }
	    };
	    return SessionStorageService;
	}());
	SessionStorageService = __decorate([
	    core_1.Injectable()
	], SessionStorageService);
	exports.SessionStorageService = SessionStorageService;


/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	// Services
	var ApiService_1 = __webpack_require__(59);
	var SettingService_1 = __webpack_require__(62);
	var StudentService = (function () {
	    function StudentService(apiService, settingService) {
	        this.apiService = apiService;
	        this.settingService = settingService;
	        this.studentUrl = '/bus-students';
	        this.holidayStudentUrl = '/hol/student';
	        this.studentScheduleUrl = '/asa-required-class-children';
	        this.importStudentScheduleUrl = '/students-schedule';
	        this.apiUrl = '';
	        this.apiUrl = this.settingService.getSetting('api_service_domain');
	    }
	    /**
	     *
	     */
	    StudentService.prototype.getStudents = function (filter) {
	        var requestUrl = this.apiUrl + this.studentUrl;
	        var hasFilter = false;
	        // Setup filter conditions
	        for (var condition in filter) {
	            if (filter[condition]) {
	                if (hasFilter) {
	                    requestUrl += '&';
	                }
	                else {
	                    requestUrl += '?';
	                    hasFilter = true;
	                }
	                requestUrl += condition + '=' + filter[condition];
	            }
	        }
	        return this.apiService.get(requestUrl);
	    };
	    StudentService.prototype.getHolidayStudents = function (holidayStudentFilter) {
	        var requestUrl = this.apiUrl + this.holidayStudentUrl;
	        var hasFilter = false;
	        // Setup filter conditions
	        for (var condition in holidayStudentFilter) {
	            if (holidayStudentFilter[condition]) {
	                if (hasFilter) {
	                    requestUrl += '&';
	                }
	                else {
	                    requestUrl += '?';
	                    hasFilter = true;
	                }
	                requestUrl += condition + '=' + holidayStudentFilter[condition];
	            }
	        }
	        return this.apiService.get(requestUrl);
	    };
	    StudentService.prototype.getHolidayStudentDetail = function (studentId) {
	        var requestUrl = this.apiUrl + this.holidayStudentUrl + '?id=' + studentId + '&page=1';
	        return this.apiService.get(requestUrl);
	    };
	    StudentService.prototype.updateHolidayStudentStatus = function (data) {
	        var requestUrl = this.apiUrl + this.holidayStudentUrl;
	        // Post content
	        var body = JSON.stringify(data);
	        return this.apiService.patch(requestUrl, body);
	    };
	    StudentService.prototype.getStudentsSchedule = function (filter) {
	        var requestUrl = this.apiUrl + this.studentScheduleUrl;
	        var hasFilter = false;
	        // Setup filter conditions
	        for (var condition in filter) {
	            if (filter[condition]) {
	                if (hasFilter) {
	                    requestUrl += '&';
	                }
	                else {
	                    requestUrl += '?';
	                    hasFilter = true;
	                }
	                requestUrl += condition + '=' + filter[condition];
	            }
	        }
	        return this.apiService.get(requestUrl);
	    };
	    StudentService.prototype.getHolidayStudentInfo = function () {
	        var requestUrl = this.apiUrl + this.holidayStudentUrl;
	        return this.apiService.get(requestUrl);
	    };
	    StudentService.prototype.importStudent = function (data) {
	        var requestUrl = this.apiUrl + this.studentUrl;
	        return this.apiService.patch(requestUrl, data);
	    };
	    StudentService.prototype.importStudentSchedule = function (data) {
	        var requestUrl = this.apiUrl + this.importStudentScheduleUrl;
	        return this.apiService.patch(requestUrl, data);
	    };
	    StudentService.prototype.updateStudentStatus = function (studentId, data) {
	        var requestUrl = this.apiUrl + this.studentUrl + "/" + studentId;
	        // Post content
	        var body = JSON.stringify(data);
	        return this.apiService.patch(requestUrl, body);
	    };
	    // Edit student
	    StudentService.prototype.editHolidayStudent = function (studentDetail) {
	        var requestUrl = this.apiUrl + this.holidayStudentUrl;
	        var body = JSON.stringify(studentDetail);
	        return this.apiService.patch(requestUrl, body);
	    };
	    //generate list period with day
	    StudentService.prototype.showClassByPeriodAndDay = function (period, weekdays) {
	        var iWeekdaysLength = weekdays.length;
	        var periodCompareName;
	        for (var i = 0; i < iWeekdaysLength; i++) {
	            periodCompareName = weekdays[i].period_name + " " + weekdays[i].day;
	            if (_.parseInt(weekdays[i].period_id) === period.id && periodCompareName.toLowerCase() === period.displayName.toLowerCase()) {
	                return weekdays[i].class || weekdays[i].class_info.name;
	            }
	        }
	        return '';
	    };
	    return StudentService;
	}());
	StudentService = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [ApiService_1.ApiService,
	        SettingService_1.SettingService])
	], StudentService);
	exports.StudentService = StudentService;


/***/ }),

/***/ 70:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	// Menu for application
	var Menu_1 = __webpack_require__(71);
	var CampusInfo_1 = __webpack_require__(72);
	// Lodash
	var _ = __webpack_require__(64);
	var MenuService = (function () {
	    function MenuService() {
	    }
	    /**
	     * Find in the menu type list the menu list that has
	     * the name matched with menuType input
	     * @param {string} menuType - the name of the menu list
	     * @return { Menu[] | [] } - list of menu or empty list
	     */
	    MenuService.prototype.getMenuList = function (menuType) {
	        var result = _.find(Menu_1.MENUS, { 'name': menuType });
	        return result ? result.menuList : [];
	    };
	    MenuService.prototype.getCampusInfo = function () {
	        return CampusInfo_1.CAMPUS_INFOS;
	    };
	    return MenuService;
	}());
	MenuService = __decorate([
	    core_1.Injectable()
	], MenuService);
	exports.MenuService = MenuService;


/***/ }),

/***/ 71:
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Menu = (function () {
	    function Menu() {
	    }
	    return Menu;
	}());
	exports.Menu = Menu;
	var MenuType = (function () {
	    function MenuType() {
	    }
	    return MenuType;
	}());
	exports.MenuType = MenuType;
	var MenuStatus = (function () {
	    function MenuStatus() {
	    }
	    return MenuStatus;
	}());
	exports.MenuStatus = MenuStatus;
	exports.MENUS = [
	    // Top menu list
	    {
	        name: "top",
	        menuList: [
	            {
	                "id": "news-event",
	                "label": "News & Events",
	                "url": "http://www.aisvietnam.com/category/news-events/",
	                "type": "link",
	                "target": "",
	                "icon": "",
	                "role": []
	            },
	            {
	                "id": "photo-gallery",
	                "label": "Photo Gallery",
	                "url": "http://www.aisvietnam.com/photo-gallery/",
	                "type": "link",
	                "target": "",
	                "icon": "",
	                "role": []
	            },
	            {
	                "id": "login-mail",
	                "label": "Login Mail",
	                "url": "https://portal.office.com",
	                "type": "link",
	                "target": "_blank",
	                "icon": "",
	                "role": []
	            },
	            {
	                "id": "my-ais",
	                "label": "myAIS",
	                "url": "http://www.myais.vn",
	                "type": "link",
	                "target": "_blank",
	                "icon": "",
	                "role": []
	            },
	            {
	                "id": "sitemap",
	                "label": "Sitemap",
	                "url": "http://www.aisvietnam.com/sitemap",
	                "type": "link",
	                "target": "",
	                "icon": "",
	                "role": []
	            }
	        ]
	    },
	    // Social connect top menu list
	    {
	        name: 'social-top',
	        menuList: [
	            {
	                "id": "facebook",
	                "label": "Facebook",
	                "url": "https://www.facebook.com/AustralianInternationalSchoolVietnam/",
	                "type": "link",
	                "target": "_blank",
	                "icon": "",
	                "role": []
	            },
	            {
	                "id": "twitter",
	                "label": "Twitter",
	                "url": "https://twitter.com/#!/aisvietnam",
	                "type": "link",
	                "target": "_blank",
	                "icon": "",
	                "role": []
	            },
	            {
	                "id": "google",
	                "label": "Google",
	                "url": "https://plus.google.com/u/0/+AustralianInternationalSchoolVietnamTT/posts",
	                "type": "link",
	                "target": "_blank",
	                "icon": "",
	                "role": []
	            },
	            {
	                "id": "youtube",
	                "label": "Youtube",
	                "url": "https://www.youtube.com/user/aisvietnam",
	                "type": "link",
	                "target": "_blank",
	                "icon": "",
	                "role": []
	            },
	            {
	                "id": "envelope-o",
	                "label": "Email",
	                "url": "http://portal.office.com/",
	                "type": "link",
	                "target": "_blank",
	                "icon": "",
	                "role": []
	            }
	        ]
	    },
	    // Login main menu
	    {
	        name: "login-main",
	        menuList: [
	            {
	                "id": "register",
	                "label": "Register",
	                "url": "/hol-register",
	                "type": "route",
	                "target": "",
	                "icon": "",
	                "role": []
	            },
	            {
	                "id": "login",
	                "label": "Login",
	                "url": "/hol-login",
	                "type": "route",
	                "target": "",
	                "icon": "",
	                "role": []
	            }
	        ]
	    },
	    // Login main menu
	    {
	        name: "hol-login",
	        menuList: [
	            {
	                "id": "register",
	                "label": "Register",
	                "url": "/hol-register",
	                "type": "route",
	                "target": "",
	                "icon": "",
	                "role": []
	            },
	            {
	                "id": "login",
	                "label": "Login",
	                "url": "/hol-login",
	                "type": "route",
	                "target": "",
	                "icon": "",
	                "role": []
	            }
	        ]
	    },
	    // Camp module main menu list
	    {
	        name: 'camp-main',
	        menuList: []
	    },
	    // ASA module main menu list
	    {
	        name: "asa-main",
	        menuList: []
	    },
	    // ASA module sub menu list
	    {
	        name: "asa-sub",
	        menuList: [
	            {
	                "id": "bookingClasses",
	                "label": "Booking Classes",
	                "url": "/booking/students",
	                "type": "route",
	                "target": "",
	                "icon": "",
	                "role": []
	            },
	            // {
	            //     "id": "manageBooking",
	            //     "label": "Manage Booking",
	            //     "url":	"",
	            //     "type":	"route",
	            //     "target": "",
	            //     "icon": "",
	            //     "role": []
	            // },
	            {
	                "id": "attendance",
	                "label": "Attendance",
	                "url": "/parent/attendance",
	                "type": "route",
	                "target": "",
	                "icon": "",
	                "role": []
	            },
	            {
	                "id": "schedule",
	                "label": "Schedule",
	                "url": "/schedule/list",
	                "type": "route",
	                "target": "",
	                "icon": "",
	                "role": []
	            }
	        ]
	    },
	    // Camp module admin sidebar list
	    {
	        name: 'camp-admin-sidebar',
	        menuList: [
	            {
	                "id": "camp-program",
	                "label": "Camp Programmes",
	                "url": "/camps/list",
	                "type": "route",
	                "target": "",
	                "icon": "nature_people",
	                "role": []
	            },
	            {
	                "id": "student",
	                "label": "Students",
	                "url": "/students/list",
	                "type": "route",
	                "target": "",
	                "icon": "people",
	                "role": []
	            },
	            {
	                "id": "camp-report",
	                "label": "Camp Reports",
	                "url": "/camps/report",
	                "type": "route",
	                "target": "",
	                "icon": "rate_review",
	                "role": []
	            }
	        ]
	    },
	    // Asa module admin sidebar list
	    {
	        name: 'asa-admin-sidebar',
	        menuList: [
	            {
	                "id": "classes",
	                "label": "Classes",
	                "url": "/classes/list",
	                "type": "route",
	                "target": "",
	                "icon": "store",
	                "role": []
	            },
	            {
	                "id": "student",
	                "label": "Students",
	                "url": "/students/list",
	                "type": "route",
	                "target": "",
	                "icon": "people",
	                "role": []
	            },
	            {
	                "id": "booking",
	                "label": "Bookings",
	                "url": "/booking/list",
	                "type": "route",
	                "target": "",
	                "icon": "bookmark",
	                "role": []
	            },
	            {
	                "id": "email",
	                "label": "Email",
	                "url": "/email/list",
	                "type": "route",
	                "target": "",
	                "icon": "mail",
	                "role": []
	            },
	            {
	                "id": "attendances",
	                "label": "Attendances",
	                "url": "/attendances",
	                "type": "route",
	                "target": "",
	                "icon": "spellcheck",
	                "role": []
	            }
	        ]
	    },
	    // Bus module parent sidebar list
	    {
	        name: 'bus-parent-sidebar',
	        menuList: [
	            {
	                "id": "bus-attendance",
	                "label": "Bus attendance",
	                "url": "",
	                "type": "route",
	                "target": "",
	                "icon": "store",
	                "role": []
	            },
	            {
	                "id": "bus-profile",
	                "label": "Profile",
	                "url": "",
	                "type": "route",
	                "target": "",
	                "icon": "people",
	                "role": []
	            }
	        ]
	    },
	    // Bus module parent sidebar list
	    {
	        name: 'bus-admin-sidebar',
	        menuList: [
	            {
	                "id": "bus-schedule",
	                "label": "Daily transport list",
	                "url": "dashboard",
	                "type": "route",
	                "target": "",
	                "icon": "directions_bus",
	                "role": ['system', 'manager']
	            },
	            {
	                "id": "bus-student-management",
	                "label": "Student report",
	                "url": "students/list",
	                "type": "route",
	                "target": "",
	                "icon": "assignment_ind",
	                "role": ['system']
	            },
	            {
	                "id": "bus-report",
	                "label": "Bus report",
	                "url": "report",
	                "type": "route",
	                "target": "",
	                "icon": "assessment",
	                "role": ['system']
	            },
	            {
	                "id": "bus-settings",
	                "label": "Settings",
	                "url": "settings",
	                "type": "route",
	                "target": "",
	                "icon": "settings",
	                "role": ['system']
	            }
	        ]
	    },
	    // Holiday module main menu list
	    {
	        name: "holiday-main",
	        menuList: []
	    },
	    // holiday module admin sidebar list
	    {
	        name: 'holiday-admin-sidebar',
	        menuList: [
	            {
	                "id": "booking",
	                "label": "Bookings",
	                "url": "/booking/list",
	                "type": "route",
	                "target": "",
	                "icon": "bookmark",
	                "role": ['system']
	            },
	            {
	                "id": "courses",
	                "label": "Courses",
	                "url": "/courses/list",
	                "type": "route",
	                "target": "",
	                "icon": "book",
	                "role": ['system']
	            },
	            {
	                "id": "classes",
	                "label": "Classes",
	                "url": "/classes/list",
	                "type": "route",
	                "target": "",
	                "icon": "store",
	                "role": ['system', 'manager']
	            },
	            {
	                "id": "student",
	                "label": "Students",
	                "url": "/students/list",
	                "type": "route",
	                "target": "",
	                "icon": "people",
	                "role": ['system']
	            },
	            {
	                "id": "email",
	                "label": "Email",
	                "url": "/email/list",
	                "type": "route",
	                "target": "",
	                "icon": "mail",
	                "role": ['system', 'manager']
	            },
	            {
	                "id": "attendances",
	                "label": "Attendances",
	                "url": "/attendances",
	                "type": "route",
	                "target": "",
	                "icon": "spellcheck",
	                "role": ['system', 'manager']
	            },
	            {
	                "id": "parents",
	                "label": "Parents",
	                "url": "/parents",
	                "type": "route",
	                "target": "",
	                "icon": "people",
	                "role": ['system']
	            },
	            {
	                "id": "setting",
	                "label": "Setting",
	                "url": "/setting",
	                "type": "route",
	                "target": "",
	                "icon": "widgets",
	                "role": ['system']
	            }
	        ]
	    },
	    {
	        name: 'holiday-staff-sidebar',
	        menuList: [
	            {
	                "id": "attendances",
	                "label": "Attendances",
	                "url": "/attendances",
	                "type": "route",
	                "target": "",
	                "icon": "spellcheck",
	                "role": []
	            },
	        ]
	    },
	    // Holiday parent sub menu
	    {
	        name: "holiday-sub",
	        menuList: [
	            {
	                "id": "holidayBooking",
	                "label": "Booking",
	                "url": "/booking/students",
	                "type": "route",
	                "target": "",
	                "icon": "",
	                "role": []
	            },
	            {
	                "id": "holidayAttendance",
	                "label": "Attendance",
	                "url": "/view-attendance",
	                "type": "route",
	                "target": "",
	                "icon": "",
	                "role": []
	            }
	        ]
	    },
	    // re-enrollment module admin sidebar list
	    {
	        name: 'reen-admin-sidebar',
	        menuList: [
	            {
	                "id": "response",
	                "label": "Responses",
	                "url": "/response/list",
	                "type": "route",
	                "target": "",
	                "icon": "bookmark",
	                "role": ['system']
	            },
	            {
	                "id": "email",
	                "label": "Email",
	                "url": "/email/list",
	                "type": "route",
	                "target": "",
	                "icon": "email",
	                "role": ['system']
	            },
	            {
	                "id": "student",
	                "label": "Students",
	                "url": "/reen-student",
	                "type": "route",
	                "target": "",
	                "icon": "store",
	                "role": ['system']
	            },
	            {
	                "id": "report",
	                "label": "Report",
	                "url": "/report",
	                "type": "route",
	                "target": "",
	                "icon": "assessment",
	                "role": ['system']
	            }
	        ]
	    },
	];


/***/ }),

/***/ 72:
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var CampusInfo = (function () {
	    function CampusInfo() {
	    }
	    return CampusInfo;
	}());
	exports.CampusInfo = CampusInfo;
	// Campus Info
	exports.CAMPUS_INFOS = [
	    {
	        "id": 1,
	        "name": "HELEN Campus",
	        "info": "F3 Block B Charmington La Pointe<br>181 Cao Thang<br>Wd.12 | District 10<br>HCMC | Vietnam<br>T: +84 28 6278 2628<br><br>info@nascorp.vn<br>www.nascorp.vn<br>"
	    },
	];


/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	// Services
	var ApiService_1 = __webpack_require__(59);
	var SettingService_1 = __webpack_require__(62);
	var LocalNetworkService = (function () {
	    function LocalNetworkService(apiService, settingService) {
	        this.apiService = apiService;
	        this.settingService = settingService;
	        // Api Domain Url
	        this.apiUrl = '';
	        // Get API service domain for communate.
	        this.apiUrl = this.settingService.getSetting('api_service_domain');
	    }
	    LocalNetworkService.prototype.getLocalNetWork = function () {
	        this.hostName = window.location.hostname;
	        if (this.hostName === "auth.aisvietnam.com") {
	            var requestUrl = 'http://auth.aisvietnam.com/negotiate';
	            return this.apiService.get(requestUrl);
	        }
	        else {
	            var requestUrl = '/negotiate';
	            return this.apiService.get(requestUrl);
	        }
	    };
	    return LocalNetworkService;
	}());
	LocalNetworkService = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [ApiService_1.ApiService,
	        SettingService_1.SettingService])
	], LocalNetworkService);
	exports.LocalNetworkService = LocalNetworkService;


/***/ }),

/***/ 74:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var MenuService_1 = __webpack_require__(70);
	var FooterComponent = (function () {
	    function FooterComponent(menuService) {
	        this.menuService = menuService;
	    }
	    FooterComponent.prototype.ngOnInit = function () {
	        /** TO DO
	         * Get current language from cookie/session
	         * If no language data from it, set default language as English
	         */
	        this.currentLang = 'en';
	        // Get top menu list
	        this.menuList = this.menuService.getMenuList('top');
	        // Get campus info list
	        this.campusList = this.menuService.getCampusInfo();
	    };
	    return FooterComponent;
	}());
	FooterComponent = __decorate([
	    core_1.Component({
	        selector: 'footer',
	        template: __webpack_require__(75),
	        styles: [__webpack_require__(79)],
	        providers: [MenuService_1.MenuService]
	    }),
	    __metadata("design:paramtypes", [MenuService_1.MenuService])
	], FooterComponent);
	exports.FooterComponent = FooterComponent;


/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div id=\"app-footer\">\n\t<div class=\"campus-info-list row small-up-1 medium-up-2 large-up-4\">\n\t\t<!-- Campus Information -->\n\t\t<div class=\"column\" *ngFor=\"let campus of campusList\">\n\t\t\t<h6 class=\"campus-title\">{{campus.name}}</h6>\n\t\t\t<div class=\"campus-text\" [innerHTML]=\"campus.info\"></div>\n\t\t</div>\n\t\t<!-- CIS Member -->\n\t\t<!-- <div class=\"column\">\n\t\t\t<p align=\"center\">\n\t\t\t\t<a href=\"http://www.ibo.org/\" target=\"_blank\"><img src=\"" + __webpack_require__(76) + "\"></a>\n\t\t\t</p>\n\t\t\t<p align=\"center\">\n\t\t\t\t<a href=\"https://www.cam.ac.uk/\" target=\"_blank\"><img src=\"" + __webpack_require__(77) + "\"></a>\n\t\t\t</p>\n\t\t\t<p align=\"center\" class=\"cis-membership\">\n\t\t\t\t<a href=\"http://www.cois.org/\" target=\"_blank\"><img src=\"" + __webpack_require__(78) + "\"></a>\n\t\t\t\t<br>\n\t\t\t</p>\n\t\t</div> -->\n\t</div>\n\t<!-- Bottom Bar -->\n\t<div class=\"bottom-bar\">\n\t\t<div class=\"copyright\">\n\t\t\t<span>Our website is best viewed using Chrome, Firefox, Safari.</span>\n\t\t</div>\n\t\t<!-- <div class=\"top-bar-right\">\n\t\t\t<ul class=\"menu\">\n\t\t\t\t<li *ngFor=\"let menu of menuList\">\n\t\t\t\t<a href=\"{{menu.url}}\" target=\"{{menu.target}}\">{{menu.label}}</a>\n\t\t\t\t</li>\n\t\t\t</ul>\n\t\t</div> -->\n\t</div>\n</div>";

/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/ib_logo.88ef45dabda5b2bbe32eb13597007f28.png";

/***/ }),

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/cambridge_university_logo.7a6d3637e5c797cd2e49d2ed5ce219be.png";

/***/ }),

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/cis_member_logo.a75e54c7e11c976905f137f41232cb3a.png";

/***/ }),

/***/ 79:
/***/ (function(module, exports) {

	module.exports = "#app-footer{background-color:#00707e;font-size:0.7rem;bottom:0;bottom-position:absolute;bottom-width:100%}#app-footer .campus-info-list{max-width:100%;padding:2rem 4rem}#app-footer .campus-info-list .column .campus-title{text-transform:uppercase;font-weight:500;font-size:1rem;color:#fff}#app-footer .campus-info-list .column .campus-text,#app-footer .campus-info-list .column .cis-membership{color:#dadada;line-height:1.375rem}#app-footer .bottom-bar{display:table;width:100%;background-color:#414042;padding:15px 4rem}#app-footer .bottom-bar .copyright{float:right;display:table-cell;vertical-align:middle}#app-footer .bottom-bar .copyright span{font-weight:500;color:#faa635}#app-footer .bottom-bar .top-bar-right{float:right}#app-footer .bottom-bar .top-bar-right .menu>li>a{color:#faa635;padding:0.6rem 0.3rem}#app-footer .bottom-bar .top-bar-right .menu>li>a:hover{color:#fff}@media only screen and (max-width: 40em){#app-footer{font-size:0.8rem}#app-footer .campus-info-list .column{padding:1rem 0}#app-footer .campus-info-list .column .campus-title{font-size:1rem}#app-footer .bottom-bar .copyright{padding:0.5rem;text-align:center}#app-footer .bottom-bar .top-bar-right{display:none}}\n"

/***/ }),

/***/ 80:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var Subject_1 = __webpack_require__(6);
	var MenuService_1 = __webpack_require__(70);
	var UserService_1 = __webpack_require__(81);
	var SessionService_1 = __webpack_require__(82);
	var router_1 = __webpack_require__(26);
	var HolidayService_1 = __webpack_require__(83);
	var services_1 = __webpack_require__(58);
	var AdminService_1 = __webpack_require__(84);
	var config_1 = __webpack_require__(85);
	var MainMenuComponent = (function () {
	    function MainMenuComponent(menuService, router, holidayService, userService, sessionService, sessionStorageService, adminService) {
	        this.menuService = menuService;
	        this.router = router;
	        this.holidayService = holidayService;
	        this.userService = userService;
	        this.sessionService = sessionService;
	        this.sessionStorageService = sessionStorageService;
	        this.adminService = adminService;
	        this.menuStatusChanged = new Subject_1.Subject();
	        this.userMenuClassVisible = 'menu-list-visible';
	    }
	    MainMenuComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.parent = new Object;
	        this.getSessionData();
	        this.hostName = window.location.hostname;
	        // Get main menu List
	        this.menuList = this.getMainMenuList();
	        //  Get sub menu list
	        this.subMenuList = this.getSubMenuList();
	        this.menuStatus = this.getMenuStatus();
	        // Subscription to catch the session changed to change the menu list content
	        this.subscription = this.userService.userDataChanged$.subscribe(function (user) {
	            _this.onSessionChanged(user);
	        });
	    };
	    MainMenuComponent.prototype.checkAccountIsVasParent = function () {
	        return this.sessionStorageService.getData('isVasParent');
	    };
	    MainMenuComponent.prototype.ngOnDestroy = function () {
	        // Destroy the subscription for session changes
	        this.subscription.unsubscribe();
	    };
	    /**
	     * Action that fired when the session change event is catched.
	     * Update the userData & the menuList.
	     */
	    MainMenuComponent.prototype.onSessionChanged = function (user) {
	        //TO DO: update menu content when session changed
	        this.userData = user;
	        // Get Menu List
	        this.menuList = this.getMainMenuList();
	        this.subMenuList = this.getSubMenuList();
	    };
	    MainMenuComponent.prototype.onMenuStatusChanged = function () {
	        this.menuStatus = this.getMenuStatus();
	    };
	    MainMenuComponent.prototype.getMenuStatus = function () {
	        if (document.URL === "http://" + config_1.devEnv.services + "/" ||
	            document.URL === "http://" + config_1.localEnv.services + "/" ||
	            document.URL === "http://" + config_1.testEnv.services + "/" ||
	            document.URL === "http://" + config_1.bisHanoiEnv.services + "/" ||
	            document.URL === "http://" + config_1.bisHanoiDevEnv.services + "/" ||
	            document.URL === "http://" + config_1.stagingEnv.services + "/" ||
	            document.URL === "https://" + config_1.procEnv.services + "/" ||
	            document.URL === "http://" + config_1.demoEnv.services + "/") {
	            return false;
	        }
	        else {
	            return true;
	        }
	    };
	    /**
	     * Return a module 's menu list content for the main menu.
	     * Return login main menu list if no user data is detected.
	     * @returns {Menu[]|[]} - module's menu list or empty list.
	     */
	    MainMenuComponent.prototype.getMainMenuList = function () {
	        var menuList = [];
	        if (!this.userData && (this.hostName === config_1.procEnv.holiday
	            || this.hostName === config_1.devEnv.holiday
	            || this.hostName === config_1.localEnv.holiday
	            || this.hostName === config_1.bisHanoiEnv.holiday
	            || this.hostName === config_1.bisHanoiDevEnv.holiday
	            || this.hostName === config_1.testEnv.holiday
	            || this.hostName === config_1.stagingEnv.holiday
	            || this.hostName === config_1.demoEnv.holiday)) {
	            menuList = this.menuService.getMenuList('hol-login');
	        }
	        else if (!this.userData) {
	            menuList = this.menuService.getMenuList('login-main');
	        }
	        else {
	            menuList = this.menuService.getMenuList(this.module + '-main');
	        }
	        return menuList;
	    };
	    /**
	     * Return a module 's SUB menu list content for the main menu.
	     * Return login main menu list if no user data is detected.
	     * @returns {Menu[]|[]} - module's menu list or empty list.
	     */
	    MainMenuComponent.prototype.getSubMenuList = function () {
	        return this.menuService.getMenuList(this.module + '-sub');
	    };
	    MainMenuComponent.prototype.toLogOut = function () {
	        this.userData = this.userService.getUserSessionData();
	        this.deleteSession();
	    };
	    /**
	 * Delete user session data.
	 */
	    MainMenuComponent.prototype.deleteSession = function () {
	        var _this = this;
	        this.sessionService.deleteSession()
	            .subscribe(function (complete) {
	            // Clear user session
	            _this.userService.clearUserSessionData();
	            _this.adminService.clearInterSession();
	            // Fire user session data changed event
	            _this.userService.userDataChanged(null);
	            // Redirect to desired URL                    
	            if (Object.values(config_1.devEnv).indexOf(window.location.hostname) !== -1) {
	                return window.location.href = "http://" + config_1.devEnv.services;
	            }
	            else if (Object.values(config_1.testEnv).indexOf(window.location.hostname) !== -1) {
	                return window.location.href = "http://" + config_1.testEnv.services;
	            }
	            else if (Object.values(config_1.bisHanoiEnv).indexOf(window.location.hostname) !== -1) {
	                return window.location.href = "http://" + config_1.bisHanoiEnv.services;
	            }
	            else if (Object.values(config_1.bisHanoiDevEnv).indexOf(window.location.hostname) !== -1) {
	                return window.location.href = "http://" + config_1.bisHanoiDevEnv.services;
	            }
	            else if (Object.values(config_1.stagingEnv).indexOf(window.location.hostname) !== -1) {
	                return window.location.href = "https://" + config_1.stagingEnv.services;
	            }
	            else if (Object.values(config_1.procEnv).indexOf(window.location.hostname) !== -1) {
	                return window.location.href = "https://" + config_1.procEnv.services;
	            }
	            else if (Object.values(config_1.demoEnv).indexOf(window.location.hostname) !== -1) {
	                return window.location.href = "http://" + config_1.demoEnv.services;
	            }
	            else {
	                return window.location.href = "http://" + config_1.localEnv.services;
	            }
	        });
	    };
	    MainMenuComponent.prototype.getSessionData = function () {
	        var _this = this;
	        this.sessionService.getSession()
	            .subscribe(function (user) {
	            _this.userData = user;
	            if (_this.userData.role !== 'system' && _this.userData.role !== 'manager') {
	                _this.getParent();
	            }
	        });
	    };
	    MainMenuComponent.prototype.toHomePage = function () {
	        // Redirect to desired URL
	        if (this.userData.role === 'parent' || this.parent.type === 'vas') {
	            if (Object.values(config_1.devEnv).indexOf(this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.devEnv.services + "/parents";
	            }
	            else if (Object.values(config_1.testEnv).indexOf(this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.testEnv.services + "/parents";
	            }
	            else if (Object.values(config_1.bisHanoiEnv).indexOf(this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.bisHanoiEnv.services + "/parents";
	            }
	            else if (Object.values(config_1.bisHanoiDevEnv).indexOf(this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.bisHanoiDevEnv.services + "/parents";
	            }
	            else if (Object.values(config_1.stagingEnv).indexOf(this.hostName) !== -1) {
	                return window.location.href = "https://" + config_1.stagingEnv.services + "/parents";
	            }
	            else if (Object.values(config_1.procEnv).indexOf(this.hostName) !== -1) {
	                return window.location.href = "https://" + config_1.procEnv.services + "/parents";
	            }
	            else if (Object.values(config_1.demoEnv).indexOf(this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.demoEnv.services + "/parents";
	            }
	            else {
	                return window.location.href = "http://" + config_1.localEnv.services + "/parents";
	            }
	        }
	        // Redirect to desired URL
	        if (this.userData.role === 'hol-parent' || this.parent.type === 'other') {
	            if (Object.values(config_1.devEnv).indexOf(this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.devEnv.services + "/other-parents";
	            }
	            else if (Object.values(config_1.testEnv).indexOf(this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.testEnv.services + "/other-parents";
	            }
	            else if (Object.values(config_1.bisHanoiEnv).indexOf(this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.bisHanoiEnv.services + "/other-parents";
	            }
	            else if (Object.values(config_1.bisHanoiDevEnv).indexOf(this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.bisHanoiDevEnv.services + "/other-parents";
	            }
	            else if (Object.values(config_1.stagingEnv).indexOf(this.hostName) !== -1) {
	                return window.location.href = "https://" + config_1.stagingEnv.services + "/other-parents";
	            }
	            else if (Object.values(config_1.procEnv).indexOf(this.hostName) !== -1) {
	                return window.location.href = "https://" + config_1.procEnv.services + "/other-parents";
	            }
	            else if (Object.values(config_1.demoEnv).indexOf(this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.demoEnv.services + "/other-parents";
	            }
	            else {
	                return window.location.href = "http://" + config_1.localEnv.services + "/other-parents";
	            }
	        }
	        if (!this.userData && !this.parent) {
	            if (Object.values(config_1.devEnv).indexOf(this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.devEnv.services;
	            }
	            else if (Object.values(config_1.testEnv).indexOf(this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.testEnv.services;
	            }
	            else if (Object.values(config_1.bisHanoiEnv).indexOf(this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.bisHanoiEnv.services;
	            }
	            else if (Object.values(config_1.bisHanoiDevEnv).indexOf(this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.bisHanoiDevEnv.services;
	            }
	            else if (Object.values(config_1.stagingEnv).indexOf(this.hostName) !== -1) {
	                return window.location.href = "https://" + config_1.stagingEnv.services;
	            }
	            else if (Object.values(config_1.procEnv).indexOf(this.hostName) !== -1) {
	                return window.location.href = "https://" + config_1.procEnv.services;
	            }
	            else if (Object.values(config_1.demoEnv).indexOf(this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.demoEnv.services;
	            }
	            else {
	                return window.location.href = "http://" + config_1.localEnv.services;
	            }
	        }
	    };
	    MainMenuComponent.prototype.toRegister = function () {
	        if (this.hostName === config_1.procEnv.holiday
	            || this.hostName === config_1.devEnv.holiday
	            || this.hostName === config_1.localEnv.holiday
	            || this.hostName === config_1.bisHanoiEnv.holiday
	            || this.hostName === config_1.bisHanoiDevEnv.holiday
	            || this.hostName === config_1.demoEnv.holiday) {
	            this.router.navigateByUrl('/hol-register');
	        }
	        else {
	            this.router.navigate(['/register']);
	        }
	    };
	    MainMenuComponent.prototype.toChangePassword = function () {
	        if (this.hostName === config_1.procEnv.holiday
	            || this.hostName === config_1.devEnv.holiday
	            || this.hostName === config_1.localEnv.holiday
	            || this.hostName === config_1.bisHanoiEnv.holiday
	            || this.hostName === config_1.bisHanoiDevEnv.holiday
	            || this.hostName === config_1.demoEnv.holiday) {
	            this.router.navigateByUrl('/hol-change-password');
	        }
	        else {
	            this.router.navigate(['/change-password']);
	        }
	    };
	    MainMenuComponent.prototype.menuStatusDataChanged = function (menu) {
	        this.menuStatusChanged.next(menu);
	    };
	    MainMenuComponent.prototype.getParent = function () {
	        var _this = this;
	        this.holidayService.getParent()
	            .subscribe(function (parent) {
	            _this.parent = parent;
	            if (_this.parent.status === "fill-info") {
	                _this.router.navigate(['/profile/add-parent']);
	            }
	            else if (_this.parent.status == "full") {
	                _this.router.navigate(['/booking/students']);
	            }
	            else {
	                _this.router.navigate(['/add-student']);
	            }
	        }, function (error) {
	            //TO DO: Handle any error if needed in the furture
	            _this.message = "";
	            _this.messageType = "alert";
	        });
	    };
	    MainMenuComponent.prototype.toProfile = function () {
	        if (this.hostName === config_1.procEnv.holiday
	            || this.hostName === config_1.devEnv.holiday
	            || this.hostName === config_1.localEnv.holiday
	            || this.hostName === config_1.bisHanoiEnv.holiday
	            || this.hostName === config_1.bisHanoiDevEnv.holiday
	            || this.hostName === config_1.demoEnv.holiday) {
	            this.router.navigateByUrl('/profile/edit-parent');
	        }
	        else {
	            this.router.navigate(['/profile/edit-parent']);
	        }
	    };
	    return MainMenuComponent;
	}());
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], MainMenuComponent.prototype, "module", void 0);
	MainMenuComponent = __decorate([
	    core_1.Component({
	        selector: 'main-menu',
	        template: __webpack_require__(86),
	        styles: [__webpack_require__(88)],
	    }),
	    __metadata("design:paramtypes", [MenuService_1.MenuService,
	        router_1.Router,
	        HolidayService_1.HolidayService,
	        UserService_1.UserService,
	        SessionService_1.SessionService,
	        services_1.SessionStorageService,
	        AdminService_1.AdminService])
	], MainMenuComponent);
	exports.MainMenuComponent = MainMenuComponent;


/***/ }),

/***/ 81:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var Subject_1 = __webpack_require__(6);
	var services_1 = __webpack_require__(58);
	var UserService = (function () {
	    function UserService(sessionStorageService) {
	        this.sessionStorageService = sessionStorageService;
	        // Observable User source
	        this.userDataChangedSource = new Subject_1.Subject();
	        // Observable User streams
	        this.userDataChanged$ = this.userDataChangedSource.asObservable();
	    }
	    UserService.prototype.getUserSessionData = function () {
	        return this.sessionStorageService.getData('eca-user');
	    };
	    UserService.prototype.setUserSessionData = function (user) {
	        return this.sessionStorageService.setData('eca-user', user);
	    };
	    UserService.prototype.clearUserSessionData = function () {
	        return this.sessionStorageService.removeData('eca-user');
	    };
	    UserService.prototype.userDataChanged = function (user) {
	        this.userDataChangedSource.next(user);
	    };
	    return UserService;
	}());
	UserService = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [services_1.SessionStorageService])
	], UserService);
	exports.UserService = UserService;


/***/ }),

/***/ 82:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var services_1 = __webpack_require__(58);
	var SessionService = (function () {
	    function SessionService(settingService, apiService) {
	        this.settingService = settingService;
	        this.apiService = apiService;
	        this.sessionUrl = '/session';
	        this.cafeteriaUrl = '/caterer-service/';
	        this.apiUrl = '';
	        this.apiUrl = this.settingService.getSetting('api_service_domain');
	    }
	    /**
	     * Get Session from API
	     * @params: none
	     * @return: status 200 - User observable object if session is provied succesfully.
	     *          status 401 - Unauthorized if user credentials are invalid.
	     * */
	    SessionService.prototype.getSession = function () {
	        var requestUrl = this.apiUrl + this.sessionUrl;
	        // Call Get Method from Api Service
	        return this.apiService.get(requestUrl);
	    };
	    /**
	     * Get Session from API
	     * @params: User Observable Object
	     * @return: status 200 - User observable object if session is created.
	     *          status 401 - Unauthorized if no session is found.
	     * */
	    SessionService.prototype.postSession = function (credential) {
	        var requestUrl = this.apiUrl + this.sessionUrl;
	        var body = JSON.stringify({
	            'role': credential.role,
	            'email': credential.email,
	            'password': credential.password
	        });
	        // Call Get Method from Api Service
	        return this.apiService.post(requestUrl, body);
	    };
	    SessionService.prototype.deleteSession = function () {
	        var requestUrl = this.apiUrl + this.sessionUrl;
	        return this.apiService.delete(requestUrl);
	    };
	    SessionService.prototype.getCafeteriaUrl = function () {
	        var requestUrl = this.apiUrl + this.cafeteriaUrl + 'daisyLink';
	        // Call Get Method from Api Service
	        return this.apiService.get(requestUrl);
	    };
	    SessionService.prototype.getSessionDaisy = function () {
	        var requestUrl = this.apiUrl + this.cafeteriaUrl + 'getTokenByCookie';
	        // Call Get Method from Api Service
	        return this.apiService.get(requestUrl);
	    };
	    return SessionService;
	}());
	SessionService = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [services_1.SettingService,
	        services_1.ApiService])
	], SessionService);
	exports.SessionService = SessionService;


/***/ }),

/***/ 83:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	// Services
	var services_1 = __webpack_require__(58);
	var HolidayService = (function () {
	    function HolidayService(apiService, settingService) {
	        this.apiService = apiService;
	        this.settingService = settingService;
	        // Api Domain Url
	        this.apiUrl = '';
	        this.courseUrl = '/hol/course';
	        this.courseClassUrl = '/hol/class/';
	        this.courseStudentUrl = '/hol/student/';
	        this.parentUrl = '/hol/parent';
	        this.convertParentUrl = '/hol/parent/convert';
	        this.parentPassword = '/hol/parent/password';
	        this.weekUrl = '/hol/week';
	        this.excursionUrl = '/hol/excursion';
	        this.questionnarie = "/hol/questionnaire";
	        this.parentEmail = '/hol/parent/email';
	        // Get API service domain for communate.
	        this.apiUrl = this.settingService.getSetting('api_service_domain');
	    }
	    HolidayService.prototype.createCourse = function (courseItem) {
	        var requestUrl = this.apiUrl + this.courseUrl;
	        // Post content
	        var body = JSON.stringify(courseItem);
	        return this.apiService.post(requestUrl, body);
	    };
	    HolidayService.prototype.createCourseClass = function (courseClassItem) {
	        var requestUrl = this.apiUrl + this.courseClassUrl;
	        // Post content
	        var body = JSON.stringify(courseClassItem);
	        return this.apiService.post(requestUrl, body);
	    };
	    HolidayService.prototype.getCourseList = function (filter) {
	        var requestUrl = this.apiUrl + this.courseUrl;
	        var hasFilter = false;
	        // Setup filter conditions
	        for (var condition in filter) {
	            if (filter[condition]) {
	                if (hasFilter) {
	                    requestUrl += '&';
	                }
	                else {
	                    requestUrl += '?';
	                    hasFilter = true;
	                }
	                requestUrl += condition + '=' + filter[condition];
	            }
	        }
	        return this.apiService.get(requestUrl);
	    };
	    HolidayService.prototype.getCourseDetail = function (courseId) {
	        var requestUrl = this.apiUrl + this.courseUrl + '?id=' + courseId;
	        return this.apiService.get(requestUrl);
	    };
	    HolidayService.prototype.getFullCourseList = function () {
	        var requestUrl = this.apiUrl + this.courseUrl;
	        return this.apiService.get(requestUrl);
	    };
	    HolidayService.prototype.editCourse = function (courseItem) {
	        var requestUrl = this.apiUrl + this.courseUrl;
	        var body = JSON.stringify({
	            id: courseItem.id,
	            name: courseItem.name,
	            type: courseItem.type,
	            school_year: courseItem.school_year,
	            start_date: courseItem.start_date,
	            end_date: courseItem.end_date,
	            description: courseItem.description,
	            status: courseItem.status
	        });
	        return this.apiService.patch(requestUrl, body);
	    };
	    HolidayService.prototype.updateParent = function (nonVasParent) {
	        var requestUrl = this.apiUrl + this.parentUrl;
	        var body = JSON.stringify(nonVasParent);
	        return this.apiService.patch(requestUrl, body);
	    };
	    HolidayService.prototype.getParent = function (filter) {
	        if (filter === void 0) { filter = []; }
	        var requestUrl = this.apiUrl + this.parentUrl;
	        var hasFilter = false;
	        // Setup filter conditions
	        for (var condition in filter) {
	            if (filter[condition]) {
	                if (hasFilter) {
	                    requestUrl += '&';
	                }
	                else {
	                    requestUrl += '?';
	                    hasFilter = true;
	                }
	                requestUrl += condition + '=' + filter[condition];
	            }
	        }
	        return this.apiService.get(requestUrl);
	    };
	    HolidayService.prototype.changeParentPassword = function (query) {
	        var requestUrl = this.apiUrl + this.parentPassword;
	        var body = JSON.stringify(query);
	        return this.apiService.patch(requestUrl, body);
	    };
	    HolidayService.prototype.changeParentEmail = function (query) {
	        var requestUrl = this.apiUrl + this.parentEmail;
	        var body = JSON.stringify(query);
	        return this.apiService.put(requestUrl, body);
	    };
	    HolidayService.prototype.convertParent = function () {
	        var requestUrl = this.apiUrl + this.convertParentUrl;
	        var body = JSON.stringify({});
	        return this.apiService.post(requestUrl, body);
	    };
	    HolidayService.prototype.getCourseClassList = function (filter) {
	        var requestUrl = this.apiUrl + this.courseClassUrl;
	        var hasFilter = false;
	        // Setup filter conditions
	        for (var condition in filter) {
	            if (filter[condition]) {
	                if (hasFilter) {
	                    requestUrl += '&';
	                }
	                else {
	                    requestUrl += '?';
	                    hasFilter = true;
	                }
	                requestUrl += condition + '=' + filter[condition];
	            }
	        }
	        return this.apiService.get(requestUrl);
	    };
	    HolidayService.prototype.getClassDetail = function (classId) {
	        var requestUrl = this.apiUrl + this.courseClassUrl + '?id=' + classId + '&page=1';
	        return this.apiService.get(requestUrl);
	    };
	    HolidayService.prototype.getFullCourseClassList = function () {
	        var requestUrl = this.apiUrl + this.courseClassUrl;
	        return this.apiService.get(requestUrl);
	    };
	    HolidayService.prototype.editClass = function (classItem) {
	        var requestUrl = this.apiUrl + this.courseClassUrl;
	        var body = JSON.stringify({
	            id: classItem.id,
	            thumbnail_id: classItem.thumbnail_id,
	            name: classItem.name,
	            room: classItem.room,
	            campus_id: classItem.campus_id,
	            teacher: classItem.teacher,
	            max_number: classItem.max_number,
	            suitable_from: classItem.suitable_from,
	            suitable_to: classItem.suitable_to,
	            total_cost: +classItem.total_cost,
	            cost_per_week: classItem.cost_per_week,
	            activities: classItem.activities,
	            status: classItem.status,
	            prices: classItem.prices
	        });
	        return this.apiService.patch(requestUrl, body);
	    };
	    // ───  ───────────────────────────────────────────────────────────────────────────
	    // Get week
	    HolidayService.prototype.getWeekService = function () {
	        var requestUrl = this.apiUrl + this.weekUrl;
	        return this.apiService.get(requestUrl);
	    };
	    // ───  ───────────────────────────────────────────────────────────────────────────
	    // Add week
	    HolidayService.prototype.addWeekService = function (weeks) {
	        var requestUrl = this.apiUrl + this.weekUrl;
	        var body = JSON.stringify(weeks);
	        return this.apiService.post(requestUrl, body);
	    };
	    //Edit week
	    HolidayService.prototype.editWeekService = function (weeks) {
	        var requestUrl = this.apiUrl + this.weekUrl;
	        var body = JSON.stringify(weeks);
	        return this.apiService.patch(requestUrl, body);
	    };
	    // ───  ───────────────────────────────────────────────────────────────────────────
	    // Get excursion
	    HolidayService.prototype.getExcursionService = function (filter) {
	        var requestUrl = this.apiUrl + this.excursionUrl;
	        var hasFilter = false;
	        // Setup filter conditions
	        for (var condition in filter) {
	            if (filter[condition]) {
	                if (hasFilter) {
	                    requestUrl += '&';
	                }
	                else {
	                    requestUrl += '?';
	                    hasFilter = true;
	                }
	                requestUrl += condition + '=' + filter[condition];
	            }
	        }
	        return this.apiService.get(requestUrl);
	    };
	    // ───  ───────────────────────────────────────────────────────────────────────────
	    // Add excursion
	    HolidayService.prototype.addExcursionService = function (excursion) {
	        var requestUrl = this.apiUrl + this.excursionUrl;
	        var body = JSON.stringify(excursion);
	        return this.apiService.post(requestUrl, body);
	    };
	    //Edit week
	    HolidayService.prototype.editExcursionService = function (excursion) {
	        var requestUrl = this.apiUrl + this.excursionUrl;
	        var body = JSON.stringify(excursion);
	        return this.apiService.patch(requestUrl, body);
	    };
	    // ───  ───────────────────────────────────────────────────────────────────────────
	    // Remove student in class
	    HolidayService.prototype.removeStudentInClass = function (studentId, classId) {
	        var requestUrl = this.apiUrl + this.courseStudentUrl + studentId + '/class/' + classId;
	        var body = {
	            "holStudentId": studentId,
	            "holClassId": classId
	        };
	        return this.apiService.deletePost(requestUrl, body);
	    };
	    // ───  ───────────────────────────────────────────────────────────────────────────
	    // Transfer waiting student in class
	    HolidayService.prototype.transferStudentInClass = function (studentId, classId, status) {
	        var requestUrl = this.apiUrl + this.courseClassUrl + classId + '/student/' + studentId;
	        var body = {
	            "holStudentId": studentId,
	            "holClassId": classId,
	            "status": status
	        };
	        return this.apiService.patch(requestUrl, body);
	    };
	    HolidayService.prototype.getParentById = function (id) {
	        var requestUrl = this.apiUrl + this.parentUrl + '/' + id;
	        return this.apiService.get(requestUrl);
	    };
	    HolidayService.prototype.getQuestionnarie = function () {
	        var requestUrl = this.apiUrl + this.questionnarie;
	        return this.apiService.get(requestUrl);
	    };
	    ;
	    HolidayService.prototype.getQuestionnarieById = function (id) {
	        var requestUrl = this.apiUrl + this.questionnarie + '/' + id;
	        return this.apiService.get(requestUrl);
	    };
	    HolidayService.prototype.upsertQuestionnarie = function (question) {
	        var body = JSON.stringify(question);
	        var requestUrl = this.apiUrl + this.questionnarie;
	        return this.apiService.put(requestUrl, body);
	    };
	    ;
	    return HolidayService;
	}());
	HolidayService = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [services_1.ApiService,
	        services_1.SettingService])
	], HolidayService);
	exports.HolidayService = HolidayService;


/***/ }),

/***/ 84:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var Subject_1 = __webpack_require__(6);
	var services_1 = __webpack_require__(58);
	var AdminService = (function () {
	    function AdminService(sessionStorageService) {
	        this.sessionStorageService = sessionStorageService;
	        this.adminDataChangedSource = new Subject_1.Subject();
	        this.logger = new Subject_1.Subject();
	        // Observable Admin streams
	        this.adminDataChanged$ = this.adminDataChangedSource.asObservable();
	    }
	    AdminService.prototype.getAdminSessionData = function () {
	        return this.sessionStorageService.getData('asa-admin');
	    };
	    AdminService.prototype.setAdminSessionData = function (admin) {
	        return this.sessionStorageService.setData('asa-admin', admin);
	    };
	    AdminService.prototype.clearAdminSessionData = function () {
	        return this.sessionStorageService.removeData('asa-admin');
	    };
	    AdminService.prototype.clearInterSession = function () {
	        return this.sessionStorageService.removeData('curId');
	    };
	    AdminService.prototype.adminDataChanged = function (admin) {
	        return this.adminDataChangedSource.next(admin);
	    };
	    return AdminService;
	}());
	AdminService = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [services_1.SessionStorageService])
	], AdminService);
	exports.AdminService = AdminService;


/***/ }),

/***/ 85:
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	//VAS
	var schoolUrl = 'demo';
	exports.devEnv = {
	    services: "services." + schoolUrl + ".dev.nascorp.vn",
	    auth: "auth." + schoolUrl + ".dev.nascorp.vn",
	    camp: "camp." + schoolUrl + ".dev.nascorp.vn",
	    asa: "asa." + schoolUrl + ".dev.nascorp.vn",
	    holiday: "holiday." + schoolUrl + ".dev.nascorp.vn",
	    bus: "bus." + schoolUrl + ".dev.nascorp.vn",
	    conference: "conference." + schoolUrl + ".dev.nascorp.vn",
	    reen: "reen." + schoolUrl + ".dev.nascorp.vn",
	    event: "event." + schoolUrl + ".dev.nascorp.vn"
	};
	exports.testEnv = {
	    services: "services." + schoolUrl + ".test.nascorp.vn",
	    auth: "auth." + schoolUrl + ".test.nascorp.vn",
	    camp: "camp." + schoolUrl + ".test.nascorp.vn",
	    asa: "asa." + schoolUrl + ".test.nascorp.vn",
	    holiday: "holiday." + schoolUrl + ".test.nascorp.vn",
	    bus: "bus." + schoolUrl + ".test.nascorp.vn",
	    conference: "conference." + schoolUrl + ".test.nascorp.vn",
	    reen: "reen." + schoolUrl + ".test.nascorp.vn",
	    event: "event." + schoolUrl + ".test.nascorp.vn"
	};
	exports.procEnv = {
	    services: "ppservices." + schoolUrl + ".edu.vn",
	    auth: "ppauth." + schoolUrl + ".edu.vn",
	    camp: "ppcamp." + schoolUrl + ".edu.vn",
	    asa: "ppasa." + schoolUrl + ".edu.vn",
	    holiday: "ppholiday." + schoolUrl + ".edu.vn",
	    bus: "ppbus." + schoolUrl + ".edu.vn",
	    conference: "ppconference." + schoolUrl + ".edu.vn",
	    reen: "ppreen." + schoolUrl + ".edu.vn",
	    event: "ppevent." + schoolUrl + ".edu.vn"
	};
	exports.stagingEnv = {
	    auth: "ppuauth." + schoolUrl + ".edu.vn",
	    services: "ppuservices." + schoolUrl + ".edu.vn",
	    asa: "ppuasa." + schoolUrl + ".edu.vn",
	    holiday: "ppuholiday." + schoolUrl + ".edu.vn",
	    bus: "ppubus." + schoolUrl + ".edu.vn",
	    camp: "ppucamp." + schoolUrl + ".edu.vn",
	    reen: "ppureen." + schoolUrl + ".edu.vn",
	    conference: "ppuconference." + schoolUrl + ".edu.vn",
	    event: "ppuevent." + schoolUrl + ".edu.vn",
	};
	exports.localEnv = {
	    services: "services.local." + schoolUrl + ".dev.nascorp.vn",
	    auth: "auth.local." + schoolUrl + ".dev.nascorp.vn",
	    camp: "camp.local." + schoolUrl + ".dev.nascorp.vn",
	    asa: "asa.local." + schoolUrl + ".dev.nascorp.vn",
	    holiday: "holiday.local." + schoolUrl + ".dev.nascorp.vn",
	    bus: "bus.local." + schoolUrl + ".dev.nascorp.vn",
	    conference: "conference.local." + schoolUrl + ".dev.nascorp.vn",
	    reen: "reen.local." + schoolUrl + ".dev.nascorp.vn",
	    event: "event.local." + schoolUrl + ".dev.nascorp.vn",
	};
	exports.demoEnv = {
	    services: "services.demo.nascorp.vn",
	    auth: "auth.demo.nascorp.vn",
	    camp: "camp.demo.nascorp.vn",
	    asa: "asa.demo.nascorp.vn",
	    holiday: "holiday.demo.nascorp.vn",
	    bus: "bus.demo.nascorp.vn",
	    conference: "conference.demo.nascorp.vn",
	    reen: "reen.demo.nascorp.vn",
	    event: "event.demo.nascorp.vn",
	};
	exports.bisHanoiEnv = {
	    services: "services.bishanoi.nascorp.vn",
	    auth: "auth.bishanoi.nascorp.vn",
	    camp: "camp.bishanoi.nascorp.vn",
	    asa: "asa.bishanoi.nascorp.vn",
	    holiday: "holiday.bishanoi.nascorp.vn",
	    bus: "bus.bishanoi.nascorp.vn",
	    conference: "conference.bishanoi.nascorp.vn",
	    reen: "reen.bishanoi.nascorp.vn",
	    event: "event.bishanoi.nascorp.vn",
	};
	exports.bisHanoiDevEnv = {
	    services: "services.bishanoi.dev.nascorp.vn",
	    auth: "auth.bishanoi.dev.nascorp.vn",
	    camp: "camp.bishanoi.dev.nascorp.vn",
	    asa: "asa.bishanoi.dev.nascorp.vn",
	    holiday: "holiday.bishanoi.dev.nascorp.vn",
	    bus: "bus.bishanoi.dev.nascorp.vn",
	    conference: "conference.bishanoi.dev.nascorp.vn",
	    reen: "reen.bishanoi.dev.nascorp.vn",
	    event: "event.bishanoi.dev.nascorp.vn",
	};
	exports.bisHanoiStagingEnv = {
	    services: "services.bishanoistaging.nascorp.vn",
	    auth: "auth.bishanoistaging.nascorp.vn",
	    camp: "camp.bishanoistaging.nascorp.vn",
	    asa: "asa.bishanoistaging.nascorp.vn",
	    holiday: "holiday.bishanoistaging.nascorp.vn",
	    bus: "bus.bishanoistaging.nascorp.vn",
	    conference: "conference.bishanoistaging.nascorp.vn",
	    reen: "reen.bishanoistaging.nascorp.vn",
	    event: "event.bishanoistaging.nascorp.vn",
	};
	exports.ishcmcEnv = {
	    services: "services.ishcmc.nascorp.vn",
	    auth: "auth.ishcmc.nascorp.vn",
	    camp: "camp.ishcmc.nascorp.vn",
	    asa: "asa.ishcmc.nascorp.vn",
	    holiday: "holiday.ishcmc.nascorp.vn",
	    bus: "bus.ishcmc.nascorp.vn",
	    conference: "conference.ishcmc.nascorp.vn",
	    reen: "reen.ishcmc.nascorp.vn",
	    event: "event.ishcmc.nascorp.vn",
	};
	exports.aavnIshcmcEnv = {
	    services: "services.aavn.ishcmc.nascorp.vn",
	    auth: "auth.aavn.ishcmc.nascorp.vn",
	    camp: "camp.aavn.ishcmc.nascorp.vn",
	    asa: "asa.aavn.ishcmc.nascorp.vn",
	    holiday: "holiday.aavn.ishcmc.nascorp.vn",
	    bus: "bus.aavn.ishcmc.nascorp.vn",
	    conference: "conference.aavn.ishcmc.nascorp.vn",
	    reen: "reen.aavn.ishcmc.nascorp.vn",
	    event: "event.aavn.ishcmc.nascorp.vn",
	};
	exports.primaryIshcmcEnv = {
	    services: "services.primary.ishcmc.nascorp.vn",
	    auth: "auth.primary.ishcmc.nascorp.vn",
	    camp: "camp.primary.ishcmc.nascorp.vn",
	    asa: "asa.primary.ishcmc.nascorp.vn",
	    holiday: "holiday.primary.ishcmc.nascorp.vn",
	    bus: "bus.primary.ishcmc.nascorp.vn",
	    conference: "conference.primary.ishcmc.nascorp.vn",
	    reen: "reen.primary.ishcmc.nascorp.vn",
	    event: "event.primary.ishcmc.nascorp.vn",
	};
	exports.secondaryIshcmcEnv = {
	    services: "services.secondary.ishcmc.nascorp.vn",
	    auth: "auth.secondary.ishcmc.nascorp.vn",
	    camp: "camp.secondary.ishcmc.nascorp.vn",
	    asa: "asa.secondary.ishcmc.nascorp.vn",
	    holiday: "holiday.secondary.ishcmc.nascorp.vn",
	    bus: "bus.secondary.ishcmc.nascorp.vn",
	    conference: "conference.secondary.ishcmc.nascorp.vn",
	    reen: "reen.secondary.ishcmc.nascorp.vn",
	    event: "event.secondary.ishcmc.nascorp.vn",
	};
	exports.isspEnv = {
	    services: "services.issp.nascorp.vn",
	    auth: "auth.issp.nascorp.vn",
	    camp: "camp.issp.nascorp.vn",
	    asa: "asa.issp.nascorp.vn",
	    holiday: "holiday.issp.nascorp.vn",
	    bus: "bus.issp.nascorp.vn",
	    conference: "conference.issp.nascorp.vn",
	    reen: "reen.issp.nascorp.vn",
	    event: "event.issp.nascorp.vn",
	};
	exports.demoHelenEnv = {
	    services: "services.demo.helen.edu.vn",
	    auth: "auth.demo.helen.edu.vn",
	    camp: "camp.demo.helen.edu.vn",
	    asa: "asa.demo.helen.edu.vn",
	    holiday: "holiday.demo.helen.edu.vn",
	    bus: "bus.demo.helen.edu.vn",
	    conference: "conference.demo.helen.edu.vn",
	    reen: "reen.demo.helen.edu.vn",
	    event: "event.demo.helen.edu.vn",
	};
	exports.demoJeduEnv = {
	    services: "services.demo.jedu.edu.vn",
	    auth: "auth.demo.jedu.edu.vn",
	    camp: "camp.demo.jedu.edu.vn",
	    asa: "asa.demo.jedu.edu.vn",
	    holiday: "holiday.demo.jedu.edu.vn",
	    bus: "bus.demo.jedu.edu.vn",
	    conference: "conference.demo.jedu.edu.vn",
	    reen: "reen.demo.jedu.edu.vn",
	    event: "event.demo.jedu.edu.vn",
	};


/***/ }),

/***/ 86:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div id=\"app-main-menu\">\n\t<!-- Hamburger Menu -->\n\t<div class=\"hamburger-menu\">\n\t\t<a href=\"#\">\n\t\t\t<i class=\"material-icons\">menu</i>\n\t\t</a>\n\t</div>\n\t<div class=\"container\">\n\t\t<div class=\"top-bar\">\n\t\t\t<!--Top bar left-->\n\t\t\t<div class=\"top-bar-left\">\n\t\t\t\t<!-- Logo -->\n\t\t\t\t<div class=\"logo\">\n\t\t\t\t\t<a (click)=\"toHomePage()\"><img src=\"" + __webpack_require__(87) + "\"></a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!--End of Top bar left-->\n\n\t\t\t<!--Top bar right-->\n\t\t\t<div class=\"top-bar-right\">\n\t\t\t\t<!-- Menu Items -->\n\t\t\t\t<div class=\"main-right-menu\">\n\t\t\t\t\t<ul class=\"menu\" *ngIf=\"menuStatus\">\n\t\t\t\t\t\t<!--Main Menu list-->\n\t\t\t\t\t\t<li *ngFor=\"let menu of menuList;\">\n\t\t\t\t\t\t\t<div *ngIf=\"!userData\">\n\t\t\t\t\t\t\t\t<!-- Show if menu is a route -->\n\t\t\t\t\t\t\t\t<a *ngIf=\"menu.type==='route'\" routerLink=\"{{menu.url}}\" routerLinkActive=\"active\">\n\t\t\t\t\t\t\t\t\t{{menu.label}}\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t<!-- Show if menu is a static menu -->\n\t\t\t\t\t\t\t\t<a *ngIf=\"menu.type==='link'\" href=\"{{menu.url}}\" target=\"{{menu.target}}\">\n\t\t\t\t\t\t\t\t\t{{menu.label}}\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t\t<!-- Show user menu item if have user data from session -->\n\t\t\t\t\t\t<li *ngIf=\"userData\" class=\"user-profile-menu\" [menuHover]=\"userMenuClassVisible\">\n\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t<a>\n\t\t\t\t\t\t\t\t\t<span>Hi, {{userData.name.split('@')[0]}}</span>\n\t\t\t\t\t\t\t\t\t<i class=\"material-icons\">keyboard_arrow_down</i>\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<ul class=\"\">\n\t\t\t\t\t\t\t\t<li>\n\t\t\t\t\t\t\t\t\t<a (click)=\"toChangePassword()\">Change Password</a>\n\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t<li *ngIf=\"!checkAccountIsVasParent()\">\n\t\t\t\t\t\t\t\t\t<a (click)=\"toProfile()\">Profile</a>\n\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t<li>\n\t\t\t\t\t\t\t\t\t<a (click)=\"toLogOut()\">Logout</a>\n\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t</ul>\n\t\t\t\t</div>\n\t\t\t\t<!--New sub menu for module-->\n\t\t\t\t<ul class=\"sub-menu\" *ngIf=\"userData\" >\n\t\t\t\t\t<!--Main Menu list-->\n\t\t\t\t\t<li *ngFor=\"let menu of subMenuList\">\n\t\t\t\t\t\t<!-- Show if menu is a route -->\n\t\t\t\t\t\t<a *ngIf=\"menu.type === 'route'\" routerLink=\"{{menu.url}}\" routerLinkActive=\"active\">\n\t\t\t\t\t\t\t{{menu.label}}\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\t<!-- Show if menu is a static menu -->\n\t\t\t\t\t\t<a *ngIf=\"menu.type === 'link'\" href=\"{{menu.url}}\" target=\"{{menu.target}}\">\n\t\t\t\t\t\t\t{{menu.label}}\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</li>\n\t\t\t\t</ul>\n\t\t\t\t<!--End of sub menu-->\n\t\t\t</div>\n\t\t\t<!--End of top bar right-->\n\t\t</div>\n\t\t<!--End of top bar-->\n\t</div>\n</div>";

/***/ }),

/***/ 87:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/helen-logo.04cf3a7917571dd46d711c96e16a5ed6.png";

/***/ }),

/***/ 88:
/***/ (function(module, exports) {

	module.exports = "#app-main-menu{background-color:#00707e;position:relative}#app-main-menu .hamburger-menu{display:none}#app-main-menu .top-bar{background:transparent;padding:0}#app-main-menu .top-bar .top-bar-left{flex:0.5 0.5 0px;background-color:#00707e;height:100%}#app-main-menu .top-bar .top-bar-left .logo{height:100%;display:flex;align-items:center;justify-content:flex-start}#app-main-menu .top-bar .top-bar-right{padding-top:1rem}#app-main-menu .logo>a{display:inline-block}#app-main-menu .logo>a img{height:116px}#app-main-menu .sub-menu{float:right;background:transparent;font-size:0.9rem}#app-main-menu .sub-menu li{list-style:none;display:inline-block;text-transform:uppercase}#app-main-menu .sub-menu li a{display:block;color:#fff;padding:0.5rem;margin:0 0.3rem}#app-main-menu .sub-menu li a.active{border-bottom:solid 2px #ffae00}#app-main-menu .main-right-menu{float:right}#app-main-menu .main-right-menu .menu{background-color:#00707e}#app-main-menu .main-right-menu .menu>li>div>a{padding:0.5rem 1rem;border-radius:0.2rem;margin-left:1rem;min-width:6.25rem;border:1px solid #00707e;color:#fff;text-align:center}#app-main-menu .main-right-menu .menu>li>div>a:hover,#app-main-menu .main-right-menu .menu>li>div>a.active{background-color:#faa635;border:1px solid #faa635;color:#00707e;border:1px solid #00707e}#app-main-menu .main-right-menu .menu>li>div>a>i{margin:0}#app-main-menu .main-right-menu .menu>li.user-profile-menu{position:relative}#app-main-menu .main-right-menu .menu>li.user-profile-menu div>a{margin-bottom:0.5rem;line-height:23px;display:inline-block;padding-top:0}#app-main-menu .main-right-menu .menu>li.user-profile-menu div>a span{display:inline-block}#app-main-menu .main-right-menu .menu>li.user-profile-menu div>a i{display:inline-block;position:relative;top:6px}#app-main-menu .main-right-menu .menu>li.user-profile-menu>ul{list-style:none;border-radius:0.2rem;position:absolute;z-index:2;right:0;width:130%;display:none}#app-main-menu .main-right-menu .menu>li.user-profile-menu.menu-list-visible>ul{display:block;box-shadow:0 8px 10px 1px rgba(0,0,0,0.14),0 3px 14px 2px rgba(0,0,0,0.12),0 5px 5px -3px rgba(0,0,0,0.2)}#app-main-menu .main-right-menu .menu>li.user-profile-menu.menu-list-visible>ul>li>a{display:block;padding:0.4rem 1rem;border-radius:0.2rem}#app-main-menu .main-right-menu .menu>li.user-profile-menu.menu-list-visible>ul>li>a:hover{background-color:#faa635;color:#00707e}@media only screen and (max-width: 40em){#app-main-menu{height:auto;min-height:4rem}#app-main-menu .hamburger-menu{position:absolute;display:none;left:0;top:50%;transform:translateY(-50%);-ms-transform:translateY(-50%);-webkit-transform:translateY(-50%)}#app-main-menu .hamburger-menu>a{color:#fff;font-size:2rem}#app-main-menu .hamburger-menu>a>i{padding:1rem}#app-main-menu .logo{padding:0.4rem;margin:0 auto}#app-main-menu .logo>a{margin:0 auto;min-height:3rem}#app-main-menu .main-right-menu{display:none}#app-main-menu .top-bar-left{flex:none !important}}\n"

/***/ }),

/***/ 89:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var MenuService_1 = __webpack_require__(70);
	var TopMenuComponent = (function () {
	    function TopMenuComponent(menuService) {
	        this.menuService = menuService;
	    }
	    TopMenuComponent.prototype.ngOnInit = function () {
	        /** TO DO
	         * Get current language from cookie/session
	         * If no language data from it, set default language as English
	         */
	        this.currentLang = 'en';
	        // Get Top Menu List
	        this.menuList = this.menuService.getMenuList('top');
	        // Get Social Connect Menu List
	        this.socialMenuList = this.menuService.getMenuList('social-top');
	    };
	    return TopMenuComponent;
	}());
	TopMenuComponent = __decorate([
	    core_1.Component({
	        selector: 'top-menu',
	        template: __webpack_require__(90),
	        styles: [__webpack_require__(91)],
	        providers: [
	            MenuService_1.MenuService
	        ]
	    }),
	    __metadata("design:paramtypes", [MenuService_1.MenuService])
	], TopMenuComponent);
	exports.TopMenuComponent = TopMenuComponent;


/***/ }),

/***/ 90:
/***/ (function(module, exports) {

	module.exports = "<div id=\"app-top-menu\" class=\"top-bar\">\n    <!-- Left Menu List -->\n\t<div class=\"top-bar-left\" *ngIf=\"currentLang=='en'\">\n\t\t<ul class=\"menu\">\n\t\t\t<li *ngFor=\"let menu of menuList\">\n\t\t\t\t<a href=\"{{menu.url}}\" target=\"{{menu.target}}\">{{menu.label}}</a>\n\t\t\t</li>\n\t\t</ul>\n\t</div>\n\t<!-- Right Menu List -->\n\t<div class=\"top-bar-right\">\n\t\t<ul class=\"menu\">\n\t\t\t<li *ngFor=\"let sMenu of socialMenuList\">\n\t\t\t\t<a href=\"{{sMenu.url}}\" target=\"{{sMenu.target}}\">\n\t\t\t\t<i class=\"fa fa-{{sMenu.id}}\"></i></a>\n\t\t\t</li>\n\t\t</ul>\n\t</div>\n</div>";

/***/ }),

/***/ 91:
/***/ (function(module, exports) {

	module.exports = "#app-top-menu{background-color:#064180;padding:0rem 4rem}#app-top-menu .menu{background-color:#064180}#app-top-menu .menu>li>a{padding:0.5rem;color:#fff}#app-top-menu .menu>li>a:hover{color:#faa635}#app-top-menu .top-bar-left .menu>li>a{padding:0.6rem 0.3rem;font-size:0.8rem}#app-top-menu .top-bar-right{flex:0 0 0px !important}@media only screen and (max-width: 40em){#app-top-menu{padding:0;overflow-x:hidden}#app-top-menu .menu{height:0}}\n"

/***/ }),

/***/ 92:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var MenuHoverDirective = (function () {
	    function MenuHoverDirective(el, renderer) {
	        this.el = el;
	        this.renderer = renderer;
	    }
	    MenuHoverDirective.prototype.onMouseEnter = function () {
	        this.setClass(this.className, true);
	    };
	    MenuHoverDirective.prototype.onMouseLeave = function () {
	        this.setClass(this.className, false);
	    };
	    MenuHoverDirective.prototype.setClass = function (className, isAdd) {
	        this.renderer.setElementClass(this.el.nativeElement, className, isAdd);
	    };
	    return MenuHoverDirective;
	}());
	__decorate([
	    core_1.Input('menuHover'),
	    __metadata("design:type", String)
	], MenuHoverDirective.prototype, "className", void 0);
	__decorate([
	    core_1.HostListener('mouseenter'),
	    __metadata("design:type", Function),
	    __metadata("design:paramtypes", []),
	    __metadata("design:returntype", void 0)
	], MenuHoverDirective.prototype, "onMouseEnter", null);
	__decorate([
	    core_1.HostListener('mouseleave'),
	    __metadata("design:type", Function),
	    __metadata("design:paramtypes", []),
	    __metadata("design:returntype", void 0)
	], MenuHoverDirective.prototype, "onMouseLeave", null);
	MenuHoverDirective = __decorate([
	    core_1.Directive({
	        selector: '[menuHover]'
	    }),
	    __metadata("design:paramtypes", [core_1.ElementRef, core_1.Renderer])
	], MenuHoverDirective);
	exports.MenuHoverDirective = MenuHoverDirective;


/***/ }),

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var AdminService_1 = __webpack_require__(84);
	var SessionService_1 = __webpack_require__(94);
	var config_1 = __webpack_require__(85);
	var $ = __webpack_require__(95);
	var AdminHeaderComponent = (function () {
	    // For logout navigate
	    function AdminHeaderComponent(adminService, sessionService, router) {
	        this.adminService = adminService;
	        this.sessionService = sessionService;
	        this.router = router;
	        // For change password
	        this.isShow = false;
	        this.isShowChangePassword = false;
	        this.oldPassword = "";
	        this.newPassword = "";
	        this.confirmPassword = "";
	        this.isOPassWrong = false;
	        this.oPassCheck = '';
	        //message
	        this.msgs = [];
	    }
	    AdminHeaderComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.getSession();
	        this.hostName = window.location.hostname;
	        this.headerName = this.getHeaderName(this.module);
	        this.subscription = this.adminService.adminDataChanged$.subscribe(function (admin) {
	            _this.onSessionChanged(admin);
	        });
	        // Get Admin session
	        this.adminData = this.adminService.getAdminSessionData();
	    };
	    AdminHeaderComponent.prototype.ngOnDestroy = function () {
	        // Destroy the subscription for session changes
	        this.subscription.unsubscribe();
	    };
	    AdminHeaderComponent.prototype.showDropDown = function () {
	        this.isShow = !this.isShow;
	    };
	    //on click outside,close div 
	    AdminHeaderComponent.prototype.onClickOutside = function (event) {
	        if (event && event['value'] === true) {
	            this.isShow = false;
	        }
	    };
	    AdminHeaderComponent.prototype.changePassword = function () {
	        this.isShowChangePassword = !this.isShowChangePassword;
	    };
	    AdminHeaderComponent.prototype.onSubmitChangePassword = function (myForm) {
	        var adminPassword = {
	            role: this.adminData.role,
	            username: this.adminData.name,
	            password: {
	                old: this.oldPassword,
	                new: this.newPassword
	            }
	        };
	        this.postPassword(adminPassword, myForm);
	    };
	    AdminHeaderComponent.prototype.onCloseChangePassword = function (myForm) {
	        this.clearPass();
	        myForm.resetForm();
	    };
	    /**
	    * Post password to change admin ldap password
	    * @param {adminPassword} - admin credential input
	    * @return none
	    */
	    AdminHeaderComponent.prototype.postPassword = function (adminPassword, myForm) {
	        var _this = this;
	        this.sessionService.changeAdminPassword(adminPassword)
	            .subscribe(function (result) {
	            _this.isShowChangePassword = false;
	            _this.clearPass();
	            //reset form state
	            myForm.resetForm();
	            _this.msgs.push({
	                severity: 'success',
	                summary: 'Success',
	                detail: 'Password has been updated'
	            });
	        }, function (err) {
	            _this.oPassCheck = _this.oldPassword;
	            if (err.status == 401) {
	                _this.isOPassWrong = true;
	                //focus old password
	                setTimeout(function () {
	                    $('#opass').focus();
	                }, 10);
	            }
	            else {
	                _this.msgs.push({
	                    severity: 'error',
	                    summary: 'Error',
	                    detail: 'Something went wrong. Please try again'
	                });
	            }
	        });
	    };
	    AdminHeaderComponent.prototype.clearPass = function () {
	        this.oldPassword = '';
	        this.newPassword = '';
	        this.confirmPassword = '';
	    };
	    AdminHeaderComponent.prototype.onSessionChanged = function (admin) {
	        //TO DO: update menu content when session changed
	        this.adminData = admin;
	        this.sidebarStatus = this.getSidebarStatus();
	    };
	    AdminHeaderComponent.prototype.getSession = function () {
	        var _this = this;
	        this.sessionService.getSession()
	            .subscribe(function (admin) {
	            _this.adminData = admin;
	            _this.sidebarStatus = _this.getSidebarStatus();
	        }, function (error) {
	        });
	    };
	    AdminHeaderComponent.prototype.toHomePage = function () {
	        // Redirect to desired URL                    
	        if (Object.values(config_1.devEnv).indexOf(this.hostName) !== -1) {
	            return window.location.href = "http://" + config_1.devEnv.services;
	        }
	        else if (Object.values(config_1.demoEnv).indexOf(this.hostName) !== -1) {
	            return window.location.href = "http://" + config_1.demoEnv.services;
	        }
	        else if (Object.values(config_1.bisHanoiEnv).indexOf(this.hostName) !== -1) {
	            return window.location.href = "http://" + config_1.bisHanoiEnv.services;
	        }
	        else if (Object.values(config_1.bisHanoiDevEnv).indexOf(this.hostName) !== -1) {
	            return window.location.href = "http://" + config_1.bisHanoiDevEnv.services;
	        }
	        else if (Object.values(config_1.bisHanoiStagingEnv).indexOf(this.hostName) !== -1) {
	            return window.location.href = "http://" + config_1.bisHanoiStagingEnv.services;
	        }
	        else if (Object.values(config_1.ishcmcEnv).indexOf(this.hostName) !== -1) {
	            return window.location.href = "http://" + config_1.ishcmcEnv.services;
	        }
	        else if (Object.values(config_1.aavnIshcmcEnv).indexOf(this.hostName) !== -1) {
	            return window.location.href = "http://" + config_1.aavnIshcmcEnv.services;
	        }
	        else if (Object.values(config_1.primaryIshcmcEnv).indexOf(this.hostName) !== -1) {
	            return window.location.href = "http://" + config_1.primaryIshcmcEnv.services;
	        }
	        else if (Object.values(config_1.secondaryIshcmcEnv).indexOf(this.hostName) !== -1) {
	            return window.location.href = "http://" + config_1.secondaryIshcmcEnv.services;
	        }
	        else if (Object.values(config_1.isspEnv).indexOf(this.hostName) !== -1) {
	            return window.location.href = "http://" + config_1.isspEnv.services;
	        }
	        else if (Object.values(config_1.demoHelenEnv).indexOf(this.hostName) !== -1) {
	            return window.location.href = "http://" + config_1.demoHelenEnv.services;
	        }
	        else if (Object.values(config_1.testEnv).indexOf(this.hostName) !== -1) {
	            return window.location.href = "http://" + config_1.testEnv.services;
	        }
	        else if (Object.values(config_1.stagingEnv).indexOf(this.hostName) !== -1) {
	            return window.location.href = "http://" + config_1.stagingEnv.services;
	        }
	        else if (Object.values(config_1.procEnv).indexOf(this.hostName) !== -1) {
	            return window.location.href = "http://" + config_1.procEnv.services;
	        }
	        else {
	            return window.location.href = "http://" + config_1.localEnv.services;
	        }
	    };
	    // Detect sidebar vibibility
	    AdminHeaderComponent.prototype.getSidebarStatus = function () {
	        return !this.adminData ? false : true;
	    };
	    AdminHeaderComponent.prototype.getHeaderName = function (moduleName) {
	        var headerName = "";
	        switch (this.module) {
	            case "camp":
	                headerName = "Camp Programmes Management";
	                break;
	            case "asa":
	                headerName = "After School Activities Management";
	                break;
	            case "bus":
	                headerName = "Bus Programmes Management";
	            case "reen":
	                headerName = "";
	            default:
	                break;
	        }
	        return headerName;
	    };
	    // Log our function
	    AdminHeaderComponent.prototype.deleteSession = function () {
	        var _this = this;
	        // console.log(this.hostName)
	        this.module = 'auth';
	        this.sessionService.deleteAdminSession()
	            .subscribe(function (complete) {
	            // Clear user session
	            _this.adminService.clearAdminSessionData();
	            // Fire user session data changed event
	            _this.adminService.adminDataChanged(null);
	            // Redirect to desired URL
	            if (Object.values(config_1.devEnv).indexOf(_this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.devEnv.auth + "/login";
	            }
	            else if (Object.values(config_1.demoEnv).indexOf(_this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.demoEnv.auth + "/login";
	            }
	            else if (Object.values(config_1.bisHanoiEnv).indexOf(_this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.bisHanoiEnv.auth + "/login";
	            }
	            else if (Object.values(config_1.bisHanoiDevEnv).indexOf(_this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.bisHanoiDevEnv.auth + "/login";
	            }
	            else if (Object.values(config_1.bisHanoiStagingEnv).indexOf(_this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.bisHanoiStagingEnv.auth + "/login";
	            }
	            else if (Object.values(config_1.ishcmcEnv).indexOf(_this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.ishcmcEnv.auth + "/login";
	            }
	            else if (Object.values(config_1.aavnIshcmcEnv).indexOf(_this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.aavnIshcmcEnv.auth + "/login";
	            }
	            else if (Object.values(config_1.primaryIshcmcEnv).indexOf(_this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.primaryIshcmcEnv.auth + "/login";
	            }
	            else if (Object.values(config_1.secondaryIshcmcEnv).indexOf(_this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.secondaryIshcmcEnv.auth + "/login";
	            }
	            else if (Object.values(config_1.isspEnv).indexOf(_this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.isspEnv.auth + "/login";
	            }
	            else if (Object.values(config_1.demoHelenEnv).indexOf(_this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.demoHelenEnv.auth + "/login";
	            }
	            else if (Object.values(config_1.testEnv).indexOf(_this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.testEnv.auth + "/login";
	            }
	            else if (Object.values(config_1.stagingEnv).indexOf(_this.hostName) !== -1) {
	                return window.location.href = "https://" + config_1.stagingEnv.auth + "/login";
	            }
	            else if (Object.values(config_1.procEnv).indexOf(_this.hostName) !== -1) {
	                return window.location.href = "https://" + config_1.procEnv.auth + "/login";
	            }
	            else {
	                return window.location.href = "http://" + config_1.localEnv.auth + "/login";
	            }
	        }, function (error) { return _this.errorMessage = error; });
	    };
	    return AdminHeaderComponent;
	}());
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], AdminHeaderComponent.prototype, "module", void 0);
	AdminHeaderComponent = __decorate([
	    core_1.Component({
	        selector: 'admin-header',
	        template: __webpack_require__(96),
	        styles: [__webpack_require__(98)]
	    }),
	    __metadata("design:paramtypes", [AdminService_1.AdminService,
	        SessionService_1.SessionService,
	        router_1.Router])
	], AdminHeaderComponent);
	exports.AdminHeaderComponent = AdminHeaderComponent;


/***/ }),

/***/ 94:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var services_1 = __webpack_require__(58);
	var SessionService = (function () {
	    function SessionService(settingService, apiService) {
	        this.settingService = settingService;
	        this.apiService = apiService;
	        this.sessionUrl = '/session';
	        this.apiUrl = '';
	        this.apiUrl = this.settingService.getSetting('api_service_domain');
	    }
	    SessionService.prototype.getSession = function () {
	        var requestUrl = this.apiUrl + this.sessionUrl;
	        // Call Get Method from Api Service
	        return this.apiService.get(requestUrl);
	    };
	    SessionService.prototype.postAdminSession = function (adminCredential) {
	        var requestUrl = '/ldap?' + 'username=' + adminCredential.username + '&password=' + adminCredential.password;
	        var body = JSON.stringify({
	            'role': adminCredential.role,
	            'username': adminCredential.username,
	            'password': adminCredential.password
	        });
	        // Call Get Method from Api Service
	        return this.apiService.post(requestUrl, body);
	    };
	    SessionService.prototype.deleteAdminSession = function () {
	        // const requestUrl = 'http://auth.eca.nascorp.vn/logout';
	        var requestUrl = this.apiUrl + this.sessionUrl;
	        return this.apiService.delete(requestUrl);
	    };
	    SessionService.prototype.changeAdminPassword = function (adminPassword) {
	        var requestUrl = this.apiUrl + '/ldap-change-password';
	        var body = JSON.stringify({
	            'username': adminPassword.username,
	            'oldPassword': adminPassword.password.old,
	            'newPassword': adminPassword.password.new,
	        });
	        // Call Get Method from Api Service
	        return this.apiService.post(requestUrl, body);
	    };
	    return SessionService;
	}());
	SessionService = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [services_1.SettingService,
	        services_1.ApiService])
	], SessionService);
	exports.SessionService = SessionService;


/***/ }),

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"header row\">\n    <h1 class=\"large-2\"><img src=\"" + __webpack_require__(97) + "\" /></h1>\n    <div class=\"header-info large-10\">\n        <div class=\"component-name\">\n            <h3>{{headerName}}</h3>\n        </div>\n\n        <!-- Logout for module Bus : -->\n        <div *ngIf=\"module == 'bus'\">\n            <div\n                *ngIf=\"adminData\"\n                click-outside\n                (clickOutside)=\"onClickOutside($event)\"\n                class=\"dropdown\"\n                (click)=\"showDropDown()\"\n            >\n                <a class=\"dropbtn\">{{ adminData.name }}</a>\n                <i class=\"material-icons\">arrow_drop_down</i>\n                <div *ngIf=\"isShow\" class=\"dropdown-content\">\n                    <a (click)=\"changePassword()\"\n                        >{{ 'DATA_CHANGE_PASSWORD' | translate }}</a\n                    >\n                    <a *ngIf=\"sidebarStatus\" (click)=\"deleteSession()\"\n                        >{{ 'DATA_LOGOUT' | translate}}</a\n                    >\n                </div>\n            </div>\n        </div>\n\n        <div *ngIf=\"module != 'bus'\">\n            <ul *ngIf=\"sidebarStatus\">\n                <li>\n                    <a (click)=\"deleteSession()\"\n                        >{{ 'DATA_LOGOUT' | translate}}</a\n                    >\n                </li>\n            </ul>\n        </div>\n    </div>\n</div>\n\n<!--Change Password Dialog-->\n<p-dialog\n    header=\"{{ 'DATA_CHANGE_PASSWORD' | translate }}\"\n    [(visible)]=\"isShowChangePassword\"\n    (onBeforeHide)=\"onCloseChangePassword(f)\"\n    [draggable]=\"false\"\n    [resizable]=\"false\"\n    [modal]=\"true\"\n    [closable]=\"true\"\n    [responsive]=\"true\"\n    [appendTo]=\"body\"\n    width=\"500\"\n>\n    <form #f=\"ngForm\" (ngSubmit)=\"onSubmitChangePassword(f)\">\n        <div class=\"dialog-content\" style=\"text-align: center\">\n            <div class=\"form-group\">\n                <input\n                    id=\"opass\"\n                    [(ngModel)]=\"oldPassword\"\n                    name=\"old-password\"\n                    type=\"password\"\n                    placeholder=\"Old Password\"\n                    #oPass=\"ngModel\"\n                    required\n                />\n                <div\n                    *ngIf=\"oPass.errors && (oPass.dirty || oPass.touched)\"\n                    class=\"alert alert-danger\"\n                >\n                    <span\n                        class=\"alert alert-danger\"\n                        [hidden]=\"oPass.error?.required\"\n                    >\n                        {{ 'DATA_PASSWORD_REQUIRED' | translate }}\n                    </span>\n                </div>\n                <div\n                    *ngIf=\"isOPassWrong && oPassCheck == oldPassword\"\n                    class=\"alert alert-danger\"\n                >\n                    <span class=\"alert alert-danger\">\n                        {{ 'DATA_WRONG_OLD_PASSWORD' | translate }}\n                    </span>\n                </div>\n            </div>\n            <div class=\"form-group\">\n                <input\n                    [(ngModel)]=\"newPassword\"\n                    name=\"new-password\"\n                    type=\"password\"\n                    placeholder=\"New Password\"\n                    pattern=\"{{ cPass.value }}\"\n                    #nPass=\"ngModel\"\n                    required\n                />\n                <div\n                    *ngIf=\"oPass.value != '' && nPass.errors?.required && (nPass.dirty || nPass.touched)\"\n                    class=\"alert alert-danger\"\n                >\n                    <span> {{ 'DATA_PASSWORD_REQUIRED' | translate }} </span>\n                </div>\n            </div>\n            <div class=\"form-group\">\n                <input\n                    [(ngModel)]=\"confirmPassword\"\n                    name=\"confirm-password\"\n                    type=\"password\"\n                    placeholder=\"Re-type Password\"\n                    pattern=\"{{ nPass.value }}\"\n                    #cPass=\"ngModel\"\n                    required\n                />\n                <div\n                    *ngIf=\"nPass.value != '' && cPass.errors?.required && (cPass.dirty || cPass.touched)\"\n                    class=\"alert alert-danger\"\n                >\n                    <span> {{ 'DATA_PASSWORD_REQUIRED' | translate }} </span>\n                </div>\n                <div\n                    *ngIf=\"nPass.value != '' && cPass.errors?.pattern && cPass.touched\"\n                    class=\"alert alert-danger\"\n                >\n                    <span> {{ 'DATA_PASSWORD_MISMATCH' | translate }} </span>\n                </div>\n            </div>\n            <!-- <input   [(ngModel)]=\"confirmPassword\" name=\"confirm-password\" type=\"password\" placeholder=\"Re-type New Password\"/> -->\n        </div>\n        <div style=\"text-align: center\">\n            <br />\n            <button [disabled]=\"f.invalid\" type=\"submit\">\n                {{ 'DATA_BUTTON_CONFIRM' | translate }}\n            </button>\n        </div>\n    </form>\n</p-dialog>\n\n<p-growl [value]=\"msgs\"></p-growl>\n";

/***/ }),

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/helen-logo-1.fe25fba31d07bf0e867e6c43e1543fa2.png";

/***/ }),

/***/ 98:
/***/ (function(module, exports) {

	module.exports = ".alert-danger{text-align:left;margin:-12px 0px 12px 5px;font-style:normal;color:#f54c2f}.header.row{height:78px;border-bottom:1px solid #e1e4e9;position:fixed;left:0;top:0;width:100%;z-index:5;max-width:100%}.header.row h1{background:#fff;display:inline-block;text-align:center;margin-bottom:0;padding:0 1.3125rem;display:flex;align-items:center;justify-content:center}.header.row h1 img{width:46px;cursor:pointer}.header.row .header-info{background:#00707e;padding:0 2rem;overflow:hidden;width:calc(100% - 160px - 1.3125rem * 2)}.header.row .header-info .component-name{float:left}.header.row .header-info .component-name h3{font-size:0.875rem;color:#fff;line-height:78px;margin-bottom:0;display:inline-block}.header.row .header-info ul{float:right;margin:0;font-size:0.875rem;line-height:77px;list-style:none}.header.row .header-info ul li a{color:#fff}.header.row .header-info .dropdown{float:right;margin:0;font-size:0.875rem;line-height:80px;list-style:none;color:#fff;display:flex;cursor:pointer}.header.row .header-info .dropdown a{color:#fff}.header.row .header-info .dropdown i{line-height:3.2 !important}.header.row .header-info .dropdown .dropdown-content{position:absolute;background-color:#f9f9f9;min-width:160px;box-shadow:0px 8px 16px 0px rgba(0,0,0,0.2);z-index:1;margin-top:65px;right:30px}.header.row .header-info .dropdown .dropdown-content a{color:#414042;padding:10px 16px;text-decoration:none;display:block;line-height:2 !important}.header.row .header-info .dropdown .dropdown-content a:hover{background-color:#eee}\n"

/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var AdminService_1 = __webpack_require__(84);
	var SessionService_1 = __webpack_require__(94);
	var config_1 = __webpack_require__(85);
	var AdminHeaderAuthComponent = (function () {
	    // For logout navigate
	    function AdminHeaderAuthComponent(adminService, sessionService, router) {
	        this.adminService = adminService;
	        this.sessionService = sessionService;
	        this.router = router;
	    }
	    AdminHeaderAuthComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.getSession();
	        this.hostName = window.location.hostname;
	        this.headerName = this.getHeaderName(this.module);
	        this.subscription = this.adminService.adminDataChanged$.subscribe(function (admin) {
	            _this.onSessionChanged(admin);
	        });
	        // Get Admin session
	        this.adminData = this.adminService.getAdminSessionData();
	    };
	    AdminHeaderAuthComponent.prototype.ngOnDestroy = function () {
	        // Destroy the subscription for session changes
	        this.subscription.unsubscribe();
	    };
	    AdminHeaderAuthComponent.prototype.onSessionChanged = function (admin) {
	        //TO DO: update menu content when session changed
	        this.adminData = admin;
	        this.sidebarStatus = this.getSidebarStatus();
	    };
	    AdminHeaderAuthComponent.prototype.getSession = function () {
	        var _this = this;
	        this.sessionService.getSession()
	            .subscribe(function (admin) {
	            _this.adminData = admin;
	            _this.sidebarStatus = _this.getSidebarStatus();
	        }, function (error) {
	        });
	    };
	    AdminHeaderAuthComponent.prototype.toHomePage = function () {
	        // Redirect to desired URL                    
	        if (Object.values(config_1.devEnv).indexOf(this.hostName) !== -1) {
	            return window.location.href = "http://" + config_1.devEnv.services;
	        }
	        else if (Object.values(config_1.testEnv).indexOf(this.hostName) !== -1) {
	            return window.location.href = "http://" + config_1.testEnv.services;
	        }
	        else if (Object.values(config_1.bisHanoiEnv).indexOf(this.hostName) !== -1) {
	            return window.location.href = "http://" + config_1.bisHanoiEnv.services;
	        }
	        else if (Object.values(config_1.bisHanoiDevEnv).indexOf(this.hostName) !== -1) {
	            return window.location.href = "http://" + config_1.bisHanoiDevEnv.services;
	        }
	        else if (Object.values(config_1.stagingEnv).indexOf(this.hostName) !== -1) {
	            return window.location.href = "https://" + config_1.stagingEnv.services;
	        }
	        else if (Object.values(config_1.procEnv).indexOf(this.hostName) !== -1) {
	            return window.location.href = "https://" + config_1.procEnv.services;
	        }
	        else if (Object.values(config_1.demoEnv).indexOf(this.hostName) !== -1) {
	            return window.location.href = "http://" + config_1.demoEnv.services;
	        }
	        else {
	            return window.location.href = "http://" + config_1.localEnv.services;
	        }
	    };
	    // Detect sidebar vibibility
	    AdminHeaderAuthComponent.prototype.getSidebarStatus = function () {
	        return !this.adminData ? false : true;
	    };
	    AdminHeaderAuthComponent.prototype.getHeaderName = function (moduleName) {
	        var headerName = "";
	        switch (this.module) {
	            case "camp":
	                headerName = "Camp Programmes Management";
	                break;
	            case "asa":
	                headerName = "After School Activities Management";
	                break;
	            case "bus":
	                headerName = "Bus Management";
	                break;
	            case "reen":
	                headerName = "Re-enrolment";
	                break;
	            case "conference":
	                headerName = "Conference Booking System";
	                break;
	            default:
	                break;
	        }
	        return headerName;
	    };
	    // Log our function
	    AdminHeaderAuthComponent.prototype.deleteSession = function () {
	        var _this = this;
	        // In case system login and booking for parent. Then, logout and login again with role parent to booking. We need to remove sessionStorage 
	        if (this.module === 'conference') {
	            window.sessionStorage.removeItem('info-parent-booking');
	            window.sessionStorage.removeItem('interview-description');
	        }
	        this.sessionService.deleteAdminSession()
	            .subscribe(function (complete) {
	            // Clear user session
	            _this.adminService.clearAdminSessionData();
	            _this.adminService.clearInterSession();
	            // Fire user session data changed event
	            _this.adminService.adminDataChanged(null);
	            // Redirect to desired URL
	            if (Object.values(config_1.devEnv).indexOf(window.location.hostname) !== -1) {
	                return window.location.href = "http://" + config_1.devEnv.auth + "/login";
	            }
	            else if (Object.values(config_1.testEnv).indexOf(window.location.hostname) !== -1) {
	                return window.location.href = "http://" + config_1.testEnv.auth + "/login";
	            }
	            else if (Object.values(config_1.bisHanoiEnv).indexOf(window.location.hostname) !== -1) {
	                return window.location.href = "http://" + config_1.bisHanoiEnv.auth + "/login";
	            }
	            else if (Object.values(config_1.bisHanoiDevEnv).indexOf(window.location.hostname) !== -1) {
	                return window.location.href = "http://" + config_1.bisHanoiDevEnv.auth + "/login";
	            }
	            else if (Object.values(config_1.stagingEnv).indexOf(window.location.hostname) !== -1) {
	                return window.location.href = "https://" + config_1.stagingEnv.auth + "/login";
	            }
	            else if (Object.values(config_1.procEnv).indexOf(window.location.hostname) !== -1) {
	                return window.location.href = "https://" + config_1.procEnv.auth + "/login";
	            }
	            else if (Object.values(config_1.demoEnv).indexOf(window.location.hostname) !== -1) {
	                return window.location.href = "http://" + config_1.demoEnv.auth + "/login";
	            }
	            else {
	                return window.location.href = "http://" + config_1.localEnv.auth + "/login";
	            }
	        }, function (error) { return _this.errorMessage = error; });
	    };
	    return AdminHeaderAuthComponent;
	}());
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], AdminHeaderAuthComponent.prototype, "module", void 0);
	AdminHeaderAuthComponent = __decorate([
	    core_1.Component({
	        selector: 'admin-header-auth',
	        template: __webpack_require__(100),
	        styles: [__webpack_require__(101)]
	    }),
	    __metadata("design:paramtypes", [AdminService_1.AdminService,
	        SessionService_1.SessionService,
	        router_1.Router])
	], AdminHeaderAuthComponent);
	exports.AdminHeaderAuthComponent = AdminHeaderAuthComponent;


/***/ }),

/***/ 100:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div id=\"app-main-menu\">\n\t<!-- Hamburger Menu -->\n\t<div class=\"hamburger-menu\">\n\t\t<a href=\"#\">\n\t\t\t<i class=\"material-icons\">menu</i>\n\t\t</a>\n\t</div>\n\t<div class=\"container\">\n\t\t<div class=\"top-bar\">\n\t\t\t<!--Top bar left-->\n\t\t\t<div class=\"top-bar-left\">\n\t\t\t\t<!-- Logo -->\n\t\t\t\t<div class=\"logo\">\n\t\t\t\t\t<a (click)=\"toHomePage()\"><img src=\"" + __webpack_require__(87) + "\"></a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!--End of Top bar left-->\n\n\t\t\t<!--Top bar right-->\n\t\t\t<div class=\"top-bar-right\">\n\t\t\t\t<!-- Menu Items -->\n\t\t\t\t<div class=\"main-right-menu\">\n\t\t\t\t\t<ul class=\"menu\" *ngIf=\"menuStatus\">\n\t\t\t\t\t\t<!--Main Menu list-->\n\t\t\t\t\t\t<li *ngFor=\"let menu of menuList;\">\n\t\t\t\t\t\t\t<div *ngIf=\"!userData\">\n\t\t\t\t\t\t\t\t<!-- Show if menu is a route -->\n\t\t\t\t\t\t\t\t<a *ngIf=\"menu.type==='route'\" routerLink=\"{{menu.url}}\" routerLinkActive=\"active\">\n\t\t\t\t\t\t\t\t\t{{menu.label}}\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t<!-- Show if menu is a static menu -->\n\t\t\t\t\t\t\t\t<a *ngIf=\"menu.type==='link'\" href=\"{{menu.url}}\" target=\"{{menu.target}}\">\n\t\t\t\t\t\t\t\t\t{{menu.label}}\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t\t<!-- Show user menu item if have user data from session -->\n\t\t\t\t\t\t<li *ngIf=\"userData\" class=\"user-profile-menu\" [menuHover]=\"userMenuClassVisible\">\n\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t<a>\n\t\t\t\t\t\t\t\t\t<span>Hi, {{userData.name.split('@')[0]}}</span>\n\t\t\t\t\t\t\t\t\t<i class=\"material-icons\">keyboard_arrow_down</i>\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<ul class=\"\">\n\t\t\t\t\t\t\t\t<li>\n\t\t\t\t\t\t\t\t\t<a (click)=\"toChangePassword()\">Change Password</a>\n\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t<li *ngIf=\"!checkAccountIsVasParent()\">\n\t\t\t\t\t\t\t\t\t<a (click)=\"toProfile()\">Profile</a>\n\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t<li>\n\t\t\t\t\t\t\t\t\t<a (click)=\"deleteSession()\">Logout</a>\n\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t</ul>\n\t\t\t\t</div>\n\t\t\t\t<!--New sub menu for module-->\n\t\t\t\t<ul class=\"sub-menu\" *ngIf=\"userData\" >\n\t\t\t\t\t<!--Main Menu list-->\n\t\t\t\t\t<li *ngFor=\"let menu of subMenuList\">\n\t\t\t\t\t\t<!-- Show if menu is a route -->\n\t\t\t\t\t\t<a *ngIf=\"menu.type === 'route'\" routerLink=\"{{menu.url}}\" routerLinkActive=\"active\">\n\t\t\t\t\t\t\t{{menu.label}}\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\t<!-- Show if menu is a static menu -->\n\t\t\t\t\t\t<a *ngIf=\"menu.type === 'link'\" href=\"{{menu.url}}\" target=\"{{menu.target}}\">\n\t\t\t\t\t\t\t{{menu.label}}\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</li>\n\t\t\t\t</ul>\n\t\t\t\t<!--End of sub menu-->\n\t\t\t</div>\n\t\t\t<!--End of top bar right-->\n\t\t</div>\n\t\t<!--End of top bar-->\n\t</div>\n</div>";

/***/ }),

/***/ 101:
/***/ (function(module, exports) {

	module.exports = "#app-main-menu{background-color:#00707e;position:relative}#app-main-menu .hamburger-menu{display:none}#app-main-menu .top-bar{background:transparent;padding:0 0.5rem 0 0;height:116px}#app-main-menu .top-bar .top-bar-left{flex:0.2 0.5 0px;height:100%}#app-main-menu .top-bar .top-bar-left .logo{height:100%}#app-main-menu .top-bar .top-bar-right{padding-top:1rem}#app-main-menu .logo>a{display:inline-block}#app-main-menu .logo>a img{height:116px}#app-main-menu .sub-menu{float:right;background:transparent;font-size:0.9rem}#app-main-menu .sub-menu li{list-style:none;display:inline-block;text-transform:uppercase}#app-main-menu .sub-menu li a{display:block;color:#fff;padding:0.5rem;margin:0 0.3rem}#app-main-menu .sub-menu li a.active{border-bottom:solid 2px #ffae00}#app-main-menu .main-right-menu{float:right}#app-main-menu .main-right-menu .menu{background-color:#00707e}#app-main-menu .main-right-menu .menu>li>div>a{padding:0.5rem 1rem;border-radius:0.2rem;margin-left:1rem;min-width:6.25rem;border:1px solid #00707e;color:#fff;text-align:center}#app-main-menu .main-right-menu .menu>li>div>a:hover,#app-main-menu .main-right-menu .menu>li>div>a.active{background-color:#faa635;border:1px solid #faa635;color:#00707e;border:1px solid #00707e}#app-main-menu .main-right-menu .menu>li>div>a>i{margin:0}#app-main-menu .main-right-menu .menu>li.user-profile-menu{position:relative}#app-main-menu .main-right-menu .menu>li.user-profile-menu div>a{margin-bottom:0.5rem;line-height:23px;display:inline-block;padding-top:0}#app-main-menu .main-right-menu .menu>li.user-profile-menu div>a span{display:inline-block}#app-main-menu .main-right-menu .menu>li.user-profile-menu div>a i{display:inline-block;position:relative;top:6px}#app-main-menu .main-right-menu .menu>li.user-profile-menu>ul{list-style:none;border-radius:0.2rem;position:absolute;z-index:2;right:0;width:130%;display:none}#app-main-menu .main-right-menu .menu>li.user-profile-menu.menu-list-visible>ul{display:block;box-shadow:0 8px 10px 1px rgba(0,0,0,0.14),0 3px 14px 2px rgba(0,0,0,0.12),0 5px 5px -3px rgba(0,0,0,0.2)}#app-main-menu .main-right-menu .menu>li.user-profile-menu.menu-list-visible>ul>li>a{display:block;padding:0.4rem 1rem;border-radius:0.2rem}#app-main-menu .main-right-menu .menu>li.user-profile-menu.menu-list-visible>ul>li>a:hover{background-color:#faa635;color:#00707e}@media only screen and (max-width: 40em){#app-main-menu{height:auto;min-height:4rem}#app-main-menu .hamburger-menu{position:absolute;display:none;left:0;top:50%;transform:translateY(-50%);-ms-transform:translateY(-50%);-webkit-transform:translateY(-50%)}#app-main-menu .hamburger-menu>a{color:#fff;font-size:2rem}#app-main-menu .hamburger-menu>a>i{padding:1rem}#app-main-menu .logo{padding:0.4rem;margin:0 auto}#app-main-menu .logo>a{margin:0 auto;min-height:3rem}#app-main-menu .main-right-menu{display:none}#app-main-menu .top-bar-left{flex:none !important}}\n"

/***/ }),

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var MenuService_1 = __webpack_require__(70);
	var AdminService_1 = __webpack_require__(84);
	var SessionService_1 = __webpack_require__(94);
	var core_2 = __webpack_require__(103);
	var AdminSidebarComponent = (function () {
	    function AdminSidebarComponent(translate, menuService, adminService, sessionService) {
	        this.translate = translate;
	        this.menuService = menuService;
	        this.adminService = adminService;
	        this.sessionService = sessionService;
	        this.hideMenu = new core_1.EventEmitter();
	        this.isSmall = false;
	        this.isShowText = false;
	    }
	    AdminSidebarComponent.prototype.toggleSmallSidebard = function () {
	        this.isSmall = !this.isSmall;
	        this.hideMenu.emit(this.isShowText);
	    };
	    AdminSidebarComponent.prototype.animationDone = function (event) {
	        if (event.fromState == "inactive") {
	            this.isShowText = !this.isShowText;
	        }
	    };
	    AdminSidebarComponent.prototype.animationStart = function (event) {
	        if (event.fromState == "active") {
	            this.isShowText = !this.isShowText;
	        }
	    };
	    AdminSidebarComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.getSession();
	        // Get Sidebar menu list
	        var sidebarName = this.getSidebarName(this.module);
	        this.sidebar = this.menuService.getMenuList(sidebarName);
	        this.subscription = this.adminService.adminDataChanged$.subscribe(function (admin) {
	            _this.onSessionChanged(admin);
	        });
	        if (sidebarName == "bus-admin-sidebar") {
	            this.sidebar.forEach(function (e) {
	                if (e.id == "bus-schedule")
	                    e.label = 'DATA_MENU_DAILY_TRANSPORT_LIST';
	                else if (e.id == "bus-student-management")
	                    e.label = 'DATA_MENU_STUDENT_REPORT';
	                else if (e.id == "bus-report")
	                    e.label = 'DATA_MENU_BUS_REPORT';
	                else if (e.id == "bus-settings")
	                    e.label = 'DATA_MENU_SETTINGS';
	            });
	        }
	    };
	    AdminSidebarComponent.prototype.ngOnDestroy = function () {
	        // Destroy the subscription for session changes
	        this.subscription.unsubscribe();
	    };
	    /**
	     * Action that fired when the session change event is catched.
	     * Update the adminData & the menuList.
	     */
	    AdminSidebarComponent.prototype.onSessionChanged = function (admin) {
	        //TO DO: update menu content when session changed
	        this.adminData = admin;
	    };
	    AdminSidebarComponent.prototype.getSidebarStatus = function () {
	        if (!this.adminData) {
	            return false;
	        }
	        else {
	            return true;
	        }
	    };
	    AdminSidebarComponent.prototype.getSidebarName = function (moduleName) {
	        var sidebarName = "";
	        switch (moduleName) {
	            case "camp":
	                sidebarName = "camp-admin-sidebar";
	                break;
	            case "asa":
	                sidebarName = "asa-admin-sidebar";
	                break;
	            case "bus":
	                sidebarName = "bus-admin-sidebar";
	                break;
	            case "holiday":
	                sidebarName = "holiday-admin-sidebar";
	                break;
	            case "reen":
	                sidebarName = "reen-admin-sidebar";
	                break;
	            default:
	                break;
	        }
	        return sidebarName;
	    };
	    // Check user role to show/hide option
	    AdminSidebarComponent.prototype.accessible = function (role) {
	        if (!role.length) {
	            return true;
	        }
	        return role.indexOf(this.adminData.role) !== -1 ? true : false;
	    };
	    AdminSidebarComponent.prototype.getSession = function () {
	        var _this = this;
	        this.sessionService.getSession()
	            .subscribe(function (admin) {
	            _this.adminData = admin;
	            _this.sidebarStatus = _this.getSidebarStatus();
	        }, function (error) {
	            //TO DO: Handle any error if needed in the furture
	            _this.message = "";
	            _this.messageType = "alert";
	        });
	    };
	    return AdminSidebarComponent;
	}());
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", String)
	], AdminSidebarComponent.prototype, "module", void 0);
	__decorate([
	    core_1.Output(),
	    __metadata("design:type", core_1.EventEmitter)
	], AdminSidebarComponent.prototype, "hideMenu", void 0);
	AdminSidebarComponent = __decorate([
	    core_1.Component({
	        selector: 'admin-sidebar',
	        template: __webpack_require__(121),
	        styles: [__webpack_require__(122)],
	        animations: [
	            core_1.trigger('toggleSidebar', [
	                core_1.state('inactive', core_1.style({
	                    width: '70px',
	                })),
	                core_1.state('active', core_1.style({
	                    width: '100%',
	                })),
	                core_1.transition('inactive => active', core_1.animate('200ms ease-in')),
	                core_1.transition('active => inactive', core_1.animate('200ms ease-out'))
	            ]),
	            core_1.trigger('toggleText', [
	                core_1.state('inactive', core_1.style({
	                    width: '0',
	                    height: '0',
	                    opacity: '0',
	                })),
	                core_1.state('active', core_1.style({
	                    width: '*',
	                    height: '*',
	                    opacity: '1',
	                })),
	                core_1.transition('inactive => active', core_1.animate('200ms ease-in')),
	                core_1.transition('active => inactive', core_1.animate('200ms ease-out'))
	            ])
	        ]
	    }),
	    __metadata("design:paramtypes", [core_2.TranslateService,
	        MenuService_1.MenuService,
	        AdminService_1.AdminService,
	        SessionService_1.SessionService])
	], AdminSidebarComponent);
	exports.AdminSidebarComponent = AdminSidebarComponent;


/***/ }),

/***/ 103:
/***/ (function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(3), __webpack_require__(7), __webpack_require__(104), __webpack_require__(105), __webpack_require__(107), __webpack_require__(108), __webpack_require__(110), __webpack_require__(114), __webpack_require__(116), __webpack_require__(119));
		else if(typeof define === 'function' && define.amd)
			define(["@angular/core", "rxjs/Observable", "rxjs/add/observable/of", "rxjs/add/operator/concat", "rxjs/add/operator/map", "rxjs/add/operator/merge", "rxjs/add/operator/share", "rxjs/add/operator/switchMap", "rxjs/add/operator/take", "rxjs/add/operator/toArray"], factory);
		else if(typeof exports === 'object')
			exports["ngx-translate-core"] = factory(require("@angular/core"), require("rxjs/Observable"), require("rxjs/add/observable/of"), require("rxjs/add/operator/concat"), require("rxjs/add/operator/map"), require("rxjs/add/operator/merge"), require("rxjs/add/operator/share"), require("rxjs/add/operator/switchMap"), require("rxjs/add/operator/take"), require("rxjs/add/operator/toArray"));
		else
			root["ngx-translate-core"] = factory(root["@angular/core"], root["rxjs/Observable"], root["rxjs/add/observable/of"], root["rxjs/add/operator/concat"], root["rxjs/add/operator/map"], root["rxjs/add/operator/merge"], root["rxjs/add/operator/share"], root["rxjs/add/operator/switchMap"], root["rxjs/add/operator/take"], root["rxjs/add/operator/toArray"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_10__, __WEBPACK_EXTERNAL_MODULE_12__, __WEBPACK_EXTERNAL_MODULE_13__, __WEBPACK_EXTERNAL_MODULE_14__, __WEBPACK_EXTERNAL_MODULE_15__, __WEBPACK_EXTERNAL_MODULE_16__, __WEBPACK_EXTERNAL_MODULE_17__, __WEBPACK_EXTERNAL_MODULE_18__, __WEBPACK_EXTERNAL_MODULE_19__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// identity function for calling harmony imports with the correct context
	/******/ 	__webpack_require__.i = function(value) { return value; };
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 11);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_0__;
	
	/***/ }),
	/* 1 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return USE_STORE; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return USE_DEFAULT_LANG; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TranslateService; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_add_observable_of__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_add_observable_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_add_observable_of__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_concat__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_concat__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_add_operator_share__ = __webpack_require__(16);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_add_operator_share___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_add_operator_share__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_add_operator_map__ = __webpack_require__(14);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_add_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_rxjs_add_operator_map__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_add_operator_merge__ = __webpack_require__(15);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_add_operator_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs_add_operator_merge__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_add_operator_switchMap__ = __webpack_require__(17);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_add_operator_switchMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_rxjs_add_operator_switchMap__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs_add_operator_toArray__ = __webpack_require__(19);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs_add_operator_toArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_rxjs_add_operator_toArray__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rxjs_add_operator_take__ = __webpack_require__(18);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rxjs_add_operator_take___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_rxjs_add_operator_take__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__translate_store__ = __webpack_require__(9);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__translate_loader__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__translate_compiler__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__missing_translation_handler__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__translate_parser__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util__ = __webpack_require__(6);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var USE_STORE = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["OpaqueToken"]('USE_STORE');
	var USE_DEFAULT_LANG = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["OpaqueToken"]('USE_DEFAULT_LANG');
	var TranslateService = (function () {
	    /**
	     *
	     * @param store an instance of the store (that is supposed to be unique)
	     * @param currentLoader An instance of the loader currently used
	     * @param compiler An instance of the compiler currently used
	     * @param parser An instance of the parser currently used
	     * @param missingTranslationHandler A handler for missing translations.
	     * @param isolate whether this service should use the store or not
	     * @param useDefaultLang whether we should use default language translation when current language translation is missing.
	     */
	    function TranslateService(store, currentLoader, compiler, parser, missingTranslationHandler, useDefaultLang, isolate) {
	        if (useDefaultLang === void 0) { useDefaultLang = true; }
	        if (isolate === void 0) { isolate = false; }
	        this.store = store;
	        this.currentLoader = currentLoader;
	        this.compiler = compiler;
	        this.parser = parser;
	        this.missingTranslationHandler = missingTranslationHandler;
	        this.useDefaultLang = useDefaultLang;
	        this.isolate = isolate;
	        this.pending = false;
	        this._onTranslationChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        this._onLangChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        this._onDefaultLangChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        this._langs = [];
	        this._translations = {};
	        this._translationRequests = {};
	    }
	    Object.defineProperty(TranslateService.prototype, "onTranslationChange", {
	        /**
	         * An EventEmitter to listen to translation change events
	         * onTranslationChange.subscribe((params: TranslationChangeEvent) => {
	         *     // do something
	         * });
	         * @type {EventEmitter<TranslationChangeEvent>}
	         */
	        get: function () {
	            return this.isolate ? this._onTranslationChange : this.store.onTranslationChange;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TranslateService.prototype, "onLangChange", {
	        /**
	         * An EventEmitter to listen to lang change events
	         * onLangChange.subscribe((params: LangChangeEvent) => {
	         *     // do something
	         * });
	         * @type {EventEmitter<LangChangeEvent>}
	         */
	        get: function () {
	            return this.isolate ? this._onLangChange : this.store.onLangChange;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TranslateService.prototype, "onDefaultLangChange", {
	        /**
	         * An EventEmitter to listen to default lang change events
	         * onDefaultLangChange.subscribe((params: DefaultLangChangeEvent) => {
	         *     // do something
	         * });
	         * @type {EventEmitter<DefaultLangChangeEvent>}
	         */
	        get: function () {
	            return this.isolate ? this._onDefaultLangChange : this.store.onDefaultLangChange;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TranslateService.prototype, "defaultLang", {
	        /**
	         * The default lang to fallback when translations are missing on the current lang
	         */
	        get: function () {
	            return this.isolate ? this._defaultLang : this.store.defaultLang;
	        },
	        set: function (defaultLang) {
	            if (this.isolate) {
	                this._defaultLang = defaultLang;
	            }
	            else {
	                this.store.defaultLang = defaultLang;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TranslateService.prototype, "currentLang", {
	        /**
	         * The lang currently used
	         * @type {string}
	         */
	        get: function () {
	            return this.isolate ? this._currentLang : this.store.currentLang;
	        },
	        set: function (currentLang) {
	            if (this.isolate) {
	                this._currentLang = currentLang;
	            }
	            else {
	                this.store.currentLang = currentLang;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TranslateService.prototype, "langs", {
	        /**
	         * an array of langs
	         * @type {Array}
	         */
	        get: function () {
	            return this.isolate ? this._langs : this.store.langs;
	        },
	        set: function (langs) {
	            if (this.isolate) {
	                this._langs = langs;
	            }
	            else {
	                this.store.langs = langs;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TranslateService.prototype, "translations", {
	        /**
	         * a list of translations per lang
	         * @type {{}}
	         */
	        get: function () {
	            return this.isolate ? this._translations : this.store.translations;
	        },
	        set: function (translations) {
	            if (this.isolate) {
	                this._currentLang = translations;
	            }
	            else {
	                this.store.translations = translations;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Sets the default language to use as a fallback
	     * @param lang
	     */
	    TranslateService.prototype.setDefaultLang = function (lang) {
	        var _this = this;
	        if (lang === this.defaultLang) {
	            return;
	        }
	        var pending = this.retrieveTranslations(lang);
	        if (typeof pending !== "undefined") {
	            // on init set the defaultLang immediately
	            if (!this.defaultLang) {
	                this.defaultLang = lang;
	            }
	            pending.take(1)
	                .subscribe(function (res) {
	                _this.changeDefaultLang(lang);
	            });
	        }
	        else {
	            this.changeDefaultLang(lang);
	        }
	    };
	    /**
	     * Gets the default language used
	     * @returns string
	     */
	    TranslateService.prototype.getDefaultLang = function () {
	        return this.defaultLang;
	    };
	    /**
	     * Changes the lang currently used
	     * @param lang
	     * @returns {Observable<*>}
	     */
	    TranslateService.prototype.use = function (lang) {
	        var _this = this;
	        // don't change the language if the language given is already selected
	        if (lang === this.currentLang) {
	            return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(this.translations[lang]);
	        }
	        var pending = this.retrieveTranslations(lang);
	        if (typeof pending !== "undefined") {
	            // on init set the currentLang immediately
	            if (!this.currentLang) {
	                this.currentLang = lang;
	            }
	            pending.take(1)
	                .subscribe(function (res) {
	                _this.changeLang(lang);
	            });
	            return pending;
	        }
	        else {
	            this.changeLang(lang);
	            return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(this.translations[lang]);
	        }
	    };
	    /**
	     * Retrieves the given translations
	     * @param lang
	     * @returns {Observable<*>}
	     */
	    TranslateService.prototype.retrieveTranslations = function (lang) {
	        var pending;
	        // if this language is unavailable, ask for it
	        if (typeof this.translations[lang] === "undefined") {
	            this._translationRequests[lang] = this._translationRequests[lang] || this.getTranslation(lang);
	            pending = this._translationRequests[lang];
	        }
	        return pending;
	    };
	    /**
	     * Gets an object of translations for a given language with the current loader
	     * and passes it through the compiler
	     * @param lang
	     * @returns {Observable<*>}
	     */
	    TranslateService.prototype.getTranslation = function (lang) {
	        var _this = this;
	        this.pending = true;
	        this.loadingTranslations = this.currentLoader.getTranslation(lang).share();
	        this.loadingTranslations.take(1)
	            .subscribe(function (res) {
	            _this.translations[lang] = _this.compiler.compileTranslations(res, lang);
	            _this.updateLangs();
	            _this.pending = false;
	        }, function (err) {
	            _this.pending = false;
	        });
	        return this.loadingTranslations;
	    };
	    /**
	     * Manually sets an object of translations for a given language
	     * after passing it through the compiler
	     * @param lang
	     * @param translations
	     * @param shouldMerge
	     */
	    TranslateService.prototype.setTranslation = function (lang, translations, shouldMerge) {
	        if (shouldMerge === void 0) { shouldMerge = false; }
	        translations = this.compiler.compileTranslations(translations, lang);
	        if (shouldMerge && this.translations[lang]) {
	            this.translations[lang] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util__["c" /* mergeDeep */])(this.translations[lang], translations);
	        }
	        else {
	            this.translations[lang] = translations;
	        }
	        this.updateLangs();
	        this.onTranslationChange.emit({ lang: lang, translations: this.translations[lang] });
	    };
	    /**
	     * Returns an array of currently available langs
	     * @returns {any}
	     */
	    TranslateService.prototype.getLangs = function () {
	        return this.langs;
	    };
	    /**
	     * @param langs
	     * Add available langs
	     */
	    TranslateService.prototype.addLangs = function (langs) {
	        var _this = this;
	        langs.forEach(function (lang) {
	            if (_this.langs.indexOf(lang) === -1) {
	                _this.langs.push(lang);
	            }
	        });
	    };
	    /**
	     * Update the list of available langs
	     */
	    TranslateService.prototype.updateLangs = function () {
	        this.addLangs(Object.keys(this.translations));
	    };
	    /**
	     * Returns the parsed result of the translations
	     * @param translations
	     * @param key
	     * @param interpolateParams
	     * @returns {any}
	     */
	    TranslateService.prototype.getParsedResult = function (translations, key, interpolateParams) {
	        var res;
	        if (key instanceof Array) {
	            var result = {}, observables = false;
	            for (var _i = 0, key_1 = key; _i < key_1.length; _i++) {
	                var k = key_1[_i];
	                result[k] = this.getParsedResult(translations, k, interpolateParams);
	                if (typeof result[k].subscribe === "function") {
	                    observables = true;
	                }
	            }
	            if (observables) {
	                var mergedObs = void 0;
	                for (var _a = 0, key_2 = key; _a < key_2.length; _a++) {
	                    var k = key_2[_a];
	                    var obs = typeof result[k].subscribe === "function" ? result[k] : __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(result[k]);
	                    if (typeof mergedObs === "undefined") {
	                        mergedObs = obs;
	                    }
	                    else {
	                        mergedObs = mergedObs.merge(obs);
	                    }
	                }
	                return mergedObs.toArray().map(function (arr) {
	                    var obj = {};
	                    arr.forEach(function (value, index) {
	                        obj[key[index]] = value;
	                    });
	                    return obj;
	                });
	            }
	            return result;
	        }
	        if (translations) {
	            res = this.parser.interpolate(this.parser.getValue(translations, key), interpolateParams);
	        }
	        if (typeof res === "undefined" && this.defaultLang && this.defaultLang !== this.currentLang && this.useDefaultLang) {
	            res = this.parser.interpolate(this.parser.getValue(this.translations[this.defaultLang], key), interpolateParams);
	        }
	        if (typeof res === "undefined") {
	            var params = { key: key, translateService: this };
	            if (typeof interpolateParams !== 'undefined') {
	                params.interpolateParams = interpolateParams;
	            }
	            res = this.missingTranslationHandler.handle(params);
	        }
	        return typeof res !== "undefined" ? res : key;
	    };
	    /**
	     * Gets the translated value of a key (or an array of keys)
	     * @param key
	     * @param interpolateParams
	     * @returns {any} the translated key, or an object of translated keys
	     */
	    TranslateService.prototype.get = function (key, interpolateParams) {
	        var _this = this;
	        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util__["b" /* isDefined */])(key) || !key.length) {
	            throw new Error("Parameter \"key\" required");
	        }
	        // check if we are loading a new translation to use
	        if (this.pending) {
	            return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].create(function (observer) {
	                var onComplete = function (res) {
	                    observer.next(res);
	                    observer.complete();
	                };
	                var onError = function (err) {
	                    observer.error(err);
	                };
	                _this.loadingTranslations.subscribe(function (res) {
	                    res = _this.getParsedResult(res, key, interpolateParams);
	                    if (typeof res.subscribe === "function") {
	                        res.subscribe(onComplete, onError);
	                    }
	                    else {
	                        onComplete(res);
	                    }
	                }, onError);
	            });
	        }
	        else {
	            var res = this.getParsedResult(this.translations[this.currentLang], key, interpolateParams);
	            if (typeof res.subscribe === "function") {
	                return res;
	            }
	            else {
	                return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(res);
	            }
	        }
	    };
	    /**
	     * Returns a stream of translated values of a key (or an array of keys) which updates
	     * whenever the language changes.
	     * @param key
	     * @param interpolateParams
	     * @returns {any} A stream of the translated key, or an object of translated keys
	     */
	    TranslateService.prototype.stream = function (key, interpolateParams) {
	        var _this = this;
	        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util__["b" /* isDefined */])(key) || !key.length) {
	            throw new Error("Parameter \"key\" required");
	        }
	        return this
	            .get(key, interpolateParams)
	            .concat(this.onLangChange.switchMap(function (event) {
	            var res = _this.getParsedResult(event.translations, key, interpolateParams);
	            if (typeof res.subscribe === "function") {
	                return res;
	            }
	            else {
	                return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(res);
	            }
	        }));
	    };
	    /**
	     * Returns a translation instantly from the internal state of loaded translation.
	     * All rules regarding the current language, the preferred language of even fallback languages will be used except any promise handling.
	     * @param key
	     * @param interpolateParams
	     * @returns {string}
	     */
	    TranslateService.prototype.instant = function (key, interpolateParams) {
	        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util__["b" /* isDefined */])(key) || !key.length) {
	            throw new Error("Parameter \"key\" required");
	        }
	        var res = this.getParsedResult(this.translations[this.currentLang], key, interpolateParams);
	        if (typeof res.subscribe !== "undefined") {
	            if (key instanceof Array) {
	                var obj_1 = {};
	                key.forEach(function (value, index) {
	                    obj_1[key[index]] = key[index];
	                });
	                return obj_1;
	            }
	            return key;
	        }
	        else {
	            return res;
	        }
	    };
	    /**
	     * Sets the translated value of a key, after compiling it
	     * @param key
	     * @param value
	     * @param lang
	     */
	    TranslateService.prototype.set = function (key, value, lang) {
	        if (lang === void 0) { lang = this.currentLang; }
	        this.translations[lang][key] = this.compiler.compile(value, lang);
	        this.updateLangs();
	        this.onTranslationChange.emit({ lang: lang, translations: this.translations[lang] });
	    };
	    /**
	     * Changes the current lang
	     * @param lang
	     */
	    TranslateService.prototype.changeLang = function (lang) {
	        this.currentLang = lang;
	        this.onLangChange.emit({ lang: lang, translations: this.translations[lang] });
	        // if there is no default lang, use the one that we just set
	        if (!this.defaultLang) {
	            this.changeDefaultLang(lang);
	        }
	    };
	    /**
	     * Changes the default lang
	     * @param lang
	     */
	    TranslateService.prototype.changeDefaultLang = function (lang) {
	        this.defaultLang = lang;
	        this.onDefaultLangChange.emit({ lang: lang, translations: this.translations[lang] });
	    };
	    /**
	     * Allows to reload the lang file from the file
	     * @param lang
	     * @returns {Observable<any>}
	     */
	    TranslateService.prototype.reloadLang = function (lang) {
	        this.resetLang(lang);
	        return this.getTranslation(lang);
	    };
	    /**
	     * Deletes inner translation
	     * @param lang
	     */
	    TranslateService.prototype.resetLang = function (lang) {
	        this._translationRequests[lang] = undefined;
	        this.translations[lang] = undefined;
	    };
	    /**
	     * Returns the language code name from the browser, e.g. "de"
	     *
	     * @returns string
	     */
	    TranslateService.prototype.getBrowserLang = function () {
	        if (typeof window === 'undefined' || typeof window.navigator === 'undefined') {
	            return undefined;
	        }
	        var browserLang = window.navigator.languages ? window.navigator.languages[0] : null;
	        browserLang = browserLang || window.navigator.language || window.navigator.browserLanguage || window.navigator.userLanguage;
	        if (browserLang.indexOf('-') !== -1) {
	            browserLang = browserLang.split('-')[0];
	        }
	        if (browserLang.indexOf('_') !== -1) {
	            browserLang = browserLang.split('_')[0];
	        }
	        return browserLang;
	    };
	    /**
	     * Returns the culture language code name from the browser, e.g. "de-DE"
	     *
	     * @returns string
	     */
	    TranslateService.prototype.getBrowserCultureLang = function () {
	        if (typeof window === 'undefined' || typeof window.navigator === 'undefined') {
	            return undefined;
	        }
	        var browserCultureLang = window.navigator.languages ? window.navigator.languages[0] : null;
	        browserCultureLang = browserCultureLang || window.navigator.language || window.navigator.browserLanguage || window.navigator.userLanguage;
	        return browserCultureLang;
	    };
	    return TranslateService;
	}());
	TranslateService = __decorate([
	    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])(),
	    __param(5, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(USE_DEFAULT_LANG)),
	    __param(6, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(USE_STORE)),
	    __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_10__translate_store__["a" /* TranslateStore */],
	        __WEBPACK_IMPORTED_MODULE_11__translate_loader__["a" /* TranslateLoader */],
	        __WEBPACK_IMPORTED_MODULE_12__translate_compiler__["a" /* TranslateCompiler */],
	        __WEBPACK_IMPORTED_MODULE_14__translate_parser__["a" /* TranslateParser */],
	        __WEBPACK_IMPORTED_MODULE_13__missing_translation_handler__["a" /* MissingTranslationHandler */], Boolean, Boolean])
	], TranslateService);
	
	
	
	/***/ }),
	/* 2 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MissingTranslationHandler; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FakeMissingTranslationHandler; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	
	var MissingTranslationHandler = (function () {
	    function MissingTranslationHandler() {
	    }
	    return MissingTranslationHandler;
	}());
	
	/**
	 * This handler is just a placeholder that does nothing, in case you don't need a missing translation handler at all
	 */
	var FakeMissingTranslationHandler = (function () {
	    function FakeMissingTranslationHandler() {
	    }
	    FakeMissingTranslationHandler.prototype.handle = function (params) {
	        return params.key;
	    };
	    return FakeMissingTranslationHandler;
	}());
	FakeMissingTranslationHandler = __decorate([
	    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])()
	], FakeMissingTranslationHandler);
	
	
	
	/***/ }),
	/* 3 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TranslateCompiler; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TranslateFakeCompiler; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	
	var TranslateCompiler = (function () {
	    function TranslateCompiler() {
	    }
	    return TranslateCompiler;
	}());
	
	/**
	 * This compiler is just a placeholder that does nothing, in case you don't need a compiler at all
	 */
	var TranslateFakeCompiler = (function (_super) {
	    __extends(TranslateFakeCompiler, _super);
	    function TranslateFakeCompiler() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    TranslateFakeCompiler.prototype.compile = function (value, lang) {
	        return value;
	    };
	    TranslateFakeCompiler.prototype.compileTranslations = function (translations, lang) {
	        return translations;
	    };
	    return TranslateFakeCompiler;
	}(TranslateCompiler));
	TranslateFakeCompiler = __decorate([
	    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])()
	], TranslateFakeCompiler);
	
	
	
	/***/ }),
	/* 4 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TranslateLoader; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TranslateFakeLoader; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__(10);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__angular_core__);
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	
	
	var TranslateLoader = (function () {
	    function TranslateLoader() {
	    }
	    return TranslateLoader;
	}());
	
	/**
	 * This loader is just a placeholder that does nothing, in case you don't need a loader at all
	 */
	var TranslateFakeLoader = (function (_super) {
	    __extends(TranslateFakeLoader, _super);
	    function TranslateFakeLoader() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    TranslateFakeLoader.prototype.getTranslation = function (lang) {
	        return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of({});
	    };
	    return TranslateFakeLoader;
	}(TranslateLoader));
	TranslateFakeLoader = __decorate([
	    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"])()
	], TranslateFakeLoader);
	
	
	
	/***/ }),
	/* 5 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TranslateParser; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TranslateDefaultParser; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(6);
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	
	
	var TranslateParser = (function () {
	    function TranslateParser() {
	    }
	    return TranslateParser;
	}());
	
	var TranslateDefaultParser = (function (_super) {
	    __extends(TranslateDefaultParser, _super);
	    function TranslateDefaultParser() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.templateMatcher = /{{\s?([^{}\s]*)\s?}}/g;
	        return _this;
	    }
	    TranslateDefaultParser.prototype.interpolate = function (expr, params) {
	        var result;
	        if (typeof expr === 'string') {
	            result = this.interpolateString(expr, params);
	        }
	        else if (typeof expr === 'function') {
	            result = this.interpolateFunction(expr, params);
	        }
	        else {
	            // this should not happen, but an unrelated TranslateService test depends on it
	            result = expr;
	        }
	        return result;
	    };
	    TranslateDefaultParser.prototype.getValue = function (target, key) {
	        var keys = key.split('.');
	        key = '';
	        do {
	            key += keys.shift();
	            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["b" /* isDefined */])(target) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["b" /* isDefined */])(target[key]) && (typeof target[key] === 'object' || !keys.length)) {
	                target = target[key];
	                key = '';
	            }
	            else if (!keys.length) {
	                target = undefined;
	            }
	            else {
	                key += '.';
	            }
	        } while (keys.length);
	        return target;
	    };
	    TranslateDefaultParser.prototype.interpolateFunction = function (fn, params) {
	        return fn(params);
	    };
	    TranslateDefaultParser.prototype.interpolateString = function (expr, params) {
	        var _this = this;
	        if (!params) {
	            return expr;
	        }
	        return expr.replace(this.templateMatcher, function (substring, b) {
	            var r = _this.getValue(params, b);
	            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["b" /* isDefined */])(r) ? r : substring;
	        });
	    };
	    return TranslateDefaultParser;
	}(TranslateParser));
	TranslateDefaultParser = __decorate([
	    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])()
	], TranslateDefaultParser);
	
	
	
	/***/ }),
	/* 6 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (immutable) */ __webpack_exports__["a"] = equals;
	/* harmony export (immutable) */ __webpack_exports__["b"] = isDefined;
	/* unused harmony export isObject */
	/* harmony export (immutable) */ __webpack_exports__["c"] = mergeDeep;
	/* tslint:disable */
	/**
	 * @name equals
	 *
	 * @description
	 * Determines if two objects or two values are equivalent.
	 *
	 * Two objects or values are considered equivalent if at least one of the following is true:
	 *
	 * * Both objects or values pass `===` comparison.
	 * * Both objects or values are of the same type and all of their properties are equal by
	 *   comparing them with `equals`.
	 *
	 * @param {*} o1 Object or value to compare.
	 * @param {*} o2 Object or value to compare.
	 * @returns {boolean} True if arguments are equal.
	 */
	/* tslint:disable */ function equals(o1, o2) {
	    if (o1 === o2)
	        return true;
	    if (o1 === null || o2 === null)
	        return false;
	    if (o1 !== o1 && o2 !== o2)
	        return true; // NaN === NaN
	    var t1 = typeof o1, t2 = typeof o2, length, key, keySet;
	    if (t1 == t2 && t1 == 'object') {
	        if (Array.isArray(o1)) {
	            if (!Array.isArray(o2))
	                return false;
	            if ((length = o1.length) == o2.length) {
	                for (key = 0; key < length; key++) {
	                    if (!equals(o1[key], o2[key]))
	                        return false;
	                }
	                return true;
	            }
	        }
	        else {
	            if (Array.isArray(o2)) {
	                return false;
	            }
	            keySet = Object.create(null);
	            for (key in o1) {
	                if (!equals(o1[key], o2[key])) {
	                    return false;
	                }
	                keySet[key] = true;
	            }
	            for (key in o2) {
	                if (!(key in keySet) && typeof o2[key] !== 'undefined') {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	    return false;
	}
	/* tslint:enable */
	function isDefined(value) {
	    return typeof value !== 'undefined' && value !== null;
	}
	function isObject(item) {
	    return (item && typeof item === 'object' && !Array.isArray(item));
	}
	function mergeDeep(target, source) {
	    target = JSON.parse(JSON.stringify(target));
	    source = JSON.parse(JSON.stringify(source));
	    var output = Object.assign({}, target);
	    if (isObject(target) && isObject(source)) {
	        Object.keys(source).forEach(function (key) {
	            if (isObject(source[key])) {
	                if (!(key in target)) {
	                    Object.assign(output, (_a = {}, _a[key] = source[key], _a));
	                }
	                else {
	                    output[key] = mergeDeep(target[key], source[key]);
	                }
	            }
	            else {
	                Object.assign(output, (_b = {}, _b[key] = source[key], _b));
	            }
	            var _a, _b;
	        });
	    }
	    return output;
	}
	
	
	/***/ }),
	/* 7 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TranslateDirective; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__translate_service__ = __webpack_require__(1);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	
	
	
	var TranslateDirective = (function () {
	    function TranslateDirective(translateService, element, _ref) {
	        var _this = this;
	        this.translateService = translateService;
	        this.element = element;
	        this._ref = _ref;
	        // subscribe to onTranslationChange event, in case the translations of the current lang change
	        if (!this.onTranslationChangeSub) {
	            this.onTranslationChangeSub = this.translateService.onTranslationChange.subscribe(function (event) {
	                if (event.lang === _this.translateService.currentLang) {
	                    _this.checkNodes(true, event.translations);
	                }
	            });
	        }
	        // subscribe to onLangChange event, in case the language changes
	        if (!this.onLangChangeSub) {
	            this.onLangChangeSub = this.translateService.onLangChange.subscribe(function (event) {
	                _this.checkNodes(true, event.translations);
	            });
	        }
	        // subscribe to onDefaultLangChange event, in case the default language changes
	        if (!this.onDefaultLangChangeSub) {
	            this.onDefaultLangChangeSub = this.translateService.onDefaultLangChange.subscribe(function (event) {
	                _this.checkNodes(true);
	            });
	        }
	    }
	    Object.defineProperty(TranslateDirective.prototype, "translate", {
	        set: function (key) {
	            if (key) {
	                this.key = key;
	                this.checkNodes();
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TranslateDirective.prototype, "translateParams", {
	        set: function (params) {
	            if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* equals */])(this.currentParams, params)) {
	                this.currentParams = params;
	                this.checkNodes(true);
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    TranslateDirective.prototype.ngAfterViewChecked = function () {
	        this.checkNodes();
	    };
	    TranslateDirective.prototype.checkNodes = function (forceUpdate, translations) {
	        if (forceUpdate === void 0) { forceUpdate = false; }
	        var nodes = this.element.nativeElement.childNodes;
	        // if the element is empty
	        if (!nodes.length) {
	            // we add the key as content
	            this.setContent(this.element.nativeElement, this.key);
	            nodes = this.element.nativeElement.childNodes;
	        }
	        for (var i = 0; i < nodes.length; ++i) {
	            var node = nodes[i];
	            if (node.nodeType === 3) {
	                var key = void 0;
	                if (this.key) {
	                    key = this.key;
	                    if (forceUpdate) {
	                        node.lastKey = null;
	                    }
	                }
	                else {
	                    var content = this.getContent(node).trim();
	                    if (content.length) {
	                        // we want to use the content as a key, not the translation value
	                        if (content !== node.currentValue) {
	                            key = content;
	                            // the content was changed from the user, we'll use it as a reference if needed
	                            node.originalContent = this.getContent(node);
	                        }
	                        else if (node.originalContent && forceUpdate) {
	                            node.lastKey = null;
	                            // the current content is the translation, not the key, use the last real content as key
	                            key = node.originalContent.trim();
	                        }
	                    }
	                }
	                this.updateValue(key, node, translations);
	            }
	        }
	    };
	    TranslateDirective.prototype.updateValue = function (key, node, translations) {
	        var _this = this;
	        if (key) {
	            if (node.lastKey === key && this.lastParams === this.currentParams) {
	                return;
	            }
	            this.lastParams = this.currentParams;
	            var onTranslation = function (res) {
	                if (res !== key) {
	                    node.lastKey = key;
	                }
	                if (!node.originalContent) {
	                    node.originalContent = _this.getContent(node);
	                }
	                node.currentValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["b" /* isDefined */])(res) ? res : (node.originalContent || key);
	                // we replace in the original content to preserve spaces that we might have trimmed
	                _this.setContent(node, _this.key ? node.currentValue : node.originalContent.replace(key, node.currentValue));
	                _this._ref.markForCheck();
	            };
	            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["b" /* isDefined */])(translations)) {
	                var res = this.translateService.getParsedResult(translations, key, this.currentParams);
	                if (typeof res.subscribe === "function") {
	                    res.subscribe(onTranslation);
	                }
	                else {
	                    onTranslation(res);
	                }
	            }
	            else {
	                this.translateService.get(key, this.currentParams).subscribe(onTranslation);
	            }
	        }
	    };
	    TranslateDirective.prototype.getContent = function (node) {
	        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["b" /* isDefined */])(node.textContent) ? node.textContent : node.data;
	    };
	    TranslateDirective.prototype.setContent = function (node, content) {
	        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["b" /* isDefined */])(node.textContent)) {
	            node.textContent = content;
	        }
	        else {
	            node.data = content;
	        }
	    };
	    TranslateDirective.prototype.ngOnDestroy = function () {
	        if (this.onLangChangeSub) {
	            this.onLangChangeSub.unsubscribe();
	        }
	        if (this.onDefaultLangChangeSub) {
	            this.onDefaultLangChangeSub.unsubscribe();
	        }
	        if (this.onTranslationChangeSub) {
	            this.onTranslationChangeSub.unsubscribe();
	        }
	    };
	    return TranslateDirective;
	}());
	__decorate([
	    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	    __metadata("design:type", String),
	    __metadata("design:paramtypes", [String])
	], TranslateDirective.prototype, "translate", null);
	__decorate([
	    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
	    __metadata("design:type", Object),
	    __metadata("design:paramtypes", [Object])
	], TranslateDirective.prototype, "translateParams", null);
	TranslateDirective = __decorate([
	    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"])({
	        selector: '[translate],[ngx-translate]'
	    }),
	    __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__translate_service__["c" /* TranslateService */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"]])
	], TranslateDirective);
	
	
	
	/***/ }),
	/* 8 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TranslatePipe; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translate_service__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(6);
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	
	
	
	var TranslatePipe = (function () {
	    function TranslatePipe(translate, _ref) {
	        this.translate = translate;
	        this._ref = _ref;
	        this.value = '';
	    }
	    TranslatePipe.prototype.updateValue = function (key, interpolateParams, translations) {
	        var _this = this;
	        var onTranslation = function (res) {
	            _this.value = res !== undefined ? res : key;
	            _this.lastKey = key;
	            _this._ref.markForCheck();
	        };
	        if (translations) {
	            var res = this.translate.getParsedResult(translations, key, interpolateParams);
	            if (typeof res.subscribe === 'function') {
	                res.subscribe(onTranslation);
	            }
	            else {
	                onTranslation(res);
	            }
	        }
	        this.translate.get(key, interpolateParams).subscribe(onTranslation);
	    };
	    TranslatePipe.prototype.transform = function (query) {
	        var _this = this;
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        if (!query || query.length === 0) {
	            return query;
	        }
	        // if we ask another time for the same key, return the last value
	        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util__["a" /* equals */])(query, this.lastKey) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util__["a" /* equals */])(args, this.lastParams)) {
	            return this.value;
	        }
	        var interpolateParams;
	        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util__["b" /* isDefined */])(args[0]) && args.length) {
	            if (typeof args[0] === 'string' && args[0].length) {
	                // we accept objects written in the template such as {n:1}, {'n':1}, {n:'v'}
	                // which is why we might need to change it to real JSON objects such as {"n":1} or {"n":"v"}
	                var validArgs = args[0]
	                    .replace(/(\')?([a-zA-Z0-9_]+)(\')?(\s)?:/g, '"$2":')
	                    .replace(/:(\s)?(\')(.*?)(\')/g, ':"$3"');
	                try {
	                    interpolateParams = JSON.parse(validArgs);
	                }
	                catch (e) {
	                    throw new SyntaxError("Wrong parameter in TranslatePipe. Expected a valid Object, received: " + args[0]);
	                }
	            }
	            else if (typeof args[0] === 'object' && !Array.isArray(args[0])) {
	                interpolateParams = args[0];
	            }
	        }
	        // store the query, in case it changes
	        this.lastKey = query;
	        // store the params, in case they change
	        this.lastParams = args;
	        // set the value
	        this.updateValue(query, interpolateParams);
	        // if there is a subscription to onLangChange, clean it
	        this._dispose();
	        // subscribe to onTranslationChange event, in case the translations change
	        if (!this.onTranslationChange) {
	            this.onTranslationChange = this.translate.onTranslationChange.subscribe(function (event) {
	                if (_this.lastKey && event.lang === _this.translate.currentLang) {
	                    _this.lastKey = null;
	                    _this.updateValue(query, interpolateParams, event.translations);
	                }
	            });
	        }
	        // subscribe to onLangChange event, in case the language changes
	        if (!this.onLangChange) {
	            this.onLangChange = this.translate.onLangChange.subscribe(function (event) {
	                if (_this.lastKey) {
	                    _this.lastKey = null; // we want to make sure it doesn't return the same value until it's been updated
	                    _this.updateValue(query, interpolateParams, event.translations);
	                }
	            });
	        }
	        // subscribe to onDefaultLangChange event, in case the default language changes
	        if (!this.onDefaultLangChange) {
	            this.onDefaultLangChange = this.translate.onDefaultLangChange.subscribe(function () {
	                if (_this.lastKey) {
	                    _this.lastKey = null; // we want to make sure it doesn't return the same value until it's been updated
	                    _this.updateValue(query, interpolateParams);
	                }
	            });
	        }
	        return this.value;
	    };
	    /**
	     * Clean any existing subscription to change events
	     * @private
	     */
	    TranslatePipe.prototype._dispose = function () {
	        if (typeof this.onTranslationChange !== 'undefined') {
	            this.onTranslationChange.unsubscribe();
	            this.onTranslationChange = undefined;
	        }
	        if (typeof this.onLangChange !== 'undefined') {
	            this.onLangChange.unsubscribe();
	            this.onLangChange = undefined;
	        }
	        if (typeof this.onDefaultLangChange !== 'undefined') {
	            this.onDefaultLangChange.unsubscribe();
	            this.onDefaultLangChange = undefined;
	        }
	    };
	    TranslatePipe.prototype.ngOnDestroy = function () {
	        this._dispose();
	    };
	    return TranslatePipe;
	}());
	TranslatePipe = __decorate([
	    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])(),
	    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Pipe"])({
	        name: 'translate',
	        pure: false // required to update the value when the promise is resolved
	    }),
	    __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__translate_service__["c" /* TranslateService */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"]])
	], TranslatePipe);
	
	
	
	/***/ }),
	/* 9 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TranslateStore; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	
	var TranslateStore = (function () {
	    function TranslateStore() {
	        /**
	         * The lang currently used
	         * @type {string}
	         */
	        this.currentLang = this.defaultLang;
	        /**
	         * a list of translations per lang
	         * @type {{}}
	         */
	        this.translations = {};
	        /**
	         * an array of langs
	         * @type {Array}
	         */
	        this.langs = [];
	        /**
	         * An EventEmitter to listen to translation change events
	         * onTranslationChange.subscribe((params: TranslationChangeEvent) => {
	         *     // do something
	         * });
	         * @type {EventEmitter<TranslationChangeEvent>}
	         */
	        this.onTranslationChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        /**
	         * An EventEmitter to listen to lang change events
	         * onLangChange.subscribe((params: LangChangeEvent) => {
	         *     // do something
	         * });
	         * @type {EventEmitter<LangChangeEvent>}
	         */
	        this.onLangChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	        /**
	         * An EventEmitter to listen to default lang change events
	         * onDefaultLangChange.subscribe((params: DefaultLangChangeEvent) => {
	         *     // do something
	         * });
	         * @type {EventEmitter<DefaultLangChangeEvent>}
	         */
	        this.onDefaultLangChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
	    }
	    return TranslateStore;
	}());
	
	
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_10__;
	
	/***/ }),
	/* 11 */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TranslateModule", function() { return TranslateModule; });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angular_core__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_translate_loader__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_translate_service__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_missing_translation_handler__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_translate_parser__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_translate_compiler__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_translate_directive__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_translate_pipe__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_translate_store__ = __webpack_require__(9);
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "TranslateLoader", function() { return __WEBPACK_IMPORTED_MODULE_1__src_translate_loader__["a"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "TranslateFakeLoader", function() { return __WEBPACK_IMPORTED_MODULE_1__src_translate_loader__["b"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "USE_STORE", function() { return __WEBPACK_IMPORTED_MODULE_2__src_translate_service__["a"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "USE_DEFAULT_LANG", function() { return __WEBPACK_IMPORTED_MODULE_2__src_translate_service__["b"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "TranslateService", function() { return __WEBPACK_IMPORTED_MODULE_2__src_translate_service__["c"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "MissingTranslationHandler", function() { return __WEBPACK_IMPORTED_MODULE_3__src_missing_translation_handler__["a"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "FakeMissingTranslationHandler", function() { return __WEBPACK_IMPORTED_MODULE_3__src_missing_translation_handler__["b"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "TranslateParser", function() { return __WEBPACK_IMPORTED_MODULE_4__src_translate_parser__["a"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "TranslateDefaultParser", function() { return __WEBPACK_IMPORTED_MODULE_4__src_translate_parser__["b"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "TranslateCompiler", function() { return __WEBPACK_IMPORTED_MODULE_5__src_translate_compiler__["a"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "TranslateFakeCompiler", function() { return __WEBPACK_IMPORTED_MODULE_5__src_translate_compiler__["b"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "TranslateDirective", function() { return __WEBPACK_IMPORTED_MODULE_6__src_translate_directive__["a"]; });
	/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "TranslatePipe", function() { return __WEBPACK_IMPORTED_MODULE_7__src_translate_pipe__["a"]; });
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var TranslateModule = TranslateModule_1 = (function () {
	    function TranslateModule() {
	    }
	    /**
	     * Use this method in your root module to provide the TranslateService
	     * @param {TranslateModuleConfig} config
	     * @returns {ModuleWithProviders}
	     */
	    TranslateModule.forRoot = function (config) {
	        if (config === void 0) { config = {}; }
	        return {
	            ngModule: TranslateModule_1,
	            providers: [
	                config.loader || { provide: __WEBPACK_IMPORTED_MODULE_1__src_translate_loader__["a" /* TranslateLoader */], useClass: __WEBPACK_IMPORTED_MODULE_1__src_translate_loader__["b" /* TranslateFakeLoader */] },
	                config.compiler || { provide: __WEBPACK_IMPORTED_MODULE_5__src_translate_compiler__["a" /* TranslateCompiler */], useClass: __WEBPACK_IMPORTED_MODULE_5__src_translate_compiler__["b" /* TranslateFakeCompiler */] },
	                config.parser || { provide: __WEBPACK_IMPORTED_MODULE_4__src_translate_parser__["a" /* TranslateParser */], useClass: __WEBPACK_IMPORTED_MODULE_4__src_translate_parser__["b" /* TranslateDefaultParser */] },
	                config.missingTranslationHandler || { provide: __WEBPACK_IMPORTED_MODULE_3__src_missing_translation_handler__["a" /* MissingTranslationHandler */], useClass: __WEBPACK_IMPORTED_MODULE_3__src_missing_translation_handler__["b" /* FakeMissingTranslationHandler */] },
	                __WEBPACK_IMPORTED_MODULE_8__src_translate_store__["a" /* TranslateStore */],
	                { provide: __WEBPACK_IMPORTED_MODULE_2__src_translate_service__["a" /* USE_STORE */], useValue: config.isolate },
	                { provide: __WEBPACK_IMPORTED_MODULE_2__src_translate_service__["b" /* USE_DEFAULT_LANG */], useValue: config.useDefaultLang },
	                __WEBPACK_IMPORTED_MODULE_2__src_translate_service__["c" /* TranslateService */]
	            ]
	        };
	    };
	    /**
	     * Use this method in your other (non root) modules to import the directive/pipe
	     * @param {TranslateModuleConfig} config
	     * @returns {ModuleWithProviders}
	     */
	    TranslateModule.forChild = function (config) {
	        if (config === void 0) { config = {}; }
	        return {
	            ngModule: TranslateModule_1,
	            providers: [
	                config.loader || { provide: __WEBPACK_IMPORTED_MODULE_1__src_translate_loader__["a" /* TranslateLoader */], useClass: __WEBPACK_IMPORTED_MODULE_1__src_translate_loader__["b" /* TranslateFakeLoader */] },
	                config.compiler || { provide: __WEBPACK_IMPORTED_MODULE_5__src_translate_compiler__["a" /* TranslateCompiler */], useClass: __WEBPACK_IMPORTED_MODULE_5__src_translate_compiler__["b" /* TranslateFakeCompiler */] },
	                config.parser || { provide: __WEBPACK_IMPORTED_MODULE_4__src_translate_parser__["a" /* TranslateParser */], useClass: __WEBPACK_IMPORTED_MODULE_4__src_translate_parser__["b" /* TranslateDefaultParser */] },
	                config.missingTranslationHandler || { provide: __WEBPACK_IMPORTED_MODULE_3__src_missing_translation_handler__["a" /* MissingTranslationHandler */], useClass: __WEBPACK_IMPORTED_MODULE_3__src_missing_translation_handler__["b" /* FakeMissingTranslationHandler */] },
	                { provide: __WEBPACK_IMPORTED_MODULE_2__src_translate_service__["a" /* USE_STORE */], useValue: config.isolate },
	                { provide: __WEBPACK_IMPORTED_MODULE_2__src_translate_service__["b" /* USE_DEFAULT_LANG */], useValue: config.useDefaultLang },
	                __WEBPACK_IMPORTED_MODULE_2__src_translate_service__["c" /* TranslateService */]
	            ]
	        };
	    };
	    return TranslateModule;
	}());
	TranslateModule = TranslateModule_1 = __decorate([
	    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"])({
	        declarations: [
	            __WEBPACK_IMPORTED_MODULE_7__src_translate_pipe__["a" /* TranslatePipe */],
	            __WEBPACK_IMPORTED_MODULE_6__src_translate_directive__["a" /* TranslateDirective */]
	        ],
	        exports: [
	            __WEBPACK_IMPORTED_MODULE_7__src_translate_pipe__["a" /* TranslatePipe */],
	            __WEBPACK_IMPORTED_MODULE_6__src_translate_directive__["a" /* TranslateDirective */]
	        ]
	    })
	], TranslateModule);
	
	var TranslateModule_1;
	
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_12__;
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_13__;
	
	/***/ }),
	/* 14 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_14__;
	
	/***/ }),
	/* 15 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_15__;
	
	/***/ }),
	/* 16 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_16__;
	
	/***/ }),
	/* 17 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_17__;
	
	/***/ }),
	/* 18 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_18__;
	
	/***/ }),
	/* 19 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_19__;
	
	/***/ })
	/******/ ]);
	});
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),

/***/ 121:
/***/ (function(module, exports) {

	module.exports = "<div class=\"sidebar\" *ngIf=\"sidebarStatus\" [@toggleSidebar]=\"isSmall ?  'inactive' : 'active'\" (@toggleSidebar.start)=\"animationStart($event)\" (@toggleSidebar.done)=\"animationDone($event)\">\n    <ul>\n        <li *ngFor=\"let item of sidebar\" [hidden]=\"!accessible(item.role)\">\n            <a routerLink=\"{{item.url}}\" routerLinkActive=\"active\">\n                <span [@toggleText]=\"isShowText ?  'inactive' : 'active'\" style=\"overflow: hidden;\">{{ item.label | translate }}</span>\n                <i class=\"material-icons\">{{item.icon}}</i>\n            </a>\n        </li>\n    </ul>\n    <div class=\"button-hide-menu\"  (click)=\"toggleSmallSidebard()\">\n        <i class=\"material-icons\" *ngIf=\"!isSmall\">chevron_left</i>\n        <i class=\"material-icons\" *ngIf=\"isSmall\">chevron_right</i>\n    </div>\n</div>";

/***/ }),

/***/ 122:
/***/ (function(module, exports) {

	module.exports = ".sidebar{box-shadow:0 4px 4px 0 rgba(0,0,0,0.14),0 3px 1px -2px rgba(0,0,0,0.2),0 1px 5px 0 rgba(0,0,0,0.12);position:absolute;background:#fff;height:100%;width:100%;border-right:1px solid #e1e4e9;z-index:1}.sidebar ul{background-color:#fff;z-index:10;position:relative;list-style:none;margin-left:0}.sidebar ul li{font-size:0.875rem;font-weight:600}.sidebar ul li a{color:#414042;display:block;overflow:hidden;padding:1.375rem}.sidebar ul li a span{display:inline-block;vertical-align:middle}.sidebar ul li a i{float:right}.sidebar ul li .active{background:#e6e6e6}.button-hide-menu{position:absolute;right:-20px;width:24px;height:40px;top:20px;line-height:40px;cursor:pointer;box-shadow:2px 1px 1px 0px rgba(0,0,0,0.14);background:#00707e;color:#fff}.button-hide-menu i{line-height:40px}\n"

/***/ }),

/***/ 123:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(94));


/***/ }),

/***/ 124:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var Observable_1 = __webpack_require__(7);
	__webpack_require__(125);
	__webpack_require__(128);
	__webpack_require__(136);
	var ClickOutsideDirective = (function () {
	    function ClickOutsideDirective(_elRef) {
	        this._elRef = _elRef;
	        this.listening = false;
	        this.clickOutside = new core_1.EventEmitter();
	    }
	    ClickOutsideDirective.prototype.ngOnInit = function () {
	        var _this = this;
	        this.globalClick = Observable_1.Observable
	            .fromEvent(document, 'click')
	            .delay(1)
	            .do(function () {
	            _this.listening = true;
	        }).subscribe(function (event) {
	            _this.onGlobalClick(event);
	        });
	    };
	    ClickOutsideDirective.prototype.ngOnDestroy = function () {
	        this.globalClick.unsubscribe();
	    };
	    ClickOutsideDirective.prototype.onGlobalClick = function (event) {
	        if (event instanceof MouseEvent && this.listening === true) {
	            if (this.isDescendant(this._elRef.nativeElement, event.target) === true) {
	                this.clickOutside.emit({
	                    target: (event.target || null),
	                    value: false
	                });
	            }
	            else {
	                this.clickOutside.emit({
	                    target: (event.target || null),
	                    value: true
	                });
	            }
	        }
	    };
	    ClickOutsideDirective.prototype.isDescendant = function (parent, child) {
	        var node = child;
	        while (node !== null) {
	            if (node === parent) {
	                return true;
	            }
	            else {
	                node = node.parentNode;
	            }
	        }
	        return false;
	    };
	    return ClickOutsideDirective;
	}());
	__decorate([
	    core_1.Output('clickOutside'),
	    __metadata("design:type", core_1.EventEmitter)
	], ClickOutsideDirective.prototype, "clickOutside", void 0);
	ClickOutsideDirective = __decorate([
	    core_1.Directive({
	        selector: '[click-outside]'
	    }),
	    __metadata("design:paramtypes", [core_1.ElementRef])
	], ClickOutsideDirective);
	exports.ClickOutsideDirective = ClickOutsideDirective;


/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(212));
	__export(__webpack_require__(81));
	__export(__webpack_require__(82));
	__export(__webpack_require__(411));
	__export(__webpack_require__(224));
	__export(__webpack_require__(229));
	__export(__webpack_require__(268));


/***/ }),

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var shared_1 = __webpack_require__(213);
	var HolLoginComponent_1 = __webpack_require__(222);
	var HolRegisterComponent_1 = __webpack_require__(227);
	var HolChoosePasswordComponent_1 = __webpack_require__(232);
	var HolForgotPasswordComponent_1 = __webpack_require__(235);
	var HolChangePasswordComponent_1 = __webpack_require__(239);
	var HolSetNewPasswordComponent_1 = __webpack_require__(242);
	var LoginComponent_1 = __webpack_require__(245);
	var LogoutComponent_1 = __webpack_require__(248);
	var RegisterComponent_1 = __webpack_require__(249);
	var ChoosePasswordComponent_1 = __webpack_require__(252);
	var ForgotPasswordComponent_1 = __webpack_require__(255);
	var SetNewPasswordComponent_1 = __webpack_require__(258);
	var ChangePasswordComponent_1 = __webpack_require__(261);
	var AddParentComponent_1 = __webpack_require__(264);
	var AddStudentComponent_1 = __webpack_require__(267);
	var UserRouting_1 = __webpack_require__(410);
	var UserService_1 = __webpack_require__(81);
	var PasswordService_1 = __webpack_require__(236);
	var RegisterService_1 = __webpack_require__(228);
	var SessionService_1 = __webpack_require__(82);
	// import { HolidayService } from '../../../holiday/services/HolidayService';
	var UserModule = (function () {
	    function UserModule() {
	    }
	    return UserModule;
	}());
	UserModule = __decorate([
	    core_1.NgModule({
	        imports: [
	            shared_1.SharedModule,
	            UserRouting_1.userRouting,
	        ],
	        declarations: [
	            HolLoginComponent_1.HolLoginComponent,
	            HolRegisterComponent_1.HolRegisterComponent,
	            HolForgotPasswordComponent_1.HolForgotPasswordComponent,
	            HolChangePasswordComponent_1.HolChangePasswordComponent,
	            HolSetNewPasswordComponent_1.HolSetNewPasswordComponent,
	            HolChoosePasswordComponent_1.HolChoosePasswordComponent,
	            LoginComponent_1.LoginComponent,
	            LogoutComponent_1.LogoutComponent,
	            RegisterComponent_1.RegisterComponent,
	            ChoosePasswordComponent_1.ChoosePasswordComponent,
	            ForgotPasswordComponent_1.ForgotPasswordComponent,
	            SetNewPasswordComponent_1.SetNewPasswordComponent,
	            ChangePasswordComponent_1.ChangePasswordComponent,
	            AddParentComponent_1.AddParentComponent,
	            AddStudentComponent_1.AddStudentComponent,
	        ],
	        providers: [
	            UserService_1.UserService,
	            SessionService_1.SessionService,
	            PasswordService_1.PasswordService,
	            RegisterService_1.RegisterService,
	        ]
	    })
	], UserModule);
	exports.UserModule = UserModule;


/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(214));


/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	var common_1 = __webpack_require__(22);
	var forms_1 = __webpack_require__(147);
	var http_1 = __webpack_require__(60);
	var components_1 = __webpack_require__(215);
	var core_2 = __webpack_require__(103);
	// AoT requires an exported function for factories
	var SharedModule = (function () {
	    /**
	     * The SharedModule which will define the modules, components & directives that will
	     * be used again in other feature modules. It 's different with the CoreModule which
	     * will define the components, directives that only use one time in the main AppModule.
	     */
	    function SharedModule() {
	    }
	    return SharedModule;
	}());
	SharedModule = __decorate([
	    core_1.NgModule({
	        imports: [
	            common_1.CommonModule,
	            forms_1.FormsModule,
	            http_1.HttpModule,
	            http_1.JsonpModule,
	            core_2.TranslateModule,
	        ],
	        declarations: [
	            components_1.AlertBoxComponent,
	            components_1.PaginatorComponent,
	        ],
	        exports: [
	            // Modules
	            common_1.CommonModule,
	            forms_1.FormsModule,
	            http_1.HttpModule,
	            http_1.JsonpModule,
	            // Components
	            components_1.AlertBoxComponent,
	            components_1.PaginatorComponent,
	            core_2.TranslateModule,
	        ]
	    })
	    /**
	     * The SharedModule which will define the modules, components & directives that will
	     * be used again in other feature modules. It 's different with the CoreModule which
	     * will define the components, directives that only use one time in the main AppModule.
	     */
	], SharedModule);
	exports.SharedModule = SharedModule;


/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(216));
	__export(__webpack_require__(219));


/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var AlertBoxComponent = (function () {
	    function AlertBoxComponent() {
	    }
	    AlertBoxComponent.prototype.ngOnInit = function () {
	        // Set default message type if no type input received.
	        if (!this.type) {
	            this.type = "warning";
	        }
	    };
	    AlertBoxComponent.prototype.onClose = function () {
	        // Set message to "" to hide the box.
	        this.message = "";
	    };
	    return AlertBoxComponent;
	}());
	__decorate([
	    core_1.Input('message'),
	    __metadata("design:type", String)
	], AlertBoxComponent.prototype, "message", void 0);
	__decorate([
	    core_1.Input('type'),
	    __metadata("design:type", String)
	], AlertBoxComponent.prototype, "type", void 0);
	AlertBoxComponent = __decorate([
	    core_1.Component({
	        selector: 'alert-box',
	        template: __webpack_require__(217),
	        styles: [__webpack_require__(218)]
	    }),
	    core_1.Injectable()
	], AlertBoxComponent);
	exports.AlertBoxComponent = AlertBoxComponent;


/***/ }),

/***/ 217:
/***/ (function(module, exports) {

	module.exports = "<div class=\"callout\" [ngClass]=\"type\" [class.hidden]=\"!message\">\n    {{message}}\n    <button class=\"close-button\" type=\"button\" (click)=\"onClose()\">\n        <span aria-hidden=\"true\">&times;</span>\n    </button>\n</div>";

/***/ }),

/***/ 218:
/***/ (function(module, exports) {

	module.exports = ".callout{padding:0.5rem 1.5rem 0.5rem 0.5rem;opacity:1;visibility:visible;transition:all ease-in-out 0.2s}.callout.hidden{visibility:hidden;opacity:0;padding:0;margin:0}.callout button.close-button{right:0.5rem;line-height:0.7}\n"

/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var PaginatorComponent = (function () {
	    function PaginatorComponent() {
	        this.currentPageUpdated = new core_1.EventEmitter();
	    }
	    PaginatorComponent.prototype.ngOnInit = function () {
	        if (this.currentPage > this.totalPage) {
	            this.currentPage = 1;
	        }
	        this.oldTotalPage = this.totalPage;
	        // Generate page number range list that will be used to display.
	        this.pageList = this.generatePageNumberList(this.numberDisplay, this.currentPage, this.totalPage);
	    };
	    PaginatorComponent.prototype.ngOnChanges = function (changes) {
	        for (var propName in changes) {
	            if (propName === 'totalPage' && changes[propName].currentValue > 0) {
	                // Re-generate page number range list that will be used to display.
	                this.pageList = this.generatePageNumberList(this.numberDisplay, this.currentPage, this.totalPage);
	            }
	            if (propName === 'currentPage') {
	                if (this.pageList && this.pageList.indexOf(changes[propName].currentValue) === -1) {
	                    // Re-generate page number range list that will be used to display.
	                    this.pageList = this.generatePageNumberList(this.numberDisplay, this.currentPage, this.totalPage);
	                }
	            }
	        }
	    };
	    PaginatorComponent.prototype.generatePageNumberList = function (numberDisplay, currentPage, totalPage) {
	        var pageNumberList = [];
	        var range = Math.floor(numberDisplay / 2);
	        var start = 0;
	        var end = currentPage + range > totalPage ? totalPage : currentPage + range;
	        // Generate start number
	        if (currentPage - range > 0) {
	            start = currentPage + range > totalPage ? totalPage - numberDisplay + 1 : currentPage - range;
	            start = start < 1 ? start = 1 : start;
	        }
	        else {
	            start = 1;
	        }
	        // Generate end number
	        end = start + numberDisplay - 1 > totalPage ? totalPage : start + numberDisplay - 1;
	        for (start; start <= end; start++) {
	            pageNumberList.push(start);
	        }
	        return pageNumberList;
	    };
	    PaginatorComponent.prototype.updateSelectedPage = function (page) {
	        if (page > 0 && page <= this.totalPage) {
	            // Update current Page
	            this.currentPage = page;
	            // generate new page list
	            this.pageList = this.generatePageNumberList(this.numberDisplay, this.currentPage, this.totalPage);
	            // Fire event for parent component to know current page had been changed
	            this.currentPageUpdated.emit(page);
	        }
	    };
	    return PaginatorComponent;
	}());
	__decorate([
	    core_1.Input('currentPage'),
	    __metadata("design:type", Number)
	], PaginatorComponent.prototype, "currentPage", void 0);
	__decorate([
	    core_1.Input('totalPage'),
	    __metadata("design:type", Number)
	], PaginatorComponent.prototype, "totalPage", void 0);
	__decorate([
	    core_1.Input('numberDisplay'),
	    __metadata("design:type", Number)
	], PaginatorComponent.prototype, "numberDisplay", void 0);
	__decorate([
	    core_1.Output(),
	    __metadata("design:type", Object)
	], PaginatorComponent.prototype, "currentPageUpdated", void 0);
	PaginatorComponent = __decorate([
	    core_1.Component({
	        selector: 'pagination',
	        template: __webpack_require__(220),
	        styles: [__webpack_require__(221)]
	    }),
	    core_1.Injectable()
	], PaginatorComponent);
	exports.PaginatorComponent = PaginatorComponent;


/***/ }),

/***/ 220:
/***/ (function(module, exports) {

	module.exports = "<div class=\"text-center\" *ngIf=\"totalPage>1\">\n    <ul class=\"paginator\">\n        <!-- First Page -->\n        <li [class.disabled]=\"currentPage === 1\" title=\"First page\" (click)=\"updateSelectedPage(1)\">\n            <i class=\"material-icons\">first_page</i>\n        </li>\n        <!-- Previous Page -->\n        <li [class.disabled]=\"currentPage === 1\" title=\"Previous page\" (click)=\"updateSelectedPage(currentPage - 1)\">\n            <i class=\"material-icons\">keyboard_arrow_left</i>\n        </li>\n        <!-- Pages -->\n        <li *ngFor=\"let page of pageList\" [class.current]=\"page === currentPage\" (click)=\"updateSelectedPage(page)\">\n            {{page}}\n        </li>\n        \n        <!-- Next Page -->\n        <li title=\"Next page\" (click)=\"updateSelectedPage(currentPage + 1)\" [class.disabled]=\"currentPage === totalPage\">\n            <i class=\"material-icons\">keyboard_arrow_right</i>\n        </li>\n        <!-- Last Page -->\n        <li title=\"Last page\" (click)=\"updateSelectedPage(totalPage)\" [class.disabled]=\"currentPage === totalPage\">\n            <i class=\"material-icons\">last_page</i>\n        </li>\n    </ul>\n</div>";

/***/ }),

/***/ 221:
/***/ (function(module, exports) {

	module.exports = "ul.paginator{display:inline-flex;display:-webkit-inline-flex;margin:1rem}ul.paginator li{margin:0 0.2rem;border:1px #00707e solid;border-radius:0.2rem;padding:0.2rem;vertical-align:middle;display:inline-block;color:#00707e;text-align:center;width:2rem;cursor:pointer}ul.paginator li.disabled{opacity:0.25;cursor:not-allowed}ul.paginator li:not(.disabled):hover{background-color:#00707e;color:#fff}ul.paginator li.current{background-color:#00707e;color:#fff;cursor:default}\n"

/***/ }),

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	// Services
	var SessionService_1 = __webpack_require__(82);
	var UserService_1 = __webpack_require__(81);
	var HolidayService_1 = __webpack_require__(83);
	var Parent_1 = __webpack_require__(223);
	var Credential_1 = __webpack_require__(224);
	var services_1 = __webpack_require__(58);
	var config_1 = __webpack_require__(85);
	var HolLoginComponent = (function () {
	    function HolLoginComponent(holidayService, sessionService, userService, router, sessionStorageService) {
	        this.holidayService = holidayService;
	        this.sessionService = sessionService;
	        this.userService = userService;
	        this.router = router;
	        this.sessionStorageService = sessionStorageService;
	        this.formSubmitted = false;
	        this.credential = new Credential_1.Credential('', '', '');
	        this.parent = new Parent_1.Parent();
	    }
	    HolLoginComponent.prototype.ngOnInit = function () {
	        this.hostName = window.location.hostname;
	        // Use Session Service to get session and check if user had already logged in.
	        this.getSession();
	        this.schools = [
	            {
	                name: 'Helen School',
	                value: 1,
	            },
	            {
	                name: 'Others',
	                value: 2,
	            },
	        ];
	        this.schools.value = 1;
	        this.selectedTab = 1;
	    };
	    ;
	    HolLoginComponent.prototype.onSubmit = function () {
	        this.credential.role = 'parent';
	        this.formSubmitted = true;
	        // Reset message content
	        this.message = "";
	        // Post user login data to create session
	        this.postSession(this.credential);
	    };
	    HolLoginComponent.prototype.onSubmitNonVas = function () {
	        this.credential.role = 'hol-parent';
	        this.formSubmitted = true;
	        // Reset message content
	        this.message = "";
	        // Post user login data to create session
	        this.postSessionNonVas(this.credential);
	    };
	    /**
	     * Get Session from API service to make sure that user had logged in.
	     * Update User Data on local storage and redirect to the desired URL
	     * if request responses session data.
	     * @param none
	     * @return none
	     */
	    HolLoginComponent.prototype.getSession = function () {
	        var _this = this;
	        this.sessionService.getSession()
	            .subscribe(function (user) {
	            _this.userService.setUserSessionData(user);
	        }, function (error) {
	            //TO DO: Handle any error if needed in the furture
	            _this.message = "";
	            _this.messageType = "alert";
	        });
	    };
	    /**
	     * Post Session to API service to create new session.
	     * Update User Data on local storage and redirect to desired URL
	     * if request responses session data.
	     * @param {Credential} - user credential input
	     * @return none
	     */
	    HolLoginComponent.prototype.postSession = function (credential) {
	        var _this = this;
	        this.sessionService.postSession(credential)
	            .subscribe(function (user) {
	            _this.sessionStorageService.setData('isVasParent', true);
	            // Set user session data
	            _this.userService.setUserSessionData(user);
	            // Fire user session data changed event
	            _this.userService.userDataChanged(user);
	            _this.router.navigate(['/parents']);
	        }, function (error) {
	            _this.formSubmitted = false;
	            _this.message = "Invalid email address or password.";
	            _this.messageType = "alert";
	        });
	    };
	    HolLoginComponent.prototype.postSessionNonVas = function (credential) {
	        var _this = this;
	        this.sessionService.postSession(credential)
	            .subscribe(function (user) {
	            _this.sessionStorageService.setData('isVasParent', false);
	            // Set user session data
	            _this.userService.setUserSessionData(user);
	            // Fire user session data changed event
	            _this.userService.userDataChanged(user);
	            // this.checkStatus();
	            _this.router.navigate(['/other-parents']);
	        }, function (error) {
	            _this.formSubmitted = false;
	            _this.message = "Invalid email address or password.";
	            _this.messageType = "alert";
	        });
	    };
	    HolLoginComponent.prototype.toHoliday = function () {
	        switch (this.hostName) {
	            case config_1.procEnv.services:
	                window.location.href = "https://" + config_1.procEnv.holiday;
	                break;
	            case config_1.bisHanoiDevEnv.services:
	                window.location.href = "http://" + config_1.bisHanoiDevEnv.holiday;
	                break;
	            case config_1.bisHanoiEnv.services:
	                window.location.href = "http://" + config_1.bisHanoiEnv.holiday;
	                break;
	            case config_1.devEnv.services:
	                window.location.href = "http://" + config_1.devEnv.holiday;
	                break;
	            case config_1.testEnv.services:
	                window.location.href = "http://" + config_1.testEnv.holiday;
	                break;
	            case config_1.stagingEnv.services:
	                window.location.href = "https://" + config_1.stagingEnv.holiday;
	                break;
	            case config_1.demoEnv.services:
	                window.location.href = "http://" + config_1.demoEnv.holiday;
	                break;
	            case config_1.localEnv.services:
	                window.location.href = "http://" + config_1.localEnv.holiday;
	                break;
	        }
	        ;
	    };
	    HolLoginComponent.prototype.activateTab = function (tabId) {
	        this.selectedTab = tabId;
	    };
	    return HolLoginComponent;
	}());
	HolLoginComponent = __decorate([
	    core_1.Component({
	        selector: 'user-login',
	        template: __webpack_require__(225),
	        styles: [__webpack_require__(226)],
	    }),
	    __metadata("design:paramtypes", [HolidayService_1.HolidayService,
	        SessionService_1.SessionService,
	        UserService_1.UserService,
	        router_1.Router,
	        services_1.SessionStorageService])
	], HolLoginComponent);
	exports.HolLoginComponent = HolLoginComponent;


/***/ }),

/***/ 223:
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Parent = (function () {
	    function Parent() {
	    }
	    return Parent;
	}());
	exports.Parent = Parent;
	var ParentItem = (function () {
	    function ParentItem() {
	    }
	    return ParentItem;
	}());
	exports.ParentItem = ParentItem;
	var HolParentDetails = (function () {
	    function HolParentDetails() {
	    }
	    return HolParentDetails;
	}());
	exports.HolParentDetails = HolParentDetails;
	var HolStudents = (function () {
	    function HolStudents() {
	    }
	    return HolStudents;
	}());
	exports.HolStudents = HolStudents;
	var HolStudentParents = (function () {
	    function HolStudentParents() {
	    }
	    return HolStudentParents;
	}());
	exports.HolStudentParents = HolStudentParents;
	var ParentChangeEmail = (function () {
	    function ParentChangeEmail() {
	        this.oldEmail = '';
	        this.newEmail = '';
	        this.reNewEmail = '';
	    }
	    return ParentChangeEmail;
	}());
	exports.ParentChangeEmail = ParentChangeEmail;
	;


/***/ }),

/***/ 224:
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Credential = (function () {
	    function Credential(role, email, password) {
	        this.role = role;
	        this.email = email;
	        this.password = password;
	    }
	    return Credential;
	}());
	exports.Credential = Credential;


/***/ }),

/***/ 225:
/***/ (function(module, exports) {

	module.exports = "<div id=\"user-login-component\" class=\"eca-background\">\n    <div class=\"component-title\">\n        <h1 style=\"color: #fff\">WELCOME TO NAS</h1>\n    </div>\n    <div class=\"component-content\">\n        <div class=\"top-content\">\n            <h3 class=\"text-center\">Login to your account</h3>\n            <div class=\"row columns\">\n                <div class=\"medium-12 columns\">\n                    <h4 class=\"text-center\">Student is studying at :</h4>\n                </div>\n                <div class=\"medium-12 columns\">\n                    <div class=\"wrap-select\">\n                        <select #school (change)=\"activateTab(school.value)\">\n                            <option\n                                *ngFor=\"let school of schools\"\n                                value=\"{{school.value}}\"\n                            >\n                                {{school.name}}\n                            </option>\n                        </select>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <!-- Form Title -->\n        <form #loginForm=\"ngForm\" *ngIf=\"selectedTab == 1\">\n            <div>\n                <!-- Alert Box -->\n                <div class=\"row\">\n                    <div class=\"medium-12 columns\">\n                        <alert-box\n                            [message]=\"message\"\n                            [type]=\"messageType\"\n                        ></alert-box>\n                    </div>\n                </div>\n                <!-- Email Input Field -->\n                <div class=\"row\">\n                    <div class=\"medium-12 columns\">\n                        <label for=\"email\">Email</label>\n                        <input\n                            type=\"email\"\n                            placeholder=\"Type your email address\"\n                            id=\"email\"\n                            [(ngModel)]=\"credential.email\"\n                            name=\"email\"\n                            #email=\"ngModel\"\n                            required\n                        />\n                        <div\n                            [hidden]=\"email.valid || email.pristine\"\n                            class=\"help-text text-alert\"\n                        >\n                            Email is required.\n                        </div>\n                    </div>\n                </div>\n                <!-- Password Input Field -->\n                <div class=\"row\">\n                    <div class=\"medium-12 columns\">\n                        <label for=\"password\">Password</label>\n                        <input\n                            type=\"password\"\n                            placeholder=\"Type your password\"\n                            id=\"password\"\n                            [(ngModel)]=\"credential.password\"\n                            name=\"password\"\n                            #password=\"ngModel\"\n                            required\n                        />\n                        <div\n                            [hidden]=\"password.valid || password.pristine\"\n                            class=\"help-text text-alert\"\n                        >\n                            Password is required.\n                        </div>\n                    </div>\n                </div>\n                <!-- Remember Me & Forgot Password -->\n                <!-- <div class=\"row\">\n\t\t\t\t\t<div class=\"medium-12 columns remember-block\">\n\t\t\t\t\t\t<a target=\"_blank\" href=\"http://www.aisvietnam.com/wp-content/uploads/2017/08/AIS-Service-GuidelineforParents.pdf\" class=\"forgot-password text-left\">Introductions to create an account</a><br/>\n\t\t\t\t\t\t<a routerLink=\"/forgot-password\" class=\"forgot-password\">Forgot Password?</a>\n\t\t\t\t\t</div>\n\t\t\t\t</div> -->\n                <!-- Submit Button -->\n                <div class=\"row\">\n                    <div class=\"medium-12 columns\">\n                        <button\n                            type=\"submit\"\n                            name=\"submit\"\n                            [disabled]=\"!loginForm.form.valid || formSubmitted\"\n                            (click)=\"onSubmit()\"\n                        >\n                            Login\n                        </button>\n                    </div>\n                </div>\n                <!-- Register Link -->\n                <!-- <div class=\"row\">\n\t\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t\t<label class=\"register-link\">Do not have an account yet? <a routerLink=\"/hol-register\">REGISTER NOW</a></label>\n\t\t\t\t\t</div>\n\t\t\t\t</div> -->\n            </div>\n        </form>\n        <form #holloginForm=\"ngForm\" *ngIf=\"selectedTab == 2\">\n            <!-- Alert Box -->\n            <div class=\"row\">\n                <div class=\"medium-12 columns\">\n                    <alert-box\n                        [message]=\"message\"\n                        [type]=\"messageType\"\n                    ></alert-box>\n                </div>\n            </div>\n            <!-- Email Input Field -->\n            <div class=\"row\">\n                <div class=\"medium-12 columns\">\n                    <label for=\"email\">Email</label>\n                    <input\n                        type=\"email\"\n                        placeholder=\"Type your email address\"\n                        id=\"email\"\n                        [(ngModel)]=\"credential.email\"\n                        name=\"email\"\n                        #email=\"ngModel\"\n                        required\n                    />\n                    <div\n                        [hidden]=\"email.valid || email.pristine\"\n                        class=\"help-text text-alert\"\n                    >\n                        Email is required.\n                    </div>\n                </div>\n            </div>\n            <!-- Password Input Field -->\n            <div class=\"row\">\n                <div class=\"medium-12 columns\">\n                    <label for=\"password\">Password</label>\n                    <input\n                        type=\"password\"\n                        placeholder=\"Type your password\"\n                        id=\"password\"\n                        [(ngModel)]=\"credential.password\"\n                        name=\"password\"\n                        #password=\"ngModel\"\n                        required\n                    />\n                    <div\n                        [hidden]=\"password.valid || password.pristine\"\n                        class=\"help-text text-alert\"\n                    >\n                        Password is required.\n                    </div>\n                </div>\n            </div>\n            <!-- Remember Me & Forgot Password -->\n            <!-- <div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns remember-block\">\n\t\t\t\t\t<a target=\"_blank\" href=\"http://www.aisvietnam.com/wp-content/uploads/2017/10/CPM-GettingStartedasNonAISParentManual-2.pdf\" class=\"forgot-password text-left\">Introductions to create an account</a><br/>\n\t\t\t\t\t<a routerLink=\"/forgot-password\" class=\"forgot-password\">Forgot Password?</a>\n\t\t\t\t</div>\n\t\t\t</div> -->\n            <!-- Submit Button -->\n            <div class=\"row\">\n                <div class=\"medium-12 columns\">\n                    <button\n                        type=\"submit\"\n                        name=\"submit\"\n                        [disabled]=\"!holloginForm.form.valid || formSubmitted\"\n                        (click)=\"onSubmitNonVas()\"\n                    >\n                        Login\n                    </button>\n                </div>\n            </div>\n            <!-- Register Link -->\n            <!-- <div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n            \t\t<label class=\"register-link\">Do not have an account yet? <a routerLink=\"/hol-register\">REGISTER NOW</a></label>\n\t\t\t\t</div>\n\t\t\t</div> -->\n        </form>\n    </div>\n</div>\n";

/***/ }),

/***/ 226:
/***/ (function(module, exports) {

	module.exports = "select{border:1px solid #dddddd;border-radius:0.2rem;-moz-border-radius:0.2rem;-webkit-border-radius:0.2rem;box-sizing:border-box;width:100%;height:2.4375rem;border:1px solid #cacaca;margin:0 0 1rem;font-family:inherit;font-size:1rem;color:#616060;background-color:#fefefe}h4{font-size:1rem;padding:1rem 0;color:#00707e;text-align:left}.tabs{margin-bottom:-7px;position:relative;z-index:29;border-top-right-radius:5px;border-top-left-radius:5px;border:none}.tabs li{width:50%}.tabs li a{background:#00707e;color:#fff;font-weight:normal;font-size:1rem}.tabs li:first-child{border-top-left-radius:5px}.tabs li:last-child{border-top-right-radius:5px}.tabs li>.is-active{background:#fff;color:#00707e;font-weight:500;border-top-right-radius:5px;border-top-left-radius:5px}#user-login-component{padding:1rem}#user-login-component .component-title{margin:3rem auto;color:#fff;text-align:center}#user-login-component .component-content{margin:3rem auto;width:31.25%;background:#fff;border-radius:0.5rem;padding-bottom:1.5rem}#user-login-component .component-content .top-content h3{padding:1rem;background:#00707e;color:#fff;border-top-right-radius:6px;border-top-left-radius:6px}#user-login-component .component-content form{padding:0 1rem;box-shadow:none}#user-login-component .component-content form div.remember-block{position:relative;font-size:0.8rem;margin-bottom:0.5rem}#user-login-component .component-content form div.remember-block input[type=\"checkbox\"]{position:absolute;height:1.1rem;width:1.1rem;top:0.5rem;cursor:pointer}#user-login-component .component-content form div.remember-block label{margin-left:1.5rem}#user-login-component .component-content form .register-link{font-size:0.65rem;font-weight:500;text-align:center}#user-login-component .component-content form .forgot-password{font-size:0.8rem;display:inline-block;line-height:30px}#user-login-component .component-content form button:not(.close-button){width:100%}#user-login-component .component-content form button.close-button{line-height:1.2}@media (min-width: 1025px){#user-login-component .component-title{max-width:450px}#user-login-component .component-content{max-width:450px}}@media (min-width: 768px) and (max-width: 1024px){#user-login-component .component-title{width:50%;max-width:450px}#user-login-component .component-content{width:50%;max-width:450px}}@media (min-width: 320px) and (max-width: 767px){#user-login-component{padding:0}#user-login-component .component-title{display:none}#user-login-component .component-content{margin:0;width:100%}#user-login-component .component-content form{border:none;border-radius:0rem}}\n"

/***/ }),

/***/ 227:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	//Libraries
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	// Services
	var SessionService_1 = __webpack_require__(82);
	var UserService_1 = __webpack_require__(81);
	var RegisterService_1 = __webpack_require__(228);
	//Models
	var Credential_1 = __webpack_require__(224);
	var NonAisParent_1 = __webpack_require__(229);
	var HolRegisterComponent = (function () {
	    function HolRegisterComponent(sessionService, userService, registerService, router) {
	        this.sessionService = sessionService;
	        this.userService = userService;
	        this.registerService = registerService;
	        this.router = router;
	        this.formSubmitted = false;
	    }
	    HolRegisterComponent.prototype.ngOnInit = function () {
	        this.redirectUrl = '/booking/students';
	        this.nonAisParent = new NonAisParent_1.NonAisParent();
	        this.credential = new Credential_1.Credential('', '', '');
	        // Use Session Service to get session and check if user had already logged in.
	        this.getSession();
	        this.schools = [
	            {
	                name: 'Australian Internation School',
	                value: 1,
	            },
	            {
	                name: 'Others',
	                value: 2,
	            },
	        ];
	        this.schools.value = 1;
	        this.selectedTab = 1;
	    };
	    HolRegisterComponent.prototype.onSubmit = function () {
	        this.credential.role = 'parent';
	        this.formSubmitted = true;
	        // Reset message content
	        this.message = "";
	        // Post user login data to create session
	        this.register();
	    };
	    HolRegisterComponent.prototype.onSubmitNonAis = function () {
	        this.credential = new Credential_1.Credential('hol-parent', '', '');
	        this.formSubmitted = true;
	        // Reset message content
	        this.message = "";
	        // Post user login data to create session
	        this.registerNonAis(this.nonAisParent);
	    };
	    /**
	     * Get Session from API service to make sure that user had logged in.
	     * Update User Data on local storage and redirect to the desired URL
	     * if request responses session data.
	     * @param none
	     * @return none
	     */
	    HolRegisterComponent.prototype.getSession = function () {
	        var _this = this;
	        this.sessionService.getSession()
	            .subscribe(function (user) {
	            _this.userService.setUserSessionData(user);
	            _this.redirect();
	        }, function (error) {
	            //TO DO: Handle any error if needed in the furture
	            _this.message = "";
	            _this.messageType = "alert";
	        });
	    };
	    HolRegisterComponent.prototype.register = function () {
	        var _this = this;
	        this.registerService.postActivationEmail(this.credential.role, this.credential.email)
	            .subscribe(function (complete) {
	            _this.messageType = "success",
	                _this.message = "An activation email had been sent.";
	            _this.formSubmitted = false;
	        }, function (error) {
	            _this.messageType = "alert";
	            _this.message = "Please input the email you provided to AIS.";
	            _this.formSubmitted = false;
	        });
	    };
	    HolRegisterComponent.prototype.registerNonAis = function (nonAisParent) {
	        var _this = this;
	        this.registerService.postNoneAisAccount(nonAisParent)
	            .subscribe(function (complete) {
	            _this.messageType = "success",
	                _this.message = "An activation email had been sent.";
	            _this.formSubmitted = false;
	        }, function (error) {
	            _this.messageType = "alert";
	            _this.message = "The information are duplicated";
	            _this.formSubmitted = false;
	        });
	    };
	    HolRegisterComponent.prototype.redirect = function () {
	        // Redirect to stored url
	        this.router.navigate([this.redirectUrl]);
	    };
	    HolRegisterComponent.prototype.activateTab = function (tabId) {
	        this.selectedTab = tabId;
	    };
	    return HolRegisterComponent;
	}());
	HolRegisterComponent = __decorate([
	    core_1.Component({
	        selector: 'user-register',
	        template: __webpack_require__(230),
	        styles: [__webpack_require__(231)]
	    }),
	    __metadata("design:paramtypes", [SessionService_1.SessionService,
	        UserService_1.UserService,
	        RegisterService_1.RegisterService,
	        router_1.Router])
	], HolRegisterComponent);
	exports.HolRegisterComponent = HolRegisterComponent;


/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	// Import Setting Service and User, Credential Model
	var services_1 = __webpack_require__(58);
	var RegisterService = (function () {
	    function RegisterService(settingService, apiService) {
	        this.settingService = settingService;
	        this.apiService = apiService;
	        this.activationUrl = '/activations';
	        this.holParentUrl = '/hol/parent';
	        this.holStudenttUrl = '/hol/student';
	        this.holPasswordUrl = '/hol/parent/password';
	        this.apiUrl = '';
	        this.apiUrl = this.settingService.getSetting('api_service_domain');
	    }
	    RegisterService.prototype.postActivationEmail = function (role, email) {
	        var requestUrl = this.apiUrl + this.activationUrl;
	        var body = JSON.stringify({
	            'role': role,
	            'email': email
	        });
	        return this.apiService.post(requestUrl, body);
	    };
	    RegisterService.prototype.verifyActivationToken = function (token) {
	        var requestUrl = this.apiUrl + this.activationUrl + "/" + token;
	        return this.apiService.get(requestUrl);
	    };
	    // verifyActivationRecovery(recovery: string): Observable<any> {
	    //     const requestUrl = this.apiUrl + this.holPasswordUrl;
	    //     return this.apiService.get(requestUrl);
	    // }
	    RegisterService.prototype.setPasswordWithActivationToken = function (token, password) {
	        var requestUrl = this.apiUrl + this.activationUrl + "/" + token;
	        // TODO: update body content
	        var body = JSON.stringify({ password: password });
	        return this.apiService.patch(requestUrl, body);
	    };
	    RegisterService.prototype.setPasswordWithActivationRecovery = function (recovery, email, password) {
	        var requestUrl = this.apiUrl + this.holPasswordUrl;
	        // TODO: update body content
	        var body = JSON.stringify({
	            'email': email,
	            'recovery': recovery,
	            'password': password
	        });
	        return this.apiService.post(requestUrl, body);
	    };
	    RegisterService.prototype.postNoneAisAccount = function (nonAisParent) {
	        var requestUrl = this.apiUrl + this.holParentUrl + "/register";
	        var body = JSON.stringify(nonAisParent);
	        return this.apiService.post(requestUrl, body);
	    };
	    RegisterService.prototype.postNonAisStudent = function (nonAisStudent) {
	        var requestUrl = this.apiUrl + this.holStudenttUrl;
	        var body = JSON.stringify(nonAisStudent);
	        return this.apiService.post(requestUrl, body);
	    };
	    RegisterService.prototype.updateParent = function (nonAisParent) {
	        var requestUrl = this.apiUrl + this.holParentUrl;
	        var body = JSON.stringify(nonAisParent);
	        return this.apiService.patch(requestUrl, body);
	    };
	    return RegisterService;
	}());
	RegisterService = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [services_1.SettingService,
	        services_1.ApiService])
	], RegisterService);
	exports.RegisterService = RegisterService;


/***/ }),

/***/ 229:
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var NonAisParent = (function () {
	    function NonAisParent() {
	    }
	    return NonAisParent;
	}());
	exports.NonAisParent = NonAisParent;


/***/ }),

/***/ 230:
/***/ (function(module, exports) {

	module.exports = "<div id=\"user-register-component\" class=\"eca-background\">\n    <div class=\"component-title\">\n        <h1>WELCOME TO AIS</h1>\n    </div>\n    <div class=\"component-content\">\n\t\t<div class=\"top-content\">\n\t\t\t<h3 class=\"text-center\">Register Account</h3>\n\t\t\t<div class=\"row columns\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<h4 class=\"text-center\">Student is studying at :</h4>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<div class=\"wrap-select\">\n\t\t\t\t\t\t<select #school (change)=\"activateTab(school.value)\">\n\t\t\t\t\t\t\t<option *ngFor=\"let school of schools\" value={{school.value}}>{{school.name}}</option>\n\t\t\t\t\t\t</select>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n        <form #registerForm=\"ngForm\" *ngIf=\"selectedTab == 1\">\n\t\t\t<!-- Alert Box -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<alert-box [message]=\"message\" [type]=\"messageType\"></alert-box>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Email Input Field -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"email\">Please type the email you registered with AIS</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Email\" id=\"email\" name=\"email\" \n\t\t\t\t\t\t\t[(ngModel)]=\"credential.email\" #email=\"ngModel\" required>\n\t\t\t\t\t<div [hidden]=\"email.valid || email.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\tEmail is required.\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Submit Button -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n            \t\t<button type=\"submit\" [disabled]=\"!registerForm.form.valid || formSubmitted\" (click)=\"onSubmit()\">Register</button>\n\t\t\t\t</div>\n\t\t\t</div>\n        </form>\n\t\t\n        <form #registerNonAisForm=\"ngForm\" *ngIf=\"selectedTab == 2\">\n\t\t\t<!-- Alert Box -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<alert-box [message]=\"message\" [type]=\"messageType\"></alert-box>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Email Input Field -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<h3 class=\"fz1125\">Parent Details</h3>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"relationship\">Relationship to student</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Type your Relationship to student\" id=\"nonais-relationship\" name=\"nonais-relationship\" required [(ngModel)]=\"nonAisParent.relationship\"\n\t\t\t\t\t #nonaisRelationship=\"ngModel\" required>\n\t\t\t\t\t<div [hidden]=\"nonaisRelationship.valid || nonaisRelationship.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\tRelationship is required.\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"family-name\">Family Name</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Type your Family Name\" id=\"nonais-family-name\" name=\"nonais-family-name\" required [(ngModel)]=\"nonAisParent.family_name\"\n\t\t\t\t\t #nonaisFamilyName=\"ngModel\" required>\n\t\t\t\t\t<div [hidden]=\"nonaisFamilyName.valid || nonaisFamilyName.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\tFamily Name is required.\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\n\t\t\t</div>\n\t\t\t<!-- Email Input Field -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"given-name\">Given Name</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Type your Given Name\" id=\"nonais-given-name\" name=\"nonais-given-name\" required\n\t\t\t\t\t\t[(ngModel)]=\"nonAisParent.given_name\" #nonaisGivenName=\"ngModel\" required>\n\t\t\t\t\t<div [hidden]=\"nonaisGivenName.valid || nonaisGivenName.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\tGiven Name is required.\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Email Input Field -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"nonais-email\">Email</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Email\" id=\"nonais-email\" name=\"nonais-email\" \n\t\t\t\t\t\t\t[(ngModel)]=\"nonAisParent.email\" #nonaisEmail=\"ngModel\" required>\n\t\t\t\t\t<div [hidden]=\"nonaisEmail.valid || nonaisEmail.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\tEmail is required.\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Phone Number Input Field -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"phone\">Phone Number</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"No international phone number please\" id=\"nonais-phone\" name=\"nonais-phone\"\n\t\t\t\t\t\t[(ngModel)]=\"nonAisParent.phone\" #nonaisPhone=\"ngModel\" required>\n\t\t\t\t\t<div [hidden]=\"nonaisPhone.valid || nonaisPhone.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\tPhone number is required.\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n           \n\t\t\t<!-- Submit Button -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<button type=\"submit\" name=\"submit\" (click)=\"onSubmitNonAis()\">Register</button>\n\t\t\t\t</div>\n\t\t\t</div>\n        </form>\n    </div>\n</div>";

/***/ }),

/***/ 231:
/***/ (function(module, exports) {

	module.exports = ".fz1125{font-size:1.125rem;margin-bottom:0.5rem}select{border:1px solid #dddddd;border-radius:0.2rem;-moz-border-radius:0.2rem;-webkit-border-radius:0.2rem;box-sizing:border-box;width:100%;height:2.4375rem;border:1px solid #cacaca;margin:0 0 1rem;font-family:inherit;font-size:1rem;color:#616060;background-color:#fefefe}h4{font-size:1rem;padding:1rem 0;color:#00707e;text-align:left}.tabs{margin-bottom:-7px;position:relative;z-index:29;border-top-right-radius:5px;border-top-left-radius:5px;border:none}.tabs li{width:50%}.tabs li a{background:#00707e;color:#fff;font-weight:400;font-size:1rem}.tabs li:first-child{border-top-left-radius:5px}.tabs li:last-child{border-top-right-radius:5px}.tabs li>.is-active{background:#fff;color:#00707e;font-weight:500;border-top-right-radius:5px;border-top-left-radius:5px}#user-register-component{padding:1rem}#user-register-component .component-title{margin:3rem auto;width:31.25%;color:#fff;text-align:center}#user-register-component .component-content{margin:3rem auto;width:31.25%;background:#fff;border-radius:0.5rem;padding-bottom:1.5rem}#user-register-component .component-content .top-content h3{padding:1rem;background:#00707e;color:#fff;border-top-right-radius:6px;border-top-left-radius:6px}#user-register-component .component-content form{padding:0 1rem;box-shadow:none}#user-register-component .component-content form .terms-conditions{font-size:0.65rem;font-weight:500;text-align:center}#user-register-component .component-content form button{width:100%}@media (min-width: 1025px){#user-register-component .component-title{max-width:400px}#user-register-component .component-content{max-width:400px}}@media (min-width: 768px) and (max-width: 1024px){#user-register-component .component-title{width:50%;max-width:400px}#user-register-component .component-content{width:50%;max-width:400px}}@media (min-width: 320px) and (max-width: 767px){#user-register-component{padding:0}#user-register-component .component-title{display:none}#user-register-component .component-content{margin:0;width:100%}#user-register-component .component-content form{border:none;border-radius:0rem}}\n"

/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	//Services
	var RegisterService_1 = __webpack_require__(228);
	var HolChoosePasswordComponent = (function () {
	    function HolChoosePasswordComponent(router, route, registerService) {
	        this.router = router;
	        this.route = route;
	        this.registerService = registerService;
	        this.redirectUrl = "hol-login";
	        this.formSubmitted = false;
	    }
	    HolChoosePasswordComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        // Get token string from URL.
	        this.route.params.forEach(function (params) {
	            _this.recovery = params['recovery'];
	        });
	        // Verify if recpvery is valid or not.
	        // this.verifyRecovery();
	    };
	    // Called when user submit form
	    HolChoosePasswordComponent.prototype.onSubmit = function () {
	        // Mark form as submitted to disable submit button
	        this.formSubmitted = true;
	        // Reset form alert message 
	        this.message = "";
	        this.messageType = "";
	        // Process set new password
	        this.setNewPassword();
	    };
	    HolChoosePasswordComponent.prototype.setNewPassword = function () {
	        var _this = this;
	        this.registerService.setPasswordWithActivationRecovery(this.recovery, this.oldEmail, this.newPassword)
	            .subscribe(function (complete) {
	            _this.message = "Set password successfully. You will be redirected to Login Page in 5 seconds.";
	            _this.messageType = "success";
	            // Delay 5s before redirect to login page
	            setTimeout(function () {
	                _this.redirect();
	            }, 5000);
	        }, function (error) {
	            if (error.json().message == 'parent-invalid') {
	                _this.message = "The email address is invalid";
	            }
	            if (error.json().message == 'recovery-invalid') {
	                _this.message = "The password was already set up";
	            }
	            _this.messageType = "alert";
	            _this.formSubmitted = false;
	        });
	    };
	    HolChoosePasswordComponent.prototype.redirect = function () {
	        // Redirect to stored url
	        this.router.navigate([this.redirectUrl]);
	    };
	    return HolChoosePasswordComponent;
	}());
	HolChoosePasswordComponent = __decorate([
	    core_1.Component({
	        selector: 'user-set-password',
	        template: __webpack_require__(233),
	        styles: [__webpack_require__(234)],
	    }),
	    __metadata("design:paramtypes", [router_1.Router,
	        router_1.ActivatedRoute,
	        RegisterService_1.RegisterService])
	], HolChoosePasswordComponent);
	exports.HolChoosePasswordComponent = HolChoosePasswordComponent;


/***/ }),

/***/ 233:
/***/ (function(module, exports) {

	module.exports = "<div id=\"user-choose-password-component\" class=\"eca-background\">\n\t<div class=\"component-title\">\n\t\t<h1>WELCOME TO AIS</h1>\n\t</div>\n\t<div class=\"component-content\">\n\t\t<form (ngSubmit)=\"onSubmit()\" #forgotPasswordForm=\"ngForm\">\n\t\t\t<h3 class=\"text-center\">Set new password</h3>\n\t\t\t<!-- Alert Box -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<alert-box [message]=\"message\" [type]=\"messageType\"></alert-box>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Email Input Field -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"email\">Please Re-type the email</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Email\" id=\"email\" name=\"email\" \n\t\t\t\t\t\t\t[(ngModel)]=\"oldEmail\" #email=\"ngModel\" required>\n\t\t\t\t\t<!--<div [hidden]=\"email.valid || email.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\tEmail is required.\n\t\t\t\t\t</div>-->\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t\n\t\t\t<!-- Password Input Field -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"password\">New Password</label>\n\t\t\t\t\t<input type=\"password\" placeholder=\"Type your new password\" id=\"password\" \n\t\t\t\t\t\t[(ngModel)]=\"newPassword\" name=\"password\" #password=\"ngModel\" required minlength=\"6\">\n\t\t\t\t\t<div [hidden]=\"password.valid || password.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\tPassword is required and must have at least 6 characters.\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Confirm Password Input Field -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"confirm-password\">Confirm New Password</label>\n\t\t\t\t\t<input type=\"password\" placeholder=\"Confirm your new password\" id=\"confirm-password\" \n\t\t\t\t\t\t[(ngModel)]=\"confirmNewPassword\" name=\"confirm-password\" #confirmPassword=\"ngModel\" required minlength=\"6\">\n\t\t\t\t\t<div [hidden]=\"confirmPassword.value === password.value || confirmPassword.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\tConfirm Password must match with the new password.\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Submit Button -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<button type=\"submit\" name=\"submit\" [disabled]=\"!forgotPasswordForm.form.valid || formSubmitted\">Submit</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</form>\n\t</div>\n</div>";

/***/ }),

/***/ 234:
/***/ (function(module, exports) {

	module.exports = "#user-choose-password-component{padding:1rem}#user-choose-password-component .component-title{margin:3rem auto;width:31.25%;color:#fff;text-align:center}#user-choose-password-component .component-content{margin:3rem auto;width:31.25%}#user-choose-password-component .component-content form button{width:100%}@media (min-width: 1025px){#user-choose-password-component .component-title{max-width:450px}#user-choose-password-component .component-content{max-width:450px}}@media (min-width: 768px) and (max-width: 1024px){#user-choose-password-component .component-title{width:50%;max-width:450px}#user-choose-password-component .component-content{width:50%;max-width:450px}}@media (min-width: 320px) and (max-width: 767px){#user-choose-password-component{padding:0}#user-choose-password-component .component-title{display:none}#user-choose-password-component .component-content{margin:0;width:100%}#user-choose-password-component .component-content form{border:none;border-radius:0rem}}\n"

/***/ }),

/***/ 235:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var Credential_1 = __webpack_require__(224);
	var PasswordService_1 = __webpack_require__(236);
	var HolForgotPasswordComponent = (function () {
	    function HolForgotPasswordComponent(passwordService) {
	        this.passwordService = passwordService;
	        this.formSubmitted = false;
	    }
	    HolForgotPasswordComponent.prototype.ngOnInit = function () {
	        this.credential = new Credential_1.Credential('hol-parent', '', '');
	    };
	    HolForgotPasswordComponent.prototype.onSubmit = function () {
	        // Call API service to send a reset password email
	        // when user submit the email address
	        this.formSubmitted = true;
	        this.sendResetPasswordEmail(this.credential);
	    };
	    /**
	     * Call API service to send the credential and request for a reset password email.
	     * @param {Credential} - user credential
	     * @complete - Update message & messageType for display, reset credential.
	     * @error - Set message & messageType as error. Reset form submit.
	     */
	    HolForgotPasswordComponent.prototype.sendResetPasswordEmail = function (credential) {
	        var _this = this;
	        this.passwordService.sendResetPasswordEmail(credential.role, credential.email)
	            .subscribe(function (complete) {
	            _this.messageType = "success",
	                _this.message = "A reset password email had been sent.";
	            _this.formSubmitted = false;
	        }, function (error) {
	            _this.messageType = "alert";
	            _this.message = "Cannot send reset password email.";
	            _this.formSubmitted = false;
	        });
	    };
	    return HolForgotPasswordComponent;
	}());
	HolForgotPasswordComponent = __decorate([
	    core_1.Component({
	        selector: 'user-forgot-password',
	        template: __webpack_require__(237),
	        styles: [__webpack_require__(238)],
	    }),
	    __metadata("design:paramtypes", [PasswordService_1.PasswordService])
	], HolForgotPasswordComponent);
	exports.HolForgotPasswordComponent = HolForgotPasswordComponent;


/***/ }),

/***/ 236:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	//Libraries
	var core_1 = __webpack_require__(3);
	// Services
	var services_1 = __webpack_require__(58);
	var PasswordService = (function () {
	    function PasswordService(settingService, apiService) {
	        this.settingService = settingService;
	        this.apiService = apiService;
	        this.passwordUrl = '/password';
	        this.passwordResetUrl = '/password-resets';
	        this.apiUrl = '';
	        this.apiUrl = this.settingService.getSetting('api_service_domain');
	    }
	    /**
	     * Call API service to request for a reset password email.
	     * @param {string} role - role of the user.
	     * @param {string} email - email to send the reset password.
	     * @returns {Observable<any>} - Status code 202: Accepted.
	     */
	    PasswordService.prototype.sendResetPasswordEmail = function (role, email) {
	        var requestUrl = this.apiUrl + this.passwordResetUrl;
	        var body = JSON.stringify({
	            'role': role,
	            'email': email
	        });
	        return this.apiService.post(requestUrl, body);
	    };
	    /**
	     * Call API service to verify the token sent in the reset password email.
	     * @param {string} token - token string.
	     * @returns {Observable<any>}
	     *  - Status code 200: OK
	     *  - Status code 404: Not Found or Expired
	     */
	    PasswordService.prototype.verifyPasswordResetToken = function (token) {
	        var requestUrl = this.apiUrl + this.passwordResetUrl + "/" + token;
	        return this.apiService.get(requestUrl);
	    };
	    /**
	     * Call API service to set new password with the token sent in the reset
	     * password email.
	     * @param {string} token
	     * @param {string} password
	     * @returns {Observable<any>}
	     *  - Status code 204: Password Assigned
	     *  - Status code 404: Not Found or Expired
	     */
	    PasswordService.prototype.setPasswordWithResetToken = function (token, password) {
	        var requestUrl = this.apiUrl + this.passwordResetUrl + "/" + token;
	        // TODO: update body content
	        var body = JSON.stringify({ password: password });
	        return this.apiService.patch(requestUrl, body);
	    };
	    /**
	     * Call API service to request for new password update.
	     * @param {string} oldPassword - old password input
	     * @param {string} newPassword - new password input
	     * @returns {Observable<any>}
	     *  - Status code 204: Password Changed
	     *  - Status code 401: Unauthorized or Incorrect Password
	     */
	    PasswordService.prototype.setNewPassword = function (oldPassword, newPassword) {
	        var requestUrl = this.apiUrl + this.passwordUrl;
	        var body = JSON.stringify({
	            'old': oldPassword,
	            'new': newPassword
	        });
	        return this.apiService.post(requestUrl, body);
	    };
	    return PasswordService;
	}());
	PasswordService = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [services_1.SettingService,
	        services_1.ApiService])
	], PasswordService);
	exports.PasswordService = PasswordService;


/***/ }),

/***/ 237:
/***/ (function(module, exports) {

	module.exports = "<div id=\"user-forgot-password-component\" class=\"eca-background\">\n\t<div class=\"component-title\">\n\t\t<h1>WELCOME TO AIS</h1>\n\t</div>\n\t<div class=\"component-content\">\n\t\t<form (ngSubmit)=\"onSubmit()\" #forgotPasswordForm=\"ngForm\">\n\t\t\t<h3 class=\"text-center\">Forgot your password</h3>\n\t\t\t<!-- Alert Box -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<alert-box [message]=\"message\" [type]=\"messageType\"></alert-box>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Email Input Field -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"email\">Email</label>\n\t\t\t\t\t<input type=\"email\" placeholder=\"Type your email to reset password\" id=\"email\" \n\t\t\t\t\t\t[(ngModel)]=\"credential.email\" name=\"email\" #email=\"ngModel\" required>\n\t\t\t\t\t<div [hidden]=\"email.valid || email.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\tEmail is required.\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Submit Button -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<button type=\"submit\" name=\"submit\" [disabled]=\"!forgotPasswordForm.form.valid || formSubmitted\">Submit</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</form>\n\t</div>\n</div>";

/***/ }),

/***/ 238:
/***/ (function(module, exports) {

	module.exports = "#user-forgot-password-component{padding:1rem}#user-forgot-password-component .component-title{margin:3rem auto;width:31.25%;color:#fff;text-align:center}#user-forgot-password-component .component-content{margin:3rem auto;width:31.25%}#user-forgot-password-component .component-content form button{width:100%}@media (min-width: 1025px){#user-forgot-password-component .component-title{max-width:450px}#user-forgot-password-component .component-content{max-width:450px}}@media (min-width: 768px) and (max-width: 1024px){#user-forgot-password-component .component-title{width:50%;max-width:450px}#user-forgot-password-component .component-content{width:50%;max-width:450px}}@media (min-width: 320px) and (max-width: 767px){#user-forgot-password-component{padding:0}#user-forgot-password-component .component-title{display:none}#user-forgot-password-component .component-content{margin:0;width:100%}#user-forgot-password-component .component-content form{border:none;border-radius:0rem}}\n"

/***/ }),

/***/ 239:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var PasswordService_1 = __webpack_require__(236);
	var HolChangePasswordComponent = (function () {
	    function HolChangePasswordComponent(passwordService, router) {
	        this.passwordService = passwordService;
	        this.router = router;
	        this.redirectUrl = "booking/students";
	        this.formSubmitted = false;
	    }
	    HolChangePasswordComponent.prototype.ngOnInit = function () {
	        this.message = "";
	        this.messageType = "";
	    };
	    HolChangePasswordComponent.prototype.onSubmit = function () {
	        // Mark form as submitted to disable submit button
	        this.formSubmitted = true;
	        // Reset form alert message 
	        this.message = "";
	        this.messageType = "";
	        this.changePassword(this.oldPassword, this.newPassword);
	    };
	    HolChangePasswordComponent.prototype.changePassword = function (oldPassword, newPassword) {
	        var _this = this;
	        this.passwordService.setNewPassword(oldPassword, newPassword)
	            .subscribe(function (complete) {
	            _this.message = "Changed password successfully. You will be redirected to Children List Page in 5 seconds.";
	            _this.messageType = "success";
	            // Delay 5s before redirect to children list page
	            setTimeout(function () {
	                _this.redirect(_this.redirectUrl);
	            }, 5000);
	        }, function (error) {
	            _this.message = "Invalid old password input.";
	            _this.messageType = "alert";
	            _this.formSubmitted = false;
	        });
	    };
	    HolChangePasswordComponent.prototype.redirect = function (redirectUrl) {
	        this.router.navigate([redirectUrl]);
	    };
	    return HolChangePasswordComponent;
	}());
	HolChangePasswordComponent = __decorate([
	    core_1.Component({
	        selector: 'user-change-password',
	        template: __webpack_require__(240),
	        styles: [__webpack_require__(241)],
	    }),
	    __metadata("design:paramtypes", [PasswordService_1.PasswordService,
	        router_1.Router])
	], HolChangePasswordComponent);
	exports.HolChangePasswordComponent = HolChangePasswordComponent;


/***/ }),

/***/ 240:
/***/ (function(module, exports) {

	module.exports = "<div id=\"user-change-password-component\" class=\"eca-background\">\n\t<div class=\"component-title\"></div>\n\t<div class=\"component-content\">\n\t\t<form (ngSubmit)=\"onSubmit()\" #changePasswordForm=\"ngForm\">\n\t\t\t<h3 class=\"text-center\">Change password</h3>\n\t\t\t<!-- Alert Box -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<alert-box [message]=\"message\" [type]=\"messageType\"></alert-box>\n\t\t\t\t</div>\n\t\t\t</div>\n            <!-- Old Password Input Field -->\n            <div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"old-password\">Old Password</label>\n\t\t\t\t\t<input type=\"password\" placeholder=\"Type your current password\" id=\"old-password\" name=\"oldPassword\"\n\t\t\t\t\t\t[(ngModel)]=\"oldPassword\" #oldPasswordControl=\"ngModel\" required minlength=\"6\">\n\t\t\t\t\t<div [hidden]=\"oldPasswordControl.valid || oldPasswordControl.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\tThis field is required and must be at least 6 characters long.\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- New Password Input Field -->\n            <div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"new-password\">New Password</label>\n\t\t\t\t\t<input type=\"password\" placeholder=\"Type your new password\" id=\"new-password\" name=\"newPassword\"\n\t\t\t\t\t\t[(ngModel)]=\"newPassword\" #newPasswordControl=\"ngModel\" required minlength=\"6\">\n\t\t\t\t\t<div [hidden]=\"newPasswordControl.valid || newPasswordControl.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\tThis field is required and must be at least 6 characters long.\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Confirm Password Input Field -->\n            <div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"confirm-new-password\">Confirm New Password</label>\n\t\t\t\t\t<input type=\"password\" placeholder=\"Confirm your new password\" id=\"confirm-new-password\" name=\"confirmNewPassword\" \n\t\t\t\t\t\t[(ngModel)]=\"confirmNewPassword\" #confirmNewPasswordControl=\"ngModel\" required>\n\t\t\t\t\t<div [hidden]=\"confirmNewPasswordControl.value === newPasswordControl.value || confirmNewPasswordControl.pristine\" \n\t\t\t\t\t\tclass=\"help-text text-alert\">\n\t\t\t\t\t\tConfirm password does not matched.\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Submit Button -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<button type=\"submit\" name=\"submit\" [disabled]=\"!changePasswordForm.form.valid || formSubmitted\">Submit</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</form>\n\t</div>\n</div>";

/***/ }),

/***/ 241:
/***/ (function(module, exports) {

	module.exports = "#user-change-password-component{padding:1rem}#user-change-password-component .component-title{margin:3rem auto;width:31.25%;color:#fff;text-align:center}#user-change-password-component .component-content{margin:3rem auto;width:31.25%}#user-change-password-component .component-content form button{width:100%}@media (min-width: 1025px){#user-change-password-component .component-title{max-width:450px}#user-change-password-component .component-content{max-width:450px}}@media (min-width: 768px) and (max-width: 1024px){#user-change-password-component .component-title{width:50%;max-width:450px}#user-change-password-component .component-content{width:50%;max-width:450px}}@media (min-width: 320px) and (max-width: 767px){#user-change-password-component{padding:0}#user-change-password-component .component-title{display:none}#user-change-password-component .component-content{margin:0;width:100%}#user-change-password-component .component-content form{border:none;border-radius:0rem}}\n"

/***/ }),

/***/ 242:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var PasswordService_1 = __webpack_require__(236);
	var HolSetNewPasswordComponent = (function () {
	    function HolSetNewPasswordComponent(router, route, passwordService) {
	        this.router = router;
	        this.route = route;
	        this.passwordService = passwordService;
	        this.redirectUrl = "hol-login";
	        this.formSubmitted = false;
	    }
	    HolSetNewPasswordComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        // Get token string from URL.
	        this.route.params.forEach(function (params) {
	            _this.token = params['token'];
	        });
	        // Verify if token is valid or not.
	        this.verifyToken();
	    };
	    // Called when user submit form
	    HolSetNewPasswordComponent.prototype.onSubmit = function () {
	        // Mark form as submitted to disable submit button
	        this.formSubmitted = true;
	        // Reset form alert message 
	        this.message = "";
	        this.messageType = "";
	        // Process set new password
	        this.setNewPassword(this.token, this.newPassword);
	    };
	    // Verify reset password token with servie
	    HolSetNewPasswordComponent.prototype.verifyToken = function () {
	        var _this = this;
	        this.passwordService.verifyPasswordResetToken(this.token)
	            .subscribe(function (complete) {
	            _this.formSubmitted = false;
	        }, function (error) {
	            // Set message type as error and message error content
	            _this.message = "Token not found or expired.";
	            _this.messageType = "alert";
	            // Set form as submitted to prevent user post their new password
	            _this.formSubmitted = true;
	        });
	    };
	    // Set new password with new password input and verified token
	    HolSetNewPasswordComponent.prototype.setNewPassword = function (token, newPassword) {
	        var _this = this;
	        this.passwordService.setPasswordWithResetToken(token, newPassword)
	            .subscribe(function (complete) {
	            // Update message on success
	            _this.message = "Changed password successfully. You will be redirected to Login Page in 5 seconds.";
	            _this.messageType = "success";
	            // Delay 5s before redirect to login page
	            setTimeout(function () {
	                _this.redirect(_this.redirectUrl);
	            }, 5000);
	        }, function (error) {
	            // Set message type as error and error message content
	            _this.message = "There is an issue when setting new password.";
	            _this.messageType = "alert";
	            // Reset form submit status
	            _this.formSubmitted = false;
	        });
	    };
	    // Redirect to desired url
	    HolSetNewPasswordComponent.prototype.redirect = function (url) {
	        this.router.navigate([this.redirectUrl]);
	    };
	    return HolSetNewPasswordComponent;
	}());
	HolSetNewPasswordComponent = __decorate([
	    core_1.Component({
	        selector: 'user-set-new-password',
	        template: __webpack_require__(243),
	        styles: [__webpack_require__(244)],
	    }),
	    __metadata("design:paramtypes", [router_1.Router,
	        router_1.ActivatedRoute,
	        PasswordService_1.PasswordService])
	], HolSetNewPasswordComponent);
	exports.HolSetNewPasswordComponent = HolSetNewPasswordComponent;


/***/ }),

/***/ 243:
/***/ (function(module, exports) {

	module.exports = "<div id=\"user-set-new-password-component\" class=\"eca-background\">\n\t<div class=\"component-title\">\n\t\t<h1>WELCOME TO AIS</h1>\n\t</div>\n\t<div class=\"component-content\">\n\t\t<form (ngSubmit)=\"onSubmit()\" #forgotPasswordForm=\"ngForm\">\n\t\t\t<h3 class=\"text-center\">Set new password</h3>\n\t\t\t<!-- Alert Box -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<alert-box [message]=\"message\" [type]=\"messageType\"></alert-box>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Password Input Field -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"password\">New Password</label>\n\t\t\t\t\t<input type=\"password\" placeholder=\"Type your new password\" id=\"password\" \n\t\t\t\t\t\t[(ngModel)]=\"newPassword\" name=\"password\" #password=\"ngModel\" required minlength=\"6\">\n\t\t\t\t\t<div [hidden]=\"password.valid || password.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\tPassword is required and must have at least 6 characters.\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Confirm Password Input Field -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"confirm-password\">Confirm New Password</label>\n\t\t\t\t\t<input type=\"password\" placeholder=\"Confirm your new password\" id=\"confirm-password\" \n\t\t\t\t\t\t[(ngModel)]=\"confirmNewPassword\" name=\"confirm-password\" #confirmPassword=\"ngModel\" required minlength=\"6\">\n\t\t\t\t\t<div [hidden]=\"confirmPassword.value === password.value || confirmPassword.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\tConfirm Password must match with the new password.\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Submit Button -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<button type=\"submit\" name=\"submit\" [disabled]=\"!forgotPasswordForm.form.valid || formSubmitted\">Submit</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</form>\n\t</div>\n</div>";

/***/ }),

/***/ 244:
/***/ (function(module, exports) {

	module.exports = "#user-set-new-password-component{padding:1rem}#user-set-new-password-component .component-title{margin:3rem auto;width:31.25%;color:#fff;text-align:center}#user-set-new-password-component .component-content{margin:3rem auto;width:31.25%}#user-set-new-password-component .component-content form button{width:100%}@media (min-width: 1025px){#user-set-new-password-component .component-title{max-width:450px}#user-set-new-password-component .component-content{max-width:450px}}@media (min-width: 768px) and (max-width: 1024px){#user-set-new-password-component .component-title{width:50%;max-width:450px}#user-set-new-password-component .component-content{width:50%;max-width:450px}}@media (min-width: 320px) and (max-width: 767px){#user-set-new-password-component{padding:0}#user-set-new-password-component .component-title{display:none}#user-set-new-password-component .component-content{margin:0;width:100%}#user-set-new-password-component .component-content form{border:none;border-radius:0rem}}\n"

/***/ }),

/***/ 245:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	// Services
	// import { HolidayService } from '../../../../holiday/services/HolidayService';
	var SessionService_1 = __webpack_require__(82);
	var UserService_1 = __webpack_require__(81);
	var Credential_1 = __webpack_require__(224);
	var LoginComponent = (function () {
	    function LoginComponent(
	        // private holidayService: HolidayService,
	        sessionService, userService, router) {
	        this.sessionService = sessionService;
	        this.userService = userService;
	        this.router = router;
	        this.formSubmitted = false;
	        this.holidayDomain = ['holiday.eca.nascorp.vn', 'holiday.eca.test.nascorp.vn', 'staging.holidayschool.aisvietnam.com', 'holidayschool.aisvietnam.com', 'holiday.local.eca.nascorp.vn'];
	    }
	    LoginComponent.prototype.ngOnInit = function () {
	        // this.redirectUrl = '/booking/students';
	        this.redirectUrl = '/parents';
	        this.credential = new Credential_1.Credential('parent', '', '');
	        // Use Session Service to get session and check if user had already logged in.
	        this.getSession();
	        this.hostName = window.location.hostname;
	    };
	    ;
	    LoginComponent.prototype.onSubmit = function () {
	        this.formSubmitted = true;
	        // Reset message content
	        this.message = "";
	        // Post user login data to create session
	        this.postSession(this.credential);
	    };
	    /**
	     * Get Session from API service to make sure that user had logged in.
	     * Update User Data on local storage and redirect to the desired URL
	     * if request responses session data.
	     * @param none
	     * @return none
	     */
	    LoginComponent.prototype.getSession = function () {
	        var _this = this;
	        this.sessionService.getSession()
	            .subscribe(function (user) {
	            _this.userService.setUserSessionData(user);
	            _this.redirect(_this.redirectUrl);
	        }, function (error) {
	            //TO DO: Handle any error if needed in the furture
	            _this.message = "";
	            _this.messageType = "alert";
	        });
	    };
	    /**
	     * Post Session to API service to create new session.
	     * Update User Data on local storage and redirect to desired URL
	     * if request responses session data.
	     * @param {Credential} - user credential input
	     * @return none
	     */
	    LoginComponent.prototype.postSession = function (credential) {
	        var _this = this;
	        this.sessionService.postSession(credential)
	            .subscribe(function (user) {
	            // Set user session data
	            _this.userService.setUserSessionData(user);
	            // Fire user session data changed event
	            _this.userService.userDataChanged(user);
	            // Redirect to desired URL
	            _this.redirect(_this.redirectUrl);
	        }, function (error) {
	            _this.formSubmitted = false;
	            _this.message = "Invalid email address or password.";
	            _this.messageType = "alert";
	        });
	    };
	    // Redirect to desired url
	    LoginComponent.prototype.redirect = function (redirectUrl) {
	        this.router.navigate([redirectUrl]);
	    };
	    return LoginComponent;
	}());
	LoginComponent = __decorate([
	    core_1.Component({
	        selector: 'user-login',
	        template: __webpack_require__(246),
	        styles: [__webpack_require__(247)],
	    }),
	    __metadata("design:paramtypes", [SessionService_1.SessionService,
	        UserService_1.UserService,
	        router_1.Router])
	], LoginComponent);
	exports.LoginComponent = LoginComponent;


/***/ }),

/***/ 246:
/***/ (function(module, exports) {

	module.exports = "<div id=\"user-login-component\" class=\"eca-background\">\n    <div class=\"component-title\">\n        <h1>WELCOME TO AIS</h1>\n    </div>\n    <div class=\"component-content\">\n        <form (ngSubmit)=\"onSubmit()\" #loginForm=\"ngForm\">\n\t\t\t<!-- Form Title -->\n            <h3 class=\"text-center\">Login to your account</h3>\n\t\t\t<!-- Alert Box -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<alert-box [message]=\"message\" [type]=\"messageType\"></alert-box>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Email Input Field -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"email\">Email</label>\n\t\t\t\t\t<input type=\"email\" placeholder=\"Type your email address\" id=\"email\" \n\t\t\t\t\t\t[(ngModel)]=\"credential.email\" name=\"email\" #email=\"ngModel\" required>\n\t\t\t\t\t<div [hidden]=\"email.valid || email.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\tEmail is required.\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Password Input Field -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"password\">Password</label>\n\t\t\t\t\t<input type=\"password\" placeholder=\"Type your password\" id=\"password\" \n\t\t\t\t\t\t[(ngModel)]=\"credential.password\" name=\"password\" #password=\"ngModel\" required>\n\t\t\t\t\t<div [hidden]=\"password.valid || password.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\tPassword is required.\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Remember Me & Forgot Password -->\n            <div class=\"row\">\n\t\t\t\t<div class=\"medium-6 columns remember-block\">\n\t\t\t\t\t<a target=\"_blank\" href=\"http://www.aisvietnam.com/wp-content/uploads/2017/08/AIS-Service-GuidelineforParents.pdf\" class=\"forgot-password text-left\">Guideline</a>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"medium-6 columns\">\n\t\t\t\t\t<a routerLink=\"/forgot-password\" class=\"forgot-password text-right\">Forgot Password?</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Submit Button -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<button type=\"submit\" name=\"submit\" [disabled]=\"!loginForm.form.valid || formSubmitted\">Login</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Register Link -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n            \t\t<label class=\"register-link\">Do not have an account yet? <a routerLink=\"/register\">REGISTER NOW</a></label>\n\t\t\t\t</div>\n\t\t\t</div>\n        </form>\n    </div>\n</div>";

/***/ }),

/***/ 247:
/***/ (function(module, exports) {

	module.exports = ".tabs{margin-bottom:-7px;position:relative;z-index:29;border-top-right-radius:5px;border-top-left-radius:5px;border:none}.tabs li{width:50%}.tabs li a{background:#00707e;color:#fff;font-weight:400;font-size:1rem}.tabs li:first-child{border-top-left-radius:5px}.tabs li:last-child{border-top-right-radius:5px}.tabs li>.is-active{background:#fff;color:#00707e;font-weight:500;border-top-right-radius:5px;border-top-left-radius:5px}#user-login-component{padding:1rem}#user-login-component .component-title{margin:3rem auto;width:31.25%;color:#fff;text-align:center}#user-login-component .component-content{margin:3rem auto;width:31.25%}#user-login-component .component-content form div.remember-block{position:relative;font-size:0.8rem;margin-bottom:0.5rem}#user-login-component .component-content form div.remember-block input[type=\"checkbox\"]{position:absolute;height:1.1rem;width:1.1rem;top:0.5rem;cursor:pointer}#user-login-component .component-content form div.remember-block label{margin-left:1.5rem}#user-login-component .component-content form .register-link{font-size:0.65rem;font-weight:500;text-align:center}#user-login-component .component-content form .forgot-password{display:block;font-size:0.8rem}#user-login-component .component-content form button:not(.close-button){width:100%}#user-login-component .component-content form button.close-button{line-height:1.2}@media (min-width: 1025px){#user-login-component .component-title{max-width:450px}#user-login-component .component-content{max-width:450px}}@media (min-width: 768px) and (max-width: 1024px){#user-login-component .component-title{width:50%;max-width:450px}#user-login-component .component-content{width:50%;max-width:450px}}@media (min-width: 320px) and (max-width: 767px){#user-login-component{padding:0}#user-login-component .component-title{display:none}#user-login-component .component-content{margin:0;width:100%}#user-login-component .component-content form{border:none;border-radius:0rem}}\n"

/***/ }),

/***/ 248:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	// Services
	var SessionService_1 = __webpack_require__(82);
	var UserService_1 = __webpack_require__(81);
	var services_1 = __webpack_require__(58);
	var config_1 = __webpack_require__(85);
	var LogoutComponent = (function () {
	    function LogoutComponent(router, sessionService, localStorageService, userService) {
	        this.router = router;
	        this.sessionService = sessionService;
	        this.localStorageService = localStorageService;
	        this.userService = userService;
	        // For logout navigate
	        this.devEnv = ['camp.eca.nascorp.vn', 'asa.eca.nascorp.vn', 'holiday.eca.nascorp.vn', 'bus.eca.nascorp.vn', 'reen.eca.nascorp.vn'];
	        this.testEnv = ['camp.eca.test.nascorp.vn', 'asa.eca.test.nascorp.vn', 'holiday.eca.test.nascorp.vn', 'bus.eca.test.nascorp.vn', 'reen.eca.test.nascorp.vn'];
	        this.stagingEnv = ['staging.outdooreducation.aisvietnam.com', 'staging.asa.aisvietnam.com', 'staging.holidayschool.aisvietnam.com', 'staging.bus.aisvietnam.com', 'staging.reen.aisvietnam.com'];
	        this.procEnv = ['outdooreducation.aisvietnam.com', 'asa.aisvietnam.com', 'holidayschool.aisvietnam.com', 'bus.aisvietnam.com', 'reen.aisvietnam.com'];
	        this.prodEnv = ['outdooreducation.ishcmc.nascorp.vn', 'holidayschool.ishcmc.nascorp.vn', 'bus.ishcmc.nascorp.vn'];
	        this.prodEnvEishcmc = ['bus.eishcmc.exe.school'];
	        this.demoEnv = ['camp.demo.nascorp.vn', 'asa.demo.nascorp.vn', 'holiday.demo.nascorp.vn', 'bus.demo.nascorp.vn', 'reen.demo.nascorp.vn'];
	        this.prodEnvBishanoi = ['bus.bishanoi.exe.school'];
	        this.prodEnvBishcm = ['bus.bishcm.exe.school'];
	        this.prodEnvIssp = ['bus.issp.exe.school'];
	        this.prodEnvBishanoistaging = ['bus.bishanoistaging.exe.school'];
	    }
	    LogoutComponent.prototype.ngOnInit = function () {
	        this.hostName = window.location.hostname;
	        // Delete session from system
	        this.deleteSession();
	    };
	    /**
	     * Delete user session data.
	     */
	    LogoutComponent.prototype.deleteSession = function () {
	        var _this = this;
	        this.sessionService.deleteSession()
	            .subscribe(function (complete) {
	            // Clear user session
	            _this.userService.clearUserSessionData();
	            // Fire user session data changed event
	            _this.userService.userDataChanged(null);
	            // Redirect to desired URL                    
	            if (_this.devEnv.indexOf(_this.hostName) !== -1) {
	                return window.location.href = 'http://services.eca.nascorp.vn';
	            }
	            else if (_this.testEnv.indexOf(_this.hostName) !== -1) {
	                return window.location.href = 'http://services.eca.test.nascorp.vn';
	            }
	            else if (config_1.bisHanoiEnv.indexOf(_this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.bisHanoiEnv.services;
	            }
	            else if (config_1.bisHanoiDevEnv.indexOf(_this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.bisHanoiDevEnv.services;
	            }
	            else if (Object.values(config_1.bisHanoiStagingEnv).indexOf(_this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.bisHanoiStagingEnv.services;
	            }
	            else if (Object.values(config_1.ishcmcEnv).indexOf(_this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.ishcmcEnv.services;
	            }
	            else if (Object.values(config_1.aavnIshcmcEnv).indexOf(_this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.aavnIshcmcEnv.services;
	            }
	            else if (Object.values(config_1.primaryIshcmcEnv).indexOf(_this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.primaryIshcmcEnv.services;
	            }
	            else if (Object.values(config_1.secondaryIshcmcEnv).indexOf(_this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.secondaryIshcmcEnv.services;
	            }
	            else if (Object.values(config_1.isspEnv).indexOf(_this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.isspEnv.services;
	            }
	            else if (Object.values(config_1.demoHelenEnv).indexOf(_this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.demoHelenEnv.services;
	            }
	            else if (_this.stagingEnv.indexOf(_this.hostName) !== -1) {
	                return window.location.href = 'http://staging.services.aisvietnam.com';
	            }
	            else if (_this.procEnv.indexOf(_this.hostName) !== -1) {
	                return window.location.href = 'https://services.aisvietnam.com';
	            }
	            else if (_this.prodEnv.indexOf(_this.hostName) !== -1) {
	                return window.location.href = 'http://services.ishcmc.nascorp.vn/login';
	            }
	            else if (_this.prodEnvEishcmc.indexOf(_this.hostName) !== -1) {
	                return window.location.href = 'http://services.eishcmc.exe.school/login';
	            }
	            else if (_this.demoEnv.indexOf(_this.hostName) !== -1) {
	                return window.location.href = 'http://auth.demo.nascorp.vn';
	            }
	            else if (_this.prodEnvBishanoi.indexOf(_this.hostName) !== -1) {
	                return window.location.href = 'http://services.bishanoi.exe.school/login';
	            }
	            else if (_this.prodEnvBishcm.indexOf(_this.hostName) !== -1) {
	                return window.location.href = 'http://services.bishcm.exe.school/login';
	            }
	            else if (_this.prodEnvIssp.indexOf(_this.hostName) !== -1) {
	                return window.location.href = 'http://services.issp.exe.school/login';
	            }
	            else if (_this.prodEnvBishanoistaging.indexOf(_this.hostName) !== -1) {
	                return window.location.href = 'http://services.bishanoistaging.exe.school/login';
	            }
	            else {
	                return window.location.href = 'http://services.local.eca.nascorp.vn';
	            }
	        }, function (error) { return _this.errorMessage = error; });
	    };
	    // Redirect to desired url
	    LogoutComponent.prototype.redirect = function (redirectUrl) {
	        this.router.navigate([redirectUrl]);
	    };
	    return LogoutComponent;
	}());
	LogoutComponent = __decorate([
	    core_1.Component({
	        selector: 'user-logout',
	        template: '',
	        styles: [],
	    }),
	    __metadata("design:paramtypes", [router_1.Router,
	        SessionService_1.SessionService,
	        services_1.LocalStorageService,
	        UserService_1.UserService])
	], LogoutComponent);
	exports.LogoutComponent = LogoutComponent;


/***/ }),

/***/ 249:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	//Libraries
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	// Services
	var SessionService_1 = __webpack_require__(82);
	var UserService_1 = __webpack_require__(81);
	var RegisterService_1 = __webpack_require__(228);
	//Models
	var Credential_1 = __webpack_require__(224);
	var NonAisParent_1 = __webpack_require__(229);
	var RegisterComponent = (function () {
	    function RegisterComponent(sessionService, userService, registerService, router) {
	        this.sessionService = sessionService;
	        this.userService = userService;
	        this.registerService = registerService;
	        this.router = router;
	        this.formSubmitted = false;
	    }
	    RegisterComponent.prototype.ngOnInit = function () {
	        this.redirectUrl = '/booking/students';
	        this.selectedTab = 1;
	        this.nonAisParent = new NonAisParent_1.NonAisParent();
	        this.credential = new Credential_1.Credential('parent', '', '');
	        // Use Session Service to get session and check if user had already logged in.
	        this.getSession();
	    };
	    RegisterComponent.prototype.onSubmit = function () {
	        this.formSubmitted = true;
	        // Reset message content
	        this.message = "";
	        // Post user login data to create session
	        this.register(this.credential);
	    };
	    /**
	     * Get Session from API service to make sure that user had logged in.
	     * Update User Data on local storage and redirect to the desired URL
	     * if request responses session data.
	     * @param none
	     * @return none
	     */
	    RegisterComponent.prototype.getSession = function () {
	        var _this = this;
	        this.sessionService.getSession()
	            .subscribe(function (user) {
	            _this.userService.setUserSessionData(user);
	            _this.redirect();
	        }, function (error) {
	            //TO DO: Handle any error if needed in the furture
	            _this.message = "";
	            _this.messageType = "alert";
	        });
	    };
	    RegisterComponent.prototype.register = function (credential) {
	        var _this = this;
	        this.registerService.postActivationEmail(credential.role, credential.email)
	            .subscribe(function (complete) {
	            _this.messageType = "success",
	                _this.message = "An activation email had been sent.";
	            _this.formSubmitted = false;
	        }, function (error) {
	            _this.messageType = "alert";
	            _this.message = "Please input the email you provided to AIS.";
	            _this.formSubmitted = false;
	        });
	    };
	    RegisterComponent.prototype.registerNonAis = function (nonAisParent) {
	        var _this = this;
	        this.registerService.postNoneAisAccount(nonAisParent)
	            .subscribe(function (complete) {
	            _this.messageType = "success",
	                _this.message = "An activation email had been sent.";
	            _this.formSubmitted = false;
	        }, function (error) {
	            _this.messageType = "alert";
	            _this.message = "Please input the email you provided to AIS.";
	            _this.formSubmitted = false;
	        });
	    };
	    RegisterComponent.prototype.redirect = function () {
	        // Redirect to stored url
	        this.router.navigate([this.redirectUrl]);
	    };
	    return RegisterComponent;
	}());
	RegisterComponent = __decorate([
	    core_1.Component({
	        selector: 'user-register',
	        template: __webpack_require__(250),
	        styles: [__webpack_require__(251)]
	    }),
	    __metadata("design:paramtypes", [SessionService_1.SessionService,
	        UserService_1.UserService,
	        RegisterService_1.RegisterService,
	        router_1.Router])
	], RegisterComponent);
	exports.RegisterComponent = RegisterComponent;


/***/ }),

/***/ 250:
/***/ (function(module, exports) {

	module.exports = "<div id=\"user-register-component\" class=\"eca-background\">\n    <div class=\"component-title\">\n        <h1>WELCOME TO AIS</h1>\n    </div>\n    <div class=\"component-content\">\n        <form #registerForm=\"ngForm\">\n\t\t\t<!-- Form Title -->\n            <h3 class=\"text-center\">Register Account</h3>\n\t\t\t<!-- Alert Box -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<alert-box [message]=\"message\" [type]=\"messageType\"></alert-box>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Email Input Field -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"email\">Please type the email you registered with AIS</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Email\" id=\"email\" name=\"email\" \n\t\t\t\t\t\t\t[(ngModel)]=\"credential.email\" #email=\"ngModel\" required>\n\t\t\t\t\t<div [hidden]=\"email.valid || email.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\tEmail is required.\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Submit Button -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n            \t\t<button type=\"submit\" [disabled]=\"!registerForm.form.valid || formSubmitted\" (click)=\"onSubmit()\">Register</button>\n\t\t\t\t</div>\n\t\t\t</div>\n        </form>\n    </div>\n</div>";

/***/ }),

/***/ 251:
/***/ (function(module, exports) {

	module.exports = ".tabs{margin-bottom:-7px;position:relative;z-index:29;border-top-right-radius:5px;border-top-left-radius:5px;border:none}.tabs li{width:50%}.tabs li a{background:#00707e;color:#fff;font-weight:400;font-size:1rem}.tabs li:first-child{border-top-left-radius:5px}.tabs li:last-child{border-top-right-radius:5px}.tabs li>.is-active{background:#fff;color:#00707e;font-weight:500;border-top-right-radius:5px;border-top-left-radius:5px}#user-register-component{padding:1rem}#user-register-component .component-title{margin:3rem auto;width:31.25%;color:#fff;text-align:center}#user-register-component .component-content{margin:3rem auto;width:31.25%}#user-register-component .component-content form .terms-conditions{font-size:0.65rem;font-weight:500;text-align:center}#user-register-component .component-content form button{width:100%}@media (min-width: 1025px){#user-register-component .component-title{max-width:400px}#user-register-component .component-content{max-width:400px}}@media (min-width: 768px) and (max-width: 1024px){#user-register-component .component-title{width:50%;max-width:400px}#user-register-component .component-content{width:50%;max-width:400px}}@media (min-width: 320px) and (max-width: 767px){#user-register-component{padding:0}#user-register-component .component-title{display:none}#user-register-component .component-content{margin:0;width:100%}#user-register-component .component-content form{border:none;border-radius:0rem}}\n"

/***/ }),

/***/ 252:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	//Services
	var RegisterService_1 = __webpack_require__(228);
	var ChoosePasswordComponent = (function () {
	    function ChoosePasswordComponent(router, route, registerService) {
	        this.router = router;
	        this.route = route;
	        this.registerService = registerService;
	        this.redirectUrl = "login";
	        this.formSubmitted = false;
	    }
	    ChoosePasswordComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        // Get token string from URL.
	        this.route.params.forEach(function (params) {
	            _this.token = params['token'];
	        });
	        // Verify if token is valid or not.
	        this.verifyToken();
	    };
	    // Called when user submit form
	    ChoosePasswordComponent.prototype.onSubmit = function () {
	        // Mark form as submitted to disable submit button
	        this.formSubmitted = true;
	        // Reset form alert message 
	        this.message = "";
	        this.messageType = "";
	        // Process set new password
	        this.setNewPassword();
	    };
	    ChoosePasswordComponent.prototype.verifyToken = function () {
	        var _this = this;
	        this.registerService.verifyActivationToken(this.token)
	            .subscribe(function (complete) {
	            _this.formSubmitted = false;
	        }, function (error) {
	            _this.message = "Token not found or expired.";
	            _this.messageType = "alert";
	            // Set form as submitted to prevent user post their new password
	            _this.formSubmitted = true;
	        });
	    };
	    ChoosePasswordComponent.prototype.setNewPassword = function () {
	        var _this = this;
	        this.registerService.setPasswordWithActivationToken(this.token, this.newPassword)
	            .subscribe(function (complete) {
	            _this.message = "Set password successfully. You will be redirected to Login Page in 5 seconds.";
	            _this.messageType = "success";
	            // Delay 5s before redirect to login page
	            setTimeout(function () {
	                _this.redirect();
	            }, 5000);
	        }, function (error) {
	            _this.message = "There is an issue when setting new password.";
	            _this.messageType = "alert";
	            _this.formSubmitted = false;
	        });
	    };
	    ChoosePasswordComponent.prototype.redirect = function () {
	        // Redirect to stored url
	        this.router.navigate([this.redirectUrl]);
	    };
	    return ChoosePasswordComponent;
	}());
	ChoosePasswordComponent = __decorate([
	    core_1.Component({
	        selector: 'user-set-password',
	        template: __webpack_require__(253),
	        styles: [__webpack_require__(254)],
	    }),
	    __metadata("design:paramtypes", [router_1.Router,
	        router_1.ActivatedRoute,
	        RegisterService_1.RegisterService])
	], ChoosePasswordComponent);
	exports.ChoosePasswordComponent = ChoosePasswordComponent;


/***/ }),

/***/ 253:
/***/ (function(module, exports) {

	module.exports = "<div id=\"user-choose-password-component\" class=\"eca-background\">\n\t<div class=\"component-title\">\n\t\t<h1>WELCOME TO AIS</h1>\n\t</div>\n\t<div class=\"component-content\">\n\t\t<form (ngSubmit)=\"onSubmit()\" #forgotPasswordForm=\"ngForm\">\n\t\t\t<h3 class=\"text-center\">Set new password</h3>\n\t\t\t<!-- Alert Box -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<alert-box [message]=\"message\" [type]=\"messageType\"></alert-box>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Password Input Field -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"password\">New Password</label>\n\t\t\t\t\t<input type=\"password\" placeholder=\"Type your new password\" id=\"password\" \n\t\t\t\t\t\t[(ngModel)]=\"newPassword\" name=\"password\" #password=\"ngModel\" required minlength=\"6\">\n\t\t\t\t\t<div [hidden]=\"password.valid || password.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\tPassword is required and must have at least 6 characters.\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Confirm Password Input Field -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"confirm-password\">Confirm New Password</label>\n\t\t\t\t\t<input type=\"password\" placeholder=\"Confirm your new password\" id=\"confirm-password\" \n\t\t\t\t\t\t[(ngModel)]=\"confirmNewPassword\" name=\"confirm-password\" #confirmPassword=\"ngModel\" required minlength=\"6\">\n\t\t\t\t\t<div [hidden]=\"confirmPassword.value === password.value || confirmPassword.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\tConfirm Password must match with the new password.\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Submit Button -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<button type=\"submit\" name=\"submit\" [disabled]=\"!forgotPasswordForm.form.valid || formSubmitted\">Submit</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</form>\n\t</div>\n</div>";

/***/ }),

/***/ 254:
234,

/***/ 255:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var Credential_1 = __webpack_require__(224);
	var PasswordService_1 = __webpack_require__(236);
	var ForgotPasswordComponent = (function () {
	    function ForgotPasswordComponent(passwordService) {
	        this.passwordService = passwordService;
	        this.formSubmitted = false;
	    }
	    ForgotPasswordComponent.prototype.ngOnInit = function () {
	        this.credential = new Credential_1.Credential('parent', '', '');
	    };
	    ForgotPasswordComponent.prototype.onSubmit = function () {
	        // Call API service to send a reset password email
	        // when user submit the email address
	        this.formSubmitted = true;
	        this.sendResetPasswordEmail(this.credential);
	    };
	    /**
	     * Call API service to send the credential and request for a reset password email.
	     * @param {Credential} - user credential
	     * @complete - Update message & messageType for display, reset credential.
	     * @error - Set message & messageType as error. Reset form submit.
	     */
	    ForgotPasswordComponent.prototype.sendResetPasswordEmail = function (credential) {
	        var _this = this;
	        this.passwordService.sendResetPasswordEmail(credential.role, credential.email)
	            .subscribe(function (complete) {
	            _this.messageType = "success",
	                _this.message = "A reset password email had been sent.";
	            _this.formSubmitted = false;
	        }, function (error) {
	            _this.messageType = "alert";
	            _this.message = "Cannot send reset password email.";
	            _this.formSubmitted = false;
	        });
	    };
	    return ForgotPasswordComponent;
	}());
	ForgotPasswordComponent = __decorate([
	    core_1.Component({
	        selector: 'user-forgot-password',
	        template: __webpack_require__(256),
	        styles: [__webpack_require__(257)],
	    }),
	    __metadata("design:paramtypes", [PasswordService_1.PasswordService])
	], ForgotPasswordComponent);
	exports.ForgotPasswordComponent = ForgotPasswordComponent;


/***/ }),

/***/ 256:
237,

/***/ 257:
238,

/***/ 258:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var PasswordService_1 = __webpack_require__(236);
	var SetNewPasswordComponent = (function () {
	    function SetNewPasswordComponent(router, route, passwordService) {
	        this.router = router;
	        this.route = route;
	        this.passwordService = passwordService;
	        this.redirectUrl = "hol-login";
	        this.formSubmitted = false;
	    }
	    SetNewPasswordComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        // Get token string from URL.
	        this.route.params.forEach(function (params) {
	            _this.token = params['token'];
	        });
	        // Verify if token is valid or not.
	        this.verifyToken();
	    };
	    // Called when user submit form
	    SetNewPasswordComponent.prototype.onSubmit = function () {
	        // Mark form as submitted to disable submit button
	        this.formSubmitted = true;
	        // Reset form alert message 
	        this.message = "";
	        this.messageType = "";
	        // Process set new password
	        this.setNewPassword(this.token, this.newPassword);
	    };
	    // Verify reset password token with servie
	    SetNewPasswordComponent.prototype.verifyToken = function () {
	        var _this = this;
	        this.passwordService.verifyPasswordResetToken(this.token)
	            .subscribe(function (complete) {
	            _this.formSubmitted = false;
	        }, function (error) {
	            // Set message type as error and message error content
	            _this.message = "Token not found or expired.";
	            _this.messageType = "alert";
	            // Set form as submitted to prevent user post their new password
	            _this.formSubmitted = true;
	        });
	    };
	    // Set new password with new password input and verified token
	    SetNewPasswordComponent.prototype.setNewPassword = function (token, newPassword) {
	        var _this = this;
	        this.passwordService.setPasswordWithResetToken(token, newPassword)
	            .subscribe(function (complete) {
	            // Update message on success
	            _this.message = "Changed password successfully. You will be redirected to Login Page in 5 seconds.";
	            _this.messageType = "success";
	            // Delay 5s before redirect to login page
	            setTimeout(function () {
	                _this.redirect(_this.redirectUrl);
	            }, 5000);
	        }, function (error) {
	            // Set message type as error and error message content
	            _this.message = "There is an issue when setting new password.";
	            _this.messageType = "alert";
	            // Reset form submit status
	            _this.formSubmitted = false;
	        });
	    };
	    // Redirect to desired url
	    SetNewPasswordComponent.prototype.redirect = function (url) {
	        this.router.navigate([this.redirectUrl]);
	    };
	    return SetNewPasswordComponent;
	}());
	SetNewPasswordComponent = __decorate([
	    core_1.Component({
	        selector: 'user-set-new-password',
	        template: __webpack_require__(259),
	        styles: [__webpack_require__(260)],
	    }),
	    __metadata("design:paramtypes", [router_1.Router,
	        router_1.ActivatedRoute,
	        PasswordService_1.PasswordService])
	], SetNewPasswordComponent);
	exports.SetNewPasswordComponent = SetNewPasswordComponent;


/***/ }),

/***/ 259:
243,

/***/ 260:
244,

/***/ 261:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(85);
	var PasswordService_1 = __webpack_require__(236);
	var ChangePasswordComponent = (function () {
	    function ChangePasswordComponent(passwordService, router) {
	        this.passwordService = passwordService;
	        this.router = router;
	        this.redirectUrl = "booking/students";
	        this.formSubmitted = false;
	        this.devEnv = ['services.eca.nascorp.vn', 'camp.eca.nascorp.vn', 'asa.eca.nascorp.vn', 'holiday.eca.nascorp.vn', 'bus.eca.nascorp.vn'];
	        this.demoEnv = ['services.demo.nascorp.vn', 'camp.demo.nascorp.vn', 'asa.demo.nascorp.vn', 'holiday.demo.nascorp.vn', 'bus.demo.nascorp.vn'];
	        this.testEnv = ['services.eca.test.nascorp.vn', 'camp.eca.test.nascorp.vn', 'asa.eca.test.nascorp.vn', 'holiday.eca.test.nascorp.vn', 'bus.eca.test.nascorp.vn'];
	        this.stagingEnv = ['staging.services.aisvietnam.com', 'staging.outdooreducation.aisvietnam.com', 'staging.asa.aisvietnam.com', 'staging.holidayschool.aisvietnam.com', 'staging.bus.aisvietnam.com'];
	        this.procEnv = ['services.aisvietnam.com', 'outdooreducation.aisvietnam.com', 'asa.aisvietnam.com', 'holidayschool.aisvietnam.com', 'bus.aisvietnam.com'];
	    }
	    ChangePasswordComponent.prototype.ngOnInit = function () {
	        this.message = "";
	        this.messageType = "";
	        this.hostName = window.location.hostname;
	        console.log(this.hostName);
	    };
	    ChangePasswordComponent.prototype.onSubmit = function () {
	        // Mark form as submitted to disable submit button
	        this.formSubmitted = true;
	        // Reset form alert message 
	        this.message = "";
	        this.messageType = "";
	        this.changePassword(this.oldPassword, this.newPassword);
	    };
	    ChangePasswordComponent.prototype.changePassword = function (oldPassword, newPassword) {
	        var _this = this;
	        this.passwordService.setNewPassword(oldPassword, newPassword)
	            .subscribe(function (complete) {
	            if (_this.devEnv.indexOf(_this.hostName) !== -1) {
	                return window.location.href = 'http://services.eca.nascorp.vn/';
	            }
	            else if (_this.demoEnv.indexOf(_this.hostName) !== -1) {
	                return window.location.href = 'http://services.demo.nascorp.vn/';
	            }
	            else if (config_1.bisHanoiEnv.indexOf(_this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.bisHanoiEnv.services;
	            }
	            else if (config_1.bisHanoiDevEnv.indexOf(_this.hostName) !== -1) {
	                return window.location.href = "http://" + config_1.bisHanoiDevEnv.services;
	            }
	            else if (_this.testEnv.indexOf(_this.hostName) !== -1) {
	                return window.location.href = 'http://services.eca.test.nascorp.vn/';
	            }
	            else if (_this.stagingEnv.indexOf(_this.hostName) !== -1) {
	                return window.location.href = 'http://staging.services.aisvietnam.com/';
	            }
	            else if (_this.procEnv.indexOf(_this.hostName) !== -1) {
	                return window.location.href = 'https://services.aisvietnam.com/';
	            }
	            else {
	                return window.location.href = 'http://services.local.eca.nascorp.vn/';
	            }
	        }, function (error) {
	            _this.message = "Invalid old password input.";
	            _this.messageType = "alert";
	            _this.formSubmitted = false;
	        });
	    };
	    ChangePasswordComponent.prototype.redirect = function (redirectUrl) {
	        this.router.navigate([redirectUrl]);
	    };
	    return ChangePasswordComponent;
	}());
	ChangePasswordComponent = __decorate([
	    core_1.Component({
	        selector: 'user-change-password',
	        template: __webpack_require__(262),
	        styles: [__webpack_require__(263)],
	    }),
	    __metadata("design:paramtypes", [PasswordService_1.PasswordService,
	        router_1.Router])
	], ChangePasswordComponent);
	exports.ChangePasswordComponent = ChangePasswordComponent;


/***/ }),

/***/ 262:
240,

/***/ 263:
241,

/***/ 264:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	// Services
	var SessionService_1 = __webpack_require__(82);
	var UserService_1 = __webpack_require__(81);
	// import { Parent } from '../../../../holiday/models/Parent';
	var Credential_1 = __webpack_require__(224);
	var AddParentComponent = (function () {
	    function AddParentComponent(
	        // private holidayService: HolidayService,
	        sessionService, userService, router) {
	        this.sessionService = sessionService;
	        this.userService = userService;
	        this.router = router;
	        this.formSubmitted = false;
	        // this.parent = new Parent();
	    }
	    AddParentComponent.prototype.ngOnInit = function () {
	        this.redirectUrl = '/booking/students';
	        this.credential = new Credential_1.Credential('parent', '', '');
	        // Use Session Service to get session and check if user had already logged in.
	        this.getSession();
	        // this.getParent();
	    };
	    ;
	    AddParentComponent.prototype.onSubmit = function () {
	        this.formSubmitted = true;
	        // Reset message content
	        this.message = "";
	        // Post user login data to create session
	        this.postSession(this.credential);
	    };
	    /**
	     * Get Session from API service to make sure that user had logged in.
	     * Update User Data on local storage and redirect to the desired URL
	     * if request responses session data.
	     * @param none
	     * @return none
	     */
	    AddParentComponent.prototype.getSession = function () {
	        var _this = this;
	        this.sessionService.getSession()
	            .subscribe(function (user) {
	            _this.userService.setUserSessionData(user);
	            _this.redirect(_this.redirectUrl);
	        }, function (error) {
	            //TO DO: Handle any error if needed in the furture
	            _this.message = "";
	            _this.messageType = "alert";
	        });
	    };
	    /**
	     * Post Session to API service to create new session.
	     * Update User Data on local storage and redirect to desired URL
	     * if request responses session data.
	     * @param {Credential} - user credential input
	     * @return none
	     */
	    AddParentComponent.prototype.postSession = function (credential) {
	        var _this = this;
	        this.sessionService.postSession(credential)
	            .subscribe(function (user) {
	            // Set user session data
	            _this.userService.setUserSessionData(user);
	            // Fire user session data changed event
	            _this.userService.userDataChanged(user);
	            // Redirect to desired URL
	            _this.router.navigate['/add-student'];
	        }, function (error) {
	            _this.formSubmitted = false;
	            _this.message = "Invalid email address or password.";
	            _this.messageType = "alert";
	        });
	    };
	    // Redirect to desired url
	    AddParentComponent.prototype.redirect = function (redirectUrl) {
	        this.router.navigate([redirectUrl]);
	    };
	    return AddParentComponent;
	}());
	AddParentComponent = __decorate([
	    core_1.Component({
	        selector: 'add-parent',
	        template: __webpack_require__(265),
	        styles: [__webpack_require__(266)],
	    }),
	    __metadata("design:paramtypes", [SessionService_1.SessionService,
	        UserService_1.UserService,
	        router_1.Router])
	], AddParentComponent);
	exports.AddParentComponent = AddParentComponent;


/***/ }),

/***/ 265:
/***/ (function(module, exports) {

	module.exports = "<div id=\"user-login-component\" class=\"eca-background\">\n    <div class=\"component-title\">\n        <h1>WELCOME TO AIS</h1>\n    </div>\n    <div class=\"component-content\">\n        <form (ngSubmit)=\"onSubmit()\" #loginForm=\"ngForm\">\n\t\t\t<!-- Form Title -->\n            <h3 class=\"text-center\">Parent Detail</h3>\n\t\t\t<!-- Alert Box -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<alert-box [message]=\"message\" [type]=\"messageType\"></alert-box>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Email Input Field -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"family-name\">Family Name</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Type your Family Name\" id=\"family-name\" name=\"family-name\" required>\n\t\t\t\t\t<!--<div [hidden]=\"email.valid || email.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\tFamily Name is required.\n\t\t\t\t\t</div>-->\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Email Input Field -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"given-name\">Given Name</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Type your Given Name\" id=\"given-name\" name=\"given-name\" required>\n\t\t\t\t\t<!--<div [hidden]=\"email.valid || email.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\tGiven Name is required.\n\t\t\t\t\t</div>-->\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Email Input Field -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"email\">Email</label>\n\t\t\t\t\t<input type=\"email\" placeholder=\"Type your email address\" id=\"email\" \n\t\t\t\t\t\t[(ngModel)]=\"credential.email\" name=\"email\" #email=\"ngModel\" required>\n\t\t\t\t\t<div [hidden]=\"email.valid || email.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\tEmail is required.\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Phone Number Input Field -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"phone\">Phone Number</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Type your Phone number\" id=\"phone\" name=\"phone\" required>\n\t\t\t\t\t<!--<div [hidden]=\"password.valid || password.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\tPhone number is required.\n\t\t\t\t\t</div>-->\n\t\t\t\t</div>\n\t\t\t</div>\n           \n\t\t\t<!-- Submit Button -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<button type=\"submit\" name=\"submit\" [disabled]=\"!loginForm.form.valid || formSubmitted\">Register</button>\n\t\t\t\t</div>\n\t\t\t</div>\n        </form>\n    </div>\n</div>";

/***/ }),

/***/ 266:
/***/ (function(module, exports) {

	module.exports = "#user-login-component{padding:1rem}#user-login-component .component-title{margin:3rem auto;width:31.25%;color:#fff;text-align:center}#user-login-component .component-content{margin:3rem auto;width:31.25%}#user-login-component .component-content form div.remember-block{position:relative;font-size:0.8rem;margin-bottom:0.5rem}#user-login-component .component-content form div.remember-block input[type=\"checkbox\"]{position:absolute;height:1.1rem;width:1.1rem;top:0.5rem;cursor:pointer}#user-login-component .component-content form div.remember-block label{margin-left:1.5rem}#user-login-component .component-content form .register-link{font-size:0.65rem;font-weight:500;text-align:center}#user-login-component .component-content form .forgot-password{display:block;font-size:0.8rem}#user-login-component .component-content form button:not(.close-button){width:100%}#user-login-component .component-content form button.close-button{line-height:1.2}@media (min-width: 1025px){#user-login-component .component-title{max-width:450px}#user-login-component .component-content{max-width:450px}}@media (min-width: 768px) and (max-width: 1024px){#user-login-component .component-title{width:50%;max-width:450px}#user-login-component .component-content{width:50%;max-width:450px}}@media (min-width: 320px) and (max-width: 767px){#user-login-component{padding:0}#user-login-component .component-title{display:none}#user-login-component .component-content{margin:0;width:100%}#user-login-component .component-content form{border:none;border-radius:0rem}}\n"

/***/ }),

/***/ 267:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	// Services
	var SessionService_1 = __webpack_require__(82);
	var UserService_1 = __webpack_require__(81);
	var RegisterService_1 = __webpack_require__(228);
	var NonAisStudent_1 = __webpack_require__(268);
	var moment = __webpack_require__(269);
	var AddStudentComponent = (function () {
	    function AddStudentComponent(registerService, sessionService, userService, router) {
	        this.registerService = registerService;
	        this.sessionService = sessionService;
	        this.userService = userService;
	        this.router = router;
	        this.formSubmitted = false;
	    }
	    AddStudentComponent.prototype.ngOnInit = function () {
	        this.resetField = '';
	        this.nonAisStudent = new NonAisStudent_1.NonAisStudent();
	        // Use Session Service to get session and check if user had already logged in.
	        this.getSession();
	    };
	    ;
	    AddStudentComponent.prototype.onSubmit = function () {
	        this.formSubmitted = true;
	        // Reset message content
	        this.message = "";
	        // Post user login data to create session
	        this.registerNonAis(this.nonAisStudent);
	    };
	    /**
	     * Get Session from API service to make sure that user had logged in.
	     * Update User Data on local storage and redirect to the desired URL
	     * if request responses session data.
	     * @param none
	     * @return none
	     */
	    AddStudentComponent.prototype.getSession = function () {
	        var _this = this;
	        this.sessionService.getSession()
	            .subscribe(function (user) {
	            _this.userService.setUserSessionData(user);
	        }, function (error) {
	            //TO DO: Handle any error if needed in the furture
	            _this.message = "";
	            _this.messageType = "alert";
	        });
	    };
	    /**
	     * Post Session to API service to create new session.
	     * Update User Data on local storage and redirect to desired URL
	     * if request responses session data.
	     * @param {Credential} - user credential input
	     * @return none
	     */
	    AddStudentComponent.prototype.postSession = function (credential) {
	        var _this = this;
	        this.sessionService.postSession(credential)
	            .subscribe(function (user) {
	            // Set user session data
	            _this.userService.setUserSessionData(user);
	            // Fire user session data changed event
	            _this.userService.userDataChanged(user);
	        }, function (error) {
	            _this.formSubmitted = false;
	            _this.message = "Invalid email address or password.";
	            _this.messageType = "alert";
	        });
	    };
	    AddStudentComponent.prototype.registerNonAis = function (nonAisStudent) {
	        var _this = this;
	        var form = Object.assign({}, nonAisStudent);
	        form.date_of_birth = moment(form.date_of_birth, 'DD/MM/YYYY').format('YYYY-MM-DD');
	        // console.log(nonAisStudent);
	        this.registerService.postNonAisStudent(form)
	            .subscribe(function (complete) {
	            _this.messageType = "success",
	                _this.message = "Adding student successfully";
	            _this.formSubmitted = false;
	            _this.router.navigateByUrl('/booking/students');
	        }, function (error) {
	            _this.formSubmitted = false;
	            _this.messageType = "alert";
	            var msg = JSON.parse(error._body);
	            if (msg.message == "student wasn't created")
	                _this.message = "The student already exist in the system";
	            else
	                _this.message = msg.message;
	        });
	    };
	    AddStudentComponent.prototype.resetMedicalField = function (medicalField) {
	        medicalField = '';
	    };
	    return AddStudentComponent;
	}());
	AddStudentComponent = __decorate([
	    core_1.Component({
	        selector: 'add-student',
	        template: __webpack_require__(408),
	        styles: [__webpack_require__(409)],
	    }),
	    __metadata("design:paramtypes", [RegisterService_1.RegisterService,
	        SessionService_1.SessionService,
	        UserService_1.UserService,
	        router_1.Router])
	], AddStudentComponent);
	exports.AddStudentComponent = AddStudentComponent;


/***/ }),

/***/ 268:
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var NonAisStudent = (function () {
	    function NonAisStudent() {
	        this.family_name = '';
	        this.given_name = '';
	        this.known_name = '';
	        this.gender = '';
	        this.date_of_birth = '';
	        this.country = '';
	        this.medical = [];
	        this.medical[0] = {
	            under_doctor_care: '',
	            medication: '',
	            allergic: '',
	            limit_paticipation_athlentic: ''
	        };
	    }
	    return NonAisStudent;
	}());
	exports.NonAisStudent = NonAisStudent;
	var StudentMedical = (function () {
	    function StudentMedical() {
	        this.under_doctor_care = "";
	        this.medication = "";
	        this.allergic = "";
	        this.limit_paticipation_athlentic = "";
	    }
	    return StudentMedical;
	}());
	exports.StudentMedical = StudentMedical;


/***/ }),

/***/ 408:
/***/ (function(module, exports) {

	module.exports = "<div id=\"user-login-component\" class=\"eca-background\">\n    <div class=\"component-title\">\n        <h1>WELCOME TO AIS</h1>\n    </div>\n    <div class=\"component-content\">\n        <form (ngSubmit)=\"onSubmit()\" #loginForm=\"ngForm\">\n\t\t\t<!-- Form Title -->\n            <h3 class=\"text-center\">Student Details</h3>\n\t\t\t<!-- Alert Box -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<alert-box [message]=\"message\" [type]=\"messageType\"></alert-box>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Family Name Input Field -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"family-name\">Family Name</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Type your Family Name\" id=\"family-name\" name=\"family-name\" required\n\t\t\t\t\t[(ngModel)]=\"nonAisStudent.family_name\" #nonaisFamilyName=\"ngModel\">\n\t\t\t\t\t<div [hidden]=\"nonaisFamilyName.valid || nonaisFamilyName.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\tFamily Name is required.\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Given Name Input Field -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"given-name\">Given Name</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Type your Given Name\" id=\"given-name\" name=\"given-name\" required\n\t\t\t\t\t\t[(ngModel)]=\"nonAisStudent.given_name\" #nonaisGivenName=\"ngModel\">\n\t\t\t\t\t<div [hidden]=\"nonaisGivenName.valid || nonaisGivenName.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\tGiven Name is required.\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Known Name Input Field -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"known-name\">Known Name</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Type your Known Name\" id=\"known-name\" name=\"known-name\" required\n\t\t\t\t\t[(ngModel)]=\"nonAisStudent.known_name\" #nonaisKnowName=\"ngModel\">\n\t\t\t\t\t<div [hidden]=\"nonaisKnowName.valid || nonaisKnowName.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\tGiven Name is required.\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Gender Option Field -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"gender\">Gender</label>\n\t\t\t\t\t<select [(ngModel)]=\"nonAisStudent.gender\" name=\"gender\">\n\t\t\t\t\t\t<option value=\"M\" selected>Male</option>\n\t\t\t\t\t\t<option value=\"F\">Female</option>\n\t\t\t\t\t</select>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- DOB Input Field -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"dob\">DOB (dd/mm/yyyy)</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"dd/mm/yyyy\" id=\"dob\" name=\"dob\" required\n\t\t\t\t\tpattern=\"^(?:(?:31(\\/)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{4})$\"\n\t\t\t\t\t[(ngModel)]=\"nonAisStudent.date_of_birth\" #nonaisDOB=\"ngModel\" required>\n\t\t\t\t\t<div [hidden]=\"nonaisDOB.valid || nonaisDOB.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\t<div *ngIf=\"nonaisDOB.errors?.required\">Day of birth is required.</div>\n\t\t\t\t\t\t<div *ngIf=\"nonaisDOB.errors?.pattern\">Please correct format date.</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- National Option Field -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<label for=\"email\">National</label>\n\t\t\t\t\t<input type=\"text\" placeholder=\"Type your Country\" id=\"country\" name=\"country\" required\n\t\t\t\t\t\t[(ngModel)]=\"nonAisStudent.country\" #nonaisCountry=\"ngModel\" required>\n\t\t\t\t\t<div [hidden]=\"nonaisCountry.valid || nonaisCountry.pristine\" class=\"help-text text-alert\">\n\t\t\t\t\t\tCountry is required.\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"detail-medical\">\n\t\t\t\t\t<h5>Detailed Medical History</h5>\n\t\t\t\t\t<ol>\n\t\t\t\t\t\t<li>Is your child currently under a doctor's care for any reason ? <br/>\n\t\t\t\t\t\t\t<!--<input type=\"radio\" name=\"doctor-care\" value=\"yes\"> Yes\n\t\t\t\t\t\t\t<input type=\"radio\" name=\"doctor-care\" value=\"no\"> No-->\n\t\t\t\t\t\t\t<input type=\"radio\" [(ngModel)]=\"doctorCareValue\"  name=\"doctor-care\" value=\"doctorCareYes\" />Yes\n    \t\t\t\t\t\t<input type=\"radio\" [(ngModel)]=\"doctorCareValue\"  name=\"doctor-care\" value=\"doctorCareNo\"/>No\n\t\t\t\t\t\t\t<input type=\"text\" [(ngModel)]=\"nonAisStudent.medical[0].under_doctor_care\" name=\"doctor_care\" *ngIf=\"doctorCareValue === 'doctorCareYes'\">\n\t\t\t\t\t\t\t<!--<input type=\"text\" [(ngModel)]=\"nonAisStudent.medical[0].under_doctor_care\" name=\"medication\" *ngIf=\"doctorCareValue === 'doctorCareNo'\" class=\"hide\">-->\n\t\t\t\t\t\t</li>\n\t\t\t\t\t\t<li>Is your child taking any kind of medication ?<br/>\n\t\t\t\t\t\t\t<input type=\"radio\" [(ngModel)]=\"medicationValue\"  name=\"medication\" value=\"medicationYes\" />Yes\n    \t\t\t\t\t\t<input type=\"radio\" [(ngModel)]=\"medicationValue\"  name=\"medication\" value=\"medicationNo\"/>No\n\t\t\t\t\t\t\t<input type=\"text\" [(ngModel)]=\"nonAisStudent.medical[0].medication\" name=\"medication\" *ngIf=\"medicationValue === 'medicationYes'\">\n\t\t\t\t\t\t\t<!--<input type=\"text\" [(ngModel)]=\"nonAisStudent.medical[0].medication\" name=\"medication\" *ngIf=\"medicationValue === 'medicationNo'\" class=\"hide\">-->\n\t\t\t\t\t\t</li>\n\t\t\t\t\t\t<li>Is your child allergic to any food or medication ?<br/>\n\t\t\t\t\t\t\t<input type=\"radio\" [(ngModel)]=\"allergicValue\"  name=\"allergic\" value=\"allergicYes\" />Yes\n    \t\t\t\t\t\t<input type=\"radio\" [(ngModel)]=\"allergicValue\"  name=\"allergic\" value=\"allergicNo\" />No\n\t\t\t\t\t\t\t<input type=\"text\" [(ngModel)]=\"nonAisStudent.medical[0].allergic\" name=\"allergic\" *ngIf=\"allergicValue === 'allergicYes'\">\n\t\t\t\t\t\t\t<!--<input type=\"text\" [(ngModel)]=\"medicalField\" name=\"medication\" *ngIf=\"allergicValue === 'allergicNo'\" class=\"hide\">-->\n\t\t\t\t\t\t</li>\n\t\t\t\t\t\t<li>Does your child have any problem that limits his/her paticipation in athletics ?<br/>\n\t\t\t\t\t\t\t<input type=\"radio\" [(ngModel)]=\"limitsValue\"  name=\"limits\" value=\"limitsYes\" />Yes\n    \t\t\t\t\t\t<input type=\"radio\" [(ngModel)]=\"limitsValue\"  name=\"limits\" value=\"limitsNo\" />No\n\t\t\t\t\t\t\t<input type=\"text\" [(ngModel)]=\"nonAisStudent.medical[0].limit_paticipation_athlentic\" name=\"limit_paticipation_athlentic\"  *ngIf=\"limitsValue === 'limitsYes'\">\n\t\t\t\t\t\t\t<!--<input type=\"text\" [(ngModel)]=\"medicalField\" name=\"medication\" *ngIf=\"limitsValue === 'limitsNo'\" class=\"hide\">-->\n\t\t\t\t\t\t</li>\n\t\t\t\t\t</ol>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- Submit Button -->\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"medium-12 columns\">\n\t\t\t\t\t<button type=\"submit\" name=\"submit\" [disabled]=\"!loginForm.form.valid || formSubmitted\">Register</button>\n\t\t\t\t</div>\n\t\t\t</div>\n        </form>\n    </div>\n</div>";

/***/ }),

/***/ 409:
/***/ (function(module, exports) {

	module.exports = ".detail-medical{padding:1.25rem}.detail-medical h5{font-size:1.125rem;color:#00707e;margin-bottom:1rem}.detail-medical li{font-size:0.875rem;color:#666;padding-bottom:0.5rem}.detail-medical li input{margin-bottom:0;vertical-align:-2px;margin-top:10px;margin-left:10px;margin-right:5px}.detail-medical li .hide{display:none}#user-login-component{padding:1rem}#user-login-component .component-title{margin:3rem auto;width:40%;color:#fff;text-align:center}#user-login-component .component-content{margin:3rem auto;width:40%}#user-login-component .component-content form div.remember-block{position:relative;font-size:0.8rem;margin-bottom:0.5rem}#user-login-component .component-content form div.remember-block input[type=\"checkbox\"]{position:absolute;height:1.1rem;width:1.1rem;top:0.5rem;cursor:pointer}#user-login-component .component-content form div.remember-block label{margin-left:1.5rem}#user-login-component .component-content form .register-link{font-size:0.65rem;font-weight:500;text-align:center}#user-login-component .component-content form .forgot-password{display:block;font-size:0.8rem}#user-login-component .component-content form button:not(.close-button){width:100%}#user-login-component .component-content form button.close-button{line-height:1.2}@media (min-width: 1025px){#user-login-component .component-title{max-width:600px}#user-login-component .component-content{max-width:600px}}@media (min-width: 768px) and (max-width: 1024px){#user-login-component .component-title{width:50%;max-width:600px}#user-login-component .component-content{width:50%;max-width:600px}}@media (min-width: 320px) and (max-width: 767px){#user-login-component{padding:0}#user-login-component .component-title{display:none}#user-login-component .component-content{margin:0;width:100%}#user-login-component .component-content form{border:none;border-radius:0rem}}\n"

/***/ }),

/***/ 410:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var router_1 = __webpack_require__(26);
	var HolLoginComponent_1 = __webpack_require__(222);
	var HolRegisterComponent_1 = __webpack_require__(227);
	var HolChoosePasswordComponent_1 = __webpack_require__(232);
	var HolForgotPasswordComponent_1 = __webpack_require__(235);
	var HolChangePasswordComponent_1 = __webpack_require__(239);
	var LoginComponent_1 = __webpack_require__(245);
	var LogoutComponent_1 = __webpack_require__(248);
	var RegisterComponent_1 = __webpack_require__(249);
	var ChoosePasswordComponent_1 = __webpack_require__(252);
	var ForgotPasswordComponent_1 = __webpack_require__(255);
	var SetNewPasswordComponent_1 = __webpack_require__(258);
	var ChangePasswordComponent_1 = __webpack_require__(261);
	var AddParentComponent_1 = __webpack_require__(264);
	var AddStudentComponent_1 = __webpack_require__(267);
	var userRoutes = [
	    {
	        path: 'register',
	        component: RegisterComponent_1.RegisterComponent
	    },
	    {
	        path: 'hol-register',
	        component: HolRegisterComponent_1.HolRegisterComponent
	    },
	    {
	        path: 'choose-password/:token',
	        component: ChoosePasswordComponent_1.ChoosePasswordComponent
	    },
	    {
	        path: 'hol-choose-password/:recovery',
	        component: HolChoosePasswordComponent_1.HolChoosePasswordComponent
	    },
	    {
	        path: 'login',
	        component: LoginComponent_1.LoginComponent
	    },
	    {
	        path: 'hol-login',
	        component: HolLoginComponent_1.HolLoginComponent
	    },
	    {
	        path: 'logout',
	        component: LogoutComponent_1.LogoutComponent
	    },
	    {
	        path: 'forgot-password',
	        component: ForgotPasswordComponent_1.ForgotPasswordComponent
	    },
	    {
	        path: 'hol-forgot-password',
	        component: HolForgotPasswordComponent_1.HolForgotPasswordComponent
	    },
	    {
	        path: 'hol-forgot-password/:token',
	        component: HolForgotPasswordComponent_1.HolForgotPasswordComponent
	    },
	    {
	        path: 'forgot-password/:token',
	        component: SetNewPasswordComponent_1.SetNewPasswordComponent
	    },
	    {
	        path: 'change-password',
	        component: ChangePasswordComponent_1.ChangePasswordComponent
	    },
	    {
	        path: 'hol-change-password',
	        component: HolChangePasswordComponent_1.HolChangePasswordComponent
	    },
	    {
	        path: 'add-parent',
	        component: AddParentComponent_1.AddParentComponent
	    },
	    {
	        path: 'add-student',
	        component: AddStudentComponent_1.AddStudentComponent
	    },
	];
	exports.userRouting = router_1.RouterModule.forChild(userRoutes);


/***/ }),

/***/ 411:
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var User = (function () {
	    function User() {
	    }
	    return User;
	}());
	exports.User = User;


/***/ }),

/***/ 412:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var SessionService_1 = __webpack_require__(82);
	var UserService_1 = __webpack_require__(81);
	__webpack_require__(413);
	var AppComponent = (function () {
	    function AppComponent(router, userService, sessionService) {
	        this.router = router;
	        this.userService = userService;
	        this.sessionService = sessionService;
	        this.module = 'bus-parent-sidebar';
	    }
	    AppComponent.prototype.ngOnInit = function () {
	        this.getSession();
	        this.hostName = window.location.hostname;
	    };
	    AppComponent.prototype.getSession = function () {
	        var _this = this;
	        this.sessionService.getSession()
	            .subscribe(function (user) {
	            _this.userService.setUserSessionData(user);
	            _this.userService.userDataChanged(user);
	            _this.userData = user;
	        }, function (error) {
	            //TO DO: Handle any error if needed in the furture
	            _this.message = "";
	            _this.messageType = "alert";
	            _this.redirectLogin();
	        });
	    };
	    AppComponent.prototype.redirectLogin = function () {
	        return window.location.href = window.location.origin.replace('bus', 'services');
	    };
	    return AppComponent;
	}());
	AppComponent = __decorate([
	    core_1.Component({
	        selector: 'my-app',
	        template: __webpack_require__(426),
	        styles: [__webpack_require__(427)]
	    }),
	    __metadata("design:paramtypes", [router_1.Router,
	        UserService_1.UserService,
	        SessionService_1.SessionService])
	], AppComponent);
	exports.AppComponent = AppComponent;


/***/ }),

/***/ 413:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 426:
/***/ (function(module, exports) {

	module.exports = "<!-- Application Top Menu -->\n<!-- <top-menu></top-menu> -->\n<!-- Application Main Menu -->\n<!-- <main-menu [module]=\"module\"></main-menu> -->\n<!-- Process bar -->\n<!--<process-bar></process-bar>-->\n<!-- Application Content -->\n<router-outlet></router-outlet>\n<!-- Application Footer -->\n<!-- <footer></footer> -->";

/***/ }),

/***/ 427:
/***/ (function(module, exports) {

	module.exports = "/*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */html{font-family:sans-serif;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block;vertical-align:baseline}audio:not([controls]){display:none;height:0}[hidden],template{display:none}a{background-color:transparent}a:active,a:hover{outline:0}abbr[title]{border-bottom:1px dotted}b,strong{font-weight:bold}dfn{font-style:italic}h1{font-size:2em;margin:0.67em 0}mark{background:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sup{top:-0.5em}sub{bottom:-0.25em}img{border:0}svg:not(:root){overflow:hidden}figure{margin:1em 40px}hr{box-sizing:content-box;height:0}pre{overflow:auto}code,kbd,pre,samp{font-family:monospace, monospace;font-size:1em}button,input,optgroup,select,textarea{color:inherit;font:inherit;margin:0}button{overflow:visible}button,select{text-transform:none}button,html input[type=\"button\"],input[type=\"reset\"],input[type=\"submit\"]{-webkit-appearance:button;cursor:pointer}button[disabled],html input[disabled]{cursor:not-allowed}button::-moz-focus-inner,input::-moz-focus-inner{border:0;padding:0}input{line-height:normal}input[type=\"checkbox\"],input[type=\"radio\"]{box-sizing:border-box;padding:0}input[type=\"number\"]::-webkit-inner-spin-button,input[type=\"number\"]::-webkit-outer-spin-button{height:auto}input[type=\"search\"]{-webkit-appearance:textfield;box-sizing:content-box}input[type=\"search\"]::-webkit-search-cancel-button,input[type=\"search\"]::-webkit-search-decoration{-webkit-appearance:none}legend{border:0;padding:0}textarea{overflow:auto}optgroup{font-weight:bold}table{border-collapse:collapse;border-spacing:0}td,th{padding:0}.foundation-mq{font-family:\"small=0em&medium=40em&large=64em&xlarge=75em&xxlarge=90em\"}html{font-size:100%;box-sizing:border-box}*,*::before,*::after{box-sizing:inherit}body{padding:0;margin:0;font-family:Segoe UI,sans-serif;font-weight:normal;line-height:1.5;color:#414042;background:#fff;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}img{max-width:100%;height:auto;-ms-interpolation-mode:bicubic;display:inline-block;vertical-align:middle}textarea{height:auto;min-height:50px;border-radius:0}select{width:100%;border-radius:0}#map_canvas img,#map_canvas embed,#map_canvas object,.map_canvas img,.map_canvas embed,.map_canvas object,.mqa-display img,.mqa-display embed,.mqa-display object{max-width:none !important}button{-webkit-appearance:none;-moz-appearance:none;background:transparent;padding:0;border:0;border-radius:0;line-height:1}[data-whatinput='mouse'] button{outline:0}.is-visible{display:block !important}.is-hidden{display:none !important}.top-bar{display:flex;align-items:center;justify-content:space-between;flex-wrap:nowrap;padding:.5rem;flex-wrap:wrap}.top-bar,.top-bar ul{background-color:#e6e6e6}.top-bar input{max-width:200px;margin-right:1rem}.top-bar .input-group-field{width:100%;margin-right:0}.top-bar input.button{width:auto}.top-bar .top-bar-left,.top-bar .top-bar-right{flex:0 0 100%;max-width:100%}@media screen and (min-width: 40em){.top-bar{flex-wrap:nowrap}.top-bar .top-bar-left,.top-bar .top-bar-right{flex:1 1 0px}}@media screen and (max-width: 63.9375em){.top-bar.stacked-for-medium{flex-wrap:wrap}.top-bar.stacked-for-medium .top-bar-left,.top-bar.stacked-for-medium .top-bar-right{flex:0 0 100%;max-width:100%}}@media screen and (max-width: 74.9375em){.top-bar.stacked-for-large{flex-wrap:wrap}.top-bar.stacked-for-large .top-bar-left,.top-bar.stacked-for-large .top-bar-right{flex:0 0 100%;max-width:100%}}.top-bar-title{flex:0 0 auto;margin-right:1rem}.top-bar-left,.top-bar-right{flex:0 0 auto}.row{max-width:75rem;margin-left:auto;margin-right:auto;display:flex;flex-flow:row wrap}.row .row{max-width:none;margin-left:-.625rem;margin-right:-.625rem}@media screen and (min-width: 40em){.row .row{margin-left:-.9375rem;margin-right:-.9375rem}}.row.expanded{max-width:none}.row.collapse>.column,.row.collapse>.columns{padding-left:0;padding-right:0}.column,.columns{flex:1 1 0px;padding-left:.625rem;padding-right:.625rem;min-width:initial}@media screen and (min-width: 40em){.column,.columns{padding-left:.9375rem;padding-right:.9375rem}}.column.row.row,.row.row.columns{float:none;display:block}.row .column.row.row,.row .row.row.columns{padding-left:0;padding-right:0;margin-left:0;margin-right:0}.small-1{flex:0 0 8.33333%;max-width:8.33333%}.small-offset-0{margin-left:0%}.small-2{flex:0 0 16.66667%;max-width:16.66667%}.small-offset-1{margin-left:8.33333%}.small-3{flex:0 0 25%;max-width:25%}.small-offset-2{margin-left:16.66667%}.small-4{flex:0 0 33.33333%;max-width:33.33333%}.small-offset-3{margin-left:25%}.small-5{flex:0 0 41.66667%;max-width:41.66667%}.small-offset-4{margin-left:33.33333%}.small-6{flex:0 0 50%;max-width:50%}.small-offset-5{margin-left:41.66667%}.small-7{flex:0 0 58.33333%;max-width:58.33333%}.small-offset-6{margin-left:50%}.small-8{flex:0 0 66.66667%;max-width:66.66667%}.small-offset-7{margin-left:58.33333%}.small-9{flex:0 0 75%;max-width:75%}.small-offset-8{margin-left:66.66667%}.small-10{flex:0 0 83.33333%;max-width:83.33333%}.small-offset-9{margin-left:75%}.small-11{flex:0 0 91.66667%;max-width:91.66667%}.small-offset-10{margin-left:83.33333%}.small-12{flex:0 0 100%;max-width:100%}.small-offset-11{margin-left:91.66667%}.small-order-1{order:1}.small-order-2{order:2}.small-order-3{order:3}.small-order-4{order:4}.small-order-5{order:5}.small-order-6{order:6}.small-up-1{flex-wrap:wrap}.small-up-1>.column,.small-up-1>.columns{flex:0 0 100%;max-width:100%}.small-up-2{flex-wrap:wrap}.small-up-2>.column,.small-up-2>.columns{flex:0 0 50%;max-width:50%}.small-up-3{flex-wrap:wrap}.small-up-3>.column,.small-up-3>.columns{flex:0 0 33.33333%;max-width:33.33333%}.small-up-4{flex-wrap:wrap}.small-up-4>.column,.small-up-4>.columns{flex:0 0 25%;max-width:25%}.small-up-5{flex-wrap:wrap}.small-up-5>.column,.small-up-5>.columns{flex:0 0 20%;max-width:20%}.small-up-6{flex-wrap:wrap}.small-up-6>.column,.small-up-6>.columns{flex:0 0 16.66667%;max-width:16.66667%}.small-up-7{flex-wrap:wrap}.small-up-7>.column,.small-up-7>.columns{flex:0 0 14.28571%;max-width:14.28571%}.small-up-8{flex-wrap:wrap}.small-up-8>.column,.small-up-8>.columns{flex:0 0 12.5%;max-width:12.5%}.small-collapse>.column,.small-collapse>.columns{padding-left:0;padding-right:0}.small-uncollapse>.column,.small-uncollapse>.columns{padding-left:.625rem;padding-right:.625rem}@media screen and (min-width: 40em){.medium-1{flex:0 0 8.33333%;max-width:8.33333%}.medium-offset-0{margin-left:0%}.medium-2{flex:0 0 16.66667%;max-width:16.66667%}.medium-offset-1{margin-left:8.33333%}.medium-3{flex:0 0 25%;max-width:25%}.medium-offset-2{margin-left:16.66667%}.medium-4{flex:0 0 33.33333%;max-width:33.33333%}.medium-offset-3{margin-left:25%}.medium-5{flex:0 0 41.66667%;max-width:41.66667%}.medium-offset-4{margin-left:33.33333%}.medium-6{flex:0 0 50%;max-width:50%}.medium-offset-5{margin-left:41.66667%}.medium-7{flex:0 0 58.33333%;max-width:58.33333%}.medium-offset-6{margin-left:50%}.medium-8{flex:0 0 66.66667%;max-width:66.66667%}.medium-offset-7{margin-left:58.33333%}.medium-9{flex:0 0 75%;max-width:75%}.medium-offset-8{margin-left:66.66667%}.medium-10{flex:0 0 83.33333%;max-width:83.33333%}.medium-offset-9{margin-left:75%}.medium-11{flex:0 0 91.66667%;max-width:91.66667%}.medium-offset-10{margin-left:83.33333%}.medium-12{flex:0 0 100%;max-width:100%}.medium-offset-11{margin-left:91.66667%}.medium-order-1{order:1}.medium-order-2{order:2}.medium-order-3{order:3}.medium-order-4{order:4}.medium-order-5{order:5}.medium-order-6{order:6}.medium-up-1{flex-wrap:wrap}.medium-up-1>.column,.medium-up-1>.columns{flex:0 0 100%;max-width:100%}.medium-up-2{flex-wrap:wrap}.medium-up-2>.column,.medium-up-2>.columns{flex:0 0 50%;max-width:50%}.medium-up-3{flex-wrap:wrap}.medium-up-3>.column,.medium-up-3>.columns{flex:0 0 33.33333%;max-width:33.33333%}.medium-up-4{flex-wrap:wrap}.medium-up-4>.column,.medium-up-4>.columns{flex:0 0 25%;max-width:25%}.medium-up-5{flex-wrap:wrap}.medium-up-5>.column,.medium-up-5>.columns{flex:0 0 20%;max-width:20%}.medium-up-6{flex-wrap:wrap}.medium-up-6>.column,.medium-up-6>.columns{flex:0 0 16.66667%;max-width:16.66667%}.medium-up-7{flex-wrap:wrap}.medium-up-7>.column,.medium-up-7>.columns{flex:0 0 14.28571%;max-width:14.28571%}.medium-up-8{flex-wrap:wrap}.medium-up-8>.column,.medium-up-8>.columns{flex:0 0 12.5%;max-width:12.5%}}@media screen and (min-width: 40em) and (min-width: 40em){.medium-expand{flex:1 1 0px}}.row.medium-unstack>.column,.row.medium-unstack>.columns{flex:0 0 100%}@media screen and (min-width: 40em){.row.medium-unstack>.column,.row.medium-unstack>.columns{flex:1 1 0px}}@media screen and (min-width: 40em){.medium-collapse>.column,.medium-collapse>.columns{padding-left:0;padding-right:0}.medium-uncollapse>.column,.medium-uncollapse>.columns{padding-left:.9375rem;padding-right:.9375rem}}@media screen and (min-width: 64em){.large-1{flex:0 0 8.33333%;max-width:8.33333%}.large-offset-0{margin-left:0%}.large-2{flex:0 0 16.66667%;max-width:16.66667%}.large-offset-1{margin-left:8.33333%}.large-3{flex:0 0 25%;max-width:25%}.large-offset-2{margin-left:16.66667%}.large-4{flex:0 0 33.33333%;max-width:33.33333%}.large-offset-3{margin-left:25%}.large-5{flex:0 0 41.66667%;max-width:41.66667%}.large-offset-4{margin-left:33.33333%}.large-6{flex:0 0 50%;max-width:50%}.large-offset-5{margin-left:41.66667%}.large-7{flex:0 0 58.33333%;max-width:58.33333%}.large-offset-6{margin-left:50%}.large-8{flex:0 0 66.66667%;max-width:66.66667%}.large-offset-7{margin-left:58.33333%}.large-9{flex:0 0 75%;max-width:75%}.large-offset-8{margin-left:66.66667%}.large-10{flex:0 0 83.33333%;max-width:83.33333%}.large-offset-9{margin-left:75%}.large-11{flex:0 0 91.66667%;max-width:91.66667%}.large-offset-10{margin-left:83.33333%}.large-12{flex:0 0 100%;max-width:100%}.large-offset-11{margin-left:91.66667%}.large-order-1{order:1}.large-order-2{order:2}.large-order-3{order:3}.large-order-4{order:4}.large-order-5{order:5}.large-order-6{order:6}.large-up-1{flex-wrap:wrap}.large-up-1>.column,.large-up-1>.columns{flex:0 0 100%;max-width:100%}.large-up-2{flex-wrap:wrap}.large-up-2>.column,.large-up-2>.columns{flex:0 0 50%;max-width:50%}.large-up-3{flex-wrap:wrap}.large-up-3>.column,.large-up-3>.columns{flex:0 0 33.33333%;max-width:33.33333%}.large-up-4{flex-wrap:wrap}.large-up-4>.column,.large-up-4>.columns{flex:0 0 25%;max-width:25%}.large-up-5{flex-wrap:wrap}.large-up-5>.column,.large-up-5>.columns{flex:0 0 20%;max-width:20%}.large-up-6{flex-wrap:wrap}.large-up-6>.column,.large-up-6>.columns{flex:0 0 16.66667%;max-width:16.66667%}.large-up-7{flex-wrap:wrap}.large-up-7>.column,.large-up-7>.columns{flex:0 0 14.28571%;max-width:14.28571%}.large-up-8{flex-wrap:wrap}.large-up-8>.column,.large-up-8>.columns{flex:0 0 12.5%;max-width:12.5%}}@media screen and (min-width: 64em) and (min-width: 64em){.large-expand{flex:1 1 0px}}.row.large-unstack>.column,.row.large-unstack>.columns{flex:0 0 100%}@media screen and (min-width: 64em){.row.large-unstack>.column,.row.large-unstack>.columns{flex:1 1 0px}}@media screen and (min-width: 64em){.large-collapse>.column,.large-collapse>.columns{padding-left:0;padding-right:0}.large-uncollapse>.column,.large-uncollapse>.columns{padding-left:.9375rem;padding-right:.9375rem}}.shrink{flex:0 0 auto;max-width:100%}.column.align-top,.align-top.columns{align-self:flex-start}.column.align-bottom,.align-bottom.columns{align-self:flex-end}.column.align-middle,.align-middle.columns{align-self:center}.column.align-stretch,.align-stretch.columns{align-self:stretch}div,dl,dt,dd,ul,ol,li,h1,h2,h3,h4,h5,h6,pre,form,p,blockquote,th,td{margin:0;padding:0}p{font-size:inherit;line-height:1.6;margin-bottom:1rem;text-rendering:optimizeLegibility}em,i{font-style:italic;line-height:inherit}strong,b{font-weight:bold;line-height:inherit}small{font-size:80%;line-height:inherit}h1,h2,h3,h4,h5,h6{font-family:Segoe UI,sans-serif;font-weight:normal;font-style:normal;color:inherit;text-rendering:optimizeLegibility;margin-top:0;margin-bottom:.5rem;line-height:1.4}h1 small,h2 small,h3 small,h4 small,h5 small,h6 small{color:#cacaca;line-height:0}h1{font-size:1.5rem}h2{font-size:1.25rem}h3{font-size:1.1875rem}h4{font-size:1.125rem}h5{font-size:1.0625rem}h6{font-size:1rem}@media screen and (min-width: 40em){h1{font-size:3rem}h2{font-size:2.5rem}h3{font-size:1.9375rem}h4{font-size:1.5625rem}h5{font-size:1.25rem}h6{font-size:1rem}}a{color:#00707e;text-decoration:none;line-height:inherit;cursor:pointer}a:hover,a:focus{color:#00606c}a img{border:0}hr{max-width:75rem;height:0;border-right:0;border-top:0;border-bottom:1px solid #cacaca;border-left:0;margin:1.25rem auto;clear:both}ul,ol,dl{line-height:1.6;margin-bottom:1rem;list-style-position:outside}li{font-size:inherit}ul{list-style-type:disc;margin-left:1.25rem}ol{margin-left:1.25rem}ul ul,ol ul,ul ol,ol ol{margin-left:1.25rem;margin-bottom:0}dl{margin-bottom:1rem}dl dt{margin-bottom:.3rem;font-weight:bold}blockquote{margin:0 0 1rem;padding:.5625rem 1.25rem 0 1.1875rem;border-left:1px solid #cacaca}blockquote,blockquote p{line-height:1.6;color:#8a8a8a}cite{display:block;font-size:.8125rem;color:#8a8a8a}cite:before{content:'\\2014 \\0020'}abbr{color:#414042;cursor:help;border-bottom:1px dotted #0a0a0a}code{font-family:Consolas,\"Liberation Mono\",Courier,monospace;font-weight:normal;color:#0a0a0a;background-color:#e6e6e6;border:1px solid #cacaca;padding:.125rem .3125rem .0625rem}kbd{padding:.125rem .25rem 0;margin:0;background-color:#e6e6e6;color:#0a0a0a;font-family:Consolas,\"Liberation Mono\",Courier,monospace}.subheader{margin-top:.2rem;margin-bottom:.5rem;font-weight:normal;line-height:1.4;color:#8a8a8a}.lead{font-size:125%;line-height:1.6}.stat{font-size:2.5rem;line-height:1}p+.stat{margin-top:-1rem}.no-bullet{margin-left:0;list-style:none}.text-left{text-align:left}.text-right{text-align:right}.text-center{text-align:center}.text-justify{text-align:justify}@media screen and (min-width: 40em){.medium-text-left{text-align:left}.medium-text-right{text-align:right}.medium-text-center{text-align:center}.medium-text-justify{text-align:justify}}@media screen and (min-width: 64em){.large-text-left{text-align:left}.large-text-right{text-align:right}.large-text-center{text-align:center}.large-text-justify{text-align:justify}}.show-for-print{display:none !important}@media print{*{background:transparent !important;color:black !important;box-shadow:none !important;text-shadow:none !important}.show-for-print{display:block !important}.hide-for-print{display:none !important}table.show-for-print{display:table !important}thead.show-for-print{display:table-header-group !important}tbody.show-for-print{display:table-row-group !important}tr.show-for-print{display:table-row !important}td.show-for-print{display:table-cell !important}th.show-for-print{display:table-cell !important}a,a:visited{text-decoration:underline}a[href]:after{content:\" (\" attr(href) \")\"}.ir a:after,a[href^='javascript:']:after,a[href^='#']:after{content:''}abbr[title]:after{content:\" (\" attr(title) \")\"}pre,blockquote{border:1px solid #8a8a8a;page-break-inside:avoid}thead{display:table-header-group}tr,img{page-break-inside:avoid}img{max-width:100% !important}@page{margin:0.5cm}p,h2,h3{orphans:3;widows:3}h2,h3{page-break-after:avoid}}[type='text'],[type='password'],[type='date'],[type='datetime'],[type='datetime-local'],[type='month'],[type='week'],[type='email'],[type='number'],[type='search'],[type='tel'],[type='time'],[type='url'],[type='color'],textarea{display:block;box-sizing:border-box;width:100%;height:2.4375rem;padding:.5rem;border:1px solid #cacaca;margin:0 0 1rem;font-family:inherit;font-size:1rem;color:#0a0a0a;background-color:#fefefe;box-shadow:inset 0 1px 2px rgba(10,10,10,0.1);border-radius:0;transition:box-shadow 0.5s,border-color 0.25s ease-in-out;-webkit-appearance:none;-moz-appearance:none}[type='text']:focus,[type='password']:focus,[type='date']:focus,[type='datetime']:focus,[type='datetime-local']:focus,[type='month']:focus,[type='week']:focus,[type='email']:focus,[type='number']:focus,[type='search']:focus,[type='tel']:focus,[type='time']:focus,[type='url']:focus,[type='color']:focus,textarea:focus{border:1px solid #8a8a8a;background-color:#fefefe;outline:none;box-shadow:0 0 5px #cacaca;transition:box-shadow 0.5s,border-color 0.25s ease-in-out}textarea{max-width:100%}textarea[rows]{height:auto}input::placeholder,textarea::placeholder{color:#cacaca}input:disabled,input[readonly],textarea:disabled,textarea[readonly]{background-color:#e6e6e6;cursor:not-allowed}[type='submit'],[type='button']{border-radius:.2rem;-webkit-appearance:none;-moz-appearance:none}input[type='search']{box-sizing:border-box}[type='file'],[type='checkbox'],[type='radio']{margin:0 0 1rem}[type='checkbox']+label,[type='radio']+label{display:inline-block;margin-left:.5rem;margin-right:1rem;margin-bottom:0;vertical-align:baseline}[type='checkbox']+label[for],[type='radio']+label[for]{cursor:pointer}label>[type='checkbox'],label>[type='radio']{margin-right:.5rem}[type='file']{width:100%}label{display:block;margin:0;font-size:.875rem;font-weight:normal;line-height:1.8;color:#0a0a0a}label.middle{margin:0 0 1rem;padding:.5625rem 0}.help-text{margin-top:-.5rem;font-size:.8125rem;font-style:italic;color:#0a0a0a}.input-group{display:flex;width:100%;margin-bottom:1rem;align-items:stretch}.input-group>:first-child{border-radius:0 0 0 0}.input-group>:last-child>*{border-radius:0 0 0 0}.input-group-label,.input-group-field,.input-group-button{margin:0;white-space:nowrap}.input-group-label{text-align:center;padding:0 1rem;background:#e6e6e6;color:#0a0a0a;border:1px solid #cacaca;white-space:nowrap;flex:0 0 auto;display:flex;align-items:center}.input-group-label:first-child{border-right:0}.input-group-label:last-child{border-left:0}.input-group-field{border-radius:0;flex:1 1 0px;width:auto;height:auto}.input-group-button{padding-top:0;padding-bottom:0;text-align:center;flex:0 0 auto}.input-group-button a,.input-group-button input,.input-group-button button{margin:0}.input-group .input-group-button{display:table-cell}fieldset{border:0;padding:0;margin:0}legend{margin-bottom:.5rem;max-width:100%}.fieldset{border:1px solid #cacaca;padding:1.25rem;margin:1.125rem 0}.fieldset legend{background:#fff;padding:0 .1875rem;margin:0;margin-left:-.1875rem}select{height:2.4375rem;padding:.5rem;border:1px solid #cacaca;margin:0 0 1rem;font-size:1rem;font-family:inherit;line-height:normal;color:#0a0a0a;background-color:#fefefe;border-radius:0;-webkit-appearance:none;-moz-appearance:none;background-image:url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' version='1.1' width='32' height='24' viewBox='0 0 32 24'><polygon points='0,0 32,0 16,24' style='fill: rgb%28138, 138, 138%29'></polygon></svg>\");background-size:9px 6px;background-position:right -1rem center;background-origin:content-box;background-repeat:no-repeat;padding-right:1.5rem}@media screen and (min-width: 0\\0){select{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAYCAYAAACbU/80AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAIpJREFUeNrEkckNgDAMBBfRkEt0ObRBBdsGXUDgmQfK4XhH2m8czQAAy27R3tsw4Qfe2x8uOO6oYLb6GlOor3GF+swURAOmUJ+RwtEJs9WvTGEYxBXqI1MQAZhCfUQKRzDMVj+TwrAIV6jvSUEkYAr1LSkcyTBb/V+KYfX7xAeusq3sLDtGH3kEGACPWIflNZfhRQAAAABJRU5ErkJggg==\")}}select:disabled{background-color:#e6e6e6;cursor:not-allowed}select::-ms-expand{display:none}select[multiple]{height:auto;background-image:none}.is-invalid-input:not(:focus){background-color:rgba(236,88,64,0.1);border-color:#ec5840}.is-invalid-label{color:#ec5840}.form-error{display:none;margin-top:-.5rem;margin-bottom:1rem;font-size:.75rem;font-weight:bold;color:#ec5840}.form-error.is-visible{display:block}.hide{display:none !important}.invisible{visibility:hidden}@media screen and (max-width: 39.9375em){.hide-for-small-only{display:none !important}}@media screen and (max-width: 0em), screen and (min-width: 40em){.show-for-small-only{display:none !important}}@media screen and (min-width: 40em){.hide-for-medium{display:none !important}}@media screen and (max-width: 39.9375em){.show-for-medium{display:none !important}}@media screen and (min-width: 40em) and (max-width: 63.9375em){.hide-for-medium-only{display:none !important}}@media screen and (max-width: 39.9375em), screen and (min-width: 64em){.show-for-medium-only{display:none !important}}@media screen and (min-width: 64em){.hide-for-large{display:none !important}}@media screen and (max-width: 63.9375em){.show-for-large{display:none !important}}@media screen and (min-width: 64em) and (max-width: 74.9375em){.hide-for-large-only{display:none !important}}@media screen and (max-width: 63.9375em), screen and (min-width: 75em){.show-for-large-only{display:none !important}}.show-for-sr,.show-on-focus{position:absolute !important;width:1px;height:1px;overflow:hidden;clip:rect(0, 0, 0, 0)}.show-on-focus:active,.show-on-focus:focus{position:static !important;height:auto;width:auto;overflow:visible;clip:auto}.show-for-landscape,.hide-for-portrait{display:block !important}@media screen and (orientation: landscape){.show-for-landscape,.hide-for-portrait{display:block !important}}@media screen and (orientation: portrait){.show-for-landscape,.hide-for-portrait{display:none !important}}.hide-for-landscape,.show-for-portrait{display:none !important}@media screen and (orientation: landscape){.hide-for-landscape,.show-for-portrait{display:none !important}}@media screen and (orientation: portrait){.hide-for-landscape,.show-for-portrait{display:block !important}}.button{display:inline-block;text-align:center;line-height:1;cursor:pointer;-webkit-appearance:none;transition:background-color 0.25s ease-out, color 0.25s ease-out;vertical-align:middle;border:1px solid transparent;border-radius:.2rem;padding:1em 1.5rem;margin:0;font-size:0.9rem;background-color:#00707e;color:#fefefe}[data-whatinput='mouse'] .button{outline:0}.button:hover,.button:focus{background-color:#005f6b;color:#fefefe}.button.tiny{font-size:.6rem}.button.small{font-size:.75rem}.button.large{font-size:1.25rem}.button.expanded{display:block;width:100%;margin-left:0;margin-right:0}.button.primary{background-color:#00707e;color:#fefefe}.button.primary:hover,.button.primary:focus{background-color:#005a65;color:#fefefe}.button.secondary{background-color:#faa635;color:#fefefe}.button.secondary:hover,.button.secondary:focus{background-color:#ed8a06;color:#fefefe}.button.tertiary{background-color:#fff;color:#0a0a0a}.button.tertiary:hover,.button.tertiary:focus{background-color:#ccc;color:#0a0a0a}.button.topbar{background-color:#064180;color:#fefefe}.button.topbar:hover,.button.topbar:focus{background-color:#053466;color:#fefefe}.button.success{background-color:#4caf50;color:#fefefe}.button.success:hover,.button.success:focus{background-color:#3d8c40;color:#fefefe}.button.warning{background-color:#ffae00;color:#fefefe}.button.warning:hover,.button.warning:focus{background-color:#cc8b00;color:#fefefe}.button.alert{background-color:#ec5840;color:#fefefe}.button.alert:hover,.button.alert:focus{background-color:#da3116;color:#fefefe}.button.hollow{border:1px solid #00707e;color:#00707e}.button.hollow,.button.hollow:hover,.button.hollow:focus{background-color:transparent}.button.hollow:hover,.button.hollow:focus{border-color:#00383f;color:#00383f}.button.hollow.primary{border:1px solid #00707e;color:#00707e}.button.hollow.primary:hover,.button.hollow.primary:focus{border-color:#00383f;color:#00383f}.button.hollow.secondary{border:1px solid #faa635;color:#faa635}.button.hollow.secondary:hover,.button.hollow.secondary:focus{border-color:#945604;color:#945604}.button.hollow.tertiary{border:1px solid #fff;color:#fff}.button.hollow.tertiary:hover,.button.hollow.tertiary:focus{border-color:gray;color:gray}.button.hollow.topbar{border:1px solid #064180;color:#064180}.button.hollow.topbar:hover,.button.hollow.topbar:focus{border-color:#032140;color:#032140}.button.hollow.success{border:1px solid #4caf50;color:#4caf50}.button.hollow.success:hover,.button.hollow.success:focus{border-color:#265828;color:#265828}.button.hollow.warning{border:1px solid #ffae00;color:#ffae00}.button.hollow.warning:hover,.button.hollow.warning:focus{border-color:#805700;color:#805700}.button.hollow.alert{border:1px solid #ec5840;color:#ec5840}.button.hollow.alert:hover,.button.hollow.alert:focus{border-color:#881f0e;color:#881f0e}.button.disabled,.button[disabled]{opacity:.25;cursor:not-allowed}.button.disabled:hover,.button.disabled:focus,.button[disabled]:hover,.button[disabled]:focus{background-color:#00707e;color:#fefefe}.button.dropdown::after{content:'';display:block;width:0;height:0;border:inset .4em;border-color:#fefefe transparent transparent;border-top-style:solid;border-bottom-width:0;position:relative;top:0.4em;float:right;margin-left:1.5rem;display:inline-block}.button.arrow-only::after{margin-left:0;float:none;top:-0.1em}.button-group{margin-bottom:1rem;display:flex;flex-wrap:nowrap;align-items:stretch}.button-group::before,.button-group::after{content:' ';display:table;flex-basis:0;order:1}.button-group::after{clear:both}.button-group .button{margin:0;margin-right:1px;margin-bottom:1px;font-size:0.9rem;flex:0 0 auto}.button-group .button:last-child{margin-right:0}.button-group.tiny .button{font-size:.6rem}.button-group.small .button{font-size:.75rem}.button-group.large .button{font-size:1.25rem}.button-group.expanded .button{flex:1 1 0px}.button-group.primary .button{background-color:#00707e;color:#fefefe}.button-group.primary .button:hover,.button-group.primary .button:focus{background-color:#005a65;color:#fefefe}.button-group.secondary .button{background-color:#faa635;color:#fefefe}.button-group.secondary .button:hover,.button-group.secondary .button:focus{background-color:#ed8a06;color:#fefefe}.button-group.tertiary .button{background-color:#fff;color:#0a0a0a}.button-group.tertiary .button:hover,.button-group.tertiary .button:focus{background-color:#ccc;color:#0a0a0a}.button-group.topbar .button{background-color:#064180;color:#fefefe}.button-group.topbar .button:hover,.button-group.topbar .button:focus{background-color:#053466;color:#fefefe}.button-group.success .button{background-color:#4caf50;color:#fefefe}.button-group.success .button:hover,.button-group.success .button:focus{background-color:#3d8c40;color:#fefefe}.button-group.warning .button{background-color:#ffae00;color:#fefefe}.button-group.warning .button:hover,.button-group.warning .button:focus{background-color:#cc8b00;color:#fefefe}.button-group.alert .button{background-color:#ec5840;color:#fefefe}.button-group.alert .button:hover,.button-group.alert .button:focus{background-color:#da3116;color:#fefefe}.button-group.stacked,.button-group.stacked-for-small,.button-group.stacked-for-medium{flex-wrap:wrap}.button-group.stacked .button,.button-group.stacked-for-small .button,.button-group.stacked-for-medium .button{flex:0 0 100%}.button-group.stacked .button:last-child,.button-group.stacked-for-small .button:last-child,.button-group.stacked-for-medium .button:last-child{margin-bottom:0}@media screen and (min-width: 40em){.button-group.stacked-for-small .button{flex:1 1 0px;margin-bottom:0}}@media screen and (min-width: 64em){.button-group.stacked-for-medium .button{flex:1 1 0px;margin-bottom:0}}@media screen and (max-width: 39.9375em){.button-group.stacked-for-small.expanded{display:block}.button-group.stacked-for-small.expanded .button{display:block;margin-right:0}}.badge{display:inline-block;padding:.3em;min-width:2.1em;font-size:.6rem;text-align:center;border-radius:50%;background:#00707e;color:#fefefe}.badge.secondary{background:#faa635;color:#fefefe}.badge.tertiary{background:#fff;color:#0a0a0a}.badge.topbar{background:#064180;color:#fefefe}.badge.success{background:#4caf50;color:#fefefe}.badge.warning{background:#ffae00;color:#fefefe}.badge.alert{background:#ec5840;color:#fefefe}.breadcrumbs{list-style:none;margin:0 0 1rem 0}.breadcrumbs::before,.breadcrumbs::after{content:' ';display:table;flex-basis:0;order:1}.breadcrumbs::after{clear:both}.breadcrumbs li{float:left;color:#0a0a0a;font-size:.6875rem;cursor:default;text-transform:uppercase}.breadcrumbs li:not(:last-child)::after{color:#cacaca;content:\"/\";margin:0 .75rem;position:relative;top:1px;opacity:1}.breadcrumbs a{color:#00707e}.breadcrumbs a:hover{text-decoration:underline}.breadcrumbs .disabled{color:#cacaca;cursor:not-allowed}.callout{margin:0 0 1rem 0;padding:1rem;border:1px solid rgba(10,10,10,0.25);border-radius:0;position:relative;color:#414042;background-color:#fff}.callout>:first-child{margin-top:0}.callout>:last-child{margin-bottom:0}.callout.primary{background-color:#c5f9ff}.callout.secondary{background-color:#fef2e1}.callout.tertiary{background-color:#fff}.callout.topbar{background-color:#c9e2fc}.callout.success{background-color:#e4f3e5}.callout.warning{background-color:#fff3d9}.callout.alert{background-color:#fce6e2}.callout.small{padding-top:.5rem;padding-right:.5rem;padding-bottom:.5rem;padding-left:.5rem}.callout.large{padding-top:3rem;padding-right:3rem;padding-bottom:3rem;padding-left:3rem}.close-button{position:absolute;color:#8a8a8a;right:1rem;top:.5rem;font-size:2em;line-height:1;cursor:pointer}[data-whatinput='mouse'] .close-button{outline:0}.close-button:hover,.close-button:focus{color:#0a0a0a}.menu{margin:0;list-style-type:none;width:100%;display:flex;flex-wrap:nowrap;align-items:center;flex-wrap:nowrap}.menu>li{flex:0 0 auto}[data-whatinput='mouse'] .menu>li{outline:0}.menu>li>a{display:block;padding:0.7rem 1rem;line-height:1}.menu input,.menu a,.menu button{margin-bottom:0}.menu>li>a{display:flex}.menu>li>a{flex-flow:row nowrap}.menu>li>a img,.menu>li>a i,.menu>li>a svg{margin-right:.25rem}.menu>li{flex:0 0 auto}.menu.vertical{flex-wrap:wrap}.menu.vertical>li{flex:0 0 100%;max-width:100%}.menu.vertical>li>a{align-items:flex-start;justify-content:flex-start}@media screen and (min-width: 40em){.menu.medium-horizontal{flex-wrap:nowrap}.menu.medium-horizontal>li{flex:0 0 auto}.menu.medium-vertical{flex-wrap:wrap}.menu.medium-vertical>li{flex:0 0 100%;max-width:100%}.menu.medium-vertical>li>a{align-items:flex-start;justify-content:flex-start}}@media screen and (min-width: 64em){.menu.large-horizontal{flex-wrap:nowrap}.menu.large-horizontal>li{flex:0 0 auto}.menu.large-vertical{flex-wrap:wrap}.menu.large-vertical>li{flex:0 0 100%;max-width:100%}.menu.large-vertical>li>a{align-items:flex-start;justify-content:flex-start}}.menu.simple li{line-height:1;display:inline-block;margin-right:1rem}.menu.simple a{padding:0}.menu.align-right{justify-content:flex-end}.menu.expanded>li{flex:1 1 0px}.menu.expanded>li:first-child:last-child{width:100%}.menu.icon-top>li>a{flex-flow:column nowrap}.menu.icon-top>li>a img,.menu.icon-top>li>a i,.menu.icon-top>li>a svg{align-self:stretch;text-align:center;margin-bottom:.25rem}.menu.nested{margin-left:1rem}.menu .active>a{color:#fefefe;background:#00707e}.menu-text{font-weight:bold;color:inherit;line-height:1;padding-top:0;padding-bottom:0;padding:0.7rem 1rem}.menu-centered{text-align:center}.menu-centered>.menu{display:inline-block}.no-js [data-responsive-menu] ul{display:none}.menu-icon{position:relative;display:inline-block;vertical-align:middle;cursor:pointer;width:20px;height:16px}.menu-icon::after{content:'';position:absolute;display:block;width:100%;height:2px;background:#fefefe;top:0;left:0;box-shadow:0 7px 0 #fefefe,0 14px 0 #fefefe}.menu-icon:hover::after{background:#cacaca;box-shadow:0 7px 0 #cacaca,0 14px 0 #cacaca}.menu-icon.dark{position:relative;display:inline-block;vertical-align:middle;cursor:pointer;width:20px;height:16px}.menu-icon.dark::after{content:'';position:absolute;display:block;width:100%;height:2px;background:#0a0a0a;top:0;left:0;box-shadow:0 7px 0 #0a0a0a,0 14px 0 #0a0a0a}.menu-icon.dark:hover::after{background:#8a8a8a;box-shadow:0 7px 0 #8a8a8a,0 14px 0 #8a8a8a}.is-drilldown{position:relative;overflow:hidden}.is-drilldown li{display:block !important}.is-drilldown-submenu{position:absolute;top:0;left:100%;z-index:-1;height:100%;width:100%;background:#fefefe;transition:transform 0.15s linear}.is-drilldown-submenu.is-active{z-index:1;display:block;transform:translateX(-100%)}.is-drilldown-submenu.is-closing{transform:translateX(100%)}.is-drilldown-submenu-parent>a{position:relative}.is-drilldown-submenu-parent>a::after{content:'';display:block;width:0;height:0;border:inset 6px;border-color:transparent transparent transparent #00707e;border-left-style:solid;border-right-width:0;position:absolute;top:50%;margin-top:-6px;right:1rem}.js-drilldown-back>a::before{content:'';display:block;width:0;height:0;border:inset 6px;border-color:transparent #00707e transparent transparent;border-right-style:solid;border-left-width:0;border-left-width:0;display:inline-block;vertical-align:middle;margin-right:0.75rem}.dropdown-pane{background-color:#fff;border:1px solid #cacaca;border-radius:0;display:block;font-size:1rem;padding:1rem;position:absolute;visibility:hidden;width:300px;z-index:10}.dropdown-pane.is-open{visibility:visible}.dropdown-pane.tiny{width:100px}.dropdown-pane.small{width:200px}.dropdown-pane.large{width:400px}.dropdown.menu>li.opens-left>.is-dropdown-submenu{left:auto;right:0;top:100%}.dropdown.menu>li.opens-right>.is-dropdown-submenu{right:auto;left:0;top:100%}.dropdown.menu>li.is-dropdown-submenu-parent>a{padding-right:1.5rem;position:relative}.dropdown.menu>li.is-dropdown-submenu-parent>a::after{content:'';display:block;width:0;height:0;border:inset 5px;border-color:#00707e transparent transparent;border-top-style:solid;border-bottom-width:0;right:5px;margin-top:-2px}[data-whatinput='mouse'] .dropdown.menu a{outline:0}.no-js .dropdown.menu ul{display:none}.dropdown.menu.vertical>li .is-dropdown-submenu{top:0}.dropdown.menu.vertical>li.opens-left>.is-dropdown-submenu{left:auto;right:100%}.dropdown.menu.vertical>li.opens-right>.is-dropdown-submenu{right:auto;left:100%}.dropdown.menu.vertical>li>a::after{right:14px;margin-top:-3px}.dropdown.menu.vertical>li.opens-left>a::after{content:'';display:block;width:0;height:0;border:inset 5px;border-color:transparent #00707e transparent transparent;border-right-style:solid;border-left-width:0}.dropdown.menu.vertical>li.opens-right>a::after{content:'';display:block;width:0;height:0;border:inset 5px;border-color:transparent transparent transparent #00707e;border-left-style:solid;border-right-width:0}@media screen and (min-width: 40em){.dropdown.menu.medium-horizontal>li.opens-left>.is-dropdown-submenu{left:auto;right:0;top:100%}.dropdown.menu.medium-horizontal>li.opens-right>.is-dropdown-submenu{right:auto;left:0;top:100%}.dropdown.menu.medium-horizontal>li.is-dropdown-submenu-parent>a{padding-right:1.5rem;position:relative}.dropdown.menu.medium-horizontal>li.is-dropdown-submenu-parent>a::after{content:'';display:block;width:0;height:0;border:inset 5px;border-color:#00707e transparent transparent;border-top-style:solid;border-bottom-width:0;right:5px;margin-top:-2px}.dropdown.menu.medium-vertical>li .is-dropdown-submenu{top:0}.dropdown.menu.medium-vertical>li.opens-left>.is-dropdown-submenu{left:auto;right:100%}.dropdown.menu.medium-vertical>li.opens-right>.is-dropdown-submenu{right:auto;left:100%}.dropdown.menu.medium-vertical>li>a::after{right:14px;margin-top:-3px}.dropdown.menu.medium-vertical>li.opens-left>a::after{content:'';display:block;width:0;height:0;border:inset 5px;border-color:transparent #00707e transparent transparent;border-right-style:solid;border-left-width:0}.dropdown.menu.medium-vertical>li.opens-right>a::after{content:'';display:block;width:0;height:0;border:inset 5px;border-color:transparent transparent transparent #00707e;border-left-style:solid;border-right-width:0}}@media screen and (min-width: 64em){.dropdown.menu.large-horizontal>li.opens-left>.is-dropdown-submenu{left:auto;right:0;top:100%}.dropdown.menu.large-horizontal>li.opens-right>.is-dropdown-submenu{right:auto;left:0;top:100%}.dropdown.menu.large-horizontal>li.is-dropdown-submenu-parent>a{padding-right:1.5rem;position:relative}.dropdown.menu.large-horizontal>li.is-dropdown-submenu-parent>a::after{content:'';display:block;width:0;height:0;border:inset 5px;border-color:#00707e transparent transparent;border-top-style:solid;border-bottom-width:0;right:5px;margin-top:-2px}.dropdown.menu.large-vertical>li .is-dropdown-submenu{top:0}.dropdown.menu.large-vertical>li.opens-left>.is-dropdown-submenu{left:auto;right:100%}.dropdown.menu.large-vertical>li.opens-right>.is-dropdown-submenu{right:auto;left:100%}.dropdown.menu.large-vertical>li>a::after{right:14px;margin-top:-3px}.dropdown.menu.large-vertical>li.opens-left>a::after{content:'';display:block;width:0;height:0;border:inset 5px;border-color:transparent #00707e transparent transparent;border-right-style:solid;border-left-width:0}.dropdown.menu.large-vertical>li.opens-right>a::after{content:'';display:block;width:0;height:0;border:inset 5px;border-color:transparent transparent transparent #00707e;border-left-style:solid;border-right-width:0}}.dropdown.menu.align-right .is-dropdown-submenu.first-sub{top:100%;left:auto;right:0}.is-dropdown-menu.vertical{width:100px}.is-dropdown-menu.vertical.align-right{float:right}.is-dropdown-submenu-parent{position:relative}.is-dropdown-submenu-parent a::after{position:absolute;top:50%;right:5px;margin-top:-2px}.is-dropdown-submenu-parent.opens-inner>.is-dropdown-submenu{top:100%;left:auto}.is-dropdown-submenu-parent.opens-left>.is-dropdown-submenu{left:auto;right:100%}.is-dropdown-submenu-parent.opens-right>.is-dropdown-submenu{right:auto;left:100%}.is-dropdown-submenu{display:none;position:absolute;top:0;left:100%;min-width:200px;z-index:1;background:#fefefe;border:1px solid #cacaca}.is-dropdown-submenu .is-dropdown-submenu-parent>a::after{right:14px;margin-top:-3px}.is-dropdown-submenu .is-dropdown-submenu-parent.opens-left>a::after{content:'';display:block;width:0;height:0;border:inset 5px;border-color:transparent #00707e transparent transparent;border-right-style:solid;border-left-width:0}.is-dropdown-submenu .is-dropdown-submenu-parent.opens-right>a::after{content:'';display:block;width:0;height:0;border:inset 5px;border-color:transparent transparent transparent #00707e;border-left-style:solid;border-right-width:0}.is-dropdown-submenu .is-dropdown-submenu{margin-top:-1px}.is-dropdown-submenu>li{width:100%}.is-dropdown-submenu.js-dropdown-active{display:block}.align-right{justify-content:flex-end}.align-center{justify-content:center}.align-justify{justify-content:space-between}.align-spaced{justify-content:space-around}.align-top{align-items:flex-start}.align-self-top{align-self:flex-start}.align-bottom{align-items:flex-end}.align-self-bottom{align-self:flex-end}.align-middle{align-items:center}.align-self-middle{align-self:center}.align-stretch{align-items:stretch}.align-self-stretch{align-self:stretch}.small-order-1{order:1}.small-order-2{order:2}.small-order-3{order:3}.small-order-4{order:4}.small-order-5{order:5}.small-order-6{order:6}@media screen and (min-width: 40em){.medium-order-1{order:1}.medium-order-2{order:2}.medium-order-3{order:3}.medium-order-4{order:4}.medium-order-5{order:5}.medium-order-6{order:6}}@media screen and (min-width: 64em){.large-order-1{order:1}.large-order-2{order:2}.large-order-3{order:3}.large-order-4{order:4}.large-order-5{order:5}.large-order-6{order:6}}.label{display:inline-block;padding:0.33333rem 0.5rem;font-size:.8rem;line-height:1;white-space:nowrap;cursor:default;border-radius:0;background:#00707e;color:#fefefe}.label.secondary{background:#faa635;color:#fefefe}.label.tertiary{background:#fff;color:#0a0a0a}.label.topbar{background:#064180;color:#fefefe}.label.success{background:#4caf50;color:#fefefe}.label.warning{background:#ffae00;color:#fefefe}.label.alert{background:#ec5840;color:#fefefe}.pagination{margin-left:0;margin-bottom:1rem}.pagination::before,.pagination::after{content:' ';display:table;flex-basis:0;order:1}.pagination::after{clear:both}.pagination li{font-size:.875rem;margin-right:.0625rem;border-radius:0;display:none}.pagination li:last-child,.pagination li:first-child{display:inline-block}@media screen and (min-width: 40em){.pagination li{display:inline-block}}.pagination a,.pagination button{color:#0a0a0a;display:block;padding:.1875rem .625rem;border-radius:0}.pagination a:hover,.pagination button:hover{background:#e6e6e6}.pagination .current{padding:.1875rem .625rem;background:#00707e;color:#fefefe;cursor:default}.pagination .disabled{padding:.1875rem .625rem;color:#cacaca;cursor:not-allowed}.pagination .disabled:hover{background:transparent}.pagination .ellipsis::after{content:'\\2026';padding:.1875rem .625rem;color:#0a0a0a}.pagination-previous a::before,.pagination-previous.disabled::before{content:'\\00ab';display:inline-block;margin-right:0.5rem}.pagination-next a::after,.pagination-next.disabled::after{content:'\\00bb';display:inline-block;margin-left:0.5rem}.sticky-container{position:relative}.sticky{position:absolute;z-index:0;transform:translate3d(0, 0, 0)}.sticky.is-stuck{position:fixed;z-index:5}.sticky.is-stuck.is-at-top{top:0}.sticky.is-stuck.is-at-bottom{bottom:0}.sticky.is-anchored{position:absolute;left:auto;right:auto}.sticky.is-anchored.is-at-bottom{bottom:0}body.is-reveal-open{overflow:hidden}html.is-reveal-open,html.is-reveal-open body{height:100%;overflow:hidden;user-select:none}.reveal-overlay{display:none;position:fixed;top:0;bottom:0;left:0;right:0;z-index:1005;background-color:rgba(10,10,10,0.45);overflow-y:scroll}.reveal{display:none;z-index:1006;padding:1rem;border:1px solid #cacaca;background-color:#fefefe;border-radius:0;position:relative;top:100px;margin-left:auto;margin-right:auto;overflow-y:auto}[data-whatinput='mouse'] .reveal{outline:0}@media screen and (min-width: 40em){.reveal{min-height:0}}.reveal .column,.reveal .columns,.reveal .columns{min-width:0}.reveal>:last-child{margin-bottom:0}@media screen and (min-width: 40em){.reveal{width:600px;max-width:75rem}}@media screen and (min-width: 40em){.reveal .reveal{left:auto;right:auto;margin:0 auto}}.reveal.collapse{padding:0}@media screen and (min-width: 40em){.reveal.tiny{width:30%;max-width:75rem}}@media screen and (min-width: 40em){.reveal.small{width:50%;max-width:75rem}}@media screen and (min-width: 40em){.reveal.large{width:90%;max-width:75rem}}.reveal.full{top:0;left:0;width:100%;height:100%;height:100vh;min-height:100vh;max-width:none;margin-left:0;border:0;border-radius:0}@media screen and (max-width: 39.9375em){.reveal{top:0;left:0;width:100%;height:100%;height:100vh;min-height:100vh;max-width:none;margin-left:0;border:0;border-radius:0}}.reveal.without-overlay{position:fixed}.switch{margin-bottom:1rem;outline:0;position:relative;user-select:none;color:#fefefe;font-weight:bold;font-size:.875rem}.switch-input{opacity:0;position:absolute}.switch-paddle{background:#cacaca;cursor:pointer;display:block;position:relative;width:4rem;height:2rem;transition:all 0.25s ease-out;border-radius:0;color:inherit;font-weight:inherit}input+.switch-paddle{margin:0}.switch-paddle::after{background:#fefefe;content:'';display:block;position:absolute;height:1.5rem;left:0.25rem;top:0.25rem;width:1.5rem;transition:all 0.25s ease-out;transform:translate3d(0, 0, 0);border-radius:0}input:checked ~ .switch-paddle{background:#00707e}input:checked ~ .switch-paddle::after{left:2.25rem}[data-whatinput='mouse'] input:focus ~ .switch-paddle{outline:0}.switch-active,.switch-inactive{position:absolute;top:50%;transform:translateY(-50%)}.switch-active{left:8%;display:none}input:checked+label>.switch-active{display:block}.switch-inactive{right:15%}input:checked+label>.switch-inactive{display:none}.switch.tiny .switch-paddle{width:3rem;height:1.5rem;font-size:.625rem}.switch.tiny .switch-paddle::after{width:1rem;height:1rem}.switch.tiny input:checked ~ .switch-paddle::after{left:1.75rem}.switch.small .switch-paddle{width:3.5rem;height:1.75rem;font-size:.75rem}.switch.small .switch-paddle::after{width:1.25rem;height:1.25rem}.switch.small input:checked ~ .switch-paddle::after{left:2rem}.switch.large .switch-paddle{width:5rem;height:2.5rem;font-size:1rem}.switch.large .switch-paddle::after{width:2rem;height:2rem}.switch.large input:checked ~ .switch-paddle::after{left:2.75rem}table{width:100%;margin-bottom:1rem;border-radius:0}table thead,table tbody,table tfoot{border:1px solid #f1f1f1;background-color:#fefefe}table caption{font-weight:bold;padding:.5rem .625rem .625rem}table thead,table tfoot{background:#f8f8f8;color:#414042}table thead tr,table tfoot tr{background:transparent}table thead th,table thead td,table tfoot th,table tfoot td{padding:.5rem .625rem .625rem;font-weight:bold;text-align:left}table tbody tr:nth-child(even){background-color:#f1f1f1}table tbody th,table tbody td{padding:.5rem .625rem .625rem}@media screen and (max-width: 63.9375em){table.stack thead{display:none}table.stack tfoot{display:none}table.stack tr,table.stack th,table.stack td{display:block}table.stack td{border-top:0}}table.scroll{display:block;width:100%;overflow-x:auto}table.hover tr:hover{background-color:#f9f9f9}table.hover tr:nth-of-type(even):hover{background-color:#ececec}.table-scroll{overflow-x:auto}.table-scroll table{width:auto}.tabs{margin:0;list-style-type:none;background:#fefefe;border:1px solid #e6e6e6}.tabs::before,.tabs::after{content:' ';display:table;flex-basis:0;order:1}.tabs::after{clear:both}.tabs.vertical>li{width:auto;float:none;display:block}.tabs.simple>li>a{padding:0}.tabs.simple>li>a:hover{background:transparent}.tabs.primary{background:#00707e}.tabs.primary>li>a{color:#fefefe}.tabs.primary>li>a:hover,.tabs.primary>li>a:focus{background:#008191}.tabs-title{float:left}.tabs-title>a{display:block;padding:1.25rem 1.5rem;line-height:1;font-size:.75rem}.tabs-title>a:hover{background:#fefefe}.tabs-title>a:focus,.tabs-title>a[aria-selected='true']{background:#e6e6e6}.tabs-content{background:#fefefe;transition:all 0.5s ease;border:1px solid #e6e6e6;border-top:0}.tabs-content.vertical{border:1px solid #e6e6e6;border-left:0}.tabs-panel{display:none;padding:1rem}.tabs-panel.is-active{display:block}.thumbnail{border:solid 4px #fefefe;box-shadow:0 0 0 1px rgba(10,10,10,0.2);display:inline-block;line-height:0;max-width:100%;transition:box-shadow 200ms ease-out;border-radius:0;margin-bottom:1rem}.thumbnail:hover,.thumbnail:focus{box-shadow:0 0 6px 1px rgba(0,112,126,0.5)}.title-bar{background:#0a0a0a;color:#fefefe;padding:.5rem;display:flex;align-items:center;justify-content:space-between}.title-bar .menu-icon{margin-left:.25rem;margin-right:.25rem}.title-bar-left,.title-bar-right{flex:1 1 0px}.title-bar-right{text-align:right}.title-bar-title{font-weight:bold;vertical-align:middle;display:inline-block}.menu-icon.dark{position:relative;display:inline-block;vertical-align:middle;cursor:pointer;width:20px;height:16px}.menu-icon.dark::after{content:'';position:absolute;display:block;width:100%;height:2px;background:#0a0a0a;top:0;left:0;box-shadow:0 7px 0 #0a0a0a,0 14px 0 #0a0a0a}.menu-icon.dark:hover::after{background:#8a8a8a;box-shadow:0 7px 0 #8a8a8a,0 14px 0 #8a8a8a}.has-tip{border-bottom:dotted 1px #8a8a8a;font-weight:bold;position:relative;display:inline-block;cursor:help}.tooltip{background-color:#0a0a0a;color:#fefefe;font-size:80%;padding:.75rem;position:absolute;z-index:10;top:calc(100% + .6495rem);max-width:10rem !important;border-radius:0}.tooltip::before{content:'';display:block;width:0;height:0;border:inset .75rem;border-color:transparent transparent #0a0a0a;border-bottom-style:solid;border-top-width:0;bottom:100%;position:absolute;left:50%;transform:translateX(-50%)}.tooltip.top::before{content:'';display:block;width:0;height:0;border:inset .75rem;border-color:#0a0a0a transparent transparent;border-top-style:solid;border-bottom-width:0;top:100%;bottom:auto}.tooltip.left::before{content:'';display:block;width:0;height:0;border:inset .75rem;border-color:transparent transparent transparent #0a0a0a;border-left-style:solid;border-right-width:0;bottom:auto;left:100%;top:50%;transform:translateY(-50%)}.tooltip.right::before{content:'';display:block;width:0;height:0;border:inset .75rem;border-color:transparent #0a0a0a transparent transparent;border-right-style:solid;border-left-width:0;bottom:auto;left:auto;right:100%;top:50%;transform:translateY(-50%)}.main-container{margin-top:78px}.main-container>.row{max-width:100% !important;background:#edf0f5}.main-container .container{min-height:calc(100% - 78px)}.main-container .container .container-inner{background:#fff;margin:15px auto;border-radius:5px;border:1px solid #e1e4e9;font-size:0.875rem;color:#414042;overflow-x:visible}.main-container .container .container-inner section{padding:1rem 2rem}.main-container .container .container-inner section.heading{overflow:hidden;position:relative;border-bottom:1px solid #f7f9fb}.main-container .container .container-inner section.heading>h3{float:left;margin-bottom:0;line-height:42px;font-size:1.25rem;font-weight:500}.main-container .container .container-inner section.camp-top{overflow:hidden;position:relative;border-bottom:1px solid #f7f9fb}.main-container .container .container-inner section.camp-top>h3{float:left;margin-bottom:0;line-height:42px;font-size:1.25rem;font-weight:500}@media only screen and (max-width: 1780px){.main-container .container{min-width:calc(100% - 300px)}}button:not(.close-button).button-default,.button:not(.close-button).button-default{background-color:#939598}button:not(.close-button).button-success,.button:not(.close-button).button-success{color:#fff;background-color:#00707e}button:not(.close-button).button-danger,.button:not(.close-button).button-danger{color:#fff;background-color:#EC5840}button:not(.close-button).button-icon i,.button:not(.close-button).button-icon i{display:inline-block;vertical-align:middle;font-size:18px;transition:all 0s}button:not(.close-button).secondary,.button:not(.close-button).secondary{background-color:#939598;color:#fefefe}button:not(.close-button).button-save,.button:not(.close-button).button-save{background-color:#00707e}button:not(.close-button).small,.button:not(.close-button).small{padding:0.3rem}.checkbox{padding:0px;position:relative}.checkbox input[type=\"checkbox\"]{display:none}.checkbox label{padding-left:28px;height:20px;font-weight:400;line-height:20px;position:relative}.checkbox input[type=\"checkbox\"]:not(:checked)+label:before,.checkbox input[type=\"checkbox\"]:checked+label:before{content:'';display:block;width:18px;height:18px;border-radius:3px;border:solid 1px #ddd;position:absolute;left:0;top:1px;margin:auto;background:#fff}.checkbox input[type=\"checkbox\"]:not(:checked)+label:after,.checkbox input[type=\"checkbox\"]:checked+label:after{content:'\\f00c';font-family:'FontAwesome';display:block;width:18px;height:18px;border-radius:3px;position:absolute;left:0;top:1px;margin:auto;text-align:center;line-height:18px;color:#414042;transition:all 0.5s;font-size:12px}.checkbox input[type=\"checkbox\"]:not(:checked)+label:after{opacity:0;transform:scale(0)}.checkbox input[type=\"checkbox\"]:checked+label:after{opacity:1;transform:scale(1)}.checkbox.rounded input[type=\"checkbox\"]:not(:checked)+label:before,.checkbox.rounded input[type=\"checkbox\"]:checked+label:before{border-radius:50%}.checkbox.rounded input[type=\"checkbox\"]:not(:checked)+label:after,.checkbox.rounded input[type=\"checkbox\"]:checked+label:after{border-radius:50%}input[type=text],input[type=date],input[type=number]{border-radius:5px;font-size:0.875rem;background:#fff;color:#414042;outline:none;box-shadow:none}.modal{display:none;position:fixed;z-index:5;left:0;top:0;width:100%;height:100%;overflow:auto;background-color:#000;background-color:rgba(0,0,0,0.4)}.modal.show{display:block}.modal .modal-content{width:80%;max-width:400px;position:absolute;top:115px;left:0;right:0;margin:0 auto;margin-bottom:50px;background:#fff;border-radius:5px;overflow:hidden}.modal .modal-content form{padding:0px}.modal .modal-content .close{color:#fff;float:right;font-size:20px;font-weight:500;line-height:1}.modal .modal-content .close:hover,.modal .modal-content .close:focus{color:#eee;text-decoration:none;cursor:pointer}.modal .modal-content .modal-header{text-align:center;padding:10px 20px;color:#fff;background:#00707e;font-size:1.25rem;font-weight:500}.modal .modal-content .modal-header h2{text-align:left;font-size:1rem;font-weight:500;margin-bottom:0}.modal .modal-content .modal-body{padding:20px}.modal .modal-content .modal-footer{padding:10px 20px;border-top:solid 1px #ddd}.modal form{border:none;box-shadow:none}.modal form .form-button-group{text-align:center}.modal form .form-button-group button{margin:1rem;min-width:7rem}.modal.medium .modal-content{max-width:650px}.modal.large .modal-content{max-width:800px}.radio{padding:0px}.radio input[type=\"radio\"]{display:none}.radio label{padding-left:28px;height:20px;font-weight:400;line-height:20px;position:relative}.radio input[type=\"radio\"]:not(:checked)+label:before,.radio input[type=\"radio\"]:checked+label:before{content:'';display:block;width:18px;height:18px;border-radius:3px;border:solid 1px #ddd;position:absolute;left:0;top:0;bottom:0;margin:auto;background:#fff}.radio input[type=\"radio\"]:checked+label:after{content:'';font-family:'FontAwesome';display:block;width:14px;height:14px;border-radius:3px;position:absolute;left:2px;top:0;bottom:0;margin:auto;background:#fe8300}.radio input[type=\"radio\"]:disabled+label{cursor:inherit}.radio input[type=\"radio\"]:disabled+label:before{background:transparent;border-color:#bcbcbc}.wrap-select{position:relative}.wrap-select:before{content:'';color:#ddd;width:2.5rem;height:1.5625rem;position:absolute;pointer-events:none;right:17px;top:17px;width:0;height:0;border-left:5px solid transparent;border-right:5px solid transparent;border-top:8px solid #ddd}.wrap-select:after{content:'';position:absolute;height:1.5625rem;width:1px;background:#ddd;top:8px;right:40px}select,input[type=\"search\"]{padding:0 50px 0 13px;border-radius:5px;font-size:0.875rem;background:#fff;border:1px solid #ddd;color:#414042;outline:none;margin-bottom:1.25rem}@font-face{font-family:'Open-Sans';src:url(\"assets/fonts/open-sans/OpenSans-Regular.ttf\") format(\"\"),url(\"assets/fonts/font-awesome/fontawesome-webfont.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:'Material Icons';font-style:normal;font-weight:400;src:url(\"assets/fonts/material-icons/MaterialIcons-Regular.woff2\") format(\"woff2\"),url(\"assets/fonts/material-icons/MaterialIcons-Regular.woff\") format(\"woff\")}@font-face{font-family:'FontAwesome';src:url(\"assets/fonts/font-awesome/fontawesome-webfont.woff2\") format(\"woff2\"),url(\"assets/fonts/font-awesome/fontawesome-webfont.woff\") format(\"woff\");font-weight:400;font-style:normal}html#parent{overflow:auto !important}.pull-left{float:left !important}.pull-right{float:right !important}.clearfix:before,.clearfix:after{content:\" \";display:table}.clearfix:after{clear:both}.material-icons{font-family:'Material Icons';font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;font-feature-settings:'liga'}.fa{display:inline-block;font:normal normal normal 14px/1 FontAwesome;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.fa-facebook:before{content:\"\\f09a\"}.fa-twitter:before{content:\"\\f099\"}.fa-google:before{content:\"\\f1a0\"}.fa-youtube:before{content:\"\\f167\"}*{transition-duration:.2s;transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1)}.overlay{position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(255,255,255,0.5);z-index:99999}.loading-logo{position:absolute;top:45%;left:45%;background:#00707e;border:1px solid #00707e;border-radius:0.4rem;text-align:center;min-width:120px;padding:0.5rem}.loading-logo .loader{border:10px solid #fff;border-top:10px solid #faa635;border-radius:50%;width:60px;height:60px;animation:spin 1.5s linear infinite;display:inline-block;margin:0 auto;background-color:#00707e}.loading-logo .loader-text{margin:0.4rem auto;color:#fff}@keyframes spin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}.loading-data{margin:0 auto;background:url(\"./assets/loader.gif\") no-repeat center center;min-height:130px;padding:15px 0px}h1{font-size:2rem;font-weight:500;margin:0}h2{font-size:1.6rem}h3{font-size:1.3rem;color:#00707e;margin-bottom:1rem}.badge{border-radius:3px;font-size:12px;margin-bottom:3px}.badge.danger{background:#E74C3C}ul.list-unstyled{padding:0px;margin:0px;list-style:none}ul.list-unstyled li{list-style:none}label{font-size:0.875rem;color:#414042;margin-bottom:0.5rem;font-weight:500}input[type=\"text\"],input[type=\"email\"],input[type=\"password\"]{border:1px solid #dddddd;border-radius:0.2rem;-moz-border-radius:0.2rem;-webkit-border-radius:0.2rem}input[type=\"text\"]:focus,input[type=\"email\"]:focus,input[type=\"password\"]:focus{border-color:#faa635}input[type=\"checkbox\"]{width:1.1rem;height:1.1rem}input:required:invalid{border-left:5px solid #ec5840}input:required:valid{border-left:5px solid #4caf50}input.search-input{background:url(\"./assets/ic_search.png\") no-repeat center right 10px;background-color:#fff;padding-right:43px}[type='text'],[type='password'],[type='date'],[type='datetime'],[type='datetime-local'],[type='month'],[type='week'],[type='email'],[type='number'],[type='search'],[type='tel'],[type='time'],[type='url'],[type='color'],textarea{color:#414042}button,.button{font-family:Segoe UI,sans-serif !important}button:not(.close-button),.button:not(.close-button){padding:0.7rem 1.5rem;background-color:#00707e;color:#fff;margin:0.5rem auto;font-size:15px;font-weight:400;letter-spacing:0.04rem;border-radius:5px;box-shadow:0 2px 2px 0 rgba(0,0,0,0.14),0 3px 1px -2px rgba(0,0,0,0.2),0 1px 5px 0 rgba(0,0,0,0.12)}button:not(.close-button):enabled:hover,.button:not(.close-button):enabled:hover{background-color:#faa635;color:#fff;box-shadow:0 8px 10px 1px rgba(0,0,0,0.14),0 3px 14px 2px rgba(0,0,0,0.12),0 5px 5px -3px rgba(0,0,0,0.2)}button:not(.close-button):enabled:active,.button:not(.close-button):enabled:active{opacity:0.5}button:not(.close-button):disabled,.button:not(.close-button):disabled{background-color:#ccc}button:not(.close-button).secondary,.button:not(.close-button).secondary{background:#BEBEBE;color:#414042}button:not(.close-button):focus,.button:not(.close-button):focus{outline:none}button.close-button{outline:none}.ui-button,button.ui-button.ui-state-default,.ui-button.ui-state-default{border:1px solid #00707e;color:#fff;background:#00707e}.ui-state-default a,.ui-state-default a:link,.ui-state-default a:visited{color:#414042}form{padding:1.5rem 1rem;border:1px solid #fff;background:#fff;border-radius:0.5rem;box-shadow:0 2px 2px 0 rgba(0,0,0,0.14),0 3px 1px -2px rgba(0,0,0,0.2),0 1px 5px 0 rgba(0,0,0,0.12)}form a:hover{color:#faa635}form .ng-valid[required]{border-left:5px solid #4caf50}form .ng-invalid{border-left:5px solid #ec5840}.text-alert{color:#ec5840}#campRegister tbody tr:nth-child(odd){background-color:#fff}#campRegister .txt-center{text-align:center}#campRegister .txt-center button{padding:1rem 2rem}@media print{display:none}.eca-background{background:url(\"assets/background.jpg\") no-repeat center center}@media (min-width: 1280px){.eca-background{-webkit-background-size:cover;-moz-background-size:cover;-o-background-size:cover;background-size:cover}}#class-calendar .fc-head-container table{margin-bottom:0rem}#class-calendar .fc-head-container .fc-day-header{padding:0.5rem}#class-calendar .fc-view-container .fc-agenda-view table tbody{background-color:transparent}#class-calendar .fc-view-container .fc-agenda-view table tbody tr:nth-child(odd){background-color:transparent}#class-calendar .fc-view-container .fc-agenda-view .fc-axis{background-color:#f8f8f8;text-align:center}#class-calendar .fc-view-container .fc-agenda-view .fc-axis>span{position:absolute;left:4;margin-top:22px;font-weight:500}#class-calendar .fc-view-container .fc-agenda-view .fc-minor .fc-axis{border-top:0px}.fc .fc-toolbar button:not(.close-button){padding:0px 1.5rem;margin:0px 5px 0px 0px}.fc table{margin-bottom:0px}.fc .fc-event.custome-event-attendance{padding:0px 5px;margin-bottom:5px;background:#fff;color:#414042;border:none;box-shadow:1px 1px 5px -1px #999}.fc .fc-event.custome-event-attendance .fc-content{padding:10px 0px;margin:0px -5px;text-align:center;background:#666;color:#fff}.fc .fc-event.custome-event-attendance .event-content{padding:5px 0px}.fc .fc-event.custome-event-attendance .event-content .badge{border-radius:3px;font-size:12px}.fc .fc-event.custome-event-attendance .event-content .avatar{width:100%;margin:3px 0px;display:block}.fc .fc-event.none .fc-content{background:#6C7A89}.fc .fc-event.absent .fc-content,.fc .fc-event.absent .badge{background:#E74C3C}.fc .fc-event.present .fc-content,.fc .fc-event.present .badge{background:#00707e}.fc .fc-event.custome-bus-schedule{padding:0px 5px;margin-bottom:5px;background:#fff;color:#414042;border:none;box-shadow:1px 1px 5px -1px #999}.fc .fc-event.custome-bus-schedule .fc-content{padding:10px 0px;margin:0px -5px;text-align:center;background:#666;color:#fff}.fc .fc-event.custome-bus-schedule .event-content{padding:5px 0px}.fc .fc-event.custome-bus-schedule .event-content .badge{border-radius:3px;font-size:12px;margin-bottom:3px}.fc .fc-event.custome-bus-schedule .event-content .badge.danger{background:#E74C3C}.ui-widget{font-family:Segoe UI, sans-serif !important}.ui-widget input,.ui-widget select,.ui-widget textarea,.ui-widget button{font-family:Segoe UI, sans-serif !important}.ui-widget-content{color:#414042}.ui-widget-content a{color:#414042}.ui-widget-header{border:none;color:#414042;font-weight:500}span.ui-dialog-title{color:#00707e !important}a.ui-dialog-titlebar-icon{color:#414042}.ui-tabview .ui-tabview-panel{border:solid 1px #ccc}.ui-inputwrapper-filled.ng-valid{border-left:none !important}.ui-datepicker .ui-datepicker-prev,.ui-datepicker .ui-datepicker-next{border:solid 1px transparent;font-weight:400;top:1px}.ui-datepicker .ui-datepicker-prev{left:1px}.ui-datepicker .ui-datepicker-next{right:1px}.ui-datepicker .ui-datepicker-prev:before,.ui-datepicker .ui-datepicker-next:before{display:block;text-align:center;line-height:30px;font-family:'FontAwesome'}.ui-datepicker .ui-datepicker-prev:before{content:'\\f053'}.ui-datepicker .ui-datepicker-next:before{content:'\\f054'}.ui-calendar{width:100%}.ui-calendar input{width:100%;padding-right:45px;background-image:url(\"./assets/calendar-icon.png\") !important;background-color:#fff !important;background-repeat:no-repeat !important;background-position:center right 10px !important;background-size:25px 25px !important}.ui-dialog{width:75%;min-width:320px;color:#414042}.ui-dialog.top-dialog{top:5% !important}.ui-dialog.medium{width:50%}.ui-dialog form{padding:0px;box-shadow:none;border:none}.ui-dialog footer{padding:15px 0px;margin:0px 15px;border-top:solid 1px #ddd;text-align:right}.ui-confirmdialog footer{border:none}.ui-growl-item-container .ui-growl-item .ui-growl-image{display:none}.ui-tabview.ui-tabview-top>.ui-tabview-nav{padding:0px;border-bottom:solid 2px #00707e;border-radius:0px}.ui-tabview.ui-tabview-top>.ui-tabview-nav li.ui-state-default{position:relative;padding:4px 15px;top:4px}.ui-tabview.ui-tabview-top>.ui-tabview-nav li.ui-state-default.ui-state-active{top:1px;border:solid 1px #00707e;background:#00707e;padding:5px 15px}.ui-tabview.ui-tabview-top>.ui-tabview-nav li.ui-state-default.ui-state-active a{color:#fff;font-size:15px}.ui-tabview .ui-tabview-panel{border:none}.setting-tabs.ui-tabview-top>.ui-tabview-nav{background:#00707e;margin:-19px -36px 0px;border-radius:0px;border-bottom:0px}.setting-tabs.ui-tabview-top>.ui-tabview-nav li{border:none;border-bottom:solid 2px transparent;background:transparent !important;margin-right:10px;font-weight:500 !important}.setting-tabs.ui-tabview-top>.ui-tabview-nav li a{color:#fff !important}.setting-tabs.ui-tabview-top>.ui-tabview-nav li:hover{background:#fff;border-bottom:solid 2px #fff}.setting-tabs.ui-tabview-top>.ui-tabview-nav li.ui-state-default.ui-state-active{top:1px;border:none;border-bottom:solid 2px #fff}.setting-tabs .ui-tabview-panel{padding:0px;padding-top:15px;border:none;z-index:-1}.background:after{position:absolute;content:'';bottom:0;left:0;width:100%;height:600px;background:url(\"./assets/background.jpg\") no-repeat center bottom;background-size:100% auto;opacity:0.1;z-index:-1}.gmap div{transition-duration:unset !important}.ui-tabview-panel table thead tr{color:#fff;background-color:#00707e}.ui-tabview-panel table thead tr td{font-weight:500}.ui-tabview-panel table tbody tr:nth-child(odd){background-color:#f1f1f1}.ui-tabview-panel table tbody tr:nth-child(even){background-color:#fff}.ui-dialog-content .row .large-2{color:#414042}table thead th,table thead td,table tfoot th,table tfoot td{font-weight:500}main{min-height:40rem}.select-camp-header{background:#f7f7f7;overflow:hidden}.select-camp-header .wrap-select-camp-header-inner{width:80%;margin:25px auto 10px}.select-camp-header .wrap-select-camp-header-inner .camp-child-icon{vertical-align:-3px;margin-right:10px}.select-camp-header .wrap-select-camp-header-inner .wrap-select-option-header{display:inline-block;position:relative}.select-camp-header .wrap-select-camp-header-inner .wrap-select-option-header:before{content:'';color:#ddd;width:2.5rem;height:1.5625rem;position:absolute;pointer-events:none;right:17px;top:17px;width:0;height:0;border-left:5px solid transparent;border-right:5px solid transparent;border-top:8px solid #ddd}.select-camp-header .wrap-select-camp-header-inner .wrap-select-option-header:after{content:'';position:absolute;height:1.5625rem;width:1px;background:#ddd;top:8px;right:40px}.select-camp-header .wrap-select-camp-header-inner .wrap-select-option-header select{padding:0 50px 0 13px;border-radius:5px;font-size:1rem;background:#f8f8f8;border:1px solid #ddd;height:2.5rem;color:#282828;outline:none}\n"

/***/ }),

/***/ 428:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var router_1 = __webpack_require__(26);
	var appRoutes = [
	    { path: '', redirectTo: 'booking/students', pathMatch: 'full' }
	];
	exports.routing = router_1.RouterModule.forRoot(appRoutes);


/***/ }),

/***/ 429:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var shared_1 = __webpack_require__(213);
	// Import components
	var BusAttendanceComponent_1 = __webpack_require__(430);
	var BusAttendanceRouting_1 = __webpack_require__(700);
	var primeng_1 = __webpack_require__(138);
	var StudentLocationComponent_1 = __webpack_require__(701);
	var primeng_2 = __webpack_require__(138);
	var BusAttendanceModule = (function () {
	    function BusAttendanceModule() {
	    }
	    return BusAttendanceModule;
	}());
	BusAttendanceModule = __decorate([
	    core_1.NgModule({
	        declarations: [
	            BusAttendanceComponent_1.BusAttendanceComponent,
	            StudentLocationComponent_1.StudentLocationComponent
	        ],
	        imports: [
	            shared_1.SharedModule,
	            primeng_1.ScheduleModule,
	            BusAttendanceRouting_1.BusAttendanceRouter,
	            primeng_2.DialogModule
	        ]
	    })
	], BusAttendanceModule);
	exports.BusAttendanceModule = BusAttendanceModule;


/***/ }),

/***/ 430:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var moment = __webpack_require__(269);
	var _ = __webpack_require__(64);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var BusServices_1 = __webpack_require__(431);
	var ChildrenServices_1 = __webpack_require__(696);
	var BusAttendanceComponent = (function () {
	    function BusAttendanceComponent(services, childrenServices, route, elementRef) {
	        this.services = services;
	        this.childrenServices = childrenServices;
	        this.route = route;
	        this.elementRef = elementRef;
	        this.events = [];
	        this.studentSchedule = [];
	        // Event click
	        this.showScheduleDialog = false;
	        //map
	        this.isViewMap = false;
	        this.isShowSchedule = true;
	        this.planningInfo = { header: '' };
	        // Schedule header config
	        this.scheduleHeaderConfig = {
	            left: 'prev,next today',
	            center: '',
	            right: 'title'
	        };
	    }
	    BusAttendanceComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.sub = this.route.params.subscribe(function (params) {
	            // Get current child id
	            _this.currentId = params['id'];
	            // Retrieve children statictis
	            _this.getChildren();
	        });
	    };
	    BusAttendanceComponent.prototype.ngAfterViewInit = function () {
	        var size = (window.screen.width);
	        this.updateScheduleView(size);
	    };
	    // Get all children
	    BusAttendanceComponent.prototype.getChildren = function () {
	        var _this = this;
	        this.childrenServices.getChildren().subscribe(function (result) {
	            _this.children = result;
	        }, function (error) {
	        });
	    };
	    // End of Init
	    // Retrieve student details
	    BusAttendanceComponent.prototype.getStudentDetail = function (from, to) {
	        var _this = this;
	        // Define requirement for getting student detail
	        var query = {
	            "filter": {
	                "from_date": from,
	                "to_date": to,
	                "pupil_code": this.currentId
	            },
	            "page": 1,
	            "max_per_page": 100
	        };
	        this.services.getBusAttendanceList(query).subscribe(function (result) {
	            _this.studentSchedule = result.data;
	            _this.addRowEmpty(_this.studentSchedule);
	            // Map student schedule to events
	            _this.events = _.map(_this.studentSchedule, function (val, key) { return _this.mapEvent(val); });
	        }, function (error) {
	        });
	    };
	    BusAttendanceComponent.prototype.addRowEmpty = function (data) {
	        var dateMissTime = data.filter(function (row) {
	            if (data.filter(function (rowFilter) { return rowFilter.date === row.date; }).length === 1)
	                return true;
	            return false;
	        });
	        dateMissTime.forEach(function (element) {
	            if (element.expected_time !== "07:00:00") {
	                // insert row temp for morning
	                var newElement = {
	                    pupil_code: "-1",
	                    expected_time: "07:00:00",
	                    date: element.date,
	                    bus: {
	                        code: "",
	                        address: ""
	                    },
	                    hostess: {
	                        name: ""
	                    }
	                };
	                data.push(newElement);
	            }
	        });
	    };
	    // Change child
	    BusAttendanceComponent.prototype.changeChild = function (event) {
	        this.currentId = event;
	        this.getStudentDetail(this.startWeek, this.endWeek);
	    };
	    // Handle schedule template fullcalendar view render
	    BusAttendanceComponent.prototype.scheduleViewRenderEvent = function (e) {
	        // Get start and end of current week as default
	        this.startWeek = moment.utc(e.view.start).format('YYYY-MM-DD');
	        this.endWeek = moment.utc(e.view.end).format('YYYY-MM-DD');
	        // Retrieve current student detail                
	        this.getStudentDetail(this.startWeek, this.endWeek);
	    };
	    // On Schedule View Render. When map student schedule to events array, we added des field which
	    // contains all specific event info so that we can custome event's display
	    BusAttendanceComponent.prototype.onEventRender = function (event, element) {
	        // console.log(event)
	        // element.find(".fc-event-title").remove();
	        // element.find(".fc-time").remove();
	        element.addClass('custome-event-attendance');
	        var start = moment(event.start).format('HH:mm');
	        var present = '';
	        var actual = '';
	        var infoBySection = '';
	        var isAbsent = false;
	        var location = '';
	        var presentDay = 'present-day';
	        if (event.des.present === null) {
	            present = '';
	            element.addClass('none');
	        }
	        else {
	            present = event.des.present ? 'Present' : 'Absent';
	            element.addClass(event.des.present ? 'present' : 'absent');
	            isAbsent = !event.des.present;
	        }
	        var isAfternoon = moment(start, 'HH:mm:ss').isAfter(moment('12:00:00', 'HH:mm:ss'));
	        var isEndAfternoon = moment(start, 'HH:mm:ss').isAfter(moment('16:00:00', 'HH:mm:ss'));
	        start = (isAfternoon ? 'Afternoon - ' + start : 'Morning');
	        var inBusAt = '';
	        if (isAfternoon) {
	            inBusAt = '<b>Get in bus at: </b>' + (event.des && event.des.pick_up_time_afternoon ? event.des.pick_up_time_afternoon : '') + '</br>';
	            if (isEndAfternoon)
	                element.find(".fc-content").css("background-color", "red");
	            else
	                element.find(".fc-content").css("background-color", "blue");
	        }
	        // Replace event header
	        element.find(".fc-time").html(start);
	        if (moment(event.start).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD')) {
	            var isTodayAfternoon = moment(new Date(), 'HH:mm:ss').isAfter(moment('12:00:00', 'HH:mm:ss'));
	            if (isTodayAfternoon === isAfternoon) {
	                location = '<a class="location" ><img class="location" src="./assets/theme/images/bus_school_icon.png" style="width:30px" ></a></br>';
	            }
	        }
	        // Check afternoon bus
	        // If afternoon
	        if (event.des.pupil_code !== "-1") {
	            if (moment(start, 'HH:mm:ss').isAfter(moment('12:00:00', 'HH:mm:ss'))) {
	                actual = '<b>Actual Drop-off time: </b>' + (isAbsent ? 'None' : (event.des && event.des.actual_time ? event.des.actual_time.substring(5, 0) : ''));
	                infoBySection = '<b>After School Class: </b>' + (event.des && event.des.asa_activities ? event.des.asa_activities : '');
	            }
	            else {
	                actual = '<b>Actual Pick-up time: </b>' + (event.des && event.des.actual_time ? event.des.actual_time.substring(5, 0) : '');
	                infoBySection = '<b>Pick-up time: </b>' + (event.des && event.des.expected_pickup_time ? event.des.expected_pickup_time.substring(5, 0) : '');
	            }
	            var new_description = '<div class="event-content">'
	                + '<b>Bus Number: </b>' + event.des.bus.code + ' ' + location
	                + '<img style="width:120px;display:block" class="avatar" src="/api/file/' + event.des.hostess.photo + '">'
	                + '<b>Hostess: </b>' + event.des.hostess.name + '</br>'
	                + '<b>Contact Number: </b>' + event.des.hostess.phone + '</br>'
	                + infoBySection + '</br>'
	                + '<b>Bus Attendance: </b> <span class="badge">' + present + '</span></br>'
	                + inBusAt + ''
	                + actual + '</br>'
	                + '<b>Report: </b>' + (event.des.note !== null ? event.des.note : '') + '</br>'
	                + '<b>Address: </b>' + event.des.address
	                + '</div>';
	        }
	        else {
	            element.hide();
	        }
	        element.append(new_description);
	    };
	    // Map Event
	    BusAttendanceComponent.prototype.mapEvent = function (event) {
	        return {
	            title: '',
	            start: moment.utc(event.date).format('YYYY-MM-DD') + 'T' + event.expected_time,
	            des: event
	        };
	    };
	    // Handle events click event
	    BusAttendanceComponent.prototype.handleEventClick = function (event) {
	        this.showScheduleDialog = true;
	        this.selectedEvent = event;
	        this.planningInfo = this.selectedEvent.calEvent.des;
	        this.planningInfo.header = 'Bus location ' + this.planningInfo.bus.code;
	    };
	    BusAttendanceComponent.prototype.showLocation = function () {
	        this.isViewMap = !this.isViewMap;
	    };
	    BusAttendanceComponent.prototype.clickAnywhere = function (event) {
	        if (event.srcElement.className == 'location') {
	            this.showLocation();
	        }
	    };
	    //change schedule view on resize screen
	    BusAttendanceComponent.prototype.onResize = function (event) {
	        var size = event.target.innerWidth;
	        this.updateScheduleView(size);
	    };
	    BusAttendanceComponent.prototype.updateScheduleView = function (size) {
	        var _this = this;
	        this.isShowSchedule = false;
	        if (size <= 768)
	            this.viewType = "basicDay";
	        else
	            this.viewType = "basicWeek";
	        setTimeout(function () { _this.isShowSchedule = true; }, 0);
	    };
	    return BusAttendanceComponent;
	}());
	__decorate([
	    core_1.HostListener('document:click', ['$event']),
	    __metadata("design:type", Function),
	    __metadata("design:paramtypes", [MouseEvent]),
	    __metadata("design:returntype", void 0)
	], BusAttendanceComponent.prototype, "clickAnywhere", null);
	__decorate([
	    core_1.HostListener('window:resize', ['$event']),
	    __metadata("design:type", Function),
	    __metadata("design:paramtypes", [Object]),
	    __metadata("design:returntype", void 0)
	], BusAttendanceComponent.prototype, "onResize", null);
	BusAttendanceComponent = __decorate([
	    core_1.Component({
	        template: __webpack_require__(697),
	        styles: [__webpack_require__(699)]
	    }),
	    __metadata("design:paramtypes", [BusServices_1.BusServices,
	        ChildrenServices_1.ChildrenServices,
	        router_1.ActivatedRoute,
	        core_1.ElementRef])
	], BusAttendanceComponent);
	exports.BusAttendanceComponent = BusAttendanceComponent;


/***/ }),

/***/ 431:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var _ = __webpack_require__(64);
	// Libraries
	var core_1 = __webpack_require__(3);
	// Services
	var services_1 = __webpack_require__(58);
	var rxjs_1 = __webpack_require__(432);
	var BusServices = (function () {
	    function BusServices(apiService, settingService) {
	        this.apiService = apiService;
	        this.settingService = settingService;
	        this.createBus = '/create-bus';
	        this.exportStudentTemplate = '/bus-planning-export';
	        this.busTransportExport = '/export-drop-off';
	        this.busTransactionHostess = '/bus-transaction-hostess';
	        this.hostessImport = '/hostess-import';
	        this.hostessImportImage = '/hostess-image-import';
	        this.guardianImport = '/guardian-import';
	        this.guardianImportImage = "/guardian-image-import";
	        //check-attendance
	        this.busTracking = '/bus-tracking';
	        this.checkBusTracking = '/check-bus-tracking';
	        this.busTrackingList = '/bus-tracking-list';
	        this.sendSMS = '/sms-send-manual';
	        this.smsHistory = '/sms-history';
	        this.busLocation = '/bus-locations';
	        this.addPhrase = '/create-phrase';
	        this.addContent = '/create-content';
	        // on setting - student list (add/update)
	        this.Status = new rxjs_1.BehaviorSubject({ 'isUpdate': false, 'isSuccess': false });
	        this.submitStatus = this.Status.asObservable();
	        this.studentImport = '/student-import';
	        this.studentImageUpload = '/student-image-import';
	        this.yearGroups = '/year-group';
	        this.gradeClasses = '/gradeClasses';
	        // Get API service domain for communate.
	        this.apiUrl = this.settingService.getSetting('api_service_domain');
	        this.bus = '/bus';
	        this.busScheduleTemplate = '/bus-template';
	        this.busListImport = '/bus-import';
	        this.busScheduleImport = '/bus-planning-import';
	        this.busSchedule = '/bus-schedule';
	        this.busStatistic = '/bus-statistic';
	        this.busTransaction = '/bus-transaction';
	        this.busTransactionList = '/bus-transaction-list';
	        this.reportReasons = '/reason';
	        this.hostess = '/hostess';
	        this.students = '/bus-students';
	        this.studentImages = '/student-images';
	        this.language = '/language';
	        this.phrase = '/phrase';
	        this.content = '/content';
	        this.guardian = '/guardian';
	        this.studentList = '/student-list';
	        this.smsTemplates = '/sms-templates';
	        this.settings = '/settings';
	        this.notifications = '/notifications';
	        this.notiFinishedRoute = '/notifications/finishedRoute';
	    }
	    /**
	    * @Jira task: SBMS-
	    * @author:
	    * @description:
	    */
	    BusServices.prototype.getStudentLocation = function (query) {
	        var i = 0;
	        var string = '?';
	        _.forEach(query, function (val, key) {
	            if (val) {
	                string = !i ? string + key + '=' + val : string + '&' + key + '=' + val;
	                i++;
	            }
	        });
	        var requestUrl = this.apiUrl + this.busLocation + string;
	        return this.apiService.get(requestUrl);
	    };
	    // ────────────────────────────────────────────────────────────────────────────────
	    // change status for update/add student
	    BusServices.prototype.changeStatus = function (isUpdate, isSuccess) {
	        this.Status.next({ isUpdate: isUpdate, isSuccess: isSuccess });
	    };
	    // ────────────────────────────────────────────────────────────────────────────────
	    // Get all bus schedule with condition
	    BusServices.prototype.getBusSchedule = function (filter) {
	        var requestUrl = this.apiUrl + this.busSchedule;
	        var body = JSON.stringify({ filter: filter });
	        return this.apiService.post(requestUrl, body);
	    };
	    // ────────────────────────────────────────────────────────────────────────────────
	    // Get schedules template of all buses
	    BusServices.prototype.getScheduleTemplate = function () {
	        var requestUrl = this.apiUrl + this.busScheduleTemplate;
	        return this.apiService.get(requestUrl);
	    };
	    // ────────────────────────────────────────────────────────────────────────────────
	    // Export imported schedules template
	    BusServices.prototype.exportScheduleTemplate = function () {
	        var requestUrl = this.apiUrl + this.exportStudentTemplate;
	        return this.apiService.get(requestUrl);
	    };
	    // ────────────────────────────────────────────────────────────────────────────────
	    // Get Schedules with condition
	    BusServices.prototype.getSchedules = function (start, end) {
	        var requestUrl = this.apiUrl + this.busScheduleTemplate + '?from=' + start + '&to=' + end;
	        return this.apiService.get(requestUrl);
	    };
	    // ────────────────────────────────────────────────────────────────────────────────
	    // Post new bus info
	    BusServices.prototype.postNewBus = function (query) {
	        var requestUrl = this.apiUrl + this.createBus;
	        return this.apiService.post(requestUrl, query);
	    };
	    // ────────────────────────────────────────────────────────────────────────────────
	    // Import Bus List Template from file .xlsx
	    BusServices.prototype.importBusList = function (data) {
	        var requestUrl = this.apiUrl + this.busListImport;
	        return this.apiService.post(requestUrl, data);
	    };
	    // ────────────────────────────────────────────────────────────────────────────────
	    // Import Schedule Template from file .xlsx
	    BusServices.prototype.postScheduleTemplate = function (data) {
	        var requestUrl = this.apiUrl + this.busScheduleImport;
	        return this.apiService.post(requestUrl, data);
	    };
	    // ────────────────────────────────────────────────────────────────────────────────
	    // Get bus info with condition
	    BusServices.prototype.getBusInfo = function (query) {
	        var requestUrl = this.apiUrl + this.bus;
	        return this.apiService.post(requestUrl, query);
	    };
	    // ────────────────────────────────────────────────────────────────────────────────
	    // Get bus statistic with condition
	    BusServices.prototype.getBusAttendanceList = function (query) {
	        var requestUrl = this.apiUrl + this.busStatistic;
	        return this.apiService.post(requestUrl, query);
	    };
	    // ────────────────────────────────────────────────────────────────────────────────
	    // Get bus statistic with condition
	    BusServices.prototype.exportBusTransportList = function (query) {
	        var requestUrl = this.apiUrl + this.busTransportExport + '?date=' + query.date + '&from_time=' + query.from_time + '&to_time=' + query.to_time + '&width=20in&height=15in&zoom=3';
	        return requestUrl;
	    };
	    // ────────────────────────────────────────────────────────────────────────────────
	    // Get bus report reason list
	    BusServices.prototype.getReportReasons = function () {
	        var requestUrl = this.apiUrl + this.reportReasons;
	        return this.apiService.get(requestUrl);
	    };
	    // ────────────────────────────────────────────────────────────────────────────────
	    // Post to update specific reason
	    BusServices.prototype.postReason = function (query) {
	        var requestUrl = this.apiUrl + this.reportReasons;
	        return this.apiService.post(requestUrl, query);
	    };
	    // ────────────────────────────────────────────────────────────────────────────────
	    //
	    BusServices.prototype.postNotiFinishedRoute = function (query) {
	        var requestUrl = this.apiUrl + '-noti' + this.notiFinishedRoute;
	        return this.apiService.post(requestUrl, query);
	    };
	    // ────────────────────────────────────────────────────────────────────────────────
	    //
	    BusServices.prototype.postNotifications = function (query) {
	        var requestUrl = this.apiUrl + '-noti' + this.notifications;
	        return this.apiService.post(requestUrl, query);
	    };
	    // ────────────────────────────────────────────────────────────────────────────────
	    // 
	    BusServices.prototype.postBusTransaction = function (query) {
	        var requestUrl = this.apiUrl + this.busTransaction;
	        return this.apiService.post(requestUrl, query);
	    };
	    //Post Bus transactionList
	    BusServices.prototype.postBusTransactionList = function (query) {
	        var requestUrl = this.apiUrl + this.busTransactionList;
	        return this.apiService.post(requestUrl, query);
	    };
	    // ────────────────────────────────────────────────────────────────────────────────
	    // Get hostess list
	    BusServices.prototype.getHostess = function (query) {
	        var requestUrl = this.apiUrl + this.hostess;
	        return this.apiService.post(requestUrl, query);
	    };
	    // ────────────────────────────────────────────────────────────────────────────────
	    // Control Hostess
	    BusServices.prototype.postCtrHostess = function (query, action) {
	        var requestUrl = this.apiUrl + this.hostess + '/ctr';
	        switch (action) {
	            case 'add':
	                return this.apiService.post(requestUrl, query);
	            case 'update':
	                return this.apiService.patch(requestUrl, query);
	            case 'delete':
	                return this.apiService.deletePost(requestUrl, query);
	        }
	    };
	    // ────────────────────────────────────────────────────────────────────────────────
	    // Import Hostess Template from file .xlsx
	    BusServices.prototype.importHostess = function (data) {
	        var requestUrl = this.apiUrl + this.hostessImport;
	        return this.apiService.post(requestUrl, data);
	    };
	    // ────────────────────────────────────────────────────────────────────────────────
	    // Import Hostess Image from file .zip
	    BusServices.prototype.importHostessImage = function (data) {
	        var requestUrl = this.apiUrl + this.hostessImportImage;
	        return this.apiService.post(requestUrl, data);
	    };
	    // ────────────────────────────────────────────────────────────────────────────────
	    // Change Bus Hostess
	    BusServices.prototype.postChangeHostess = function (query) {
	        var requestUrl = this.apiUrl + this.busTransactionHostess;
	        return this.apiService.post(requestUrl, query);
	    };
	    // ────────────────────────────────────────────────────────────────────────────────
	    // Get student list for bus
	    BusServices.prototype.getStudents = function (query) {
	        var i = 0;
	        var string = '?';
	        _.forEach(query, function (val, key) {
	            if (val) {
	                string = !i ? string + key + '=' + val : string + '&' + key + '=' + val;
	                i++;
	            }
	        });
	        var requestUrl = this.apiUrl + this.students + string;
	        return this.apiService.get(requestUrl);
	    };
	    //get list student images
	    BusServices.prototype.getStudentImages = function (query) {
	        var string = '/' + query;
	        var requestUrl = this.apiUrl + this.studentImages + string;
	        return this.apiService.get(requestUrl);
	    };
	    // ────────────────────────────────────────────────────────────────────────────────
	    // Import student list
	    BusServices.prototype.importStudent = function (data) {
	        var requestUrl = this.apiUrl + this.students;
	        return this.apiService.patch(requestUrl, data);
	    };
	    // ────────────────────────────────────────────────────────────────────────────────
	    // Import student image by file .zip
	    BusServices.prototype.importStudentImage = function (data) {
	        var requestUrl = this.apiUrl + this.studentImageUpload;
	        return this.apiService.post(requestUrl, data);
	    };
	    //get all language
	    BusServices.prototype.getLanguages = function () {
	        var requestUrl = this.apiUrl + this.language;
	        return this.apiService.get(requestUrl);
	    };
	    //create language
	    BusServices.prototype.postLanguage = function (query) {
	        var requestUrl = this.apiUrl + this.language;
	        return this.apiService.post(requestUrl, query);
	    };
	    //update language
	    BusServices.prototype.postChangeLanguage = function (query) {
	        var requestUrl = this.apiUrl + this.language;
	        return this.apiService.patch(requestUrl, query);
	    };
	    //get all Phrase
	    BusServices.prototype.getAllPhrases = function () {
	        var requestUrl = this.apiUrl + this.phrase;
	        return this.apiService.get(requestUrl);
	    };
	    BusServices.prototype.getPhrases = function (query) {
	        var requestUrl = this.apiUrl + this.phrase;
	        return this.apiService.post(requestUrl, query);
	    };
	    //add new Phrase
	    BusServices.prototype.postPhrase = function (query) {
	        var requestUrl = this.apiUrl + this.addPhrase;
	        return this.apiService.post(requestUrl, query);
	    };
	    //update Phrase
	    BusServices.prototype.postChangePhrase = function (query) {
	        var requestUrl = this.apiUrl + this.phrase;
	        return this.apiService.patch(requestUrl, query);
	    };
	    //get content
	    BusServices.prototype.getContent = function (query) {
	        var requestUrl = this.apiUrl + this.content;
	        return this.apiService.post(requestUrl, query);
	    };
	    //add new Content
	    BusServices.prototype.postContent = function (query) {
	        var requestUrl = this.apiUrl + this.addContent;
	        return this.apiService.post(requestUrl, query);
	    };
	    //Update Content
	    BusServices.prototype.postChangeContent = function (query) {
	        var requestUrl = this.apiUrl + this.content;
	        return this.apiService.patch(requestUrl, query);
	    };
	    //destroy Content
	    BusServices.prototype.destroyContent = function (query) {
	        var requestUrl = this.apiUrl + this.content;
	        return this.apiService.deletePost(requestUrl, query);
	    };
	    //get guardian
	    BusServices.prototype.getGuardian = function (query) {
	        var requestUrl = this.apiUrl + this.guardian;
	        return this.apiService.post(requestUrl, query);
	    };
	    // Import guardian Template from file .xlsx
	    BusServices.prototype.importGuardian = function (data) {
	        var requestUrl = this.apiUrl + this.guardianImport;
	        return this.apiService.post(requestUrl, data);
	    };
	    // Import guardian Image from file .zip
	    BusServices.prototype.importGuardianImage = function (data) {
	        var requestUrl = this.apiUrl + this.guardianImportImage;
	        return this.apiService.post(requestUrl, data);
	    };
	    //get student
	    BusServices.prototype.getStudentList = function (query) {
	        var requestUrl = this.apiUrl + this.studentList;
	        return this.apiService.post(requestUrl, query);
	    };
	    // Import student Template from file .xlsx
	    BusServices.prototype.importStudentList = function (data) {
	        var requestUrl = this.apiUrl + this.studentImport;
	        return this.apiService.post(requestUrl, data);
	    };
	    // ------------------------------- >>
	    //get student to update/show detail
	    BusServices.prototype.getStudent = function (data) {
	        var requestUrl = this.apiUrl + this.students + '/' + data;
	        return this.apiService.get(requestUrl);
	    };
	    //get year level
	    BusServices.prototype.getYearGroup = function () {
	        var requestUrl = this.apiUrl + this.yearGroups;
	        return this.apiService.get(requestUrl);
	    };
	    //get grade_class
	    BusServices.prototype.getGradeClass = function () {
	        var requestUrl = this.apiUrl + this.gradeClasses;
	        return this.apiService.get(requestUrl);
	    };
	    //update student depend on ID
	    BusServices.prototype.updateStudent = function (query, data) {
	        var requestUrl = this.apiUrl + this.students + '/' + data;
	        return this.apiService.patch(requestUrl, query);
	    };
	    //create new student (and maybe guardian)
	    BusServices.prototype.addStudent = function (query) {
	        var requestUrl = this.apiUrl + this.students;
	        return this.apiService.post(requestUrl, query);
	    };
	    //Create Bus-Tracking
	    BusServices.prototype.postBusTracking = function (query) {
	        var requestUrl = this.apiUrl + this.busTracking;
	        return this.apiService.post(requestUrl, query);
	    };
	    //Update Bus-tracking
	    BusServices.prototype.patchBusTracking = function (query) {
	        var requestUrl = this.apiUrl + this.busTracking + '/' + query.id;
	        return this.apiService.patch(requestUrl, query);
	    };
	    /**
	    * @Jira task:
	    * @author:
	    * @description:
	    */
	    BusServices.prototype.getBusTrackingList = function (query) {
	        var requestUrl = this.apiUrl + this.busTrackingList;
	        return this.apiService.post(requestUrl, query);
	    };
	    //check Bus-tracking
	    BusServices.prototype.getBusTracking = function (query) {
	        var requestUrl = this.apiUrl + this.checkBusTracking;
	        return this.apiService.post(requestUrl, query);
	    };
	    //send SMS manual single/multi
	    BusServices.prototype.sendSMSManual = function (query) {
	        var requestUrl = this.apiUrl + this.sendSMS;
	        return this.apiService.post(requestUrl, query);
	    };
	    //Get SMS History
	    BusServices.prototype.getSMSHistory = function (data) {
	        var requestUrl = this.apiUrl + this.smsHistory + '?pupilCode=' + data.pupil_code + '&date=' + data.date + '&expectedTime=' + data.expected_time;
	        return this.apiService.get(requestUrl);
	    };
	    //Post Save SMS History
	    BusServices.prototype.postSMSHistory = function (query) {
	        var requestUrl = this.apiUrl + this.smsHistory;
	        return this.apiService.post(requestUrl, query);
	    };
	    /**
	    * @Jira task: SBMS-139
	    * @author: tri.le
	    * @description:  auto-complete for guardianID
	    * @params: guardianID
	    * @returns: guarlist
	    */
	    BusServices.prototype.searchByGuardianID = function (query, guardianID) {
	        var _this = this;
	        return guardianID.debounceTime(700) //until it lets the next data through
	            .distinctUntilChanged() //will ensure that only distinct data passes through
	            .switchMap(function (guardianID) {
	            query.search.guardianid = guardianID;
	            return _this.getGuardIDList(query);
	        });
	    };
	    BusServices.prototype.getGuardIDList = function (query) {
	        var requestUrl = this.apiUrl + this.guardian;
	        return this.apiService.post(requestUrl, query);
	    };
	    BusServices.prototype.getSmsTemplates = function (query) {
	        var requestUrl = this.apiUrl + this.smsTemplates + this.convertObjectTorequestGet(query);
	        return this.apiService.get(requestUrl);
	    };
	    BusServices.prototype.addSmsTemplates = function (body) {
	        var requestUrl = this.apiUrl + this.smsTemplates;
	        return this.apiService.post(requestUrl, body);
	    };
	    BusServices.prototype.updateSmsTemplates = function (body, id) {
	        var requestUrl = this.apiUrl + this.smsTemplates + '/' + id;
	        return this.apiService.put(requestUrl, body);
	    };
	    BusServices.prototype.convertObjectTorequestGet = function (query) {
	        var i = 0;
	        var string = '?';
	        _.forEach(query, function (val, key) {
	            if (val) {
	                string = !i ? string + key + '=' + val : string + '&' + key + '=' + val;
	                i++;
	            }
	        });
	        return string;
	    };
	    BusServices.prototype.getSettings = function (query) {
	        var requestUrl = this.apiUrl + this.settings + this.convertObjectTorequestGet(query);
	        return this.apiService.get(requestUrl);
	    };
	    BusServices.prototype.addSettings = function (body) {
	        var requestUrl = this.apiUrl + this.settings;
	        return this.apiService.post(requestUrl, body);
	    };
	    BusServices.prototype.updateSettings = function (body, id) {
	        var requestUrl = this.apiUrl + this.settings + '/' + id;
	        return this.apiService.put(requestUrl, body);
	    };
	    BusServices.prototype.getLocationOfBus = function (query) {
	        var url = this.apiUrl + this.busLocation;
	        var param = this.queryBuilder(query);
	        return this.apiService.get(url + param);
	    };
	    BusServices.prototype.snapToRoadApi = function (payload) {
	        var url = "https://roads.googleapis.com/v1/snapToRoads";
	        var param = this.queryBuilder(payload);
	        return this.apiService.getToThirdParty(url + param);
	    };
	    BusServices.prototype.queryBuilder = function (query) {
	        var string = '?';
	        var i = 0;
	        _.forEach(query, function (val, key) {
	            if (val) {
	                string = !i ? string + key + '=' + val : string + '&' + key + '=' + val;
	                i++;
	            }
	        });
	        return string;
	    };
	    BusServices.prototype.saveBusLocation = function (data) {
	        var url = this.apiUrl + this.busLocation;
	        return this.apiService.post(url, data);
	    };
	    return BusServices;
	}());
	BusServices = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [services_1.ApiService,
	        services_1.SettingService])
	], BusServices);
	exports.BusServices = BusServices;


/***/ }),

/***/ 696:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	// Services
	var services_1 = __webpack_require__(58);
	var ChildrenServices = (function () {
	    function ChildrenServices(apiService, settingService) {
	        this.apiService = apiService;
	        this.settingService = settingService;
	        this.apiUrl = '/api';
	        this.children = '/parent-children';
	    }
	    // Get Chilren of logged parent
	    ChildrenServices.prototype.getChildren = function () {
	        var requestUrl = this.apiUrl + this.children;
	        return this.apiService.get(requestUrl);
	    };
	    return ChildrenServices;
	}());
	ChildrenServices = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [services_1.ApiService,
	        services_1.SettingService])
	], ChildrenServices);
	exports.ChildrenServices = ChildrenServices;


/***/ }),

/***/ 697:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<main>\n    <div class=\"select-camp-header\" *ngIf=\"children\">\n        <div class=\"wrap-select-camp-header-inner\">\n            <img src=\"" + __webpack_require__(698) + "\" alt=\"Camp-child-icon\" class=\"camp-child-icon\">\n            <div class=\"wrap-select-option-header\">\n                <select [ngModel]=\"currentId\" (ngModelChange)=\"changeChild($event)\">\n                    <option *ngFor=\"let child of children\" [attr.value]=\"child.pupilCode\">\n                        {{child.pupilCode}} - {{child.foreName}} {{child.surName}} ({{child.grade_class.name}})\n                    </option>\n                </select>\n            </div>\n        </div>\n    </div>\n\n    <section>\n        <!--Schedules calendar-->\n        <div class=\"schedule-wrap\" *ngIf=\"currentId\" >\n            <p-schedule *ngIf=\"isShowSchedule\" [events]=\"events\" [header]=\"scheduleHeaderConfig\" [editable]=\"false\" [allDaySlot]=\"false\" [height]=\"'auto'\" [hiddenDays]=\"[0,6]\"\n                [defaultView]=\"viewType\" [eventRender]=\"onEventRender\" (onViewRender)=\"scheduleViewRenderEvent($event)\" (onEventClick)=\"handleEventClick($event)\"\n                #scheduleFc></p-schedule>\n        </div>\n        <!--End of Schedules calendar-->\n    </section>\n</main>\n\n<!--Change bus dialog-->\n<p-dialog [header]=\"planningInfo.header\" [(visible)]=\"isViewMap\" [draggable]=\"false\" [resizable]=\"false\" [modal]=\"true\" [closable]=\"false\"\n    [responsive]=\"true\" [appendTo]=\"body\">\n    <div *ngIf=\"planningInfo.hostess\">\n        <label for=\"\">Hostess:\n            <b>{{ planningInfo.hostess.name}}</b>\n        </label>\n    </div>\n    <div *ngIf=\"planningInfo.hostess\">\n        <label for=\"\">Contact Number:\n            <b>{{planningInfo.hostess.phone}}</b>\n        </label>\n    </div>\n    <div style=\"min-height: 360px; position: relative\">\n        <student-location-details [content]=\"planningInfo ? planningInfo : {}\" ></student-location-details>\n    </div>\n    <div style=\"text-align: center\">\n        <br/>\n        <button (click)=\"isViewMap=false\">Acknowledge</button>\n    </div>\n</p-dialog>";

/***/ }),

/***/ 698:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/select_camp_child_icon.b8f75fbf810f2db55dbf73548992cfa2.png";

/***/ }),

/***/ 699:
/***/ (function(module, exports) {

	module.exports = "/*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */html{font-family:sans-serif;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block;vertical-align:baseline}audio:not([controls]){display:none;height:0}[hidden],template{display:none}a{background-color:transparent}a:active,a:hover{outline:0}abbr[title]{border-bottom:1px dotted}b,strong{font-weight:bold}dfn{font-style:italic}h1{font-size:2em;margin:0.67em 0}mark{background:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sup{top:-0.5em}sub{bottom:-0.25em}img{border:0}svg:not(:root){overflow:hidden}figure{margin:1em 40px}hr{box-sizing:content-box;height:0}pre{overflow:auto}code,kbd,pre,samp{font-family:monospace, monospace;font-size:1em}button,input,optgroup,select,textarea{color:inherit;font:inherit;margin:0}button{overflow:visible}button,select{text-transform:none}button,html input[type=\"button\"],input[type=\"reset\"],input[type=\"submit\"]{-webkit-appearance:button;cursor:pointer}button[disabled],html input[disabled]{cursor:not-allowed}button::-moz-focus-inner,input::-moz-focus-inner{border:0;padding:0}input{line-height:normal}input[type=\"checkbox\"],input[type=\"radio\"]{box-sizing:border-box;padding:0}input[type=\"number\"]::-webkit-inner-spin-button,input[type=\"number\"]::-webkit-outer-spin-button{height:auto}input[type=\"search\"]{-webkit-appearance:textfield;box-sizing:content-box}input[type=\"search\"]::-webkit-search-cancel-button,input[type=\"search\"]::-webkit-search-decoration{-webkit-appearance:none}legend{border:0;padding:0}textarea{overflow:auto}optgroup{font-weight:bold}table{border-collapse:collapse;border-spacing:0}td,th{padding:0}.foundation-mq{font-family:\"small=0em&medium=40em&large=64em&xlarge=75em&xxlarge=90em\"}html{font-size:100%;box-sizing:border-box}*,*::before,*::after{box-sizing:inherit}body{padding:0;margin:0;font-family:Segoe UI,sans-serif;font-weight:normal;line-height:1.5;color:#414042;background:#fff;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}img{max-width:100%;height:auto;-ms-interpolation-mode:bicubic;display:inline-block;vertical-align:middle}textarea{height:auto;min-height:50px;border-radius:0}select{width:100%;border-radius:0}#map_canvas img,#map_canvas embed,#map_canvas object,.map_canvas img,.map_canvas embed,.map_canvas object,.mqa-display img,.mqa-display embed,.mqa-display object{max-width:none !important}button{-webkit-appearance:none;-moz-appearance:none;background:transparent;padding:0;border:0;border-radius:0;line-height:1}[data-whatinput='mouse'] button{outline:0}.is-visible{display:block !important}.is-hidden{display:none !important}.top-bar{display:flex;align-items:center;justify-content:space-between;flex-wrap:nowrap;padding:.5rem;flex-wrap:wrap}.top-bar,.top-bar ul{background-color:#e6e6e6}.top-bar input{max-width:200px;margin-right:1rem}.top-bar .input-group-field{width:100%;margin-right:0}.top-bar input.button{width:auto}.top-bar .top-bar-left,.top-bar .top-bar-right{flex:0 0 100%;max-width:100%}@media screen and (min-width: 40em){.top-bar{flex-wrap:nowrap}.top-bar .top-bar-left,.top-bar .top-bar-right{flex:1 1 0px}}@media screen and (max-width: 63.9375em){.top-bar.stacked-for-medium{flex-wrap:wrap}.top-bar.stacked-for-medium .top-bar-left,.top-bar.stacked-for-medium .top-bar-right{flex:0 0 100%;max-width:100%}}@media screen and (max-width: 74.9375em){.top-bar.stacked-for-large{flex-wrap:wrap}.top-bar.stacked-for-large .top-bar-left,.top-bar.stacked-for-large .top-bar-right{flex:0 0 100%;max-width:100%}}.top-bar-title{flex:0 0 auto;margin-right:1rem}.top-bar-left,.top-bar-right{flex:0 0 auto}.row{max-width:75rem;margin-left:auto;margin-right:auto;display:flex;flex-flow:row wrap}.row .row{max-width:none;margin-left:-.625rem;margin-right:-.625rem}@media screen and (min-width: 40em){.row .row{margin-left:-.9375rem;margin-right:-.9375rem}}.row.expanded{max-width:none}.row.collapse>.column,.row.collapse>.columns{padding-left:0;padding-right:0}.column,.columns{flex:1 1 0px;padding-left:.625rem;padding-right:.625rem;min-width:initial}@media screen and (min-width: 40em){.column,.columns{padding-left:.9375rem;padding-right:.9375rem}}.column.row.row,.row.row.columns{float:none;display:block}.row .column.row.row,.row .row.row.columns{padding-left:0;padding-right:0;margin-left:0;margin-right:0}.small-1{flex:0 0 8.33333%;max-width:8.33333%}.small-offset-0{margin-left:0%}.small-2{flex:0 0 16.66667%;max-width:16.66667%}.small-offset-1{margin-left:8.33333%}.small-3{flex:0 0 25%;max-width:25%}.small-offset-2{margin-left:16.66667%}.small-4{flex:0 0 33.33333%;max-width:33.33333%}.small-offset-3{margin-left:25%}.small-5{flex:0 0 41.66667%;max-width:41.66667%}.small-offset-4{margin-left:33.33333%}.small-6{flex:0 0 50%;max-width:50%}.small-offset-5{margin-left:41.66667%}.small-7{flex:0 0 58.33333%;max-width:58.33333%}.small-offset-6{margin-left:50%}.small-8{flex:0 0 66.66667%;max-width:66.66667%}.small-offset-7{margin-left:58.33333%}.small-9{flex:0 0 75%;max-width:75%}.small-offset-8{margin-left:66.66667%}.small-10{flex:0 0 83.33333%;max-width:83.33333%}.small-offset-9{margin-left:75%}.small-11{flex:0 0 91.66667%;max-width:91.66667%}.small-offset-10{margin-left:83.33333%}.small-12{flex:0 0 100%;max-width:100%}.small-offset-11{margin-left:91.66667%}.small-order-1{order:1}.small-order-2{order:2}.small-order-3{order:3}.small-order-4{order:4}.small-order-5{order:5}.small-order-6{order:6}.small-up-1{flex-wrap:wrap}.small-up-1>.column,.small-up-1>.columns{flex:0 0 100%;max-width:100%}.small-up-2{flex-wrap:wrap}.small-up-2>.column,.small-up-2>.columns{flex:0 0 50%;max-width:50%}.small-up-3{flex-wrap:wrap}.small-up-3>.column,.small-up-3>.columns{flex:0 0 33.33333%;max-width:33.33333%}.small-up-4{flex-wrap:wrap}.small-up-4>.column,.small-up-4>.columns{flex:0 0 25%;max-width:25%}.small-up-5{flex-wrap:wrap}.small-up-5>.column,.small-up-5>.columns{flex:0 0 20%;max-width:20%}.small-up-6{flex-wrap:wrap}.small-up-6>.column,.small-up-6>.columns{flex:0 0 16.66667%;max-width:16.66667%}.small-up-7{flex-wrap:wrap}.small-up-7>.column,.small-up-7>.columns{flex:0 0 14.28571%;max-width:14.28571%}.small-up-8{flex-wrap:wrap}.small-up-8>.column,.small-up-8>.columns{flex:0 0 12.5%;max-width:12.5%}.small-collapse>.column,.small-collapse>.columns{padding-left:0;padding-right:0}.small-uncollapse>.column,.small-uncollapse>.columns{padding-left:.625rem;padding-right:.625rem}@media screen and (min-width: 40em){.medium-1{flex:0 0 8.33333%;max-width:8.33333%}.medium-offset-0{margin-left:0%}.medium-2{flex:0 0 16.66667%;max-width:16.66667%}.medium-offset-1{margin-left:8.33333%}.medium-3{flex:0 0 25%;max-width:25%}.medium-offset-2{margin-left:16.66667%}.medium-4{flex:0 0 33.33333%;max-width:33.33333%}.medium-offset-3{margin-left:25%}.medium-5{flex:0 0 41.66667%;max-width:41.66667%}.medium-offset-4{margin-left:33.33333%}.medium-6{flex:0 0 50%;max-width:50%}.medium-offset-5{margin-left:41.66667%}.medium-7{flex:0 0 58.33333%;max-width:58.33333%}.medium-offset-6{margin-left:50%}.medium-8{flex:0 0 66.66667%;max-width:66.66667%}.medium-offset-7{margin-left:58.33333%}.medium-9{flex:0 0 75%;max-width:75%}.medium-offset-8{margin-left:66.66667%}.medium-10{flex:0 0 83.33333%;max-width:83.33333%}.medium-offset-9{margin-left:75%}.medium-11{flex:0 0 91.66667%;max-width:91.66667%}.medium-offset-10{margin-left:83.33333%}.medium-12{flex:0 0 100%;max-width:100%}.medium-offset-11{margin-left:91.66667%}.medium-order-1{order:1}.medium-order-2{order:2}.medium-order-3{order:3}.medium-order-4{order:4}.medium-order-5{order:5}.medium-order-6{order:6}.medium-up-1{flex-wrap:wrap}.medium-up-1>.column,.medium-up-1>.columns{flex:0 0 100%;max-width:100%}.medium-up-2{flex-wrap:wrap}.medium-up-2>.column,.medium-up-2>.columns{flex:0 0 50%;max-width:50%}.medium-up-3{flex-wrap:wrap}.medium-up-3>.column,.medium-up-3>.columns{flex:0 0 33.33333%;max-width:33.33333%}.medium-up-4{flex-wrap:wrap}.medium-up-4>.column,.medium-up-4>.columns{flex:0 0 25%;max-width:25%}.medium-up-5{flex-wrap:wrap}.medium-up-5>.column,.medium-up-5>.columns{flex:0 0 20%;max-width:20%}.medium-up-6{flex-wrap:wrap}.medium-up-6>.column,.medium-up-6>.columns{flex:0 0 16.66667%;max-width:16.66667%}.medium-up-7{flex-wrap:wrap}.medium-up-7>.column,.medium-up-7>.columns{flex:0 0 14.28571%;max-width:14.28571%}.medium-up-8{flex-wrap:wrap}.medium-up-8>.column,.medium-up-8>.columns{flex:0 0 12.5%;max-width:12.5%}}@media screen and (min-width: 40em) and (min-width: 40em){.medium-expand{flex:1 1 0px}}.row.medium-unstack>.column,.row.medium-unstack>.columns{flex:0 0 100%}@media screen and (min-width: 40em){.row.medium-unstack>.column,.row.medium-unstack>.columns{flex:1 1 0px}}@media screen and (min-width: 40em){.medium-collapse>.column,.medium-collapse>.columns{padding-left:0;padding-right:0}.medium-uncollapse>.column,.medium-uncollapse>.columns{padding-left:.9375rem;padding-right:.9375rem}}@media screen and (min-width: 64em){.large-1{flex:0 0 8.33333%;max-width:8.33333%}.large-offset-0{margin-left:0%}.large-2{flex:0 0 16.66667%;max-width:16.66667%}.large-offset-1{margin-left:8.33333%}.large-3{flex:0 0 25%;max-width:25%}.large-offset-2{margin-left:16.66667%}.large-4{flex:0 0 33.33333%;max-width:33.33333%}.large-offset-3{margin-left:25%}.large-5{flex:0 0 41.66667%;max-width:41.66667%}.large-offset-4{margin-left:33.33333%}.large-6{flex:0 0 50%;max-width:50%}.large-offset-5{margin-left:41.66667%}.large-7{flex:0 0 58.33333%;max-width:58.33333%}.large-offset-6{margin-left:50%}.large-8{flex:0 0 66.66667%;max-width:66.66667%}.large-offset-7{margin-left:58.33333%}.large-9{flex:0 0 75%;max-width:75%}.large-offset-8{margin-left:66.66667%}.large-10{flex:0 0 83.33333%;max-width:83.33333%}.large-offset-9{margin-left:75%}.large-11{flex:0 0 91.66667%;max-width:91.66667%}.large-offset-10{margin-left:83.33333%}.large-12{flex:0 0 100%;max-width:100%}.large-offset-11{margin-left:91.66667%}.large-order-1{order:1}.large-order-2{order:2}.large-order-3{order:3}.large-order-4{order:4}.large-order-5{order:5}.large-order-6{order:6}.large-up-1{flex-wrap:wrap}.large-up-1>.column,.large-up-1>.columns{flex:0 0 100%;max-width:100%}.large-up-2{flex-wrap:wrap}.large-up-2>.column,.large-up-2>.columns{flex:0 0 50%;max-width:50%}.large-up-3{flex-wrap:wrap}.large-up-3>.column,.large-up-3>.columns{flex:0 0 33.33333%;max-width:33.33333%}.large-up-4{flex-wrap:wrap}.large-up-4>.column,.large-up-4>.columns{flex:0 0 25%;max-width:25%}.large-up-5{flex-wrap:wrap}.large-up-5>.column,.large-up-5>.columns{flex:0 0 20%;max-width:20%}.large-up-6{flex-wrap:wrap}.large-up-6>.column,.large-up-6>.columns{flex:0 0 16.66667%;max-width:16.66667%}.large-up-7{flex-wrap:wrap}.large-up-7>.column,.large-up-7>.columns{flex:0 0 14.28571%;max-width:14.28571%}.large-up-8{flex-wrap:wrap}.large-up-8>.column,.large-up-8>.columns{flex:0 0 12.5%;max-width:12.5%}}@media screen and (min-width: 64em) and (min-width: 64em){.large-expand{flex:1 1 0px}}.row.large-unstack>.column,.row.large-unstack>.columns{flex:0 0 100%}@media screen and (min-width: 64em){.row.large-unstack>.column,.row.large-unstack>.columns{flex:1 1 0px}}@media screen and (min-width: 64em){.large-collapse>.column,.large-collapse>.columns{padding-left:0;padding-right:0}.large-uncollapse>.column,.large-uncollapse>.columns{padding-left:.9375rem;padding-right:.9375rem}}.shrink{flex:0 0 auto;max-width:100%}.column.align-top,.align-top.columns{align-self:flex-start}.column.align-bottom,.align-bottom.columns{align-self:flex-end}.column.align-middle,.align-middle.columns{align-self:center}.column.align-stretch,.align-stretch.columns{align-self:stretch}div,dl,dt,dd,ul,ol,li,h1,h2,h3,h4,h5,h6,pre,form,p,blockquote,th,td{margin:0;padding:0}p{font-size:inherit;line-height:1.6;margin-bottom:1rem;text-rendering:optimizeLegibility}em,i{font-style:italic;line-height:inherit}strong,b{font-weight:bold;line-height:inherit}small{font-size:80%;line-height:inherit}h1,h2,h3,h4,h5,h6{font-family:Segoe UI,sans-serif;font-weight:normal;font-style:normal;color:inherit;text-rendering:optimizeLegibility;margin-top:0;margin-bottom:.5rem;line-height:1.4}h1 small,h2 small,h3 small,h4 small,h5 small,h6 small{color:#cacaca;line-height:0}h1{font-size:1.5rem}h2{font-size:1.25rem}h3{font-size:1.1875rem}h4{font-size:1.125rem}h5{font-size:1.0625rem}h6{font-size:1rem}@media screen and (min-width: 40em){h1{font-size:3rem}h2{font-size:2.5rem}h3{font-size:1.9375rem}h4{font-size:1.5625rem}h5{font-size:1.25rem}h6{font-size:1rem}}a{color:#00707e;text-decoration:none;line-height:inherit;cursor:pointer}a:hover,a:focus{color:#00606c}a img{border:0}hr{max-width:75rem;height:0;border-right:0;border-top:0;border-bottom:1px solid #cacaca;border-left:0;margin:1.25rem auto;clear:both}ul,ol,dl{line-height:1.6;margin-bottom:1rem;list-style-position:outside}li{font-size:inherit}ul{list-style-type:disc;margin-left:1.25rem}ol{margin-left:1.25rem}ul ul,ol ul,ul ol,ol ol{margin-left:1.25rem;margin-bottom:0}dl{margin-bottom:1rem}dl dt{margin-bottom:.3rem;font-weight:bold}blockquote{margin:0 0 1rem;padding:.5625rem 1.25rem 0 1.1875rem;border-left:1px solid #cacaca}blockquote,blockquote p{line-height:1.6;color:#8a8a8a}cite{display:block;font-size:.8125rem;color:#8a8a8a}cite:before{content:'\\2014 \\0020'}abbr{color:#414042;cursor:help;border-bottom:1px dotted #0a0a0a}code{font-family:Consolas,\"Liberation Mono\",Courier,monospace;font-weight:normal;color:#0a0a0a;background-color:#e6e6e6;border:1px solid #cacaca;padding:.125rem .3125rem .0625rem}kbd{padding:.125rem .25rem 0;margin:0;background-color:#e6e6e6;color:#0a0a0a;font-family:Consolas,\"Liberation Mono\",Courier,monospace}.subheader{margin-top:.2rem;margin-bottom:.5rem;font-weight:normal;line-height:1.4;color:#8a8a8a}.lead{font-size:125%;line-height:1.6}.stat{font-size:2.5rem;line-height:1}p+.stat{margin-top:-1rem}.no-bullet{margin-left:0;list-style:none}.text-left{text-align:left}.text-right{text-align:right}.text-center{text-align:center}.text-justify{text-align:justify}@media screen and (min-width: 40em){.medium-text-left{text-align:left}.medium-text-right{text-align:right}.medium-text-center{text-align:center}.medium-text-justify{text-align:justify}}@media screen and (min-width: 64em){.large-text-left{text-align:left}.large-text-right{text-align:right}.large-text-center{text-align:center}.large-text-justify{text-align:justify}}.show-for-print{display:none !important}@media print{*{background:transparent !important;color:black !important;box-shadow:none !important;text-shadow:none !important}.show-for-print{display:block !important}.hide-for-print{display:none !important}table.show-for-print{display:table !important}thead.show-for-print{display:table-header-group !important}tbody.show-for-print{display:table-row-group !important}tr.show-for-print{display:table-row !important}td.show-for-print{display:table-cell !important}th.show-for-print{display:table-cell !important}a,a:visited{text-decoration:underline}a[href]:after{content:\" (\" attr(href) \")\"}.ir a:after,a[href^='javascript:']:after,a[href^='#']:after{content:''}abbr[title]:after{content:\" (\" attr(title) \")\"}pre,blockquote{border:1px solid #8a8a8a;page-break-inside:avoid}thead{display:table-header-group}tr,img{page-break-inside:avoid}img{max-width:100% !important}@page{margin:0.5cm}p,h2,h3{orphans:3;widows:3}h2,h3{page-break-after:avoid}}[type='text'],[type='password'],[type='date'],[type='datetime'],[type='datetime-local'],[type='month'],[type='week'],[type='email'],[type='number'],[type='search'],[type='tel'],[type='time'],[type='url'],[type='color'],textarea{display:block;box-sizing:border-box;width:100%;height:2.4375rem;padding:.5rem;border:1px solid #cacaca;margin:0 0 1rem;font-family:inherit;font-size:1rem;color:#0a0a0a;background-color:#fefefe;box-shadow:inset 0 1px 2px rgba(10,10,10,0.1);border-radius:0;transition:box-shadow 0.5s,border-color 0.25s ease-in-out;-webkit-appearance:none;-moz-appearance:none}[type='text']:focus,[type='password']:focus,[type='date']:focus,[type='datetime']:focus,[type='datetime-local']:focus,[type='month']:focus,[type='week']:focus,[type='email']:focus,[type='number']:focus,[type='search']:focus,[type='tel']:focus,[type='time']:focus,[type='url']:focus,[type='color']:focus,textarea:focus{border:1px solid #8a8a8a;background-color:#fefefe;outline:none;box-shadow:0 0 5px #cacaca;transition:box-shadow 0.5s,border-color 0.25s ease-in-out}textarea{max-width:100%}textarea[rows]{height:auto}input::placeholder,textarea::placeholder{color:#cacaca}input:disabled,input[readonly],textarea:disabled,textarea[readonly]{background-color:#e6e6e6;cursor:not-allowed}[type='submit'],[type='button']{border-radius:.2rem;-webkit-appearance:none;-moz-appearance:none}input[type='search']{box-sizing:border-box}[type='file'],[type='checkbox'],[type='radio']{margin:0 0 1rem}[type='checkbox']+label,[type='radio']+label{display:inline-block;margin-left:.5rem;margin-right:1rem;margin-bottom:0;vertical-align:baseline}[type='checkbox']+label[for],[type='radio']+label[for]{cursor:pointer}label>[type='checkbox'],label>[type='radio']{margin-right:.5rem}[type='file']{width:100%}label{display:block;margin:0;font-size:.875rem;font-weight:normal;line-height:1.8;color:#0a0a0a}label.middle{margin:0 0 1rem;padding:.5625rem 0}.help-text{margin-top:-.5rem;font-size:.8125rem;font-style:italic;color:#0a0a0a}.input-group{display:flex;width:100%;margin-bottom:1rem;align-items:stretch}.input-group>:first-child{border-radius:0 0 0 0}.input-group>:last-child>*{border-radius:0 0 0 0}.input-group-label,.input-group-field,.input-group-button{margin:0;white-space:nowrap}.input-group-label{text-align:center;padding:0 1rem;background:#e6e6e6;color:#0a0a0a;border:1px solid #cacaca;white-space:nowrap;flex:0 0 auto;display:flex;align-items:center}.input-group-label:first-child{border-right:0}.input-group-label:last-child{border-left:0}.input-group-field{border-radius:0;flex:1 1 0px;width:auto;height:auto}.input-group-button{padding-top:0;padding-bottom:0;text-align:center;flex:0 0 auto}.input-group-button a,.input-group-button input,.input-group-button button{margin:0}.input-group .input-group-button{display:table-cell}fieldset{border:0;padding:0;margin:0}legend{margin-bottom:.5rem;max-width:100%}.fieldset{border:1px solid #cacaca;padding:1.25rem;margin:1.125rem 0}.fieldset legend{background:#fff;padding:0 .1875rem;margin:0;margin-left:-.1875rem}select{height:2.4375rem;padding:.5rem;border:1px solid #cacaca;margin:0 0 1rem;font-size:1rem;font-family:inherit;line-height:normal;color:#0a0a0a;background-color:#fefefe;border-radius:0;-webkit-appearance:none;-moz-appearance:none;background-image:url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' version='1.1' width='32' height='24' viewBox='0 0 32 24'><polygon points='0,0 32,0 16,24' style='fill: rgb%28138, 138, 138%29'></polygon></svg>\");background-size:9px 6px;background-position:right -1rem center;background-origin:content-box;background-repeat:no-repeat;padding-right:1.5rem}@media screen and (min-width: 0\\0){select{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAYCAYAAACbU/80AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAIpJREFUeNrEkckNgDAMBBfRkEt0ObRBBdsGXUDgmQfK4XhH2m8czQAAy27R3tsw4Qfe2x8uOO6oYLb6GlOor3GF+swURAOmUJ+RwtEJs9WvTGEYxBXqI1MQAZhCfUQKRzDMVj+TwrAIV6jvSUEkYAr1LSkcyTBb/V+KYfX7xAeusq3sLDtGH3kEGACPWIflNZfhRQAAAABJRU5ErkJggg==\")}}select:disabled{background-color:#e6e6e6;cursor:not-allowed}select::-ms-expand{display:none}select[multiple]{height:auto;background-image:none}.is-invalid-input:not(:focus){background-color:rgba(236,88,64,0.1);border-color:#ec5840}.is-invalid-label{color:#ec5840}.form-error{display:none;margin-top:-.5rem;margin-bottom:1rem;font-size:.75rem;font-weight:bold;color:#ec5840}.form-error.is-visible{display:block}.hide{display:none !important}.invisible{visibility:hidden}@media screen and (max-width: 39.9375em){.hide-for-small-only{display:none !important}}@media screen and (max-width: 0em), screen and (min-width: 40em){.show-for-small-only{display:none !important}}@media screen and (min-width: 40em){.hide-for-medium{display:none !important}}@media screen and (max-width: 39.9375em){.show-for-medium{display:none !important}}@media screen and (min-width: 40em) and (max-width: 63.9375em){.hide-for-medium-only{display:none !important}}@media screen and (max-width: 39.9375em), screen and (min-width: 64em){.show-for-medium-only{display:none !important}}@media screen and (min-width: 64em){.hide-for-large{display:none !important}}@media screen and (max-width: 63.9375em){.show-for-large{display:none !important}}@media screen and (min-width: 64em) and (max-width: 74.9375em){.hide-for-large-only{display:none !important}}@media screen and (max-width: 63.9375em), screen and (min-width: 75em){.show-for-large-only{display:none !important}}.show-for-sr,.show-on-focus{position:absolute !important;width:1px;height:1px;overflow:hidden;clip:rect(0, 0, 0, 0)}.show-on-focus:active,.show-on-focus:focus{position:static !important;height:auto;width:auto;overflow:visible;clip:auto}.show-for-landscape,.hide-for-portrait{display:block !important}@media screen and (orientation: landscape){.show-for-landscape,.hide-for-portrait{display:block !important}}@media screen and (orientation: portrait){.show-for-landscape,.hide-for-portrait{display:none !important}}.hide-for-landscape,.show-for-portrait{display:none !important}@media screen and (orientation: landscape){.hide-for-landscape,.show-for-portrait{display:none !important}}@media screen and (orientation: portrait){.hide-for-landscape,.show-for-portrait{display:block !important}}.button{display:inline-block;text-align:center;line-height:1;cursor:pointer;-webkit-appearance:none;transition:background-color 0.25s ease-out, color 0.25s ease-out;vertical-align:middle;border:1px solid transparent;border-radius:.2rem;padding:1em 1.5rem;margin:0;font-size:0.9rem;background-color:#00707e;color:#fefefe}[data-whatinput='mouse'] .button{outline:0}.button:hover,.button:focus{background-color:#005f6b;color:#fefefe}.button.tiny{font-size:.6rem}.button.small{font-size:.75rem}.button.large{font-size:1.25rem}.button.expanded{display:block;width:100%;margin-left:0;margin-right:0}.button.primary{background-color:#00707e;color:#fefefe}.button.primary:hover,.button.primary:focus{background-color:#005a65;color:#fefefe}.button.secondary{background-color:#faa635;color:#fefefe}.button.secondary:hover,.button.secondary:focus{background-color:#ed8a06;color:#fefefe}.button.tertiary{background-color:#fff;color:#0a0a0a}.button.tertiary:hover,.button.tertiary:focus{background-color:#ccc;color:#0a0a0a}.button.topbar{background-color:#064180;color:#fefefe}.button.topbar:hover,.button.topbar:focus{background-color:#053466;color:#fefefe}.button.success{background-color:#4caf50;color:#fefefe}.button.success:hover,.button.success:focus{background-color:#3d8c40;color:#fefefe}.button.warning{background-color:#ffae00;color:#fefefe}.button.warning:hover,.button.warning:focus{background-color:#cc8b00;color:#fefefe}.button.alert{background-color:#ec5840;color:#fefefe}.button.alert:hover,.button.alert:focus{background-color:#da3116;color:#fefefe}.button.hollow{border:1px solid #00707e;color:#00707e}.button.hollow,.button.hollow:hover,.button.hollow:focus{background-color:transparent}.button.hollow:hover,.button.hollow:focus{border-color:#00383f;color:#00383f}.button.hollow.primary{border:1px solid #00707e;color:#00707e}.button.hollow.primary:hover,.button.hollow.primary:focus{border-color:#00383f;color:#00383f}.button.hollow.secondary{border:1px solid #faa635;color:#faa635}.button.hollow.secondary:hover,.button.hollow.secondary:focus{border-color:#945604;color:#945604}.button.hollow.tertiary{border:1px solid #fff;color:#fff}.button.hollow.tertiary:hover,.button.hollow.tertiary:focus{border-color:gray;color:gray}.button.hollow.topbar{border:1px solid #064180;color:#064180}.button.hollow.topbar:hover,.button.hollow.topbar:focus{border-color:#032140;color:#032140}.button.hollow.success{border:1px solid #4caf50;color:#4caf50}.button.hollow.success:hover,.button.hollow.success:focus{border-color:#265828;color:#265828}.button.hollow.warning{border:1px solid #ffae00;color:#ffae00}.button.hollow.warning:hover,.button.hollow.warning:focus{border-color:#805700;color:#805700}.button.hollow.alert{border:1px solid #ec5840;color:#ec5840}.button.hollow.alert:hover,.button.hollow.alert:focus{border-color:#881f0e;color:#881f0e}.button.disabled,.button[disabled]{opacity:.25;cursor:not-allowed}.button.disabled:hover,.button.disabled:focus,.button[disabled]:hover,.button[disabled]:focus{background-color:#00707e;color:#fefefe}.button.dropdown::after{content:'';display:block;width:0;height:0;border:inset .4em;border-color:#fefefe transparent transparent;border-top-style:solid;border-bottom-width:0;position:relative;top:0.4em;float:right;margin-left:1.5rem;display:inline-block}.button.arrow-only::after{margin-left:0;float:none;top:-0.1em}.button-group{margin-bottom:1rem;display:flex;flex-wrap:nowrap;align-items:stretch}.button-group::before,.button-group::after{content:' ';display:table;flex-basis:0;order:1}.button-group::after{clear:both}.button-group .button{margin:0;margin-right:1px;margin-bottom:1px;font-size:0.9rem;flex:0 0 auto}.button-group .button:last-child{margin-right:0}.button-group.tiny .button{font-size:.6rem}.button-group.small .button{font-size:.75rem}.button-group.large .button{font-size:1.25rem}.button-group.expanded .button{flex:1 1 0px}.button-group.primary .button{background-color:#00707e;color:#fefefe}.button-group.primary .button:hover,.button-group.primary .button:focus{background-color:#005a65;color:#fefefe}.button-group.secondary .button{background-color:#faa635;color:#fefefe}.button-group.secondary .button:hover,.button-group.secondary .button:focus{background-color:#ed8a06;color:#fefefe}.button-group.tertiary .button{background-color:#fff;color:#0a0a0a}.button-group.tertiary .button:hover,.button-group.tertiary .button:focus{background-color:#ccc;color:#0a0a0a}.button-group.topbar .button{background-color:#064180;color:#fefefe}.button-group.topbar .button:hover,.button-group.topbar .button:focus{background-color:#053466;color:#fefefe}.button-group.success .button{background-color:#4caf50;color:#fefefe}.button-group.success .button:hover,.button-group.success .button:focus{background-color:#3d8c40;color:#fefefe}.button-group.warning .button{background-color:#ffae00;color:#fefefe}.button-group.warning .button:hover,.button-group.warning .button:focus{background-color:#cc8b00;color:#fefefe}.button-group.alert .button{background-color:#ec5840;color:#fefefe}.button-group.alert .button:hover,.button-group.alert .button:focus{background-color:#da3116;color:#fefefe}.button-group.stacked,.button-group.stacked-for-small,.button-group.stacked-for-medium{flex-wrap:wrap}.button-group.stacked .button,.button-group.stacked-for-small .button,.button-group.stacked-for-medium .button{flex:0 0 100%}.button-group.stacked .button:last-child,.button-group.stacked-for-small .button:last-child,.button-group.stacked-for-medium .button:last-child{margin-bottom:0}@media screen and (min-width: 40em){.button-group.stacked-for-small .button{flex:1 1 0px;margin-bottom:0}}@media screen and (min-width: 64em){.button-group.stacked-for-medium .button{flex:1 1 0px;margin-bottom:0}}@media screen and (max-width: 39.9375em){.button-group.stacked-for-small.expanded{display:block}.button-group.stacked-for-small.expanded .button{display:block;margin-right:0}}.badge{display:inline-block;padding:.3em;min-width:2.1em;font-size:.6rem;text-align:center;border-radius:50%;background:#00707e;color:#fefefe}.badge.secondary{background:#faa635;color:#fefefe}.badge.tertiary{background:#fff;color:#0a0a0a}.badge.topbar{background:#064180;color:#fefefe}.badge.success{background:#4caf50;color:#fefefe}.badge.warning{background:#ffae00;color:#fefefe}.badge.alert{background:#ec5840;color:#fefefe}.breadcrumbs{list-style:none;margin:0 0 1rem 0}.breadcrumbs::before,.breadcrumbs::after{content:' ';display:table;flex-basis:0;order:1}.breadcrumbs::after{clear:both}.breadcrumbs li{float:left;color:#0a0a0a;font-size:.6875rem;cursor:default;text-transform:uppercase}.breadcrumbs li:not(:last-child)::after{color:#cacaca;content:\"/\";margin:0 .75rem;position:relative;top:1px;opacity:1}.breadcrumbs a{color:#00707e}.breadcrumbs a:hover{text-decoration:underline}.breadcrumbs .disabled{color:#cacaca;cursor:not-allowed}.callout{margin:0 0 1rem 0;padding:1rem;border:1px solid rgba(10,10,10,0.25);border-radius:0;position:relative;color:#414042;background-color:#fff}.callout>:first-child{margin-top:0}.callout>:last-child{margin-bottom:0}.callout.primary{background-color:#c5f9ff}.callout.secondary{background-color:#fef2e1}.callout.tertiary{background-color:#fff}.callout.topbar{background-color:#c9e2fc}.callout.success{background-color:#e4f3e5}.callout.warning{background-color:#fff3d9}.callout.alert{background-color:#fce6e2}.callout.small{padding-top:.5rem;padding-right:.5rem;padding-bottom:.5rem;padding-left:.5rem}.callout.large{padding-top:3rem;padding-right:3rem;padding-bottom:3rem;padding-left:3rem}.close-button{position:absolute;color:#8a8a8a;right:1rem;top:.5rem;font-size:2em;line-height:1;cursor:pointer}[data-whatinput='mouse'] .close-button{outline:0}.close-button:hover,.close-button:focus{color:#0a0a0a}.menu{margin:0;list-style-type:none;width:100%;display:flex;flex-wrap:nowrap;align-items:center;flex-wrap:nowrap}.menu>li{flex:0 0 auto}[data-whatinput='mouse'] .menu>li{outline:0}.menu>li>a{display:block;padding:0.7rem 1rem;line-height:1}.menu input,.menu a,.menu button{margin-bottom:0}.menu>li>a{display:flex}.menu>li>a{flex-flow:row nowrap}.menu>li>a img,.menu>li>a i,.menu>li>a svg{margin-right:.25rem}.menu>li{flex:0 0 auto}.menu.vertical{flex-wrap:wrap}.menu.vertical>li{flex:0 0 100%;max-width:100%}.menu.vertical>li>a{align-items:flex-start;justify-content:flex-start}@media screen and (min-width: 40em){.menu.medium-horizontal{flex-wrap:nowrap}.menu.medium-horizontal>li{flex:0 0 auto}.menu.medium-vertical{flex-wrap:wrap}.menu.medium-vertical>li{flex:0 0 100%;max-width:100%}.menu.medium-vertical>li>a{align-items:flex-start;justify-content:flex-start}}@media screen and (min-width: 64em){.menu.large-horizontal{flex-wrap:nowrap}.menu.large-horizontal>li{flex:0 0 auto}.menu.large-vertical{flex-wrap:wrap}.menu.large-vertical>li{flex:0 0 100%;max-width:100%}.menu.large-vertical>li>a{align-items:flex-start;justify-content:flex-start}}.menu.simple li{line-height:1;display:inline-block;margin-right:1rem}.menu.simple a{padding:0}.menu.align-right{justify-content:flex-end}.menu.expanded>li{flex:1 1 0px}.menu.expanded>li:first-child:last-child{width:100%}.menu.icon-top>li>a{flex-flow:column nowrap}.menu.icon-top>li>a img,.menu.icon-top>li>a i,.menu.icon-top>li>a svg{align-self:stretch;text-align:center;margin-bottom:.25rem}.menu.nested{margin-left:1rem}.menu .active>a{color:#fefefe;background:#00707e}.menu-text{font-weight:bold;color:inherit;line-height:1;padding-top:0;padding-bottom:0;padding:0.7rem 1rem}.menu-centered{text-align:center}.menu-centered>.menu{display:inline-block}.no-js [data-responsive-menu] ul{display:none}.menu-icon{position:relative;display:inline-block;vertical-align:middle;cursor:pointer;width:20px;height:16px}.menu-icon::after{content:'';position:absolute;display:block;width:100%;height:2px;background:#fefefe;top:0;left:0;box-shadow:0 7px 0 #fefefe,0 14px 0 #fefefe}.menu-icon:hover::after{background:#cacaca;box-shadow:0 7px 0 #cacaca,0 14px 0 #cacaca}.menu-icon.dark{position:relative;display:inline-block;vertical-align:middle;cursor:pointer;width:20px;height:16px}.menu-icon.dark::after{content:'';position:absolute;display:block;width:100%;height:2px;background:#0a0a0a;top:0;left:0;box-shadow:0 7px 0 #0a0a0a,0 14px 0 #0a0a0a}.menu-icon.dark:hover::after{background:#8a8a8a;box-shadow:0 7px 0 #8a8a8a,0 14px 0 #8a8a8a}.is-drilldown{position:relative;overflow:hidden}.is-drilldown li{display:block !important}.is-drilldown-submenu{position:absolute;top:0;left:100%;z-index:-1;height:100%;width:100%;background:#fefefe;transition:transform 0.15s linear}.is-drilldown-submenu.is-active{z-index:1;display:block;transform:translateX(-100%)}.is-drilldown-submenu.is-closing{transform:translateX(100%)}.is-drilldown-submenu-parent>a{position:relative}.is-drilldown-submenu-parent>a::after{content:'';display:block;width:0;height:0;border:inset 6px;border-color:transparent transparent transparent #00707e;border-left-style:solid;border-right-width:0;position:absolute;top:50%;margin-top:-6px;right:1rem}.js-drilldown-back>a::before{content:'';display:block;width:0;height:0;border:inset 6px;border-color:transparent #00707e transparent transparent;border-right-style:solid;border-left-width:0;border-left-width:0;display:inline-block;vertical-align:middle;margin-right:0.75rem}.dropdown-pane{background-color:#fff;border:1px solid #cacaca;border-radius:0;display:block;font-size:1rem;padding:1rem;position:absolute;visibility:hidden;width:300px;z-index:10}.dropdown-pane.is-open{visibility:visible}.dropdown-pane.tiny{width:100px}.dropdown-pane.small{width:200px}.dropdown-pane.large{width:400px}.dropdown.menu>li.opens-left>.is-dropdown-submenu{left:auto;right:0;top:100%}.dropdown.menu>li.opens-right>.is-dropdown-submenu{right:auto;left:0;top:100%}.dropdown.menu>li.is-dropdown-submenu-parent>a{padding-right:1.5rem;position:relative}.dropdown.menu>li.is-dropdown-submenu-parent>a::after{content:'';display:block;width:0;height:0;border:inset 5px;border-color:#00707e transparent transparent;border-top-style:solid;border-bottom-width:0;right:5px;margin-top:-2px}[data-whatinput='mouse'] .dropdown.menu a{outline:0}.no-js .dropdown.menu ul{display:none}.dropdown.menu.vertical>li .is-dropdown-submenu{top:0}.dropdown.menu.vertical>li.opens-left>.is-dropdown-submenu{left:auto;right:100%}.dropdown.menu.vertical>li.opens-right>.is-dropdown-submenu{right:auto;left:100%}.dropdown.menu.vertical>li>a::after{right:14px;margin-top:-3px}.dropdown.menu.vertical>li.opens-left>a::after{content:'';display:block;width:0;height:0;border:inset 5px;border-color:transparent #00707e transparent transparent;border-right-style:solid;border-left-width:0}.dropdown.menu.vertical>li.opens-right>a::after{content:'';display:block;width:0;height:0;border:inset 5px;border-color:transparent transparent transparent #00707e;border-left-style:solid;border-right-width:0}@media screen and (min-width: 40em){.dropdown.menu.medium-horizontal>li.opens-left>.is-dropdown-submenu{left:auto;right:0;top:100%}.dropdown.menu.medium-horizontal>li.opens-right>.is-dropdown-submenu{right:auto;left:0;top:100%}.dropdown.menu.medium-horizontal>li.is-dropdown-submenu-parent>a{padding-right:1.5rem;position:relative}.dropdown.menu.medium-horizontal>li.is-dropdown-submenu-parent>a::after{content:'';display:block;width:0;height:0;border:inset 5px;border-color:#00707e transparent transparent;border-top-style:solid;border-bottom-width:0;right:5px;margin-top:-2px}.dropdown.menu.medium-vertical>li .is-dropdown-submenu{top:0}.dropdown.menu.medium-vertical>li.opens-left>.is-dropdown-submenu{left:auto;right:100%}.dropdown.menu.medium-vertical>li.opens-right>.is-dropdown-submenu{right:auto;left:100%}.dropdown.menu.medium-vertical>li>a::after{right:14px;margin-top:-3px}.dropdown.menu.medium-vertical>li.opens-left>a::after{content:'';display:block;width:0;height:0;border:inset 5px;border-color:transparent #00707e transparent transparent;border-right-style:solid;border-left-width:0}.dropdown.menu.medium-vertical>li.opens-right>a::after{content:'';display:block;width:0;height:0;border:inset 5px;border-color:transparent transparent transparent #00707e;border-left-style:solid;border-right-width:0}}@media screen and (min-width: 64em){.dropdown.menu.large-horizontal>li.opens-left>.is-dropdown-submenu{left:auto;right:0;top:100%}.dropdown.menu.large-horizontal>li.opens-right>.is-dropdown-submenu{right:auto;left:0;top:100%}.dropdown.menu.large-horizontal>li.is-dropdown-submenu-parent>a{padding-right:1.5rem;position:relative}.dropdown.menu.large-horizontal>li.is-dropdown-submenu-parent>a::after{content:'';display:block;width:0;height:0;border:inset 5px;border-color:#00707e transparent transparent;border-top-style:solid;border-bottom-width:0;right:5px;margin-top:-2px}.dropdown.menu.large-vertical>li .is-dropdown-submenu{top:0}.dropdown.menu.large-vertical>li.opens-left>.is-dropdown-submenu{left:auto;right:100%}.dropdown.menu.large-vertical>li.opens-right>.is-dropdown-submenu{right:auto;left:100%}.dropdown.menu.large-vertical>li>a::after{right:14px;margin-top:-3px}.dropdown.menu.large-vertical>li.opens-left>a::after{content:'';display:block;width:0;height:0;border:inset 5px;border-color:transparent #00707e transparent transparent;border-right-style:solid;border-left-width:0}.dropdown.menu.large-vertical>li.opens-right>a::after{content:'';display:block;width:0;height:0;border:inset 5px;border-color:transparent transparent transparent #00707e;border-left-style:solid;border-right-width:0}}.dropdown.menu.align-right .is-dropdown-submenu.first-sub{top:100%;left:auto;right:0}.is-dropdown-menu.vertical{width:100px}.is-dropdown-menu.vertical.align-right{float:right}.is-dropdown-submenu-parent{position:relative}.is-dropdown-submenu-parent a::after{position:absolute;top:50%;right:5px;margin-top:-2px}.is-dropdown-submenu-parent.opens-inner>.is-dropdown-submenu{top:100%;left:auto}.is-dropdown-submenu-parent.opens-left>.is-dropdown-submenu{left:auto;right:100%}.is-dropdown-submenu-parent.opens-right>.is-dropdown-submenu{right:auto;left:100%}.is-dropdown-submenu{display:none;position:absolute;top:0;left:100%;min-width:200px;z-index:1;background:#fefefe;border:1px solid #cacaca}.is-dropdown-submenu .is-dropdown-submenu-parent>a::after{right:14px;margin-top:-3px}.is-dropdown-submenu .is-dropdown-submenu-parent.opens-left>a::after{content:'';display:block;width:0;height:0;border:inset 5px;border-color:transparent #00707e transparent transparent;border-right-style:solid;border-left-width:0}.is-dropdown-submenu .is-dropdown-submenu-parent.opens-right>a::after{content:'';display:block;width:0;height:0;border:inset 5px;border-color:transparent transparent transparent #00707e;border-left-style:solid;border-right-width:0}.is-dropdown-submenu .is-dropdown-submenu{margin-top:-1px}.is-dropdown-submenu>li{width:100%}.is-dropdown-submenu.js-dropdown-active{display:block}.align-right{justify-content:flex-end}.align-center{justify-content:center}.align-justify{justify-content:space-between}.align-spaced{justify-content:space-around}.align-top{align-items:flex-start}.align-self-top{align-self:flex-start}.align-bottom{align-items:flex-end}.align-self-bottom{align-self:flex-end}.align-middle{align-items:center}.align-self-middle{align-self:center}.align-stretch{align-items:stretch}.align-self-stretch{align-self:stretch}.small-order-1{order:1}.small-order-2{order:2}.small-order-3{order:3}.small-order-4{order:4}.small-order-5{order:5}.small-order-6{order:6}@media screen and (min-width: 40em){.medium-order-1{order:1}.medium-order-2{order:2}.medium-order-3{order:3}.medium-order-4{order:4}.medium-order-5{order:5}.medium-order-6{order:6}}@media screen and (min-width: 64em){.large-order-1{order:1}.large-order-2{order:2}.large-order-3{order:3}.large-order-4{order:4}.large-order-5{order:5}.large-order-6{order:6}}.label{display:inline-block;padding:0.33333rem 0.5rem;font-size:.8rem;line-height:1;white-space:nowrap;cursor:default;border-radius:0;background:#00707e;color:#fefefe}.label.secondary{background:#faa635;color:#fefefe}.label.tertiary{background:#fff;color:#0a0a0a}.label.topbar{background:#064180;color:#fefefe}.label.success{background:#4caf50;color:#fefefe}.label.warning{background:#ffae00;color:#fefefe}.label.alert{background:#ec5840;color:#fefefe}.pagination{margin-left:0;margin-bottom:1rem}.pagination::before,.pagination::after{content:' ';display:table;flex-basis:0;order:1}.pagination::after{clear:both}.pagination li{font-size:.875rem;margin-right:.0625rem;border-radius:0;display:none}.pagination li:last-child,.pagination li:first-child{display:inline-block}@media screen and (min-width: 40em){.pagination li{display:inline-block}}.pagination a,.pagination button{color:#0a0a0a;display:block;padding:.1875rem .625rem;border-radius:0}.pagination a:hover,.pagination button:hover{background:#e6e6e6}.pagination .current{padding:.1875rem .625rem;background:#00707e;color:#fefefe;cursor:default}.pagination .disabled{padding:.1875rem .625rem;color:#cacaca;cursor:not-allowed}.pagination .disabled:hover{background:transparent}.pagination .ellipsis::after{content:'\\2026';padding:.1875rem .625rem;color:#0a0a0a}.pagination-previous a::before,.pagination-previous.disabled::before{content:'\\00ab';display:inline-block;margin-right:0.5rem}.pagination-next a::after,.pagination-next.disabled::after{content:'\\00bb';display:inline-block;margin-left:0.5rem}.sticky-container{position:relative}.sticky{position:absolute;z-index:0;transform:translate3d(0, 0, 0)}.sticky.is-stuck{position:fixed;z-index:5}.sticky.is-stuck.is-at-top{top:0}.sticky.is-stuck.is-at-bottom{bottom:0}.sticky.is-anchored{position:absolute;left:auto;right:auto}.sticky.is-anchored.is-at-bottom{bottom:0}body.is-reveal-open{overflow:hidden}html.is-reveal-open,html.is-reveal-open body{height:100%;overflow:hidden;user-select:none}.reveal-overlay{display:none;position:fixed;top:0;bottom:0;left:0;right:0;z-index:1005;background-color:rgba(10,10,10,0.45);overflow-y:scroll}.reveal{display:none;z-index:1006;padding:1rem;border:1px solid #cacaca;background-color:#fefefe;border-radius:0;position:relative;top:100px;margin-left:auto;margin-right:auto;overflow-y:auto}[data-whatinput='mouse'] .reveal{outline:0}@media screen and (min-width: 40em){.reveal{min-height:0}}.reveal .column,.reveal .columns,.reveal .columns{min-width:0}.reveal>:last-child{margin-bottom:0}@media screen and (min-width: 40em){.reveal{width:600px;max-width:75rem}}@media screen and (min-width: 40em){.reveal .reveal{left:auto;right:auto;margin:0 auto}}.reveal.collapse{padding:0}@media screen and (min-width: 40em){.reveal.tiny{width:30%;max-width:75rem}}@media screen and (min-width: 40em){.reveal.small{width:50%;max-width:75rem}}@media screen and (min-width: 40em){.reveal.large{width:90%;max-width:75rem}}.reveal.full{top:0;left:0;width:100%;height:100%;height:100vh;min-height:100vh;max-width:none;margin-left:0;border:0;border-radius:0}@media screen and (max-width: 39.9375em){.reveal{top:0;left:0;width:100%;height:100%;height:100vh;min-height:100vh;max-width:none;margin-left:0;border:0;border-radius:0}}.reveal.without-overlay{position:fixed}.switch{margin-bottom:1rem;outline:0;position:relative;user-select:none;color:#fefefe;font-weight:bold;font-size:.875rem}.switch-input{opacity:0;position:absolute}.switch-paddle{background:#cacaca;cursor:pointer;display:block;position:relative;width:4rem;height:2rem;transition:all 0.25s ease-out;border-radius:0;color:inherit;font-weight:inherit}input+.switch-paddle{margin:0}.switch-paddle::after{background:#fefefe;content:'';display:block;position:absolute;height:1.5rem;left:0.25rem;top:0.25rem;width:1.5rem;transition:all 0.25s ease-out;transform:translate3d(0, 0, 0);border-radius:0}input:checked ~ .switch-paddle{background:#00707e}input:checked ~ .switch-paddle::after{left:2.25rem}[data-whatinput='mouse'] input:focus ~ .switch-paddle{outline:0}.switch-active,.switch-inactive{position:absolute;top:50%;transform:translateY(-50%)}.switch-active{left:8%;display:none}input:checked+label>.switch-active{display:block}.switch-inactive{right:15%}input:checked+label>.switch-inactive{display:none}.switch.tiny .switch-paddle{width:3rem;height:1.5rem;font-size:.625rem}.switch.tiny .switch-paddle::after{width:1rem;height:1rem}.switch.tiny input:checked ~ .switch-paddle::after{left:1.75rem}.switch.small .switch-paddle{width:3.5rem;height:1.75rem;font-size:.75rem}.switch.small .switch-paddle::after{width:1.25rem;height:1.25rem}.switch.small input:checked ~ .switch-paddle::after{left:2rem}.switch.large .switch-paddle{width:5rem;height:2.5rem;font-size:1rem}.switch.large .switch-paddle::after{width:2rem;height:2rem}.switch.large input:checked ~ .switch-paddle::after{left:2.75rem}table{width:100%;margin-bottom:1rem;border-radius:0}table thead,table tbody,table tfoot{border:1px solid #f1f1f1;background-color:#fefefe}table caption{font-weight:bold;padding:.5rem .625rem .625rem}table thead,table tfoot{background:#f8f8f8;color:#414042}table thead tr,table tfoot tr{background:transparent}table thead th,table thead td,table tfoot th,table tfoot td{padding:.5rem .625rem .625rem;font-weight:bold;text-align:left}table tbody tr:nth-child(even){background-color:#f1f1f1}table tbody th,table tbody td{padding:.5rem .625rem .625rem}@media screen and (max-width: 63.9375em){table.stack thead{display:none}table.stack tfoot{display:none}table.stack tr,table.stack th,table.stack td{display:block}table.stack td{border-top:0}}table.scroll{display:block;width:100%;overflow-x:auto}table.hover tr:hover{background-color:#f9f9f9}table.hover tr:nth-of-type(even):hover{background-color:#ececec}.table-scroll{overflow-x:auto}.table-scroll table{width:auto}.tabs{margin:0;list-style-type:none;background:#fefefe;border:1px solid #e6e6e6}.tabs::before,.tabs::after{content:' ';display:table;flex-basis:0;order:1}.tabs::after{clear:both}.tabs.vertical>li{width:auto;float:none;display:block}.tabs.simple>li>a{padding:0}.tabs.simple>li>a:hover{background:transparent}.tabs.primary{background:#00707e}.tabs.primary>li>a{color:#fefefe}.tabs.primary>li>a:hover,.tabs.primary>li>a:focus{background:#008191}.tabs-title{float:left}.tabs-title>a{display:block;padding:1.25rem 1.5rem;line-height:1;font-size:.75rem}.tabs-title>a:hover{background:#fefefe}.tabs-title>a:focus,.tabs-title>a[aria-selected='true']{background:#e6e6e6}.tabs-content{background:#fefefe;transition:all 0.5s ease;border:1px solid #e6e6e6;border-top:0}.tabs-content.vertical{border:1px solid #e6e6e6;border-left:0}.tabs-panel{display:none;padding:1rem}.tabs-panel.is-active{display:block}.thumbnail{border:solid 4px #fefefe;box-shadow:0 0 0 1px rgba(10,10,10,0.2);display:inline-block;line-height:0;max-width:100%;transition:box-shadow 200ms ease-out;border-radius:0;margin-bottom:1rem}.thumbnail:hover,.thumbnail:focus{box-shadow:0 0 6px 1px rgba(0,112,126,0.5)}.title-bar{background:#0a0a0a;color:#fefefe;padding:.5rem;display:flex;align-items:center;justify-content:space-between}.title-bar .menu-icon{margin-left:.25rem;margin-right:.25rem}.title-bar-left,.title-bar-right{flex:1 1 0px}.title-bar-right{text-align:right}.title-bar-title{font-weight:bold;vertical-align:middle;display:inline-block}.menu-icon.dark{position:relative;display:inline-block;vertical-align:middle;cursor:pointer;width:20px;height:16px}.menu-icon.dark::after{content:'';position:absolute;display:block;width:100%;height:2px;background:#0a0a0a;top:0;left:0;box-shadow:0 7px 0 #0a0a0a,0 14px 0 #0a0a0a}.menu-icon.dark:hover::after{background:#8a8a8a;box-shadow:0 7px 0 #8a8a8a,0 14px 0 #8a8a8a}.has-tip{border-bottom:dotted 1px #8a8a8a;font-weight:bold;position:relative;display:inline-block;cursor:help}.tooltip{background-color:#0a0a0a;color:#fefefe;font-size:80%;padding:.75rem;position:absolute;z-index:10;top:calc(100% + .6495rem);max-width:10rem !important;border-radius:0}.tooltip::before{content:'';display:block;width:0;height:0;border:inset .75rem;border-color:transparent transparent #0a0a0a;border-bottom-style:solid;border-top-width:0;bottom:100%;position:absolute;left:50%;transform:translateX(-50%)}.tooltip.top::before{content:'';display:block;width:0;height:0;border:inset .75rem;border-color:#0a0a0a transparent transparent;border-top-style:solid;border-bottom-width:0;top:100%;bottom:auto}.tooltip.left::before{content:'';display:block;width:0;height:0;border:inset .75rem;border-color:transparent transparent transparent #0a0a0a;border-left-style:solid;border-right-width:0;bottom:auto;left:100%;top:50%;transform:translateY(-50%)}.tooltip.right::before{content:'';display:block;width:0;height:0;border:inset .75rem;border-color:transparent #0a0a0a transparent transparent;border-right-style:solid;border-left-width:0;bottom:auto;left:auto;right:100%;top:50%;transform:translateY(-50%)}.main-container{margin-top:78px}.main-container>.row{max-width:100% !important;background:#edf0f5}.main-container .container{min-height:calc(100% - 78px)}.main-container .container .container-inner{background:#fff;margin:15px auto;border-radius:5px;border:1px solid #e1e4e9;font-size:0.875rem;color:#414042;overflow-x:visible}.main-container .container .container-inner section{padding:1rem 2rem}.main-container .container .container-inner section.heading{overflow:hidden;position:relative;border-bottom:1px solid #f7f9fb}.main-container .container .container-inner section.heading>h3{float:left;margin-bottom:0;line-height:42px;font-size:1.25rem;font-weight:500}.main-container .container .container-inner section.camp-top{overflow:hidden;position:relative;border-bottom:1px solid #f7f9fb}.main-container .container .container-inner section.camp-top>h3{float:left;margin-bottom:0;line-height:42px;font-size:1.25rem;font-weight:500}@media only screen and (max-width: 1780px){.main-container .container{min-width:calc(100% - 300px)}}button:not(.close-button).button-default,.button:not(.close-button).button-default{background-color:#939598}button:not(.close-button).button-success,.button:not(.close-button).button-success{color:#fff;background-color:#00707e}button:not(.close-button).button-danger,.button:not(.close-button).button-danger{color:#fff;background-color:#EC5840}button:not(.close-button).button-icon i,.button:not(.close-button).button-icon i{display:inline-block;vertical-align:middle;font-size:18px;transition:all 0s}button:not(.close-button).secondary,.button:not(.close-button).secondary{background-color:#939598;color:#fefefe}button:not(.close-button).button-save,.button:not(.close-button).button-save{background-color:#00707e}button:not(.close-button).small,.button:not(.close-button).small{padding:0.3rem}.checkbox{padding:0px;position:relative}.checkbox input[type=\"checkbox\"]{display:none}.checkbox label{padding-left:28px;height:20px;font-weight:400;line-height:20px;position:relative}.checkbox input[type=\"checkbox\"]:not(:checked)+label:before,.checkbox input[type=\"checkbox\"]:checked+label:before{content:'';display:block;width:18px;height:18px;border-radius:3px;border:solid 1px #ddd;position:absolute;left:0;top:1px;margin:auto;background:#fff}.checkbox input[type=\"checkbox\"]:not(:checked)+label:after,.checkbox input[type=\"checkbox\"]:checked+label:after{content:'\\f00c';font-family:'FontAwesome';display:block;width:18px;height:18px;border-radius:3px;position:absolute;left:0;top:1px;margin:auto;text-align:center;line-height:18px;color:#414042;transition:all 0.5s;font-size:12px}.checkbox input[type=\"checkbox\"]:not(:checked)+label:after{opacity:0;transform:scale(0)}.checkbox input[type=\"checkbox\"]:checked+label:after{opacity:1;transform:scale(1)}.checkbox.rounded input[type=\"checkbox\"]:not(:checked)+label:before,.checkbox.rounded input[type=\"checkbox\"]:checked+label:before{border-radius:50%}.checkbox.rounded input[type=\"checkbox\"]:not(:checked)+label:after,.checkbox.rounded input[type=\"checkbox\"]:checked+label:after{border-radius:50%}input[type=text],input[type=date],input[type=number]{border-radius:5px;font-size:0.875rem;background:#fff;color:#414042;outline:none;box-shadow:none}.modal{display:none;position:fixed;z-index:5;left:0;top:0;width:100%;height:100%;overflow:auto;background-color:#000;background-color:rgba(0,0,0,0.4)}.modal.show{display:block}.modal .modal-content{width:80%;max-width:400px;position:absolute;top:115px;left:0;right:0;margin:0 auto;margin-bottom:50px;background:#fff;border-radius:5px;overflow:hidden}.modal .modal-content form{padding:0px}.modal .modal-content .close{color:#fff;float:right;font-size:20px;font-weight:500;line-height:1}.modal .modal-content .close:hover,.modal .modal-content .close:focus{color:#eee;text-decoration:none;cursor:pointer}.modal .modal-content .modal-header{text-align:center;padding:10px 20px;color:#fff;background:#00707e;font-size:1.25rem;font-weight:500}.modal .modal-content .modal-header h2{text-align:left;font-size:1rem;font-weight:500;margin-bottom:0}.modal .modal-content .modal-body{padding:20px}.modal .modal-content .modal-footer{padding:10px 20px;border-top:solid 1px #ddd}.modal form{border:none;box-shadow:none}.modal form .form-button-group{text-align:center}.modal form .form-button-group button{margin:1rem;min-width:7rem}.modal.medium .modal-content{max-width:650px}.modal.large .modal-content{max-width:800px}.radio{padding:0px}.radio input[type=\"radio\"]{display:none}.radio label{padding-left:28px;height:20px;font-weight:400;line-height:20px;position:relative}.radio input[type=\"radio\"]:not(:checked)+label:before,.radio input[type=\"radio\"]:checked+label:before{content:'';display:block;width:18px;height:18px;border-radius:3px;border:solid 1px #ddd;position:absolute;left:0;top:0;bottom:0;margin:auto;background:#fff}.radio input[type=\"radio\"]:checked+label:after{content:'';font-family:'FontAwesome';display:block;width:14px;height:14px;border-radius:3px;position:absolute;left:2px;top:0;bottom:0;margin:auto;background:#fe8300}.radio input[type=\"radio\"]:disabled+label{cursor:inherit}.radio input[type=\"radio\"]:disabled+label:before{background:transparent;border-color:#bcbcbc}.wrap-select{position:relative}.wrap-select:before{content:'';color:#ddd;width:2.5rem;height:1.5625rem;position:absolute;pointer-events:none;right:17px;top:17px;width:0;height:0;border-left:5px solid transparent;border-right:5px solid transparent;border-top:8px solid #ddd}.wrap-select:after{content:'';position:absolute;height:1.5625rem;width:1px;background:#ddd;top:8px;right:40px}select,input[type=\"search\"]{padding:0 50px 0 13px;border-radius:5px;font-size:0.875rem;background:#fff;border:1px solid #ddd;color:#414042;outline:none;margin-bottom:1.25rem}@font-face{font-family:'Open-Sans';src:url(\"assets/fonts/open-sans/OpenSans-Regular.ttf\") format(\"\"),url(\"assets/fonts/font-awesome/fontawesome-webfont.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:'Material Icons';font-style:normal;font-weight:400;src:url(\"assets/fonts/material-icons/MaterialIcons-Regular.woff2\") format(\"woff2\"),url(\"assets/fonts/material-icons/MaterialIcons-Regular.woff\") format(\"woff\")}@font-face{font-family:'FontAwesome';src:url(\"assets/fonts/font-awesome/fontawesome-webfont.woff2\") format(\"woff2\"),url(\"assets/fonts/font-awesome/fontawesome-webfont.woff\") format(\"woff\");font-weight:400;font-style:normal}html#parent{overflow:auto !important}.pull-left{float:left !important}.pull-right{float:right !important}.clearfix:before,.clearfix:after{content:\" \";display:table}.clearfix:after{clear:both}.material-icons{font-family:'Material Icons';font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;font-feature-settings:'liga'}.fa{display:inline-block;font:normal normal normal 14px/1 FontAwesome;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.fa-facebook:before{content:\"\\f09a\"}.fa-twitter:before{content:\"\\f099\"}.fa-google:before{content:\"\\f1a0\"}.fa-youtube:before{content:\"\\f167\"}*{transition-duration:.2s;transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1)}.overlay{position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(255,255,255,0.5);z-index:99999}.loading-logo{position:absolute;top:45%;left:45%;background:#00707e;border:1px solid #00707e;border-radius:0.4rem;text-align:center;min-width:120px;padding:0.5rem}.loading-logo .loader{border:10px solid #fff;border-top:10px solid #faa635;border-radius:50%;width:60px;height:60px;animation:spin 1.5s linear infinite;display:inline-block;margin:0 auto;background-color:#00707e}.loading-logo .loader-text{margin:0.4rem auto;color:#fff}@keyframes spin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}.loading-data{margin:0 auto;background:url(\"./assets/loader.gif\") no-repeat center center;min-height:130px;padding:15px 0px}h1{font-size:2rem;font-weight:500;margin:0}h2{font-size:1.6rem}h3{font-size:1.3rem;color:#00707e;margin-bottom:1rem}.badge{border-radius:3px;font-size:12px;margin-bottom:3px}.badge.danger{background:#E74C3C}ul.list-unstyled{padding:0px;margin:0px;list-style:none}ul.list-unstyled li{list-style:none}label{font-size:0.875rem;color:#414042;margin-bottom:0.5rem;font-weight:500}input[type=\"text\"],input[type=\"email\"],input[type=\"password\"]{border:1px solid #dddddd;border-radius:0.2rem;-moz-border-radius:0.2rem;-webkit-border-radius:0.2rem}input[type=\"text\"]:focus,input[type=\"email\"]:focus,input[type=\"password\"]:focus{border-color:#faa635}input[type=\"checkbox\"]{width:1.1rem;height:1.1rem}input:required:invalid{border-left:5px solid #ec5840}input:required:valid{border-left:5px solid #4caf50}input.search-input{background:url(\"./assets/ic_search.png\") no-repeat center right 10px;background-color:#fff;padding-right:43px}[type='text'],[type='password'],[type='date'],[type='datetime'],[type='datetime-local'],[type='month'],[type='week'],[type='email'],[type='number'],[type='search'],[type='tel'],[type='time'],[type='url'],[type='color'],textarea{color:#414042}button,.button{font-family:Segoe UI,sans-serif !important}button:not(.close-button),.button:not(.close-button){padding:0.7rem 1.5rem;background-color:#00707e;color:#fff;margin:0.5rem auto;font-size:15px;font-weight:400;letter-spacing:0.04rem;border-radius:5px;box-shadow:0 2px 2px 0 rgba(0,0,0,0.14),0 3px 1px -2px rgba(0,0,0,0.2),0 1px 5px 0 rgba(0,0,0,0.12)}button:not(.close-button):enabled:hover,.button:not(.close-button):enabled:hover{background-color:#faa635;color:#fff;box-shadow:0 8px 10px 1px rgba(0,0,0,0.14),0 3px 14px 2px rgba(0,0,0,0.12),0 5px 5px -3px rgba(0,0,0,0.2)}button:not(.close-button):enabled:active,.button:not(.close-button):enabled:active{opacity:0.5}button:not(.close-button):disabled,.button:not(.close-button):disabled{background-color:#ccc}button:not(.close-button).secondary,.button:not(.close-button).secondary{background:#BEBEBE;color:#414042}button:not(.close-button):focus,.button:not(.close-button):focus{outline:none}button.close-button{outline:none}.ui-button,button.ui-button.ui-state-default,.ui-button.ui-state-default{border:1px solid #00707e;color:#fff;background:#00707e}.ui-state-default a,.ui-state-default a:link,.ui-state-default a:visited{color:#414042}form{padding:1.5rem 1rem;border:1px solid #fff;background:#fff;border-radius:0.5rem;box-shadow:0 2px 2px 0 rgba(0,0,0,0.14),0 3px 1px -2px rgba(0,0,0,0.2),0 1px 5px 0 rgba(0,0,0,0.12)}form a:hover{color:#faa635}form .ng-valid[required]{border-left:5px solid #4caf50}form .ng-invalid{border-left:5px solid #ec5840}.text-alert{color:#ec5840}#campRegister tbody tr:nth-child(odd){background-color:#fff}#campRegister .txt-center{text-align:center}#campRegister .txt-center button{padding:1rem 2rem}@media print{display:none}.eca-background{background:url(\"assets/background.jpg\") no-repeat center center}@media (min-width: 1280px){.eca-background{-webkit-background-size:cover;-moz-background-size:cover;-o-background-size:cover;background-size:cover}}#class-calendar .fc-head-container table{margin-bottom:0rem}#class-calendar .fc-head-container .fc-day-header{padding:0.5rem}#class-calendar .fc-view-container .fc-agenda-view table tbody{background-color:transparent}#class-calendar .fc-view-container .fc-agenda-view table tbody tr:nth-child(odd){background-color:transparent}#class-calendar .fc-view-container .fc-agenda-view .fc-axis{background-color:#f8f8f8;text-align:center}#class-calendar .fc-view-container .fc-agenda-view .fc-axis>span{position:absolute;left:4;margin-top:22px;font-weight:500}#class-calendar .fc-view-container .fc-agenda-view .fc-minor .fc-axis{border-top:0px}.fc .fc-toolbar button:not(.close-button){padding:0px 1.5rem;margin:0px 5px 0px 0px}.fc table{margin-bottom:0px}.fc .fc-event.custome-event-attendance{padding:0px 5px;margin-bottom:5px;background:#fff;color:#414042;border:none;box-shadow:1px 1px 5px -1px #999}.fc .fc-event.custome-event-attendance .fc-content{padding:10px 0px;margin:0px -5px;text-align:center;background:#666;color:#fff}.fc .fc-event.custome-event-attendance .event-content{padding:5px 0px}.fc .fc-event.custome-event-attendance .event-content .badge{border-radius:3px;font-size:12px}.fc .fc-event.custome-event-attendance .event-content .avatar{width:100%;margin:3px 0px;display:block}.fc .fc-event.none .fc-content{background:#6C7A89}.fc .fc-event.absent .fc-content,.fc .fc-event.absent .badge{background:#E74C3C}.fc .fc-event.present .fc-content,.fc .fc-event.present .badge{background:#00707e}.fc .fc-event.custome-bus-schedule{padding:0px 5px;margin-bottom:5px;background:#fff;color:#414042;border:none;box-shadow:1px 1px 5px -1px #999}.fc .fc-event.custome-bus-schedule .fc-content{padding:10px 0px;margin:0px -5px;text-align:center;background:#666;color:#fff}.fc .fc-event.custome-bus-schedule .event-content{padding:5px 0px}.fc .fc-event.custome-bus-schedule .event-content .badge{border-radius:3px;font-size:12px;margin-bottom:3px}.fc .fc-event.custome-bus-schedule .event-content .badge.danger{background:#E74C3C}.ui-widget{font-family:Segoe UI, sans-serif !important}.ui-widget input,.ui-widget select,.ui-widget textarea,.ui-widget button{font-family:Segoe UI, sans-serif !important}.ui-widget-content{color:#414042}.ui-widget-content a{color:#414042}.ui-widget-header{border:none;color:#414042;font-weight:500}span.ui-dialog-title{color:#00707e !important}a.ui-dialog-titlebar-icon{color:#414042}.ui-tabview .ui-tabview-panel{border:solid 1px #ccc}.ui-inputwrapper-filled.ng-valid{border-left:none !important}.ui-datepicker .ui-datepicker-prev,.ui-datepicker .ui-datepicker-next{border:solid 1px transparent;font-weight:400;top:1px}.ui-datepicker .ui-datepicker-prev{left:1px}.ui-datepicker .ui-datepicker-next{right:1px}.ui-datepicker .ui-datepicker-prev:before,.ui-datepicker .ui-datepicker-next:before{display:block;text-align:center;line-height:30px;font-family:'FontAwesome'}.ui-datepicker .ui-datepicker-prev:before{content:'\\f053'}.ui-datepicker .ui-datepicker-next:before{content:'\\f054'}.ui-calendar{width:100%}.ui-calendar input{width:100%;padding-right:45px;background-image:url(\"./assets/calendar-icon.png\") !important;background-color:#fff !important;background-repeat:no-repeat !important;background-position:center right 10px !important;background-size:25px 25px !important}.ui-dialog{width:75%;min-width:320px;color:#414042}.ui-dialog.top-dialog{top:5% !important}.ui-dialog.medium{width:50%}.ui-dialog form{padding:0px;box-shadow:none;border:none}.ui-dialog footer{padding:15px 0px;margin:0px 15px;border-top:solid 1px #ddd;text-align:right}.ui-confirmdialog footer{border:none}.ui-growl-item-container .ui-growl-item .ui-growl-image{display:none}.ui-tabview.ui-tabview-top>.ui-tabview-nav{padding:0px;border-bottom:solid 2px #00707e;border-radius:0px}.ui-tabview.ui-tabview-top>.ui-tabview-nav li.ui-state-default{position:relative;padding:4px 15px;top:4px}.ui-tabview.ui-tabview-top>.ui-tabview-nav li.ui-state-default.ui-state-active{top:1px;border:solid 1px #00707e;background:#00707e;padding:5px 15px}.ui-tabview.ui-tabview-top>.ui-tabview-nav li.ui-state-default.ui-state-active a{color:#fff;font-size:15px}.ui-tabview .ui-tabview-panel{border:none}.setting-tabs.ui-tabview-top>.ui-tabview-nav{background:#00707e;margin:-19px -36px 0px;border-radius:0px;border-bottom:0px}.setting-tabs.ui-tabview-top>.ui-tabview-nav li{border:none;border-bottom:solid 2px transparent;background:transparent !important;margin-right:10px;font-weight:500 !important}.setting-tabs.ui-tabview-top>.ui-tabview-nav li a{color:#fff !important}.setting-tabs.ui-tabview-top>.ui-tabview-nav li:hover{background:#fff;border-bottom:solid 2px #fff}.setting-tabs.ui-tabview-top>.ui-tabview-nav li.ui-state-default.ui-state-active{top:1px;border:none;border-bottom:solid 2px #fff}.setting-tabs .ui-tabview-panel{padding:0px;padding-top:15px;border:none;z-index:-1}.background:after{position:absolute;content:'';bottom:0;left:0;width:100%;height:600px;background:url(\"./assets/background.jpg\") no-repeat center bottom;background-size:100% auto;opacity:0.1;z-index:-1}.gmap div{transition-duration:unset !important}.ui-tabview-panel table thead tr{color:#fff;background-color:#00707e}.ui-tabview-panel table thead tr td{font-weight:500}.ui-tabview-panel table tbody tr:nth-child(odd){background-color:#f1f1f1}.ui-tabview-panel table tbody tr:nth-child(even){background-color:#fff}.ui-dialog-content .row .large-2{color:#414042}table thead th,table thead td,table tfoot th,table tfoot td{font-weight:500}main{min-height:40rem}.select-camp-header{background:#f7f7f7;overflow:hidden}.select-camp-header .wrap-select-camp-header-inner{width:80%;margin:25px auto 10px}.select-camp-header .wrap-select-camp-header-inner .camp-child-icon{vertical-align:-3px;margin-right:10px}.select-camp-header .wrap-select-camp-header-inner .wrap-select-option-header{display:inline-block;position:relative}.select-camp-header .wrap-select-camp-header-inner .wrap-select-option-header:before{content:'';color:#ddd;width:2.5rem;height:1.5625rem;position:absolute;pointer-events:none;right:17px;top:17px;width:0;height:0;border-left:5px solid transparent;border-right:5px solid transparent;border-top:8px solid #ddd}.select-camp-header .wrap-select-camp-header-inner .wrap-select-option-header:after{content:'';position:absolute;height:1.5625rem;width:1px;background:#ddd;top:8px;right:40px}.select-camp-header .wrap-select-camp-header-inner .wrap-select-option-header select{padding:0 50px 0 13px;border-radius:5px;font-size:1rem;background:#f8f8f8;border:1px solid #ddd;height:2.5rem;color:#282828;outline:none}.schedule-wrap{width:80%;margin:25px auto}\n"

/***/ }),

/***/ 700:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var router_1 = __webpack_require__(26);
	// Import components
	var BusAttendanceComponent_1 = __webpack_require__(430);
	var BusAttendaceRoutes = [
	    { path: 'bus-attendance', component: BusAttendanceComponent_1.BusAttendanceComponent },
	    { path: 'bus-attendance/:id', component: BusAttendanceComponent_1.BusAttendanceComponent }
	];
	exports.BusAttendanceRouter = router_1.RouterModule.forChild(BusAttendaceRoutes);


/***/ }),

/***/ 701:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var LocationServices_1 = __webpack_require__(702);
	var Subscription_1 = __webpack_require__(11);
	var StudentLocationComponent = (function () {
	    function StudentLocationComponent(locationService) {
	        this.locationService = locationService;
	        this.marker = [];
	    }
	    Object.defineProperty(StudentLocationComponent.prototype, "content", {
	        set: function (value) {
	            this.infoBus = value;
	            if (this.locationSubscription instanceof Subscription_1.Subscription)
	                this.locationSubscription.unsubscribe();
	            if (this.infoBus)
	                this.initMap();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ;
	    StudentLocationComponent.prototype.ngOnDestroy = function () {
	        this.locationSubscription.unsubscribe();
	    };
	    StudentLocationComponent.prototype.ngOnInit = function () {
	    };
	    StudentLocationComponent.prototype.initMap = function () {
	        var _this = this;
	        var mapProp = {
	            center: new google.maps.LatLng(10.799246, 106.6595112),
	            zoom: 15,
	            mapTypeId: google.maps.MapTypeId.ROADMAP
	        };
	        this.map = new google.maps.Map(this.gmapElement.nativeElement, mapProp);
	        this.locationSubscription = this.locationService.getMessages('busLocationClient').subscribe(function (data) {
	            _this.marker.setMap && _this.marker.setMap(null);
	            var location = JSON.parse(data);
	            if (_this.infoBus.bus.code == location.bus_code) {
	                var markerPlace = new google.maps.LatLng(location.lat, location.long);
	                _this.setMarket(markerPlace, location.bus_code);
	                _this.map.setCenter(markerPlace);
	            }
	            else {
	                _this.setMarket(null, '');
	            }
	        }, function (err) {
	            console.log(err);
	        });
	    };
	    StudentLocationComponent.prototype.setMarket = function (markerPlace, nameOfBus) {
	        this.marker = new google.maps.Marker({
	            position: markerPlace,
	            title: nameOfBus
	        });
	        this.marker.setMap(this.map);
	    };
	    return StudentLocationComponent;
	}());
	__decorate([
	    core_1.ViewChild('gmap'),
	    __metadata("design:type", Object)
	], StudentLocationComponent.prototype, "gmapElement", void 0);
	__decorate([
	    core_1.Input(),
	    __metadata("design:type", Object),
	    __metadata("design:paramtypes", [Object])
	], StudentLocationComponent.prototype, "content", null);
	StudentLocationComponent = __decorate([
	    core_1.Component({
	        selector: 'student-location-details',
	        template: __webpack_require__(751),
	        styles: [__webpack_require__(752)]
	    }),
	    __metadata("design:paramtypes", [LocationServices_1.LocationServices])
	], StudentLocationComponent);
	exports.StudentLocationComponent = StudentLocationComponent;


/***/ }),

/***/ 702:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Libraries
	var core_1 = __webpack_require__(3);
	var Observable_1 = __webpack_require__(7);
	// Services
	var services_1 = __webpack_require__(58);
	// socket
	var io = __webpack_require__(703);
	var LocationServices = (function () {
	    function LocationServices(apiService, settingService) {
	        this.apiService = apiService;
	        this.settingService = settingService;
	        this.socketUrl = '/';
	    }
	    LocationServices.prototype.getMessages = function (eventListen) {
	        var _this = this;
	        var observable = new Observable_1.Observable(function (observer) {
	            _this.socket = io(_this.socketUrl);
	            _this.socket.on(eventListen, function (data) {
	                observer.next(data);
	            });
	            return function () {
	                _this.socket.disconnect();
	            };
	        });
	        return observable;
	    };
	    return LocationServices;
	}());
	LocationServices = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [services_1.ApiService,
	        services_1.SettingService])
	], LocationServices);
	exports.LocationServices = LocationServices;


/***/ }),

/***/ 703:
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var url = __webpack_require__(704);
	var parser = __webpack_require__(709);
	var Manager = __webpack_require__(718);
	var debug = __webpack_require__(706)('socket.io-client');
	
	/**
	 * Module exports.
	 */
	
	module.exports = exports = lookup;
	
	/**
	 * Managers cache.
	 */
	
	var cache = exports.managers = {};
	
	/**
	 * Looks up an existing `Manager` for multiplexing.
	 * If the user summons:
	 *
	 *   `io('http://localhost/a');`
	 *   `io('http://localhost/b');`
	 *
	 * We reuse the existing instance based on same scheme/port/host,
	 * and we initialize sockets for each namespace.
	 *
	 * @api public
	 */
	
	function lookup (uri, opts) {
	  if (typeof uri === 'object') {
	    opts = uri;
	    uri = undefined;
	  }
	
	  opts = opts || {};
	
	  var parsed = url(uri);
	  var source = parsed.source;
	  var id = parsed.id;
	  var path = parsed.path;
	  var sameNamespace = cache[id] && path in cache[id].nsps;
	  var newConnection = opts.forceNew || opts['force new connection'] ||
	                      false === opts.multiplex || sameNamespace;
	
	  var io;
	
	  if (newConnection) {
	    debug('ignoring socket cache for %s', source);
	    io = Manager(source, opts);
	  } else {
	    if (!cache[id]) {
	      debug('new io instance for %s', source);
	      cache[id] = Manager(source, opts);
	    }
	    io = cache[id];
	  }
	  if (parsed.query && !opts.query) {
	    opts.query = parsed.query;
	  }
	  return io.socket(parsed.path, opts);
	}
	
	/**
	 * Protocol version.
	 *
	 * @api public
	 */
	
	exports.protocol = parser.protocol;
	
	/**
	 * `connect`.
	 *
	 * @param {String} uri
	 * @api public
	 */
	
	exports.connect = lookup;
	
	/**
	 * Expose constructors for standalone build.
	 *
	 * @api public
	 */
	
	exports.Manager = __webpack_require__(718);
	exports.Socket = __webpack_require__(746);


/***/ }),

/***/ 704:
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var parseuri = __webpack_require__(705);
	var debug = __webpack_require__(706)('socket.io-client:url');
	
	/**
	 * Module exports.
	 */
	
	module.exports = url;
	
	/**
	 * URL parser.
	 *
	 * @param {String} url
	 * @param {Object} An object meant to mimic window.location.
	 *                 Defaults to window.location.
	 * @api public
	 */
	
	function url (uri, loc) {
	  var obj = uri;
	
	  // default to window.location
	  loc = loc || (typeof location !== 'undefined' && location);
	  if (null == uri) uri = loc.protocol + '//' + loc.host;
	
	  // relative path support
	  if ('string' === typeof uri) {
	    if ('/' === uri.charAt(0)) {
	      if ('/' === uri.charAt(1)) {
	        uri = loc.protocol + uri;
	      } else {
	        uri = loc.host + uri;
	      }
	    }
	
	    if (!/^(https?|wss?):\/\//.test(uri)) {
	      debug('protocol-less url %s', uri);
	      if ('undefined' !== typeof loc) {
	        uri = loc.protocol + '//' + uri;
	      } else {
	        uri = 'https://' + uri;
	      }
	    }
	
	    // parse
	    debug('parse %s', uri);
	    obj = parseuri(uri);
	  }
	
	  // make sure we treat `localhost:80` and `localhost` equally
	  if (!obj.port) {
	    if (/^(http|ws)$/.test(obj.protocol)) {
	      obj.port = '80';
	    } else if (/^(http|ws)s$/.test(obj.protocol)) {
	      obj.port = '443';
	    }
	  }
	
	  obj.path = obj.path || '/';
	
	  var ipv6 = obj.host.indexOf(':') !== -1;
	  var host = ipv6 ? '[' + obj.host + ']' : obj.host;
	
	  // define unique id
	  obj.id = obj.protocol + '://' + host + ':' + obj.port;
	  // define href
	  obj.href = obj.protocol + '://' + host + (loc && loc.port === obj.port ? '' : (':' + obj.port));
	
	  return obj;
	}


/***/ }),

/***/ 705:
/***/ (function(module, exports) {

	/**
	 * Parses an URI
	 *
	 * @author Steven Levithan <stevenlevithan.com> (MIT license)
	 * @api private
	 */
	
	var re = /^(?:(?![^:@]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
	
	var parts = [
	    'source', 'protocol', 'authority', 'userInfo', 'user', 'password', 'host', 'port', 'relative', 'path', 'directory', 'file', 'query', 'anchor'
	];
	
	module.exports = function parseuri(str) {
	    var src = str,
	        b = str.indexOf('['),
	        e = str.indexOf(']');
	
	    if (b != -1 && e != -1) {
	        str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);
	    }
	
	    var m = re.exec(str || ''),
	        uri = {},
	        i = 14;
	
	    while (i--) {
	        uri[parts[i]] = m[i] || '';
	    }
	
	    if (b != -1 && e != -1) {
	        uri.source = src;
	        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');
	        uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');
	        uri.ipv6uri = true;
	    }
	
	    uri.pathNames = pathNames(uri, uri['path']);
	    uri.queryKey = queryKey(uri, uri['query']);
	
	    return uri;
	};
	
	function pathNames(obj, path) {
	    var regx = /\/{2,9}/g,
	        names = path.replace(regx, "/").split("/");
	
	    if (path.substr(0, 1) == '/' || path.length === 0) {
	        names.splice(0, 1);
	    }
	    if (path.substr(path.length - 1, 1) == '/') {
	        names.splice(names.length - 1, 1);
	    }
	
	    return names;
	}
	
	function queryKey(uri, query) {
	    var data = {};
	
	    query.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function ($0, $1, $2) {
	        if ($1) {
	            data[$1] = $2;
	        }
	    });
	
	    return data;
	}


/***/ }),

/***/ 706:
[1022, 707],

/***/ 707:
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = __webpack_require__(708);
	
	/**
	 * Active `debug` instances.
	 */
	exports.instances = [];
	
	/**
	 * The currently active debug mode names, and names to skip.
	 */
	
	exports.names = [];
	exports.skips = [];
	
	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	 */
	
	exports.formatters = {};
	
	/**
	 * Select a color.
	 * @param {String} namespace
	 * @return {Number}
	 * @api private
	 */
	
	function selectColor(namespace) {
	  var hash = 0, i;
	
	  for (i in namespace) {
	    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
	    hash |= 0; // Convert to 32bit integer
	  }
	
	  return exports.colors[Math.abs(hash) % exports.colors.length];
	}
	
	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */
	
	function createDebug(namespace) {
	
	  var prevTime;
	
	  function debug() {
	    // disabled?
	    if (!debug.enabled) return;
	
	    var self = debug;
	
	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;
	
	    // turn the `arguments` into a proper Array
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	
	    args[0] = exports.coerce(args[0]);
	
	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %O
	      args.unshift('%O');
	    }
	
	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') return match;
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);
	
	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });
	
	    // apply env-specific formatting (colors, etc.)
	    exports.formatArgs.call(self, args);
	
	    var logFn = debug.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }
	
	  debug.namespace = namespace;
	  debug.enabled = exports.enabled(namespace);
	  debug.useColors = exports.useColors();
	  debug.color = selectColor(namespace);
	  debug.destroy = destroy;
	
	  // env-specific initialization logic for debug instances
	  if ('function' === typeof exports.init) {
	    exports.init(debug);
	  }
	
	  exports.instances.push(debug);
	
	  return debug;
	}
	
	function destroy () {
	  var index = exports.instances.indexOf(this);
	  if (index !== -1) {
	    exports.instances.splice(index, 1);
	    return true;
	  } else {
	    return false;
	  }
	}
	
	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */
	
	function enable(namespaces) {
	  exports.save(namespaces);
	
	  exports.names = [];
	  exports.skips = [];
	
	  var i;
	  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
	  var len = split.length;
	
	  for (i = 0; i < len; i++) {
	    if (!split[i]) continue; // ignore empty strings
	    namespaces = split[i].replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }
	
	  for (i = 0; i < exports.instances.length; i++) {
	    var instance = exports.instances[i];
	    instance.enabled = exports.enabled(instance.namespace);
	  }
	}
	
	/**
	 * Disable debug output.
	 *
	 * @api public
	 */
	
	function disable() {
	  exports.enable('');
	}
	
	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */
	
	function enabled(name) {
	  if (name[name.length - 1] === '*') {
	    return true;
	  }
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */
	
	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}


/***/ }),

/***/ 708:
/***/ (function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000;
	var m = s * 60;
	var h = m * 60;
	var d = h * 24;
	var y = d * 365.25;
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} [options]
	 * @throws {Error} throw an error if val is not a non-empty string or a number
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function(val, options) {
	  options = options || {};
	  var type = typeof val;
	  if (type === 'string' && val.length > 0) {
	    return parse(val);
	  } else if (type === 'number' && isNaN(val) === false) {
	    return options.long ? fmtLong(val) : fmtShort(val);
	  }
	  throw new Error(
	    'val is not a non-empty string or a valid number. val=' +
	      JSON.stringify(val)
	  );
	};
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = String(str);
	  if (str.length > 100) {
	    return;
	  }
	  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
	    str
	  );
	  if (!match) {
	    return;
	  }
	  var n = parseFloat(match[1]);
	  var type = (match[2] || 'ms').toLowerCase();
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y;
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d;
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h;
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m;
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s;
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n;
	    default:
	      return undefined;
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtShort(ms) {
	  if (ms >= d) {
	    return Math.round(ms / d) + 'd';
	  }
	  if (ms >= h) {
	    return Math.round(ms / h) + 'h';
	  }
	  if (ms >= m) {
	    return Math.round(ms / m) + 'm';
	  }
	  if (ms >= s) {
	    return Math.round(ms / s) + 's';
	  }
	  return ms + 'ms';
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtLong(ms) {
	  return plural(ms, d, 'day') ||
	    plural(ms, h, 'hour') ||
	    plural(ms, m, 'minute') ||
	    plural(ms, s, 'second') ||
	    ms + ' ms';
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, n, name) {
	  if (ms < n) {
	    return;
	  }
	  if (ms < n * 1.5) {
	    return Math.floor(ms / n) + ' ' + name;
	  }
	  return Math.ceil(ms / n) + ' ' + name + 's';
	}


/***/ }),

/***/ 709:
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var debug = __webpack_require__(706)('socket.io-parser');
	var Emitter = __webpack_require__(710);
	var binary = __webpack_require__(711);
	var isArray = __webpack_require__(712);
	var isBuf = __webpack_require__(713);
	
	/**
	 * Protocol version.
	 *
	 * @api public
	 */
	
	exports.protocol = 4;
	
	/**
	 * Packet types.
	 *
	 * @api public
	 */
	
	exports.types = [
	  'CONNECT',
	  'DISCONNECT',
	  'EVENT',
	  'ACK',
	  'ERROR',
	  'BINARY_EVENT',
	  'BINARY_ACK'
	];
	
	/**
	 * Packet type `connect`.
	 *
	 * @api public
	 */
	
	exports.CONNECT = 0;
	
	/**
	 * Packet type `disconnect`.
	 *
	 * @api public
	 */
	
	exports.DISCONNECT = 1;
	
	/**
	 * Packet type `event`.
	 *
	 * @api public
	 */
	
	exports.EVENT = 2;
	
	/**
	 * Packet type `ack`.
	 *
	 * @api public
	 */
	
	exports.ACK = 3;
	
	/**
	 * Packet type `error`.
	 *
	 * @api public
	 */
	
	exports.ERROR = 4;
	
	/**
	 * Packet type 'binary event'
	 *
	 * @api public
	 */
	
	exports.BINARY_EVENT = 5;
	
	/**
	 * Packet type `binary ack`. For acks with binary arguments.
	 *
	 * @api public
	 */
	
	exports.BINARY_ACK = 6;
	
	/**
	 * Encoder constructor.
	 *
	 * @api public
	 */
	
	exports.Encoder = Encoder;
	
	/**
	 * Decoder constructor.
	 *
	 * @api public
	 */
	
	exports.Decoder = Decoder;
	
	/**
	 * A socket.io Encoder instance
	 *
	 * @api public
	 */
	
	function Encoder() {}
	
	var ERROR_PACKET = exports.ERROR + '"encode error"';
	
	/**
	 * Encode a packet as a single string if non-binary, or as a
	 * buffer sequence, depending on packet type.
	 *
	 * @param {Object} obj - packet object
	 * @param {Function} callback - function to handle encodings (likely engine.write)
	 * @return Calls callback with Array of encodings
	 * @api public
	 */
	
	Encoder.prototype.encode = function(obj, callback){
	  debug('encoding packet %j', obj);
	
	  if (exports.BINARY_EVENT === obj.type || exports.BINARY_ACK === obj.type) {
	    encodeAsBinary(obj, callback);
	  } else {
	    var encoding = encodeAsString(obj);
	    callback([encoding]);
	  }
	};
	
	/**
	 * Encode packet as string.
	 *
	 * @param {Object} packet
	 * @return {String} encoded
	 * @api private
	 */
	
	function encodeAsString(obj) {
	
	  // first is type
	  var str = '' + obj.type;
	
	  // attachments if we have them
	  if (exports.BINARY_EVENT === obj.type || exports.BINARY_ACK === obj.type) {
	    str += obj.attachments + '-';
	  }
	
	  // if we have a namespace other than `/`
	  // we append it followed by a comma `,`
	  if (obj.nsp && '/' !== obj.nsp) {
	    str += obj.nsp + ',';
	  }
	
	  // immediately followed by the id
	  if (null != obj.id) {
	    str += obj.id;
	  }
	
	  // json data
	  if (null != obj.data) {
	    var payload = tryStringify(obj.data);
	    if (payload !== false) {
	      str += payload;
	    } else {
	      return ERROR_PACKET;
	    }
	  }
	
	  debug('encoded %j as %s', obj, str);
	  return str;
	}
	
	function tryStringify(str) {
	  try {
	    return JSON.stringify(str);
	  } catch(e){
	    return false;
	  }
	}
	
	/**
	 * Encode packet as 'buffer sequence' by removing blobs, and
	 * deconstructing packet into object with placeholders and
	 * a list of buffers.
	 *
	 * @param {Object} packet
	 * @return {Buffer} encoded
	 * @api private
	 */
	
	function encodeAsBinary(obj, callback) {
	
	  function writeEncoding(bloblessData) {
	    var deconstruction = binary.deconstructPacket(bloblessData);
	    var pack = encodeAsString(deconstruction.packet);
	    var buffers = deconstruction.buffers;
	
	    buffers.unshift(pack); // add packet info to beginning of data list
	    callback(buffers); // write all the buffers
	  }
	
	  binary.removeBlobs(obj, writeEncoding);
	}
	
	/**
	 * A socket.io Decoder instance
	 *
	 * @return {Object} decoder
	 * @api public
	 */
	
	function Decoder() {
	  this.reconstructor = null;
	}
	
	/**
	 * Mix in `Emitter` with Decoder.
	 */
	
	Emitter(Decoder.prototype);
	
	/**
	 * Decodes an encoded packet string into packet JSON.
	 *
	 * @param {String} obj - encoded packet
	 * @return {Object} packet
	 * @api public
	 */
	
	Decoder.prototype.add = function(obj) {
	  var packet;
	  if (typeof obj === 'string') {
	    if (this.reconstructor) {
	      throw new Error("got plaintext data when reconstructing a packet");
	    }
	    packet = decodeString(obj);
	    if (exports.BINARY_EVENT === packet.type || exports.BINARY_ACK === packet.type) { // binary packet's json
	      this.reconstructor = new BinaryReconstructor(packet);
	
	      // no attachments, labeled binary but no binary data to follow
	      if (this.reconstructor.reconPack.attachments === 0) {
	        this.emit('decoded', packet);
	      }
	    } else { // non-binary full packet
	      this.emit('decoded', packet);
	    }
	  } else if (isBuf(obj) || obj.base64) { // raw binary data
	    if (!this.reconstructor) {
	      throw new Error('got binary data when not reconstructing a packet');
	    } else {
	      packet = this.reconstructor.takeBinaryData(obj);
	      if (packet) { // received final buffer
	        this.reconstructor = null;
	        this.emit('decoded', packet);
	      }
	    }
	  } else {
	    throw new Error('Unknown type: ' + obj);
	  }
	};
	
	function isPayloadValid(type, payload) {
	  switch (type) {
	    case 0: // CONNECT
	      return typeof payload === "object";
	    case 1: // DISCONNECT
	      return payload === undefined;
	    case 4: // ERROR
	      return typeof payload === "string" || typeof payload === "object";
	    case 2: // EVENT
	    case 5: // BINARY_EVENT
	      return (
	        isArray(payload) &&
	        (typeof payload[0] === "string" || typeof payload[0] === "number")
	      );
	    case 3: // ACK
	    case 6: // BINARY_ACK
	      return isArray(payload);
	  }
	}
	
	/**
	 * Decode a packet String (JSON data)
	 *
	 * @param {String} str
	 * @return {Object} packet
	 * @api private
	 */
	
	function decodeString(str) {
	  var i = 0;
	  // look up type
	  var p = {
	    type: Number(str.charAt(0))
	  };
	
	  if (null == exports.types[p.type]) {
	    return error('unknown packet type ' + p.type);
	  }
	
	  // look up attachments if type binary
	  if (exports.BINARY_EVENT === p.type || exports.BINARY_ACK === p.type) {
	    var start = i + 1;
	    while (str.charAt(++i) !== '-' && i != str.length) {}
	    var buf = str.substring(start, i);
	    if (buf != Number(buf) || str.charAt(i) !== '-') {
	      throw new Error('Illegal attachments');
	    }
	    p.attachments = Number(buf);
	  }
	
	  // look up namespace (if any)
	  if ('/' === str.charAt(i + 1)) {
	    var start = i + 1;
	    while (++i) {
	      var c = str.charAt(i);
	      if (',' === c) break;
	      if (i === str.length) break;
	    }
	    p.nsp = str.substring(start, i);
	  } else {
	    p.nsp = '/';
	  }
	
	  // look up id
	  var next = str.charAt(i + 1);
	  if ('' !== next && Number(next) == next) {
	    var start = i + 1;
	    while (++i) {
	      var c = str.charAt(i);
	      if (null == c || Number(c) != c) {
	        --i;
	        break;
	      }
	      if (i === str.length) break;
	    }
	    p.id = Number(str.substring(start, i + 1));
	  }
	
	  // look up json data
	  if (str.charAt(++i)) {
	    var payload = tryParse(str.substr(i));
	    if (isPayloadValid(p.type, payload)) {
	      p.data = payload;
	    } else {
	      throw new Error("invalid payload");
	    }
	  }
	
	  debug('decoded %s as %j', str, p);
	  return p;
	}
	
	function tryParse(str) {
	  try {
	    return JSON.parse(str);
	  } catch(e){
	    return false;
	  }
	}
	
	/**
	 * Deallocates a parser's resources
	 *
	 * @api public
	 */
	
	Decoder.prototype.destroy = function() {
	  if (this.reconstructor) {
	    this.reconstructor.finishedReconstruction();
	  }
	};
	
	/**
	 * A manager of a binary event's 'buffer sequence'. Should
	 * be constructed whenever a packet of type BINARY_EVENT is
	 * decoded.
	 *
	 * @param {Object} packet
	 * @return {BinaryReconstructor} initialized reconstructor
	 * @api private
	 */
	
	function BinaryReconstructor(packet) {
	  this.reconPack = packet;
	  this.buffers = [];
	}
	
	/**
	 * Method to be called when binary data received from connection
	 * after a BINARY_EVENT packet.
	 *
	 * @param {Buffer | ArrayBuffer} binData - the raw binary data received
	 * @return {null | Object} returns null if more binary data is expected or
	 *   a reconstructed packet object if all buffers have been received.
	 * @api private
	 */
	
	BinaryReconstructor.prototype.takeBinaryData = function(binData) {
	  this.buffers.push(binData);
	  if (this.buffers.length === this.reconPack.attachments) { // done with buffer list
	    var packet = binary.reconstructPacket(this.reconPack, this.buffers);
	    this.finishedReconstruction();
	    return packet;
	  }
	  return null;
	};
	
	/**
	 * Cleans up binary packet reconstruction variables.
	 *
	 * @api private
	 */
	
	BinaryReconstructor.prototype.finishedReconstruction = function() {
	  this.reconPack = null;
	  this.buffers = [];
	};
	
	function error(msg) {
	  return {
	    type: exports.ERROR,
	    data: 'parser error: ' + msg
	  };
	}


/***/ }),

/***/ 710:
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Expose `Emitter`.
	 */
	
	if (true) {
	  module.exports = Emitter;
	}
	
	/**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */
	
	function Emitter(obj) {
	  if (obj) return mixin(obj);
	};
	
	/**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in Emitter.prototype) {
	    obj[key] = Emitter.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.on =
	Emitter.prototype.addEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
	    .push(fn);
	  return this;
	};
	
	/**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.once = function(event, fn){
	  function on() {
	    this.off(event, on);
	    fn.apply(this, arguments);
	  }
	
	  on.fn = fn;
	  this.on(event, on);
	  return this;
	};
	
	/**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.off =
	Emitter.prototype.removeListener =
	Emitter.prototype.removeAllListeners =
	Emitter.prototype.removeEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	
	  // all
	  if (0 == arguments.length) {
	    this._callbacks = {};
	    return this;
	  }
	
	  // specific event
	  var callbacks = this._callbacks['$' + event];
	  if (!callbacks) return this;
	
	  // remove all handlers
	  if (1 == arguments.length) {
	    delete this._callbacks['$' + event];
	    return this;
	  }
	
	  // remove specific handler
	  var cb;
	  for (var i = 0; i < callbacks.length; i++) {
	    cb = callbacks[i];
	    if (cb === fn || cb.fn === fn) {
	      callbacks.splice(i, 1);
	      break;
	    }
	  }
	
	  // Remove event specific arrays for event types that no
	  // one is subscribed for to avoid memory leak.
	  if (callbacks.length === 0) {
	    delete this._callbacks['$' + event];
	  }
	
	  return this;
	};
	
	/**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */
	
	Emitter.prototype.emit = function(event){
	  this._callbacks = this._callbacks || {};
	
	  var args = new Array(arguments.length - 1)
	    , callbacks = this._callbacks['$' + event];
	
	  for (var i = 1; i < arguments.length; i++) {
	    args[i - 1] = arguments[i];
	  }
	
	  if (callbacks) {
	    callbacks = callbacks.slice(0);
	    for (var i = 0, len = callbacks.length; i < len; ++i) {
	      callbacks[i].apply(this, args);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */
	
	Emitter.prototype.listeners = function(event){
	  this._callbacks = this._callbacks || {};
	  return this._callbacks['$' + event] || [];
	};
	
	/**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */
	
	Emitter.prototype.hasListeners = function(event){
	  return !! this.listeners(event).length;
	};


/***/ }),

/***/ 711:
/***/ (function(module, exports, __webpack_require__) {

	/*global Blob,File*/
	
	/**
	 * Module requirements
	 */
	
	var isArray = __webpack_require__(712);
	var isBuf = __webpack_require__(713);
	var toString = Object.prototype.toString;
	var withNativeBlob = typeof Blob === 'function' || (typeof Blob !== 'undefined' && toString.call(Blob) === '[object BlobConstructor]');
	var withNativeFile = typeof File === 'function' || (typeof File !== 'undefined' && toString.call(File) === '[object FileConstructor]');
	
	/**
	 * Replaces every Buffer | ArrayBuffer in packet with a numbered placeholder.
	 * Anything with blobs or files should be fed through removeBlobs before coming
	 * here.
	 *
	 * @param {Object} packet - socket.io event packet
	 * @return {Object} with deconstructed packet and list of buffers
	 * @api public
	 */
	
	exports.deconstructPacket = function(packet) {
	  var buffers = [];
	  var packetData = packet.data;
	  var pack = packet;
	  pack.data = _deconstructPacket(packetData, buffers);
	  pack.attachments = buffers.length; // number of binary 'attachments'
	  return {packet: pack, buffers: buffers};
	};
	
	function _deconstructPacket(data, buffers) {
	  if (!data) return data;
	
	  if (isBuf(data)) {
	    var placeholder = { _placeholder: true, num: buffers.length };
	    buffers.push(data);
	    return placeholder;
	  } else if (isArray(data)) {
	    var newData = new Array(data.length);
	    for (var i = 0; i < data.length; i++) {
	      newData[i] = _deconstructPacket(data[i], buffers);
	    }
	    return newData;
	  } else if (typeof data === 'object' && !(data instanceof Date)) {
	    var newData = {};
	    for (var key in data) {
	      newData[key] = _deconstructPacket(data[key], buffers);
	    }
	    return newData;
	  }
	  return data;
	}
	
	/**
	 * Reconstructs a binary packet from its placeholder packet and buffers
	 *
	 * @param {Object} packet - event packet with placeholders
	 * @param {Array} buffers - binary buffers to put in placeholder positions
	 * @return {Object} reconstructed packet
	 * @api public
	 */
	
	exports.reconstructPacket = function(packet, buffers) {
	  packet.data = _reconstructPacket(packet.data, buffers);
	  packet.attachments = undefined; // no longer useful
	  return packet;
	};
	
	function _reconstructPacket(data, buffers) {
	  if (!data) return data;
	
	  if (data && data._placeholder === true) {
	    var isIndexValid =
	      typeof data.num === "number" &&
	      data.num >= 0 &&
	      data.num < buffers.length;
	    if (isIndexValid) {
	      return buffers[data.num]; // appropriate buffer (should be natural order anyway)
	    } else {
	      throw new Error("illegal attachments");
	    }
	  } else if (isArray(data)) {
	    for (var i = 0; i < data.length; i++) {
	      data[i] = _reconstructPacket(data[i], buffers);
	    }
	  } else if (typeof data === 'object') {
	    for (var key in data) {
	      data[key] = _reconstructPacket(data[key], buffers);
	    }
	  }
	
	  return data;
	}
	
	/**
	 * Asynchronously removes Blobs or Files from data via
	 * FileReader's readAsArrayBuffer method. Used before encoding
	 * data as msgpack. Calls callback with the blobless data.
	 *
	 * @param {Object} data
	 * @param {Function} callback
	 * @api private
	 */
	
	exports.removeBlobs = function(data, callback) {
	  function _removeBlobs(obj, curKey, containingObject) {
	    if (!obj) return obj;
	
	    // convert any blob
	    if ((withNativeBlob && obj instanceof Blob) ||
	        (withNativeFile && obj instanceof File)) {
	      pendingBlobs++;
	
	      // async filereader
	      var fileReader = new FileReader();
	      fileReader.onload = function() { // this.result == arraybuffer
	        if (containingObject) {
	          containingObject[curKey] = this.result;
	        }
	        else {
	          bloblessData = this.result;
	        }
	
	        // if nothing pending its callback time
	        if(! --pendingBlobs) {
	          callback(bloblessData);
	        }
	      };
	
	      fileReader.readAsArrayBuffer(obj); // blob -> arraybuffer
	    } else if (isArray(obj)) { // handle array
	      for (var i = 0; i < obj.length; i++) {
	        _removeBlobs(obj[i], i, obj);
	      }
	    } else if (typeof obj === 'object' && !isBuf(obj)) { // and object
	      for (var key in obj) {
	        _removeBlobs(obj[key], key, obj);
	      }
	    }
	  }
	
	  var pendingBlobs = 0;
	  var bloblessData = data;
	  _removeBlobs(bloblessData);
	  if (!pendingBlobs) {
	    callback(bloblessData);
	  }
	};


/***/ }),

/***/ 712:
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ }),

/***/ 713:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {
	module.exports = isBuf;
	
	var withNativeBuffer = typeof Buffer === 'function' && typeof Buffer.isBuffer === 'function';
	var withNativeArrayBuffer = typeof ArrayBuffer === 'function';
	
	var isView = function (obj) {
	  return typeof ArrayBuffer.isView === 'function' ? ArrayBuffer.isView(obj) : (obj.buffer instanceof ArrayBuffer);
	};
	
	/**
	 * Returns true if obj is a buffer or an arraybuffer.
	 *
	 * @api private
	 */
	
	function isBuf(obj) {
	  return (withNativeBuffer && Buffer.isBuffer(obj)) ||
	          (withNativeArrayBuffer && (obj instanceof ArrayBuffer || isView(obj)));
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(714).Buffer))

/***/ }),

/***/ 714:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(715)
	var ieee754 = __webpack_require__(716)
	var isArray = __webpack_require__(717)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 715:
/***/ (function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  var i
	  for (i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ }),

/***/ 716:
/***/ (function(module, exports) {

	/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ }),

/***/ 717:
712,

/***/ 718:
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var eio = __webpack_require__(719);
	var Socket = __webpack_require__(746);
	var Emitter = __webpack_require__(710);
	var parser = __webpack_require__(709);
	var on = __webpack_require__(748);
	var bind = __webpack_require__(749);
	var debug = __webpack_require__(706)('socket.io-client:manager');
	var indexOf = __webpack_require__(745);
	var Backoff = __webpack_require__(750);
	
	/**
	 * IE6+ hasOwnProperty
	 */
	
	var has = Object.prototype.hasOwnProperty;
	
	/**
	 * Module exports
	 */
	
	module.exports = Manager;
	
	/**
	 * `Manager` constructor.
	 *
	 * @param {String} engine instance or engine uri/opts
	 * @param {Object} options
	 * @api public
	 */
	
	function Manager (uri, opts) {
	  if (!(this instanceof Manager)) return new Manager(uri, opts);
	  if (uri && ('object' === typeof uri)) {
	    opts = uri;
	    uri = undefined;
	  }
	  opts = opts || {};
	
	  opts.path = opts.path || '/socket.io';
	  this.nsps = {};
	  this.subs = [];
	  this.opts = opts;
	  this.reconnection(opts.reconnection !== false);
	  this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
	  this.reconnectionDelay(opts.reconnectionDelay || 1000);
	  this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
	  this.randomizationFactor(opts.randomizationFactor || 0.5);
	  this.backoff = new Backoff({
	    min: this.reconnectionDelay(),
	    max: this.reconnectionDelayMax(),
	    jitter: this.randomizationFactor()
	  });
	  this.timeout(null == opts.timeout ? 20000 : opts.timeout);
	  this.readyState = 'closed';
	  this.uri = uri;
	  this.connecting = [];
	  this.lastPing = null;
	  this.encoding = false;
	  this.packetBuffer = [];
	  var _parser = opts.parser || parser;
	  this.encoder = new _parser.Encoder();
	  this.decoder = new _parser.Decoder();
	  this.autoConnect = opts.autoConnect !== false;
	  if (this.autoConnect) this.open();
	}
	
	/**
	 * Propagate given event to sockets and emit on `this`
	 *
	 * @api private
	 */
	
	Manager.prototype.emitAll = function () {
	  this.emit.apply(this, arguments);
	  for (var nsp in this.nsps) {
	    if (has.call(this.nsps, nsp)) {
	      this.nsps[nsp].emit.apply(this.nsps[nsp], arguments);
	    }
	  }
	};
	
	/**
	 * Update `socket.id` of all sockets
	 *
	 * @api private
	 */
	
	Manager.prototype.updateSocketIds = function () {
	  for (var nsp in this.nsps) {
	    if (has.call(this.nsps, nsp)) {
	      this.nsps[nsp].id = this.generateId(nsp);
	    }
	  }
	};
	
	/**
	 * generate `socket.id` for the given `nsp`
	 *
	 * @param {String} nsp
	 * @return {String}
	 * @api private
	 */
	
	Manager.prototype.generateId = function (nsp) {
	  return (nsp === '/' ? '' : (nsp + '#')) + this.engine.id;
	};
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Manager.prototype);
	
	/**
	 * Sets the `reconnection` config.
	 *
	 * @param {Boolean} true/false if it should automatically reconnect
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.reconnection = function (v) {
	  if (!arguments.length) return this._reconnection;
	  this._reconnection = !!v;
	  return this;
	};
	
	/**
	 * Sets the reconnection attempts config.
	 *
	 * @param {Number} max reconnection attempts before giving up
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.reconnectionAttempts = function (v) {
	  if (!arguments.length) return this._reconnectionAttempts;
	  this._reconnectionAttempts = v;
	  return this;
	};
	
	/**
	 * Sets the delay between reconnections.
	 *
	 * @param {Number} delay
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.reconnectionDelay = function (v) {
	  if (!arguments.length) return this._reconnectionDelay;
	  this._reconnectionDelay = v;
	  this.backoff && this.backoff.setMin(v);
	  return this;
	};
	
	Manager.prototype.randomizationFactor = function (v) {
	  if (!arguments.length) return this._randomizationFactor;
	  this._randomizationFactor = v;
	  this.backoff && this.backoff.setJitter(v);
	  return this;
	};
	
	/**
	 * Sets the maximum delay between reconnections.
	 *
	 * @param {Number} delay
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.reconnectionDelayMax = function (v) {
	  if (!arguments.length) return this._reconnectionDelayMax;
	  this._reconnectionDelayMax = v;
	  this.backoff && this.backoff.setMax(v);
	  return this;
	};
	
	/**
	 * Sets the connection timeout. `false` to disable
	 *
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.timeout = function (v) {
	  if (!arguments.length) return this._timeout;
	  this._timeout = v;
	  return this;
	};
	
	/**
	 * Starts trying to reconnect if reconnection is enabled and we have not
	 * started reconnecting yet
	 *
	 * @api private
	 */
	
	Manager.prototype.maybeReconnectOnOpen = function () {
	  // Only try to reconnect if it's the first time we're connecting
	  if (!this.reconnecting && this._reconnection && this.backoff.attempts === 0) {
	    // keeps reconnection from firing twice for the same reconnection loop
	    this.reconnect();
	  }
	};
	
	/**
	 * Sets the current transport `socket`.
	 *
	 * @param {Function} optional, callback
	 * @return {Manager} self
	 * @api public
	 */
	
	Manager.prototype.open =
	Manager.prototype.connect = function (fn, opts) {
	  debug('readyState %s', this.readyState);
	  if (~this.readyState.indexOf('open')) return this;
	
	  debug('opening %s', this.uri);
	  this.engine = eio(this.uri, this.opts);
	  var socket = this.engine;
	  var self = this;
	  this.readyState = 'opening';
	  this.skipReconnect = false;
	
	  // emit `open`
	  var openSub = on(socket, 'open', function () {
	    self.onopen();
	    fn && fn();
	  });
	
	  // emit `connect_error`
	  var errorSub = on(socket, 'error', function (data) {
	    debug('connect_error');
	    self.cleanup();
	    self.readyState = 'closed';
	    self.emitAll('connect_error', data);
	    if (fn) {
	      var err = new Error('Connection error');
	      err.data = data;
	      fn(err);
	    } else {
	      // Only do this if there is no fn to handle the error
	      self.maybeReconnectOnOpen();
	    }
	  });
	
	  // emit `connect_timeout`
	  if (false !== this._timeout) {
	    var timeout = this._timeout;
	    debug('connect attempt will timeout after %d', timeout);
	
	    if (timeout === 0) {
	      openSub.destroy(); // prevents a race condition with the 'open' event
	    }
	
	    // set timer
	    var timer = setTimeout(function () {
	      debug('connect attempt timed out after %d', timeout);
	      openSub.destroy();
	      socket.close();
	      socket.emit('error', 'timeout');
	      self.emitAll('connect_timeout', timeout);
	    }, timeout);
	
	    this.subs.push({
	      destroy: function () {
	        clearTimeout(timer);
	      }
	    });
	  }
	
	  this.subs.push(openSub);
	  this.subs.push(errorSub);
	
	  return this;
	};
	
	/**
	 * Called upon transport open.
	 *
	 * @api private
	 */
	
	Manager.prototype.onopen = function () {
	  debug('open');
	
	  // clear old subs
	  this.cleanup();
	
	  // mark as open
	  this.readyState = 'open';
	  this.emit('open');
	
	  // add new subs
	  var socket = this.engine;
	  this.subs.push(on(socket, 'data', bind(this, 'ondata')));
	  this.subs.push(on(socket, 'ping', bind(this, 'onping')));
	  this.subs.push(on(socket, 'pong', bind(this, 'onpong')));
	  this.subs.push(on(socket, 'error', bind(this, 'onerror')));
	  this.subs.push(on(socket, 'close', bind(this, 'onclose')));
	  this.subs.push(on(this.decoder, 'decoded', bind(this, 'ondecoded')));
	};
	
	/**
	 * Called upon a ping.
	 *
	 * @api private
	 */
	
	Manager.prototype.onping = function () {
	  this.lastPing = new Date();
	  this.emitAll('ping');
	};
	
	/**
	 * Called upon a packet.
	 *
	 * @api private
	 */
	
	Manager.prototype.onpong = function () {
	  this.emitAll('pong', new Date() - this.lastPing);
	};
	
	/**
	 * Called with data.
	 *
	 * @api private
	 */
	
	Manager.prototype.ondata = function (data) {
	  this.decoder.add(data);
	};
	
	/**
	 * Called when parser fully decodes a packet.
	 *
	 * @api private
	 */
	
	Manager.prototype.ondecoded = function (packet) {
	  this.emit('packet', packet);
	};
	
	/**
	 * Called upon socket error.
	 *
	 * @api private
	 */
	
	Manager.prototype.onerror = function (err) {
	  debug('error', err);
	  this.emitAll('error', err);
	};
	
	/**
	 * Creates a new socket for the given `nsp`.
	 *
	 * @return {Socket}
	 * @api public
	 */
	
	Manager.prototype.socket = function (nsp, opts) {
	  var socket = this.nsps[nsp];
	  if (!socket) {
	    socket = new Socket(this, nsp, opts);
	    this.nsps[nsp] = socket;
	    var self = this;
	    socket.on('connecting', onConnecting);
	    socket.on('connect', function () {
	      socket.id = self.generateId(nsp);
	    });
	
	    if (this.autoConnect) {
	      // manually call here since connecting event is fired before listening
	      onConnecting();
	    }
	  }
	
	  function onConnecting () {
	    if (!~indexOf(self.connecting, socket)) {
	      self.connecting.push(socket);
	    }
	  }
	
	  return socket;
	};
	
	/**
	 * Called upon a socket close.
	 *
	 * @param {Socket} socket
	 */
	
	Manager.prototype.destroy = function (socket) {
	  var index = indexOf(this.connecting, socket);
	  if (~index) this.connecting.splice(index, 1);
	  if (this.connecting.length) return;
	
	  this.close();
	};
	
	/**
	 * Writes a packet.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Manager.prototype.packet = function (packet) {
	  debug('writing packet %j', packet);
	  var self = this;
	  if (packet.query && packet.type === 0) packet.nsp += '?' + packet.query;
	
	  if (!self.encoding) {
	    // encode, then write to engine with result
	    self.encoding = true;
	    this.encoder.encode(packet, function (encodedPackets) {
	      for (var i = 0; i < encodedPackets.length; i++) {
	        self.engine.write(encodedPackets[i], packet.options);
	      }
	      self.encoding = false;
	      self.processPacketQueue();
	    });
	  } else { // add packet to the queue
	    self.packetBuffer.push(packet);
	  }
	};
	
	/**
	 * If packet buffer is non-empty, begins encoding the
	 * next packet in line.
	 *
	 * @api private
	 */
	
	Manager.prototype.processPacketQueue = function () {
	  if (this.packetBuffer.length > 0 && !this.encoding) {
	    var pack = this.packetBuffer.shift();
	    this.packet(pack);
	  }
	};
	
	/**
	 * Clean up transport subscriptions and packet buffer.
	 *
	 * @api private
	 */
	
	Manager.prototype.cleanup = function () {
	  debug('cleanup');
	
	  var subsLength = this.subs.length;
	  for (var i = 0; i < subsLength; i++) {
	    var sub = this.subs.shift();
	    sub.destroy();
	  }
	
	  this.packetBuffer = [];
	  this.encoding = false;
	  this.lastPing = null;
	
	  this.decoder.destroy();
	};
	
	/**
	 * Close the current socket.
	 *
	 * @api private
	 */
	
	Manager.prototype.close =
	Manager.prototype.disconnect = function () {
	  debug('disconnect');
	  this.skipReconnect = true;
	  this.reconnecting = false;
	  if ('opening' === this.readyState) {
	    // `onclose` will not fire because
	    // an open event never happened
	    this.cleanup();
	  }
	  this.backoff.reset();
	  this.readyState = 'closed';
	  if (this.engine) this.engine.close();
	};
	
	/**
	 * Called upon engine close.
	 *
	 * @api private
	 */
	
	Manager.prototype.onclose = function (reason) {
	  debug('onclose');
	
	  this.cleanup();
	  this.backoff.reset();
	  this.readyState = 'closed';
	  this.emit('close', reason);
	
	  if (this._reconnection && !this.skipReconnect) {
	    this.reconnect();
	  }
	};
	
	/**
	 * Attempt a reconnection.
	 *
	 * @api private
	 */
	
	Manager.prototype.reconnect = function () {
	  if (this.reconnecting || this.skipReconnect) return this;
	
	  var self = this;
	
	  if (this.backoff.attempts >= this._reconnectionAttempts) {
	    debug('reconnect failed');
	    this.backoff.reset();
	    this.emitAll('reconnect_failed');
	    this.reconnecting = false;
	  } else {
	    var delay = this.backoff.duration();
	    debug('will wait %dms before reconnect attempt', delay);
	
	    this.reconnecting = true;
	    var timer = setTimeout(function () {
	      if (self.skipReconnect) return;
	
	      debug('attempting reconnect');
	      self.emitAll('reconnect_attempt', self.backoff.attempts);
	      self.emitAll('reconnecting', self.backoff.attempts);
	
	      // check again for the case socket closed in above events
	      if (self.skipReconnect) return;
	
	      self.open(function (err) {
	        if (err) {
	          debug('reconnect attempt error');
	          self.reconnecting = false;
	          self.reconnect();
	          self.emitAll('reconnect_error', err.data);
	        } else {
	          debug('reconnect success');
	          self.onreconnect();
	        }
	      });
	    }, delay);
	
	    this.subs.push({
	      destroy: function () {
	        clearTimeout(timer);
	      }
	    });
	  }
	};
	
	/**
	 * Called upon successful reconnect.
	 *
	 * @api private
	 */
	
	Manager.prototype.onreconnect = function () {
	  var attempt = this.backoff.attempts;
	  this.reconnecting = false;
	  this.backoff.reset();
	  this.updateSocketIds();
	  this.emitAll('reconnect', attempt);
	};


/***/ }),

/***/ 719:
/***/ (function(module, exports, __webpack_require__) {

	
	module.exports = __webpack_require__(720);
	
	/**
	 * Exports parser
	 *
	 * @api public
	 *
	 */
	module.exports.parser = __webpack_require__(728);


/***/ }),

/***/ 720:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	var transports = __webpack_require__(721);
	var Emitter = __webpack_require__(710);
	var debug = __webpack_require__(740)('engine.io-client:socket');
	var index = __webpack_require__(745);
	var parser = __webpack_require__(728);
	var parseuri = __webpack_require__(705);
	var parseqs = __webpack_require__(737);
	
	/**
	 * Module exports.
	 */
	
	module.exports = Socket;
	
	/**
	 * Socket constructor.
	 *
	 * @param {String|Object} uri or options
	 * @param {Object} options
	 * @api public
	 */
	
	function Socket (uri, opts) {
	  if (!(this instanceof Socket)) return new Socket(uri, opts);
	
	  opts = opts || {};
	
	  if (uri && 'object' === typeof uri) {
	    opts = uri;
	    uri = null;
	  }
	
	  if (uri) {
	    uri = parseuri(uri);
	    opts.hostname = uri.host;
	    opts.secure = uri.protocol === 'https' || uri.protocol === 'wss';
	    opts.port = uri.port;
	    if (uri.query) opts.query = uri.query;
	  } else if (opts.host) {
	    opts.hostname = parseuri(opts.host).host;
	  }
	
	  this.secure = null != opts.secure ? opts.secure
	    : (typeof location !== 'undefined' && 'https:' === location.protocol);
	
	  if (opts.hostname && !opts.port) {
	    // if no port is specified manually, use the protocol default
	    opts.port = this.secure ? '443' : '80';
	  }
	
	  this.agent = opts.agent || false;
	  this.hostname = opts.hostname ||
	    (typeof location !== 'undefined' ? location.hostname : 'localhost');
	  this.port = opts.port || (typeof location !== 'undefined' && location.port
	      ? location.port
	      : (this.secure ? 443 : 80));
	  this.query = opts.query || {};
	  if ('string' === typeof this.query) this.query = parseqs.decode(this.query);
	  this.upgrade = false !== opts.upgrade;
	  this.path = (opts.path || '/engine.io').replace(/\/$/, '') + '/';
	  this.forceJSONP = !!opts.forceJSONP;
	  this.jsonp = false !== opts.jsonp;
	  this.forceBase64 = !!opts.forceBase64;
	  this.enablesXDR = !!opts.enablesXDR;
	  this.withCredentials = false !== opts.withCredentials;
	  this.timestampParam = opts.timestampParam || 't';
	  this.timestampRequests = opts.timestampRequests;
	  this.transports = opts.transports || ['polling', 'websocket'];
	  this.transportOptions = opts.transportOptions || {};
	  this.readyState = '';
	  this.writeBuffer = [];
	  this.prevBufferLen = 0;
	  this.policyPort = opts.policyPort || 843;
	  this.rememberUpgrade = opts.rememberUpgrade || false;
	  this.binaryType = null;
	  this.onlyBinaryUpgrades = opts.onlyBinaryUpgrades;
	  this.perMessageDeflate = false !== opts.perMessageDeflate ? (opts.perMessageDeflate || {}) : false;
	
	  if (true === this.perMessageDeflate) this.perMessageDeflate = {};
	  if (this.perMessageDeflate && null == this.perMessageDeflate.threshold) {
	    this.perMessageDeflate.threshold = 1024;
	  }
	
	  // SSL options for Node.js client
	  this.pfx = opts.pfx || undefined;
	  this.key = opts.key || undefined;
	  this.passphrase = opts.passphrase || undefined;
	  this.cert = opts.cert || undefined;
	  this.ca = opts.ca || undefined;
	  this.ciphers = opts.ciphers || undefined;
	  this.rejectUnauthorized = opts.rejectUnauthorized === undefined ? true : opts.rejectUnauthorized;
	  this.forceNode = !!opts.forceNode;
	
	  // detect ReactNative environment
	  this.isReactNative = (typeof navigator !== 'undefined' && typeof navigator.product === 'string' && navigator.product.toLowerCase() === 'reactnative');
	
	  // other options for Node.js or ReactNative client
	  if (typeof self === 'undefined' || this.isReactNative) {
	    if (opts.extraHeaders && Object.keys(opts.extraHeaders).length > 0) {
	      this.extraHeaders = opts.extraHeaders;
	    }
	
	    if (opts.localAddress) {
	      this.localAddress = opts.localAddress;
	    }
	  }
	
	  // set on handshake
	  this.id = null;
	  this.upgrades = null;
	  this.pingInterval = null;
	  this.pingTimeout = null;
	
	  // set on heartbeat
	  this.pingIntervalTimer = null;
	  this.pingTimeoutTimer = null;
	
	  this.open();
	}
	
	Socket.priorWebsocketSuccess = false;
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Socket.prototype);
	
	/**
	 * Protocol version.
	 *
	 * @api public
	 */
	
	Socket.protocol = parser.protocol; // this is an int
	
	/**
	 * Expose deps for legacy compatibility
	 * and standalone browser access.
	 */
	
	Socket.Socket = Socket;
	Socket.Transport = __webpack_require__(727);
	Socket.transports = __webpack_require__(721);
	Socket.parser = __webpack_require__(728);
	
	/**
	 * Creates transport of the given type.
	 *
	 * @param {String} transport name
	 * @return {Transport}
	 * @api private
	 */
	
	Socket.prototype.createTransport = function (name) {
	  debug('creating transport "%s"', name);
	  var query = clone(this.query);
	
	  // append engine.io protocol identifier
	  query.EIO = parser.protocol;
	
	  // transport name
	  query.transport = name;
	
	  // per-transport options
	  var options = this.transportOptions[name] || {};
	
	  // session id if we already have one
	  if (this.id) query.sid = this.id;
	
	  var transport = new transports[name]({
	    query: query,
	    socket: this,
	    agent: options.agent || this.agent,
	    hostname: options.hostname || this.hostname,
	    port: options.port || this.port,
	    secure: options.secure || this.secure,
	    path: options.path || this.path,
	    forceJSONP: options.forceJSONP || this.forceJSONP,
	    jsonp: options.jsonp || this.jsonp,
	    forceBase64: options.forceBase64 || this.forceBase64,
	    enablesXDR: options.enablesXDR || this.enablesXDR,
	    withCredentials: options.withCredentials || this.withCredentials,
	    timestampRequests: options.timestampRequests || this.timestampRequests,
	    timestampParam: options.timestampParam || this.timestampParam,
	    policyPort: options.policyPort || this.policyPort,
	    pfx: options.pfx || this.pfx,
	    key: options.key || this.key,
	    passphrase: options.passphrase || this.passphrase,
	    cert: options.cert || this.cert,
	    ca: options.ca || this.ca,
	    ciphers: options.ciphers || this.ciphers,
	    rejectUnauthorized: options.rejectUnauthorized || this.rejectUnauthorized,
	    perMessageDeflate: options.perMessageDeflate || this.perMessageDeflate,
	    extraHeaders: options.extraHeaders || this.extraHeaders,
	    forceNode: options.forceNode || this.forceNode,
	    localAddress: options.localAddress || this.localAddress,
	    requestTimeout: options.requestTimeout || this.requestTimeout,
	    protocols: options.protocols || void (0),
	    isReactNative: this.isReactNative
	  });
	
	  return transport;
	};
	
	function clone (obj) {
	  var o = {};
	  for (var i in obj) {
	    if (obj.hasOwnProperty(i)) {
	      o[i] = obj[i];
	    }
	  }
	  return o;
	}
	
	/**
	 * Initializes transport to use and starts probe.
	 *
	 * @api private
	 */
	Socket.prototype.open = function () {
	  var transport;
	  if (this.rememberUpgrade && Socket.priorWebsocketSuccess && this.transports.indexOf('websocket') !== -1) {
	    transport = 'websocket';
	  } else if (0 === this.transports.length) {
	    // Emit error on next tick so it can be listened to
	    var self = this;
	    setTimeout(function () {
	      self.emit('error', 'No transports available');
	    }, 0);
	    return;
	  } else {
	    transport = this.transports[0];
	  }
	  this.readyState = 'opening';
	
	  // Retry with the next transport if the transport is disabled (jsonp: false)
	  try {
	    transport = this.createTransport(transport);
	  } catch (e) {
	    this.transports.shift();
	    this.open();
	    return;
	  }
	
	  transport.open();
	  this.setTransport(transport);
	};
	
	/**
	 * Sets the current transport. Disables the existing one (if any).
	 *
	 * @api private
	 */
	
	Socket.prototype.setTransport = function (transport) {
	  debug('setting transport %s', transport.name);
	  var self = this;
	
	  if (this.transport) {
	    debug('clearing existing transport %s', this.transport.name);
	    this.transport.removeAllListeners();
	  }
	
	  // set up transport
	  this.transport = transport;
	
	  // set up transport listeners
	  transport
	  .on('drain', function () {
	    self.onDrain();
	  })
	  .on('packet', function (packet) {
	    self.onPacket(packet);
	  })
	  .on('error', function (e) {
	    self.onError(e);
	  })
	  .on('close', function () {
	    self.onClose('transport close');
	  });
	};
	
	/**
	 * Probes a transport.
	 *
	 * @param {String} transport name
	 * @api private
	 */
	
	Socket.prototype.probe = function (name) {
	  debug('probing transport "%s"', name);
	  var transport = this.createTransport(name, { probe: 1 });
	  var failed = false;
	  var self = this;
	
	  Socket.priorWebsocketSuccess = false;
	
	  function onTransportOpen () {
	    if (self.onlyBinaryUpgrades) {
	      var upgradeLosesBinary = !this.supportsBinary && self.transport.supportsBinary;
	      failed = failed || upgradeLosesBinary;
	    }
	    if (failed) return;
	
	    debug('probe transport "%s" opened', name);
	    transport.send([{ type: 'ping', data: 'probe' }]);
	    transport.once('packet', function (msg) {
	      if (failed) return;
	      if ('pong' === msg.type && 'probe' === msg.data) {
	        debug('probe transport "%s" pong', name);
	        self.upgrading = true;
	        self.emit('upgrading', transport);
	        if (!transport) return;
	        Socket.priorWebsocketSuccess = 'websocket' === transport.name;
	
	        debug('pausing current transport "%s"', self.transport.name);
	        self.transport.pause(function () {
	          if (failed) return;
	          if ('closed' === self.readyState) return;
	          debug('changing transport and sending upgrade packet');
	
	          cleanup();
	
	          self.setTransport(transport);
	          transport.send([{ type: 'upgrade' }]);
	          self.emit('upgrade', transport);
	          transport = null;
	          self.upgrading = false;
	          self.flush();
	        });
	      } else {
	        debug('probe transport "%s" failed', name);
	        var err = new Error('probe error');
	        err.transport = transport.name;
	        self.emit('upgradeError', err);
	      }
	    });
	  }
	
	  function freezeTransport () {
	    if (failed) return;
	
	    // Any callback called by transport should be ignored since now
	    failed = true;
	
	    cleanup();
	
	    transport.close();
	    transport = null;
	  }
	
	  // Handle any error that happens while probing
	  function onerror (err) {
	    var error = new Error('probe error: ' + err);
	    error.transport = transport.name;
	
	    freezeTransport();
	
	    debug('probe transport "%s" failed because of error: %s', name, err);
	
	    self.emit('upgradeError', error);
	  }
	
	  function onTransportClose () {
	    onerror('transport closed');
	  }
	
	  // When the socket is closed while we're probing
	  function onclose () {
	    onerror('socket closed');
	  }
	
	  // When the socket is upgraded while we're probing
	  function onupgrade (to) {
	    if (transport && to.name !== transport.name) {
	      debug('"%s" works - aborting "%s"', to.name, transport.name);
	      freezeTransport();
	    }
	  }
	
	  // Remove all listeners on the transport and on self
	  function cleanup () {
	    transport.removeListener('open', onTransportOpen);
	    transport.removeListener('error', onerror);
	    transport.removeListener('close', onTransportClose);
	    self.removeListener('close', onclose);
	    self.removeListener('upgrading', onupgrade);
	  }
	
	  transport.once('open', onTransportOpen);
	  transport.once('error', onerror);
	  transport.once('close', onTransportClose);
	
	  this.once('close', onclose);
	  this.once('upgrading', onupgrade);
	
	  transport.open();
	};
	
	/**
	 * Called when connection is deemed open.
	 *
	 * @api public
	 */
	
	Socket.prototype.onOpen = function () {
	  debug('socket open');
	  this.readyState = 'open';
	  Socket.priorWebsocketSuccess = 'websocket' === this.transport.name;
	  this.emit('open');
	  this.flush();
	
	  // we check for `readyState` in case an `open`
	  // listener already closed the socket
	  if ('open' === this.readyState && this.upgrade && this.transport.pause) {
	    debug('starting upgrade probes');
	    for (var i = 0, l = this.upgrades.length; i < l; i++) {
	      this.probe(this.upgrades[i]);
	    }
	  }
	};
	
	/**
	 * Handles a packet.
	 *
	 * @api private
	 */
	
	Socket.prototype.onPacket = function (packet) {
	  if ('opening' === this.readyState || 'open' === this.readyState ||
	      'closing' === this.readyState) {
	    debug('socket receive: type "%s", data "%s"', packet.type, packet.data);
	
	    this.emit('packet', packet);
	
	    // Socket is live - any packet counts
	    this.emit('heartbeat');
	
	    switch (packet.type) {
	      case 'open':
	        this.onHandshake(JSON.parse(packet.data));
	        break;
	
	      case 'pong':
	        this.setPing();
	        this.emit('pong');
	        break;
	
	      case 'error':
	        var err = new Error('server error');
	        err.code = packet.data;
	        this.onError(err);
	        break;
	
	      case 'message':
	        this.emit('data', packet.data);
	        this.emit('message', packet.data);
	        break;
	    }
	  } else {
	    debug('packet received with socket readyState "%s"', this.readyState);
	  }
	};
	
	/**
	 * Called upon handshake completion.
	 *
	 * @param {Object} handshake obj
	 * @api private
	 */
	
	Socket.prototype.onHandshake = function (data) {
	  this.emit('handshake', data);
	  this.id = data.sid;
	  this.transport.query.sid = data.sid;
	  this.upgrades = this.filterUpgrades(data.upgrades);
	  this.pingInterval = data.pingInterval;
	  this.pingTimeout = data.pingTimeout;
	  this.onOpen();
	  // In case open handler closes socket
	  if ('closed' === this.readyState) return;
	  this.setPing();
	
	  // Prolong liveness of socket on heartbeat
	  this.removeListener('heartbeat', this.onHeartbeat);
	  this.on('heartbeat', this.onHeartbeat);
	};
	
	/**
	 * Resets ping timeout.
	 *
	 * @api private
	 */
	
	Socket.prototype.onHeartbeat = function (timeout) {
	  clearTimeout(this.pingTimeoutTimer);
	  var self = this;
	  self.pingTimeoutTimer = setTimeout(function () {
	    if ('closed' === self.readyState) return;
	    self.onClose('ping timeout');
	  }, timeout || (self.pingInterval + self.pingTimeout));
	};
	
	/**
	 * Pings server every `this.pingInterval` and expects response
	 * within `this.pingTimeout` or closes connection.
	 *
	 * @api private
	 */
	
	Socket.prototype.setPing = function () {
	  var self = this;
	  clearTimeout(self.pingIntervalTimer);
	  self.pingIntervalTimer = setTimeout(function () {
	    debug('writing ping packet - expecting pong within %sms', self.pingTimeout);
	    self.ping();
	    self.onHeartbeat(self.pingTimeout);
	  }, self.pingInterval);
	};
	
	/**
	* Sends a ping packet.
	*
	* @api private
	*/
	
	Socket.prototype.ping = function () {
	  var self = this;
	  this.sendPacket('ping', function () {
	    self.emit('ping');
	  });
	};
	
	/**
	 * Called on `drain` event
	 *
	 * @api private
	 */
	
	Socket.prototype.onDrain = function () {
	  this.writeBuffer.splice(0, this.prevBufferLen);
	
	  // setting prevBufferLen = 0 is very important
	  // for example, when upgrading, upgrade packet is sent over,
	  // and a nonzero prevBufferLen could cause problems on `drain`
	  this.prevBufferLen = 0;
	
	  if (0 === this.writeBuffer.length) {
	    this.emit('drain');
	  } else {
	    this.flush();
	  }
	};
	
	/**
	 * Flush write buffers.
	 *
	 * @api private
	 */
	
	Socket.prototype.flush = function () {
	  if ('closed' !== this.readyState && this.transport.writable &&
	    !this.upgrading && this.writeBuffer.length) {
	    debug('flushing %d packets in socket', this.writeBuffer.length);
	    this.transport.send(this.writeBuffer);
	    // keep track of current length of writeBuffer
	    // splice writeBuffer and callbackBuffer on `drain`
	    this.prevBufferLen = this.writeBuffer.length;
	    this.emit('flush');
	  }
	};
	
	/**
	 * Sends a message.
	 *
	 * @param {String} message.
	 * @param {Function} callback function.
	 * @param {Object} options.
	 * @return {Socket} for chaining.
	 * @api public
	 */
	
	Socket.prototype.write =
	Socket.prototype.send = function (msg, options, fn) {
	  this.sendPacket('message', msg, options, fn);
	  return this;
	};
	
	/**
	 * Sends a packet.
	 *
	 * @param {String} packet type.
	 * @param {String} data.
	 * @param {Object} options.
	 * @param {Function} callback function.
	 * @api private
	 */
	
	Socket.prototype.sendPacket = function (type, data, options, fn) {
	  if ('function' === typeof data) {
	    fn = data;
	    data = undefined;
	  }
	
	  if ('function' === typeof options) {
	    fn = options;
	    options = null;
	  }
	
	  if ('closing' === this.readyState || 'closed' === this.readyState) {
	    return;
	  }
	
	  options = options || {};
	  options.compress = false !== options.compress;
	
	  var packet = {
	    type: type,
	    data: data,
	    options: options
	  };
	  this.emit('packetCreate', packet);
	  this.writeBuffer.push(packet);
	  if (fn) this.once('flush', fn);
	  this.flush();
	};
	
	/**
	 * Closes the connection.
	 *
	 * @api private
	 */
	
	Socket.prototype.close = function () {
	  if ('opening' === this.readyState || 'open' === this.readyState) {
	    this.readyState = 'closing';
	
	    var self = this;
	
	    if (this.writeBuffer.length) {
	      this.once('drain', function () {
	        if (this.upgrading) {
	          waitForUpgrade();
	        } else {
	          close();
	        }
	      });
	    } else if (this.upgrading) {
	      waitForUpgrade();
	    } else {
	      close();
	    }
	  }
	
	  function close () {
	    self.onClose('forced close');
	    debug('socket closing - telling transport to close');
	    self.transport.close();
	  }
	
	  function cleanupAndClose () {
	    self.removeListener('upgrade', cleanupAndClose);
	    self.removeListener('upgradeError', cleanupAndClose);
	    close();
	  }
	
	  function waitForUpgrade () {
	    // wait for upgrade to finish since we can't send packets while pausing a transport
	    self.once('upgrade', cleanupAndClose);
	    self.once('upgradeError', cleanupAndClose);
	  }
	
	  return this;
	};
	
	/**
	 * Called upon transport error
	 *
	 * @api private
	 */
	
	Socket.prototype.onError = function (err) {
	  debug('socket error %j', err);
	  Socket.priorWebsocketSuccess = false;
	  this.emit('error', err);
	  this.onClose('transport error', err);
	};
	
	/**
	 * Called upon transport close.
	 *
	 * @api private
	 */
	
	Socket.prototype.onClose = function (reason, desc) {
	  if ('opening' === this.readyState || 'open' === this.readyState || 'closing' === this.readyState) {
	    debug('socket close with reason: "%s"', reason);
	    var self = this;
	
	    // clear timers
	    clearTimeout(this.pingIntervalTimer);
	    clearTimeout(this.pingTimeoutTimer);
	
	    // stop event from firing again for transport
	    this.transport.removeAllListeners('close');
	
	    // ensure transport won't stay open
	    this.transport.close();
	
	    // ignore further transport communication
	    this.transport.removeAllListeners();
	
	    // set ready state
	    this.readyState = 'closed';
	
	    // clear session id
	    this.id = null;
	
	    // emit close event
	    this.emit('close', reason, desc);
	
	    // clean buffers after, so users can still
	    // grab the buffers on `close` event
	    self.writeBuffer = [];
	    self.prevBufferLen = 0;
	  }
	};
	
	/**
	 * Filters upgrades, returning only those matching client transports.
	 *
	 * @param {Array} server upgrades
	 * @api private
	 *
	 */
	
	Socket.prototype.filterUpgrades = function (upgrades) {
	  var filteredUpgrades = [];
	  for (var i = 0, j = upgrades.length; i < j; i++) {
	    if (~index(this.transports, upgrades[i])) filteredUpgrades.push(upgrades[i]);
	  }
	  return filteredUpgrades;
	};


/***/ }),

/***/ 721:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies
	 */
	
	var XMLHttpRequest = __webpack_require__(722);
	var XHR = __webpack_require__(725);
	var JSONP = __webpack_require__(742);
	var websocket = __webpack_require__(743);
	
	/**
	 * Export transports.
	 */
	
	exports.polling = polling;
	exports.websocket = websocket;
	
	/**
	 * Polling transport polymorphic constructor.
	 * Decides on xhr vs jsonp based on feature detection.
	 *
	 * @api private
	 */
	
	function polling (opts) {
	  var xhr;
	  var xd = false;
	  var xs = false;
	  var jsonp = false !== opts.jsonp;
	
	  if (typeof location !== 'undefined') {
	    var isSSL = 'https:' === location.protocol;
	    var port = location.port;
	
	    // some user agents have empty `location.port`
	    if (!port) {
	      port = isSSL ? 443 : 80;
	    }
	
	    xd = opts.hostname !== location.hostname || port !== opts.port;
	    xs = opts.secure !== isSSL;
	  }
	
	  opts.xdomain = xd;
	  opts.xscheme = xs;
	  xhr = new XMLHttpRequest(opts);
	
	  if ('open' in xhr && !opts.forceJSONP) {
	    return new XHR(opts);
	  } else {
	    if (!jsonp) throw new Error('JSONP disabled');
	    return new JSONP(opts);
	  }
	}


/***/ }),

/***/ 722:
/***/ (function(module, exports, __webpack_require__) {

	// browser shim for xmlhttprequest module
	
	var hasCORS = __webpack_require__(723);
	var globalThis = __webpack_require__(724);
	
	module.exports = function (opts) {
	  var xdomain = opts.xdomain;
	
	  // scheme must be same when usign XDomainRequest
	  // http://blogs.msdn.com/b/ieinternals/archive/2010/05/13/xdomainrequest-restrictions-limitations-and-workarounds.aspx
	  var xscheme = opts.xscheme;
	
	  // XDomainRequest has a flow of not sending cookie, therefore it should be disabled as a default.
	  // https://github.com/Automattic/engine.io-client/pull/217
	  var enablesXDR = opts.enablesXDR;
	
	  // XMLHttpRequest can be disabled on IE
	  try {
	    if ('undefined' !== typeof XMLHttpRequest && (!xdomain || hasCORS)) {
	      return new XMLHttpRequest();
	    }
	  } catch (e) { }
	
	  // Use XDomainRequest for IE8 if enablesXDR is true
	  // because loading bar keeps flashing when using jsonp-polling
	  // https://github.com/yujiosaka/socke.io-ie8-loading-example
	  try {
	    if ('undefined' !== typeof XDomainRequest && !xscheme && enablesXDR) {
	      return new XDomainRequest();
	    }
	  } catch (e) { }
	
	  if (!xdomain) {
	    try {
	      return new globalThis[['Active'].concat('Object').join('X')]('Microsoft.XMLHTTP');
	    } catch (e) { }
	  }
	};


/***/ }),

/***/ 723:
/***/ (function(module, exports) {

	
	/**
	 * Module exports.
	 *
	 * Logic borrowed from Modernizr:
	 *
	 *   - https://github.com/Modernizr/Modernizr/blob/master/feature-detects/cors.js
	 */
	
	try {
	  module.exports = typeof XMLHttpRequest !== 'undefined' &&
	    'withCredentials' in new XMLHttpRequest();
	} catch (err) {
	  // if XMLHttp support is disabled in IE then it will throw
	  // when trying to create
	  module.exports = false;
	}


/***/ }),

/***/ 724:
/***/ (function(module, exports) {

	module.exports = (function () {
	  if (typeof self !== 'undefined') {
	    return self;
	  } else if (typeof window !== 'undefined') {
	    return window;
	  } else {
	    return Function('return this')(); // eslint-disable-line no-new-func
	  }
	})();


/***/ }),

/***/ 725:
/***/ (function(module, exports, __webpack_require__) {

	/* global attachEvent */
	
	/**
	 * Module requirements.
	 */
	
	var XMLHttpRequest = __webpack_require__(722);
	var Polling = __webpack_require__(726);
	var Emitter = __webpack_require__(710);
	var inherit = __webpack_require__(738);
	var debug = __webpack_require__(740)('engine.io-client:polling-xhr');
	var globalThis = __webpack_require__(724);
	
	/**
	 * Module exports.
	 */
	
	module.exports = XHR;
	module.exports.Request = Request;
	
	/**
	 * Empty function
	 */
	
	function empty () {}
	
	/**
	 * XHR Polling constructor.
	 *
	 * @param {Object} opts
	 * @api public
	 */
	
	function XHR (opts) {
	  Polling.call(this, opts);
	  this.requestTimeout = opts.requestTimeout;
	  this.extraHeaders = opts.extraHeaders;
	
	  if (typeof location !== 'undefined') {
	    var isSSL = 'https:' === location.protocol;
	    var port = location.port;
	
	    // some user agents have empty `location.port`
	    if (!port) {
	      port = isSSL ? 443 : 80;
	    }
	
	    this.xd = (typeof location !== 'undefined' && opts.hostname !== location.hostname) ||
	      port !== opts.port;
	    this.xs = opts.secure !== isSSL;
	  }
	}
	
	/**
	 * Inherits from Polling.
	 */
	
	inherit(XHR, Polling);
	
	/**
	 * XHR supports binary
	 */
	
	XHR.prototype.supportsBinary = true;
	
	/**
	 * Creates a request.
	 *
	 * @param {String} method
	 * @api private
	 */
	
	XHR.prototype.request = function (opts) {
	  opts = opts || {};
	  opts.uri = this.uri();
	  opts.xd = this.xd;
	  opts.xs = this.xs;
	  opts.agent = this.agent || false;
	  opts.supportsBinary = this.supportsBinary;
	  opts.enablesXDR = this.enablesXDR;
	  opts.withCredentials = this.withCredentials;
	
	  // SSL options for Node.js client
	  opts.pfx = this.pfx;
	  opts.key = this.key;
	  opts.passphrase = this.passphrase;
	  opts.cert = this.cert;
	  opts.ca = this.ca;
	  opts.ciphers = this.ciphers;
	  opts.rejectUnauthorized = this.rejectUnauthorized;
	  opts.requestTimeout = this.requestTimeout;
	
	  // other options for Node.js client
	  opts.extraHeaders = this.extraHeaders;
	
	  return new Request(opts);
	};
	
	/**
	 * Sends data.
	 *
	 * @param {String} data to send.
	 * @param {Function} called upon flush.
	 * @api private
	 */
	
	XHR.prototype.doWrite = function (data, fn) {
	  var isBinary = typeof data !== 'string' && data !== undefined;
	  var req = this.request({ method: 'POST', data: data, isBinary: isBinary });
	  var self = this;
	  req.on('success', fn);
	  req.on('error', function (err) {
	    self.onError('xhr post error', err);
	  });
	  this.sendXhr = req;
	};
	
	/**
	 * Starts a poll cycle.
	 *
	 * @api private
	 */
	
	XHR.prototype.doPoll = function () {
	  debug('xhr poll');
	  var req = this.request();
	  var self = this;
	  req.on('data', function (data) {
	    self.onData(data);
	  });
	  req.on('error', function (err) {
	    self.onError('xhr poll error', err);
	  });
	  this.pollXhr = req;
	};
	
	/**
	 * Request constructor
	 *
	 * @param {Object} options
	 * @api public
	 */
	
	function Request (opts) {
	  this.method = opts.method || 'GET';
	  this.uri = opts.uri;
	  this.xd = !!opts.xd;
	  this.xs = !!opts.xs;
	  this.async = false !== opts.async;
	  this.data = undefined !== opts.data ? opts.data : null;
	  this.agent = opts.agent;
	  this.isBinary = opts.isBinary;
	  this.supportsBinary = opts.supportsBinary;
	  this.enablesXDR = opts.enablesXDR;
	  this.withCredentials = opts.withCredentials;
	  this.requestTimeout = opts.requestTimeout;
	
	  // SSL options for Node.js client
	  this.pfx = opts.pfx;
	  this.key = opts.key;
	  this.passphrase = opts.passphrase;
	  this.cert = opts.cert;
	  this.ca = opts.ca;
	  this.ciphers = opts.ciphers;
	  this.rejectUnauthorized = opts.rejectUnauthorized;
	
	  // other options for Node.js client
	  this.extraHeaders = opts.extraHeaders;
	
	  this.create();
	}
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Request.prototype);
	
	/**
	 * Creates the XHR object and sends the request.
	 *
	 * @api private
	 */
	
	Request.prototype.create = function () {
	  var opts = { agent: this.agent, xdomain: this.xd, xscheme: this.xs, enablesXDR: this.enablesXDR };
	
	  // SSL options for Node.js client
	  opts.pfx = this.pfx;
	  opts.key = this.key;
	  opts.passphrase = this.passphrase;
	  opts.cert = this.cert;
	  opts.ca = this.ca;
	  opts.ciphers = this.ciphers;
	  opts.rejectUnauthorized = this.rejectUnauthorized;
	
	  var xhr = this.xhr = new XMLHttpRequest(opts);
	  var self = this;
	
	  try {
	    debug('xhr open %s: %s', this.method, this.uri);
	    xhr.open(this.method, this.uri, this.async);
	    try {
	      if (this.extraHeaders) {
	        xhr.setDisableHeaderCheck && xhr.setDisableHeaderCheck(true);
	        for (var i in this.extraHeaders) {
	          if (this.extraHeaders.hasOwnProperty(i)) {
	            xhr.setRequestHeader(i, this.extraHeaders[i]);
	          }
	        }
	      }
	    } catch (e) {}
	
	    if ('POST' === this.method) {
	      try {
	        if (this.isBinary) {
	          xhr.setRequestHeader('Content-type', 'application/octet-stream');
	        } else {
	          xhr.setRequestHeader('Content-type', 'text/plain;charset=UTF-8');
	        }
	      } catch (e) {}
	    }
	
	    try {
	      xhr.setRequestHeader('Accept', '*/*');
	    } catch (e) {}
	
	    // ie6 check
	    if ('withCredentials' in xhr) {
	      xhr.withCredentials = this.withCredentials;
	    }
	
	    if (this.requestTimeout) {
	      xhr.timeout = this.requestTimeout;
	    }
	
	    if (this.hasXDR()) {
	      xhr.onload = function () {
	        self.onLoad();
	      };
	      xhr.onerror = function () {
	        self.onError(xhr.responseText);
	      };
	    } else {
	      xhr.onreadystatechange = function () {
	        if (xhr.readyState === 2) {
	          try {
	            var contentType = xhr.getResponseHeader('Content-Type');
	            if (self.supportsBinary && contentType === 'application/octet-stream' || contentType === 'application/octet-stream; charset=UTF-8') {
	              xhr.responseType = 'arraybuffer';
	            }
	          } catch (e) {}
	        }
	        if (4 !== xhr.readyState) return;
	        if (200 === xhr.status || 1223 === xhr.status) {
	          self.onLoad();
	        } else {
	          // make sure the `error` event handler that's user-set
	          // does not throw in the same tick and gets caught here
	          setTimeout(function () {
	            self.onError(typeof xhr.status === 'number' ? xhr.status : 0);
	          }, 0);
	        }
	      };
	    }
	
	    debug('xhr data %s', this.data);
	    xhr.send(this.data);
	  } catch (e) {
	    // Need to defer since .create() is called directly fhrom the constructor
	    // and thus the 'error' event can only be only bound *after* this exception
	    // occurs.  Therefore, also, we cannot throw here at all.
	    setTimeout(function () {
	      self.onError(e);
	    }, 0);
	    return;
	  }
	
	  if (typeof document !== 'undefined') {
	    this.index = Request.requestsCount++;
	    Request.requests[this.index] = this;
	  }
	};
	
	/**
	 * Called upon successful response.
	 *
	 * @api private
	 */
	
	Request.prototype.onSuccess = function () {
	  this.emit('success');
	  this.cleanup();
	};
	
	/**
	 * Called if we have data.
	 *
	 * @api private
	 */
	
	Request.prototype.onData = function (data) {
	  this.emit('data', data);
	  this.onSuccess();
	};
	
	/**
	 * Called upon error.
	 *
	 * @api private
	 */
	
	Request.prototype.onError = function (err) {
	  this.emit('error', err);
	  this.cleanup(true);
	};
	
	/**
	 * Cleans up house.
	 *
	 * @api private
	 */
	
	Request.prototype.cleanup = function (fromError) {
	  if ('undefined' === typeof this.xhr || null === this.xhr) {
	    return;
	  }
	  // xmlhttprequest
	  if (this.hasXDR()) {
	    this.xhr.onload = this.xhr.onerror = empty;
	  } else {
	    this.xhr.onreadystatechange = empty;
	  }
	
	  if (fromError) {
	    try {
	      this.xhr.abort();
	    } catch (e) {}
	  }
	
	  if (typeof document !== 'undefined') {
	    delete Request.requests[this.index];
	  }
	
	  this.xhr = null;
	};
	
	/**
	 * Called upon load.
	 *
	 * @api private
	 */
	
	Request.prototype.onLoad = function () {
	  var data;
	  try {
	    var contentType;
	    try {
	      contentType = this.xhr.getResponseHeader('Content-Type');
	    } catch (e) {}
	    if (contentType === 'application/octet-stream' || contentType === 'application/octet-stream; charset=UTF-8') {
	      data = this.xhr.response || this.xhr.responseText;
	    } else {
	      data = this.xhr.responseText;
	    }
	  } catch (e) {
	    this.onError(e);
	  }
	  if (null != data) {
	    this.onData(data);
	  }
	};
	
	/**
	 * Check if it has XDomainRequest.
	 *
	 * @api private
	 */
	
	Request.prototype.hasXDR = function () {
	  return typeof XDomainRequest !== 'undefined' && !this.xs && this.enablesXDR;
	};
	
	/**
	 * Aborts the request.
	 *
	 * @api public
	 */
	
	Request.prototype.abort = function () {
	  this.cleanup();
	};
	
	/**
	 * Aborts pending requests when unloading the window. This is needed to prevent
	 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
	 * emitted.
	 */
	
	Request.requestsCount = 0;
	Request.requests = {};
	
	if (typeof document !== 'undefined') {
	  if (typeof attachEvent === 'function') {
	    attachEvent('onunload', unloadHandler);
	  } else if (typeof addEventListener === 'function') {
	    var terminationEvent = 'onpagehide' in globalThis ? 'pagehide' : 'unload';
	    addEventListener(terminationEvent, unloadHandler, false);
	  }
	}
	
	function unloadHandler () {
	  for (var i in Request.requests) {
	    if (Request.requests.hasOwnProperty(i)) {
	      Request.requests[i].abort();
	    }
	  }
	}


/***/ }),

/***/ 726:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	var Transport = __webpack_require__(727);
	var parseqs = __webpack_require__(737);
	var parser = __webpack_require__(728);
	var inherit = __webpack_require__(738);
	var yeast = __webpack_require__(739);
	var debug = __webpack_require__(740)('engine.io-client:polling');
	
	/**
	 * Module exports.
	 */
	
	module.exports = Polling;
	
	/**
	 * Is XHR2 supported?
	 */
	
	var hasXHR2 = (function () {
	  var XMLHttpRequest = __webpack_require__(722);
	  var xhr = new XMLHttpRequest({ xdomain: false });
	  return null != xhr.responseType;
	})();
	
	/**
	 * Polling interface.
	 *
	 * @param {Object} opts
	 * @api private
	 */
	
	function Polling (opts) {
	  var forceBase64 = (opts && opts.forceBase64);
	  if (!hasXHR2 || forceBase64) {
	    this.supportsBinary = false;
	  }
	  Transport.call(this, opts);
	}
	
	/**
	 * Inherits from Transport.
	 */
	
	inherit(Polling, Transport);
	
	/**
	 * Transport name.
	 */
	
	Polling.prototype.name = 'polling';
	
	/**
	 * Opens the socket (triggers polling). We write a PING message to determine
	 * when the transport is open.
	 *
	 * @api private
	 */
	
	Polling.prototype.doOpen = function () {
	  this.poll();
	};
	
	/**
	 * Pauses polling.
	 *
	 * @param {Function} callback upon buffers are flushed and transport is paused
	 * @api private
	 */
	
	Polling.prototype.pause = function (onPause) {
	  var self = this;
	
	  this.readyState = 'pausing';
	
	  function pause () {
	    debug('paused');
	    self.readyState = 'paused';
	    onPause();
	  }
	
	  if (this.polling || !this.writable) {
	    var total = 0;
	
	    if (this.polling) {
	      debug('we are currently polling - waiting to pause');
	      total++;
	      this.once('pollComplete', function () {
	        debug('pre-pause polling complete');
	        --total || pause();
	      });
	    }
	
	    if (!this.writable) {
	      debug('we are currently writing - waiting to pause');
	      total++;
	      this.once('drain', function () {
	        debug('pre-pause writing complete');
	        --total || pause();
	      });
	    }
	  } else {
	    pause();
	  }
	};
	
	/**
	 * Starts polling cycle.
	 *
	 * @api public
	 */
	
	Polling.prototype.poll = function () {
	  debug('polling');
	  this.polling = true;
	  this.doPoll();
	  this.emit('poll');
	};
	
	/**
	 * Overloads onData to detect payloads.
	 *
	 * @api private
	 */
	
	Polling.prototype.onData = function (data) {
	  var self = this;
	  debug('polling got data %s', data);
	  var callback = function (packet, index, total) {
	    // if its the first message we consider the transport open
	    if ('opening' === self.readyState && packet.type === 'open') {
	      self.onOpen();
	    }
	
	    // if its a close packet, we close the ongoing requests
	    if ('close' === packet.type) {
	      self.onClose();
	      return false;
	    }
	
	    // otherwise bypass onData and handle the message
	    self.onPacket(packet);
	  };
	
	  // decode payload
	  parser.decodePayload(data, this.socket.binaryType, callback);
	
	  // if an event did not trigger closing
	  if ('closed' !== this.readyState) {
	    // if we got data we're not polling
	    this.polling = false;
	    this.emit('pollComplete');
	
	    if ('open' === this.readyState) {
	      this.poll();
	    } else {
	      debug('ignoring poll - transport state "%s"', this.readyState);
	    }
	  }
	};
	
	/**
	 * For polling, send a close packet.
	 *
	 * @api private
	 */
	
	Polling.prototype.doClose = function () {
	  var self = this;
	
	  function close () {
	    debug('writing close packet');
	    self.write([{ type: 'close' }]);
	  }
	
	  if ('open' === this.readyState) {
	    debug('transport open - closing');
	    close();
	  } else {
	    // in case we're trying to close while
	    // handshaking is in progress (GH-164)
	    debug('transport not open - deferring close');
	    this.once('open', close);
	  }
	};
	
	/**
	 * Writes a packets payload.
	 *
	 * @param {Array} data packets
	 * @param {Function} drain callback
	 * @api private
	 */
	
	Polling.prototype.write = function (packets) {
	  var self = this;
	  this.writable = false;
	  var callbackfn = function () {
	    self.writable = true;
	    self.emit('drain');
	  };
	
	  parser.encodePayload(packets, this.supportsBinary, function (data) {
	    self.doWrite(data, callbackfn);
	  });
	};
	
	/**
	 * Generates uri for connection.
	 *
	 * @api private
	 */
	
	Polling.prototype.uri = function () {
	  var query = this.query || {};
	  var schema = this.secure ? 'https' : 'http';
	  var port = '';
	
	  // cache busting is forced
	  if (false !== this.timestampRequests) {
	    query[this.timestampParam] = yeast();
	  }
	
	  if (!this.supportsBinary && !query.sid) {
	    query.b64 = 1;
	  }
	
	  query = parseqs.encode(query);
	
	  // avoid port if default for schema
	  if (this.port && (('https' === schema && Number(this.port) !== 443) ||
	     ('http' === schema && Number(this.port) !== 80))) {
	    port = ':' + this.port;
	  }
	
	  // prepend ? to query
	  if (query.length) {
	    query = '?' + query;
	  }
	
	  var ipv6 = this.hostname.indexOf(':') !== -1;
	  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
	};


/***/ }),

/***/ 727:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	var parser = __webpack_require__(728);
	var Emitter = __webpack_require__(710);
	
	/**
	 * Module exports.
	 */
	
	module.exports = Transport;
	
	/**
	 * Transport abstract constructor.
	 *
	 * @param {Object} options.
	 * @api private
	 */
	
	function Transport (opts) {
	  this.path = opts.path;
	  this.hostname = opts.hostname;
	  this.port = opts.port;
	  this.secure = opts.secure;
	  this.query = opts.query;
	  this.timestampParam = opts.timestampParam;
	  this.timestampRequests = opts.timestampRequests;
	  this.readyState = '';
	  this.agent = opts.agent || false;
	  this.socket = opts.socket;
	  this.enablesXDR = opts.enablesXDR;
	  this.withCredentials = opts.withCredentials;
	
	  // SSL options for Node.js client
	  this.pfx = opts.pfx;
	  this.key = opts.key;
	  this.passphrase = opts.passphrase;
	  this.cert = opts.cert;
	  this.ca = opts.ca;
	  this.ciphers = opts.ciphers;
	  this.rejectUnauthorized = opts.rejectUnauthorized;
	  this.forceNode = opts.forceNode;
	
	  // results of ReactNative environment detection
	  this.isReactNative = opts.isReactNative;
	
	  // other options for Node.js client
	  this.extraHeaders = opts.extraHeaders;
	  this.localAddress = opts.localAddress;
	}
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Transport.prototype);
	
	/**
	 * Emits an error.
	 *
	 * @param {String} str
	 * @return {Transport} for chaining
	 * @api public
	 */
	
	Transport.prototype.onError = function (msg, desc) {
	  var err = new Error(msg);
	  err.type = 'TransportError';
	  err.description = desc;
	  this.emit('error', err);
	  return this;
	};
	
	/**
	 * Opens the transport.
	 *
	 * @api public
	 */
	
	Transport.prototype.open = function () {
	  if ('closed' === this.readyState || '' === this.readyState) {
	    this.readyState = 'opening';
	    this.doOpen();
	  }
	
	  return this;
	};
	
	/**
	 * Closes the transport.
	 *
	 * @api private
	 */
	
	Transport.prototype.close = function () {
	  if ('opening' === this.readyState || 'open' === this.readyState) {
	    this.doClose();
	    this.onClose();
	  }
	
	  return this;
	};
	
	/**
	 * Sends multiple packets.
	 *
	 * @param {Array} packets
	 * @api private
	 */
	
	Transport.prototype.send = function (packets) {
	  if ('open' === this.readyState) {
	    this.write(packets);
	  } else {
	    throw new Error('Transport not open');
	  }
	};
	
	/**
	 * Called upon open
	 *
	 * @api private
	 */
	
	Transport.prototype.onOpen = function () {
	  this.readyState = 'open';
	  this.writable = true;
	  this.emit('open');
	};
	
	/**
	 * Called with data.
	 *
	 * @param {String} data
	 * @api private
	 */
	
	Transport.prototype.onData = function (data) {
	  var packet = parser.decodePacket(data, this.socket.binaryType);
	  this.onPacket(packet);
	};
	
	/**
	 * Called with a decoded packet.
	 */
	
	Transport.prototype.onPacket = function (packet) {
	  this.emit('packet', packet);
	};
	
	/**
	 * Called upon close.
	 *
	 * @api private
	 */
	
	Transport.prototype.onClose = function () {
	  this.readyState = 'closed';
	  this.emit('close');
	};


/***/ }),

/***/ 728:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	var keys = __webpack_require__(729);
	var hasBinary = __webpack_require__(730);
	var sliceBuffer = __webpack_require__(732);
	var after = __webpack_require__(733);
	var utf8 = __webpack_require__(734);
	
	var base64encoder;
	if (typeof ArrayBuffer !== 'undefined') {
	  base64encoder = __webpack_require__(735);
	}
	
	/**
	 * Check if we are running an android browser. That requires us to use
	 * ArrayBuffer with polling transports...
	 *
	 * http://ghinda.net/jpeg-blob-ajax-android/
	 */
	
	var isAndroid = typeof navigator !== 'undefined' && /Android/i.test(navigator.userAgent);
	
	/**
	 * Check if we are running in PhantomJS.
	 * Uploading a Blob with PhantomJS does not work correctly, as reported here:
	 * https://github.com/ariya/phantomjs/issues/11395
	 * @type boolean
	 */
	var isPhantomJS = typeof navigator !== 'undefined' && /PhantomJS/i.test(navigator.userAgent);
	
	/**
	 * When true, avoids using Blobs to encode payloads.
	 * @type boolean
	 */
	var dontSendBlobs = isAndroid || isPhantomJS;
	
	/**
	 * Current protocol version.
	 */
	
	exports.protocol = 3;
	
	/**
	 * Packet types.
	 */
	
	var packets = exports.packets = {
	    open:     0    // non-ws
	  , close:    1    // non-ws
	  , ping:     2
	  , pong:     3
	  , message:  4
	  , upgrade:  5
	  , noop:     6
	};
	
	var packetslist = keys(packets);
	
	/**
	 * Premade error packet.
	 */
	
	var err = { type: 'error', data: 'parser error' };
	
	/**
	 * Create a blob api even for blob builder when vendor prefixes exist
	 */
	
	var Blob = __webpack_require__(736);
	
	/**
	 * Encodes a packet.
	 *
	 *     <packet type id> [ <data> ]
	 *
	 * Example:
	 *
	 *     5hello world
	 *     3
	 *     4
	 *
	 * Binary is encoded in an identical principle
	 *
	 * @api private
	 */
	
	exports.encodePacket = function (packet, supportsBinary, utf8encode, callback) {
	  if (typeof supportsBinary === 'function') {
	    callback = supportsBinary;
	    supportsBinary = false;
	  }
	
	  if (typeof utf8encode === 'function') {
	    callback = utf8encode;
	    utf8encode = null;
	  }
	
	  var data = (packet.data === undefined)
	    ? undefined
	    : packet.data.buffer || packet.data;
	
	  if (typeof ArrayBuffer !== 'undefined' && data instanceof ArrayBuffer) {
	    return encodeArrayBuffer(packet, supportsBinary, callback);
	  } else if (typeof Blob !== 'undefined' && data instanceof Blob) {
	    return encodeBlob(packet, supportsBinary, callback);
	  }
	
	  // might be an object with { base64: true, data: dataAsBase64String }
	  if (data && data.base64) {
	    return encodeBase64Object(packet, callback);
	  }
	
	  // Sending data as a utf-8 string
	  var encoded = packets[packet.type];
	
	  // data fragment is optional
	  if (undefined !== packet.data) {
	    encoded += utf8encode ? utf8.encode(String(packet.data), { strict: false }) : String(packet.data);
	  }
	
	  return callback('' + encoded);
	
	};
	
	function encodeBase64Object(packet, callback) {
	  // packet data is an object { base64: true, data: dataAsBase64String }
	  var message = 'b' + exports.packets[packet.type] + packet.data.data;
	  return callback(message);
	}
	
	/**
	 * Encode packet helpers for binary types
	 */
	
	function encodeArrayBuffer(packet, supportsBinary, callback) {
	  if (!supportsBinary) {
	    return exports.encodeBase64Packet(packet, callback);
	  }
	
	  var data = packet.data;
	  var contentArray = new Uint8Array(data);
	  var resultBuffer = new Uint8Array(1 + data.byteLength);
	
	  resultBuffer[0] = packets[packet.type];
	  for (var i = 0; i < contentArray.length; i++) {
	    resultBuffer[i+1] = contentArray[i];
	  }
	
	  return callback(resultBuffer.buffer);
	}
	
	function encodeBlobAsArrayBuffer(packet, supportsBinary, callback) {
	  if (!supportsBinary) {
	    return exports.encodeBase64Packet(packet, callback);
	  }
	
	  var fr = new FileReader();
	  fr.onload = function() {
	    exports.encodePacket({ type: packet.type, data: fr.result }, supportsBinary, true, callback);
	  };
	  return fr.readAsArrayBuffer(packet.data);
	}
	
	function encodeBlob(packet, supportsBinary, callback) {
	  if (!supportsBinary) {
	    return exports.encodeBase64Packet(packet, callback);
	  }
	
	  if (dontSendBlobs) {
	    return encodeBlobAsArrayBuffer(packet, supportsBinary, callback);
	  }
	
	  var length = new Uint8Array(1);
	  length[0] = packets[packet.type];
	  var blob = new Blob([length.buffer, packet.data]);
	
	  return callback(blob);
	}
	
	/**
	 * Encodes a packet with binary data in a base64 string
	 *
	 * @param {Object} packet, has `type` and `data`
	 * @return {String} base64 encoded message
	 */
	
	exports.encodeBase64Packet = function(packet, callback) {
	  var message = 'b' + exports.packets[packet.type];
	  if (typeof Blob !== 'undefined' && packet.data instanceof Blob) {
	    var fr = new FileReader();
	    fr.onload = function() {
	      var b64 = fr.result.split(',')[1];
	      callback(message + b64);
	    };
	    return fr.readAsDataURL(packet.data);
	  }
	
	  var b64data;
	  try {
	    b64data = String.fromCharCode.apply(null, new Uint8Array(packet.data));
	  } catch (e) {
	    // iPhone Safari doesn't let you apply with typed arrays
	    var typed = new Uint8Array(packet.data);
	    var basic = new Array(typed.length);
	    for (var i = 0; i < typed.length; i++) {
	      basic[i] = typed[i];
	    }
	    b64data = String.fromCharCode.apply(null, basic);
	  }
	  message += btoa(b64data);
	  return callback(message);
	};
	
	/**
	 * Decodes a packet. Changes format to Blob if requested.
	 *
	 * @return {Object} with `type` and `data` (if any)
	 * @api private
	 */
	
	exports.decodePacket = function (data, binaryType, utf8decode) {
	  if (data === undefined) {
	    return err;
	  }
	  // String data
	  if (typeof data === 'string') {
	    if (data.charAt(0) === 'b') {
	      return exports.decodeBase64Packet(data.substr(1), binaryType);
	    }
	
	    if (utf8decode) {
	      data = tryDecode(data);
	      if (data === false) {
	        return err;
	      }
	    }
	    var type = data.charAt(0);
	
	    if (Number(type) != type || !packetslist[type]) {
	      return err;
	    }
	
	    if (data.length > 1) {
	      return { type: packetslist[type], data: data.substring(1) };
	    } else {
	      return { type: packetslist[type] };
	    }
	  }
	
	  var asArray = new Uint8Array(data);
	  var type = asArray[0];
	  var rest = sliceBuffer(data, 1);
	  if (Blob && binaryType === 'blob') {
	    rest = new Blob([rest]);
	  }
	  return { type: packetslist[type], data: rest };
	};
	
	function tryDecode(data) {
	  try {
	    data = utf8.decode(data, { strict: false });
	  } catch (e) {
	    return false;
	  }
	  return data;
	}
	
	/**
	 * Decodes a packet encoded in a base64 string
	 *
	 * @param {String} base64 encoded message
	 * @return {Object} with `type` and `data` (if any)
	 */
	
	exports.decodeBase64Packet = function(msg, binaryType) {
	  var type = packetslist[msg.charAt(0)];
	  if (!base64encoder) {
	    return { type: type, data: { base64: true, data: msg.substr(1) } };
	  }
	
	  var data = base64encoder.decode(msg.substr(1));
	
	  if (binaryType === 'blob' && Blob) {
	    data = new Blob([data]);
	  }
	
	  return { type: type, data: data };
	};
	
	/**
	 * Encodes multiple messages (payload).
	 *
	 *     <length>:data
	 *
	 * Example:
	 *
	 *     11:hello world2:hi
	 *
	 * If any contents are binary, they will be encoded as base64 strings. Base64
	 * encoded strings are marked with a b before the length specifier
	 *
	 * @param {Array} packets
	 * @api private
	 */
	
	exports.encodePayload = function (packets, supportsBinary, callback) {
	  if (typeof supportsBinary === 'function') {
	    callback = supportsBinary;
	    supportsBinary = null;
	  }
	
	  var isBinary = hasBinary(packets);
	
	  if (supportsBinary && isBinary) {
	    if (Blob && !dontSendBlobs) {
	      return exports.encodePayloadAsBlob(packets, callback);
	    }
	
	    return exports.encodePayloadAsArrayBuffer(packets, callback);
	  }
	
	  if (!packets.length) {
	    return callback('0:');
	  }
	
	  function setLengthHeader(message) {
	    return message.length + ':' + message;
	  }
	
	  function encodeOne(packet, doneCallback) {
	    exports.encodePacket(packet, !isBinary ? false : supportsBinary, false, function(message) {
	      doneCallback(null, setLengthHeader(message));
	    });
	  }
	
	  map(packets, encodeOne, function(err, results) {
	    return callback(results.join(''));
	  });
	};
	
	/**
	 * Async array map using after
	 */
	
	function map(ary, each, done) {
	  var result = new Array(ary.length);
	  var next = after(ary.length, done);
	
	  var eachWithIndex = function(i, el, cb) {
	    each(el, function(error, msg) {
	      result[i] = msg;
	      cb(error, result);
	    });
	  };
	
	  for (var i = 0; i < ary.length; i++) {
	    eachWithIndex(i, ary[i], next);
	  }
	}
	
	/*
	 * Decodes data when a payload is maybe expected. Possible binary contents are
	 * decoded from their base64 representation
	 *
	 * @param {String} data, callback method
	 * @api public
	 */
	
	exports.decodePayload = function (data, binaryType, callback) {
	  if (typeof data !== 'string') {
	    return exports.decodePayloadAsBinary(data, binaryType, callback);
	  }
	
	  if (typeof binaryType === 'function') {
	    callback = binaryType;
	    binaryType = null;
	  }
	
	  var packet;
	  if (data === '') {
	    // parser error - ignoring payload
	    return callback(err, 0, 1);
	  }
	
	  var length = '', n, msg;
	
	  for (var i = 0, l = data.length; i < l; i++) {
	    var chr = data.charAt(i);
	
	    if (chr !== ':') {
	      length += chr;
	      continue;
	    }
	
	    if (length === '' || (length != (n = Number(length)))) {
	      // parser error - ignoring payload
	      return callback(err, 0, 1);
	    }
	
	    msg = data.substr(i + 1, n);
	
	    if (length != msg.length) {
	      // parser error - ignoring payload
	      return callback(err, 0, 1);
	    }
	
	    if (msg.length) {
	      packet = exports.decodePacket(msg, binaryType, false);
	
	      if (err.type === packet.type && err.data === packet.data) {
	        // parser error in individual packet - ignoring payload
	        return callback(err, 0, 1);
	      }
	
	      var ret = callback(packet, i + n, l);
	      if (false === ret) return;
	    }
	
	    // advance cursor
	    i += n;
	    length = '';
	  }
	
	  if (length !== '') {
	    // parser error - ignoring payload
	    return callback(err, 0, 1);
	  }
	
	};
	
	/**
	 * Encodes multiple messages (payload) as binary.
	 *
	 * <1 = binary, 0 = string><number from 0-9><number from 0-9>[...]<number
	 * 255><data>
	 *
	 * Example:
	 * 1 3 255 1 2 3, if the binary contents are interpreted as 8 bit integers
	 *
	 * @param {Array} packets
	 * @return {ArrayBuffer} encoded payload
	 * @api private
	 */
	
	exports.encodePayloadAsArrayBuffer = function(packets, callback) {
	  if (!packets.length) {
	    return callback(new ArrayBuffer(0));
	  }
	
	  function encodeOne(packet, doneCallback) {
	    exports.encodePacket(packet, true, true, function(data) {
	      return doneCallback(null, data);
	    });
	  }
	
	  map(packets, encodeOne, function(err, encodedPackets) {
	    var totalLength = encodedPackets.reduce(function(acc, p) {
	      var len;
	      if (typeof p === 'string'){
	        len = p.length;
	      } else {
	        len = p.byteLength;
	      }
	      return acc + len.toString().length + len + 2; // string/binary identifier + separator = 2
	    }, 0);
	
	    var resultArray = new Uint8Array(totalLength);
	
	    var bufferIndex = 0;
	    encodedPackets.forEach(function(p) {
	      var isString = typeof p === 'string';
	      var ab = p;
	      if (isString) {
	        var view = new Uint8Array(p.length);
	        for (var i = 0; i < p.length; i++) {
	          view[i] = p.charCodeAt(i);
	        }
	        ab = view.buffer;
	      }
	
	      if (isString) { // not true binary
	        resultArray[bufferIndex++] = 0;
	      } else { // true binary
	        resultArray[bufferIndex++] = 1;
	      }
	
	      var lenStr = ab.byteLength.toString();
	      for (var i = 0; i < lenStr.length; i++) {
	        resultArray[bufferIndex++] = parseInt(lenStr[i]);
	      }
	      resultArray[bufferIndex++] = 255;
	
	      var view = new Uint8Array(ab);
	      for (var i = 0; i < view.length; i++) {
	        resultArray[bufferIndex++] = view[i];
	      }
	    });
	
	    return callback(resultArray.buffer);
	  });
	};
	
	/**
	 * Encode as Blob
	 */
	
	exports.encodePayloadAsBlob = function(packets, callback) {
	  function encodeOne(packet, doneCallback) {
	    exports.encodePacket(packet, true, true, function(encoded) {
	      var binaryIdentifier = new Uint8Array(1);
	      binaryIdentifier[0] = 1;
	      if (typeof encoded === 'string') {
	        var view = new Uint8Array(encoded.length);
	        for (var i = 0; i < encoded.length; i++) {
	          view[i] = encoded.charCodeAt(i);
	        }
	        encoded = view.buffer;
	        binaryIdentifier[0] = 0;
	      }
	
	      var len = (encoded instanceof ArrayBuffer)
	        ? encoded.byteLength
	        : encoded.size;
	
	      var lenStr = len.toString();
	      var lengthAry = new Uint8Array(lenStr.length + 1);
	      for (var i = 0; i < lenStr.length; i++) {
	        lengthAry[i] = parseInt(lenStr[i]);
	      }
	      lengthAry[lenStr.length] = 255;
	
	      if (Blob) {
	        var blob = new Blob([binaryIdentifier.buffer, lengthAry.buffer, encoded]);
	        doneCallback(null, blob);
	      }
	    });
	  }
	
	  map(packets, encodeOne, function(err, results) {
	    return callback(new Blob(results));
	  });
	};
	
	/*
	 * Decodes data when a payload is maybe expected. Strings are decoded by
	 * interpreting each byte as a key code for entries marked to start with 0. See
	 * description of encodePayloadAsBinary
	 *
	 * @param {ArrayBuffer} data, callback method
	 * @api public
	 */
	
	exports.decodePayloadAsBinary = function (data, binaryType, callback) {
	  if (typeof binaryType === 'function') {
	    callback = binaryType;
	    binaryType = null;
	  }
	
	  var bufferTail = data;
	  var buffers = [];
	
	  while (bufferTail.byteLength > 0) {
	    var tailArray = new Uint8Array(bufferTail);
	    var isString = tailArray[0] === 0;
	    var msgLength = '';
	
	    for (var i = 1; ; i++) {
	      if (tailArray[i] === 255) break;
	
	      // 310 = char length of Number.MAX_VALUE
	      if (msgLength.length > 310) {
	        return callback(err, 0, 1);
	      }
	
	      msgLength += tailArray[i];
	    }
	
	    bufferTail = sliceBuffer(bufferTail, 2 + msgLength.length);
	    msgLength = parseInt(msgLength);
	
	    var msg = sliceBuffer(bufferTail, 0, msgLength);
	    if (isString) {
	      try {
	        msg = String.fromCharCode.apply(null, new Uint8Array(msg));
	      } catch (e) {
	        // iPhone Safari doesn't let you apply to typed arrays
	        var typed = new Uint8Array(msg);
	        msg = '';
	        for (var i = 0; i < typed.length; i++) {
	          msg += String.fromCharCode(typed[i]);
	        }
	      }
	    }
	
	    buffers.push(msg);
	    bufferTail = sliceBuffer(bufferTail, msgLength);
	  }
	
	  var total = buffers.length;
	  buffers.forEach(function(buffer, i) {
	    callback(exports.decodePacket(buffer, binaryType, true), i, total);
	  });
	};


/***/ }),

/***/ 729:
/***/ (function(module, exports) {

	
	/**
	 * Gets the keys for an object.
	 *
	 * @return {Array} keys
	 * @api private
	 */
	
	module.exports = Object.keys || function keys (obj){
	  var arr = [];
	  var has = Object.prototype.hasOwnProperty;
	
	  for (var i in obj) {
	    if (has.call(obj, i)) {
	      arr.push(i);
	    }
	  }
	  return arr;
	};


/***/ }),

/***/ 730:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/* global Blob File */
	
	/*
	 * Module requirements.
	 */
	
	var isArray = __webpack_require__(731);
	
	var toString = Object.prototype.toString;
	var withNativeBlob = typeof Blob === 'function' ||
	                        typeof Blob !== 'undefined' && toString.call(Blob) === '[object BlobConstructor]';
	var withNativeFile = typeof File === 'function' ||
	                        typeof File !== 'undefined' && toString.call(File) === '[object FileConstructor]';
	
	/**
	 * Module exports.
	 */
	
	module.exports = hasBinary;
	
	/**
	 * Checks for binary data.
	 *
	 * Supports Buffer, ArrayBuffer, Blob and File.
	 *
	 * @param {Object} anything
	 * @api public
	 */
	
	function hasBinary (obj) {
	  if (!obj || typeof obj !== 'object') {
	    return false;
	  }
	
	  if (isArray(obj)) {
	    for (var i = 0, l = obj.length; i < l; i++) {
	      if (hasBinary(obj[i])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  if ((typeof Buffer === 'function' && Buffer.isBuffer && Buffer.isBuffer(obj)) ||
	    (typeof ArrayBuffer === 'function' && obj instanceof ArrayBuffer) ||
	    (withNativeBlob && obj instanceof Blob) ||
	    (withNativeFile && obj instanceof File)
	  ) {
	    return true;
	  }
	
	  // see: https://github.com/Automattic/has-binary/pull/4
	  if (obj.toJSON && typeof obj.toJSON === 'function' && arguments.length === 1) {
	    return hasBinary(obj.toJSON(), true);
	  }
	
	  for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key) && hasBinary(obj[key])) {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(714).Buffer))

/***/ }),

/***/ 731:
712,

/***/ 732:
/***/ (function(module, exports) {

	/**
	 * An abstraction for slicing an arraybuffer even when
	 * ArrayBuffer.prototype.slice is not supported
	 *
	 * @api public
	 */
	
	module.exports = function(arraybuffer, start, end) {
	  var bytes = arraybuffer.byteLength;
	  start = start || 0;
	  end = end || bytes;
	
	  if (arraybuffer.slice) { return arraybuffer.slice(start, end); }
	
	  if (start < 0) { start += bytes; }
	  if (end < 0) { end += bytes; }
	  if (end > bytes) { end = bytes; }
	
	  if (start >= bytes || start >= end || bytes === 0) {
	    return new ArrayBuffer(0);
	  }
	
	  var abv = new Uint8Array(arraybuffer);
	  var result = new Uint8Array(end - start);
	  for (var i = start, ii = 0; i < end; i++, ii++) {
	    result[ii] = abv[i];
	  }
	  return result.buffer;
	};


/***/ }),

/***/ 733:
/***/ (function(module, exports) {

	module.exports = after
	
	function after(count, callback, err_cb) {
	    var bail = false
	    err_cb = err_cb || noop
	    proxy.count = count
	
	    return (count === 0) ? callback() : proxy
	
	    function proxy(err, result) {
	        if (proxy.count <= 0) {
	            throw new Error('after called too many times')
	        }
	        --proxy.count
	
	        // after first error, rest are passed to err_cb
	        if (err) {
	            bail = true
	            callback(err)
	            // future error callbacks will go to error handler
	            callback = err_cb
	        } else if (proxy.count === 0 && !bail) {
	            callback(null, result)
	        }
	    }
	}
	
	function noop() {}


/***/ }),

/***/ 734:
/***/ (function(module, exports) {

	/*! https://mths.be/utf8js v2.1.2 by @mathias */
	
	var stringFromCharCode = String.fromCharCode;
	
	// Taken from https://mths.be/punycode
	function ucs2decode(string) {
		var output = [];
		var counter = 0;
		var length = string.length;
		var value;
		var extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}
	
	// Taken from https://mths.be/punycode
	function ucs2encode(array) {
		var length = array.length;
		var index = -1;
		var value;
		var output = '';
		while (++index < length) {
			value = array[index];
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
		}
		return output;
	}
	
	function checkScalarValue(codePoint, strict) {
		if (codePoint >= 0xD800 && codePoint <= 0xDFFF) {
			if (strict) {
				throw Error(
					'Lone surrogate U+' + codePoint.toString(16).toUpperCase() +
					' is not a scalar value'
				);
			}
			return false;
		}
		return true;
	}
	/*--------------------------------------------------------------------------*/
	
	function createByte(codePoint, shift) {
		return stringFromCharCode(((codePoint >> shift) & 0x3F) | 0x80);
	}
	
	function encodeCodePoint(codePoint, strict) {
		if ((codePoint & 0xFFFFFF80) == 0) { // 1-byte sequence
			return stringFromCharCode(codePoint);
		}
		var symbol = '';
		if ((codePoint & 0xFFFFF800) == 0) { // 2-byte sequence
			symbol = stringFromCharCode(((codePoint >> 6) & 0x1F) | 0xC0);
		}
		else if ((codePoint & 0xFFFF0000) == 0) { // 3-byte sequence
			if (!checkScalarValue(codePoint, strict)) {
				codePoint = 0xFFFD;
			}
			symbol = stringFromCharCode(((codePoint >> 12) & 0x0F) | 0xE0);
			symbol += createByte(codePoint, 6);
		}
		else if ((codePoint & 0xFFE00000) == 0) { // 4-byte sequence
			symbol = stringFromCharCode(((codePoint >> 18) & 0x07) | 0xF0);
			symbol += createByte(codePoint, 12);
			symbol += createByte(codePoint, 6);
		}
		symbol += stringFromCharCode((codePoint & 0x3F) | 0x80);
		return symbol;
	}
	
	function utf8encode(string, opts) {
		opts = opts || {};
		var strict = false !== opts.strict;
	
		var codePoints = ucs2decode(string);
		var length = codePoints.length;
		var index = -1;
		var codePoint;
		var byteString = '';
		while (++index < length) {
			codePoint = codePoints[index];
			byteString += encodeCodePoint(codePoint, strict);
		}
		return byteString;
	}
	
	/*--------------------------------------------------------------------------*/
	
	function readContinuationByte() {
		if (byteIndex >= byteCount) {
			throw Error('Invalid byte index');
		}
	
		var continuationByte = byteArray[byteIndex] & 0xFF;
		byteIndex++;
	
		if ((continuationByte & 0xC0) == 0x80) {
			return continuationByte & 0x3F;
		}
	
		// If we end up here, it’s not a continuation byte
		throw Error('Invalid continuation byte');
	}
	
	function decodeSymbol(strict) {
		var byte1;
		var byte2;
		var byte3;
		var byte4;
		var codePoint;
	
		if (byteIndex > byteCount) {
			throw Error('Invalid byte index');
		}
	
		if (byteIndex == byteCount) {
			return false;
		}
	
		// Read first byte
		byte1 = byteArray[byteIndex] & 0xFF;
		byteIndex++;
	
		// 1-byte sequence (no continuation bytes)
		if ((byte1 & 0x80) == 0) {
			return byte1;
		}
	
		// 2-byte sequence
		if ((byte1 & 0xE0) == 0xC0) {
			byte2 = readContinuationByte();
			codePoint = ((byte1 & 0x1F) << 6) | byte2;
			if (codePoint >= 0x80) {
				return codePoint;
			} else {
				throw Error('Invalid continuation byte');
			}
		}
	
		// 3-byte sequence (may include unpaired surrogates)
		if ((byte1 & 0xF0) == 0xE0) {
			byte2 = readContinuationByte();
			byte3 = readContinuationByte();
			codePoint = ((byte1 & 0x0F) << 12) | (byte2 << 6) | byte3;
			if (codePoint >= 0x0800) {
				return checkScalarValue(codePoint, strict) ? codePoint : 0xFFFD;
			} else {
				throw Error('Invalid continuation byte');
			}
		}
	
		// 4-byte sequence
		if ((byte1 & 0xF8) == 0xF0) {
			byte2 = readContinuationByte();
			byte3 = readContinuationByte();
			byte4 = readContinuationByte();
			codePoint = ((byte1 & 0x07) << 0x12) | (byte2 << 0x0C) |
				(byte3 << 0x06) | byte4;
			if (codePoint >= 0x010000 && codePoint <= 0x10FFFF) {
				return codePoint;
			}
		}
	
		throw Error('Invalid UTF-8 detected');
	}
	
	var byteArray;
	var byteCount;
	var byteIndex;
	function utf8decode(byteString, opts) {
		opts = opts || {};
		var strict = false !== opts.strict;
	
		byteArray = ucs2decode(byteString);
		byteCount = byteArray.length;
		byteIndex = 0;
		var codePoints = [];
		var tmp;
		while ((tmp = decodeSymbol(strict)) !== false) {
			codePoints.push(tmp);
		}
		return ucs2encode(codePoints);
	}
	
	module.exports = {
		version: '2.1.2',
		encode: utf8encode,
		decode: utf8decode
	};


/***/ }),

/***/ 735:
/***/ (function(module, exports) {

	/*
	 * base64-arraybuffer
	 * https://github.com/niklasvh/base64-arraybuffer
	 *
	 * Copyright (c) 2012 Niklas von Hertzen
	 * Licensed under the MIT license.
	 */
	(function(chars){
	  "use strict";
	
	  exports.encode = function(arraybuffer) {
	    var bytes = new Uint8Array(arraybuffer),
	    i, len = bytes.length, base64 = "";
	
	    for (i = 0; i < len; i+=3) {
	      base64 += chars[bytes[i] >> 2];
	      base64 += chars[((bytes[i] & 3) << 4) | (bytes[i + 1] >> 4)];
	      base64 += chars[((bytes[i + 1] & 15) << 2) | (bytes[i + 2] >> 6)];
	      base64 += chars[bytes[i + 2] & 63];
	    }
	
	    if ((len % 3) === 2) {
	      base64 = base64.substring(0, base64.length - 1) + "=";
	    } else if (len % 3 === 1) {
	      base64 = base64.substring(0, base64.length - 2) + "==";
	    }
	
	    return base64;
	  };
	
	  exports.decode =  function(base64) {
	    var bufferLength = base64.length * 0.75,
	    len = base64.length, i, p = 0,
	    encoded1, encoded2, encoded3, encoded4;
	
	    if (base64[base64.length - 1] === "=") {
	      bufferLength--;
	      if (base64[base64.length - 2] === "=") {
	        bufferLength--;
	      }
	    }
	
	    var arraybuffer = new ArrayBuffer(bufferLength),
	    bytes = new Uint8Array(arraybuffer);
	
	    for (i = 0; i < len; i+=4) {
	      encoded1 = chars.indexOf(base64[i]);
	      encoded2 = chars.indexOf(base64[i+1]);
	      encoded3 = chars.indexOf(base64[i+2]);
	      encoded4 = chars.indexOf(base64[i+3]);
	
	      bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
	      bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
	      bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
	    }
	
	    return arraybuffer;
	  };
	})("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/");


/***/ }),

/***/ 736:
/***/ (function(module, exports) {

	/**
	 * Create a blob builder even when vendor prefixes exist
	 */
	
	var BlobBuilder = typeof BlobBuilder !== 'undefined' ? BlobBuilder :
	  typeof WebKitBlobBuilder !== 'undefined' ? WebKitBlobBuilder :
	  typeof MSBlobBuilder !== 'undefined' ? MSBlobBuilder :
	  typeof MozBlobBuilder !== 'undefined' ? MozBlobBuilder : 
	  false;
	
	/**
	 * Check if Blob constructor is supported
	 */
	
	var blobSupported = (function() {
	  try {
	    var a = new Blob(['hi']);
	    return a.size === 2;
	  } catch(e) {
	    return false;
	  }
	})();
	
	/**
	 * Check if Blob constructor supports ArrayBufferViews
	 * Fails in Safari 6, so we need to map to ArrayBuffers there.
	 */
	
	var blobSupportsArrayBufferView = blobSupported && (function() {
	  try {
	    var b = new Blob([new Uint8Array([1,2])]);
	    return b.size === 2;
	  } catch(e) {
	    return false;
	  }
	})();
	
	/**
	 * Check if BlobBuilder is supported
	 */
	
	var blobBuilderSupported = BlobBuilder
	  && BlobBuilder.prototype.append
	  && BlobBuilder.prototype.getBlob;
	
	/**
	 * Helper function that maps ArrayBufferViews to ArrayBuffers
	 * Used by BlobBuilder constructor and old browsers that didn't
	 * support it in the Blob constructor.
	 */
	
	function mapArrayBufferViews(ary) {
	  return ary.map(function(chunk) {
	    if (chunk.buffer instanceof ArrayBuffer) {
	      var buf = chunk.buffer;
	
	      // if this is a subarray, make a copy so we only
	      // include the subarray region from the underlying buffer
	      if (chunk.byteLength !== buf.byteLength) {
	        var copy = new Uint8Array(chunk.byteLength);
	        copy.set(new Uint8Array(buf, chunk.byteOffset, chunk.byteLength));
	        buf = copy.buffer;
	      }
	
	      return buf;
	    }
	
	    return chunk;
	  });
	}
	
	function BlobBuilderConstructor(ary, options) {
	  options = options || {};
	
	  var bb = new BlobBuilder();
	  mapArrayBufferViews(ary).forEach(function(part) {
	    bb.append(part);
	  });
	
	  return (options.type) ? bb.getBlob(options.type) : bb.getBlob();
	};
	
	function BlobConstructor(ary, options) {
	  return new Blob(mapArrayBufferViews(ary), options || {});
	};
	
	if (typeof Blob !== 'undefined') {
	  BlobBuilderConstructor.prototype = Blob.prototype;
	  BlobConstructor.prototype = Blob.prototype;
	}
	
	module.exports = (function() {
	  if (blobSupported) {
	    return blobSupportsArrayBufferView ? Blob : BlobConstructor;
	  } else if (blobBuilderSupported) {
	    return BlobBuilderConstructor;
	  } else {
	    return undefined;
	  }
	})();


/***/ }),

/***/ 737:
/***/ (function(module, exports) {

	/**
	 * Compiles a querystring
	 * Returns string representation of the object
	 *
	 * @param {Object}
	 * @api private
	 */
	
	exports.encode = function (obj) {
	  var str = '';
	
	  for (var i in obj) {
	    if (obj.hasOwnProperty(i)) {
	      if (str.length) str += '&';
	      str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
	    }
	  }
	
	  return str;
	};
	
	/**
	 * Parses a simple querystring into an object
	 *
	 * @param {String} qs
	 * @api private
	 */
	
	exports.decode = function(qs){
	  var qry = {};
	  var pairs = qs.split('&');
	  for (var i = 0, l = pairs.length; i < l; i++) {
	    var pair = pairs[i].split('=');
	    qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
	  }
	  return qry;
	};


/***/ }),

/***/ 738:
/***/ (function(module, exports) {

	
	module.exports = function(a, b){
	  var fn = function(){};
	  fn.prototype = b.prototype;
	  a.prototype = new fn;
	  a.prototype.constructor = a;
	};

/***/ }),

/***/ 739:
/***/ (function(module, exports) {

	'use strict';
	
	var alphabet = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_'.split('')
	  , length = 64
	  , map = {}
	  , seed = 0
	  , i = 0
	  , prev;
	
	/**
	 * Return a string representing the specified number.
	 *
	 * @param {Number} num The number to convert.
	 * @returns {String} The string representation of the number.
	 * @api public
	 */
	function encode(num) {
	  var encoded = '';
	
	  do {
	    encoded = alphabet[num % length] + encoded;
	    num = Math.floor(num / length);
	  } while (num > 0);
	
	  return encoded;
	}
	
	/**
	 * Return the integer value specified by the given string.
	 *
	 * @param {String} str The string to convert.
	 * @returns {Number} The integer value represented by the string.
	 * @api public
	 */
	function decode(str) {
	  var decoded = 0;
	
	  for (i = 0; i < str.length; i++) {
	    decoded = decoded * length + map[str.charAt(i)];
	  }
	
	  return decoded;
	}
	
	/**
	 * Yeast: A tiny growing id generator.
	 *
	 * @returns {String} A unique id.
	 * @api public
	 */
	function yeast() {
	  var now = encode(+new Date());
	
	  if (now !== prev) return seed = 0, prev = now;
	  return now +'.'+ encode(seed++);
	}
	
	//
	// Map each character to its index.
	//
	for (; i < length; i++) map[alphabet[i]] = i;
	
	//
	// Expose the `yeast`, `encode` and `decode` functions.
	//
	yeast.encode = encode;
	yeast.decode = decode;
	module.exports = yeast;


/***/ }),

/***/ 740:
[1022, 741],

/***/ 741:
707,

/***/ 742:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module requirements.
	 */
	
	var Polling = __webpack_require__(726);
	var inherit = __webpack_require__(738);
	var globalThis = __webpack_require__(724);
	
	/**
	 * Module exports.
	 */
	
	module.exports = JSONPPolling;
	
	/**
	 * Cached regular expressions.
	 */
	
	var rNewline = /\n/g;
	var rEscapedNewline = /\\n/g;
	
	/**
	 * Global JSONP callbacks.
	 */
	
	var callbacks;
	
	/**
	 * Noop.
	 */
	
	function empty () { }
	
	/**
	 * JSONP Polling constructor.
	 *
	 * @param {Object} opts.
	 * @api public
	 */
	
	function JSONPPolling (opts) {
	  Polling.call(this, opts);
	
	  this.query = this.query || {};
	
	  // define global callbacks array if not present
	  // we do this here (lazily) to avoid unneeded global pollution
	  if (!callbacks) {
	    // we need to consider multiple engines in the same page
	    callbacks = globalThis.___eio = (globalThis.___eio || []);
	  }
	
	  // callback identifier
	  this.index = callbacks.length;
	
	  // add callback to jsonp global
	  var self = this;
	  callbacks.push(function (msg) {
	    self.onData(msg);
	  });
	
	  // append to query string
	  this.query.j = this.index;
	
	  // prevent spurious errors from being emitted when the window is unloaded
	  if (typeof addEventListener === 'function') {
	    addEventListener('beforeunload', function () {
	      if (self.script) self.script.onerror = empty;
	    }, false);
	  }
	}
	
	/**
	 * Inherits from Polling.
	 */
	
	inherit(JSONPPolling, Polling);
	
	/*
	 * JSONP only supports binary as base64 encoded strings
	 */
	
	JSONPPolling.prototype.supportsBinary = false;
	
	/**
	 * Closes the socket.
	 *
	 * @api private
	 */
	
	JSONPPolling.prototype.doClose = function () {
	  if (this.script) {
	    this.script.parentNode.removeChild(this.script);
	    this.script = null;
	  }
	
	  if (this.form) {
	    this.form.parentNode.removeChild(this.form);
	    this.form = null;
	    this.iframe = null;
	  }
	
	  Polling.prototype.doClose.call(this);
	};
	
	/**
	 * Starts a poll cycle.
	 *
	 * @api private
	 */
	
	JSONPPolling.prototype.doPoll = function () {
	  var self = this;
	  var script = document.createElement('script');
	
	  if (this.script) {
	    this.script.parentNode.removeChild(this.script);
	    this.script = null;
	  }
	
	  script.async = true;
	  script.src = this.uri();
	  script.onerror = function (e) {
	    self.onError('jsonp poll error', e);
	  };
	
	  var insertAt = document.getElementsByTagName('script')[0];
	  if (insertAt) {
	    insertAt.parentNode.insertBefore(script, insertAt);
	  } else {
	    (document.head || document.body).appendChild(script);
	  }
	  this.script = script;
	
	  var isUAgecko = 'undefined' !== typeof navigator && /gecko/i.test(navigator.userAgent);
	
	  if (isUAgecko) {
	    setTimeout(function () {
	      var iframe = document.createElement('iframe');
	      document.body.appendChild(iframe);
	      document.body.removeChild(iframe);
	    }, 100);
	  }
	};
	
	/**
	 * Writes with a hidden iframe.
	 *
	 * @param {String} data to send
	 * @param {Function} called upon flush.
	 * @api private
	 */
	
	JSONPPolling.prototype.doWrite = function (data, fn) {
	  var self = this;
	
	  if (!this.form) {
	    var form = document.createElement('form');
	    var area = document.createElement('textarea');
	    var id = this.iframeId = 'eio_iframe_' + this.index;
	    var iframe;
	
	    form.className = 'socketio';
	    form.style.position = 'absolute';
	    form.style.top = '-1000px';
	    form.style.left = '-1000px';
	    form.target = id;
	    form.method = 'POST';
	    form.setAttribute('accept-charset', 'utf-8');
	    area.name = 'd';
	    form.appendChild(area);
	    document.body.appendChild(form);
	
	    this.form = form;
	    this.area = area;
	  }
	
	  this.form.action = this.uri();
	
	  function complete () {
	    initIframe();
	    fn();
	  }
	
	  function initIframe () {
	    if (self.iframe) {
	      try {
	        self.form.removeChild(self.iframe);
	      } catch (e) {
	        self.onError('jsonp polling iframe removal error', e);
	      }
	    }
	
	    try {
	      // ie6 dynamic iframes with target="" support (thanks Chris Lambacher)
	      var html = '<iframe src="javascript:0" name="' + self.iframeId + '">';
	      iframe = document.createElement(html);
	    } catch (e) {
	      iframe = document.createElement('iframe');
	      iframe.name = self.iframeId;
	      iframe.src = 'javascript:0';
	    }
	
	    iframe.id = self.iframeId;
	
	    self.form.appendChild(iframe);
	    self.iframe = iframe;
	  }
	
	  initIframe();
	
	  // escape \n to prevent it from being converted into \r\n by some UAs
	  // double escaping is required for escaped new lines because unescaping of new lines can be done safely on server-side
	  data = data.replace(rEscapedNewline, '\\\n');
	  this.area.value = data.replace(rNewline, '\\n');
	
	  try {
	    this.form.submit();
	  } catch (e) {}
	
	  if (this.iframe.attachEvent) {
	    this.iframe.onreadystatechange = function () {
	      if (self.iframe.readyState === 'complete') {
	        complete();
	      }
	    };
	  } else {
	    this.iframe.onload = complete;
	  }
	};


/***/ }),

/***/ 743:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/**
	 * Module dependencies.
	 */
	
	var Transport = __webpack_require__(727);
	var parser = __webpack_require__(728);
	var parseqs = __webpack_require__(737);
	var inherit = __webpack_require__(738);
	var yeast = __webpack_require__(739);
	var debug = __webpack_require__(740)('engine.io-client:websocket');
	
	var BrowserWebSocket, NodeWebSocket;
	
	if (typeof WebSocket !== 'undefined') {
	  BrowserWebSocket = WebSocket;
	} else if (typeof self !== 'undefined') {
	  BrowserWebSocket = self.WebSocket || self.MozWebSocket;
	}
	
	if (typeof window === 'undefined') {
	  try {
	    NodeWebSocket = __webpack_require__(744);
	  } catch (e) { }
	}
	
	/**
	 * Get either the `WebSocket` or `MozWebSocket` globals
	 * in the browser or try to resolve WebSocket-compatible
	 * interface exposed by `ws` for Node-like environment.
	 */
	
	var WebSocketImpl = BrowserWebSocket || NodeWebSocket;
	
	/**
	 * Module exports.
	 */
	
	module.exports = WS;
	
	/**
	 * WebSocket transport constructor.
	 *
	 * @api {Object} connection options
	 * @api public
	 */
	
	function WS (opts) {
	  var forceBase64 = (opts && opts.forceBase64);
	  if (forceBase64) {
	    this.supportsBinary = false;
	  }
	  this.perMessageDeflate = opts.perMessageDeflate;
	  this.usingBrowserWebSocket = BrowserWebSocket && !opts.forceNode;
	  this.protocols = opts.protocols;
	  if (!this.usingBrowserWebSocket) {
	    WebSocketImpl = NodeWebSocket;
	  }
	  Transport.call(this, opts);
	}
	
	/**
	 * Inherits from Transport.
	 */
	
	inherit(WS, Transport);
	
	/**
	 * Transport name.
	 *
	 * @api public
	 */
	
	WS.prototype.name = 'websocket';
	
	/*
	 * WebSockets support binary
	 */
	
	WS.prototype.supportsBinary = true;
	
	/**
	 * Opens socket.
	 *
	 * @api private
	 */
	
	WS.prototype.doOpen = function () {
	  if (!this.check()) {
	    // let probe timeout
	    return;
	  }
	
	  var uri = this.uri();
	  var protocols = this.protocols;
	
	  var opts = {};
	
	  if (!this.isReactNative) {
	    opts.agent = this.agent;
	    opts.perMessageDeflate = this.perMessageDeflate;
	
	    // SSL options for Node.js client
	    opts.pfx = this.pfx;
	    opts.key = this.key;
	    opts.passphrase = this.passphrase;
	    opts.cert = this.cert;
	    opts.ca = this.ca;
	    opts.ciphers = this.ciphers;
	    opts.rejectUnauthorized = this.rejectUnauthorized;
	  }
	
	  if (this.extraHeaders) {
	    opts.headers = this.extraHeaders;
	  }
	  if (this.localAddress) {
	    opts.localAddress = this.localAddress;
	  }
	
	  try {
	    this.ws =
	      this.usingBrowserWebSocket && !this.isReactNative
	        ? protocols
	          ? new WebSocketImpl(uri, protocols)
	          : new WebSocketImpl(uri)
	        : new WebSocketImpl(uri, protocols, opts);
	  } catch (err) {
	    return this.emit('error', err);
	  }
	
	  if (this.ws.binaryType === undefined) {
	    this.supportsBinary = false;
	  }
	
	  if (this.ws.supports && this.ws.supports.binary) {
	    this.supportsBinary = true;
	    this.ws.binaryType = 'nodebuffer';
	  } else {
	    this.ws.binaryType = 'arraybuffer';
	  }
	
	  this.addEventListeners();
	};
	
	/**
	 * Adds event listeners to the socket
	 *
	 * @api private
	 */
	
	WS.prototype.addEventListeners = function () {
	  var self = this;
	
	  this.ws.onopen = function () {
	    self.onOpen();
	  };
	  this.ws.onclose = function () {
	    self.onClose();
	  };
	  this.ws.onmessage = function (ev) {
	    self.onData(ev.data);
	  };
	  this.ws.onerror = function (e) {
	    self.onError('websocket error', e);
	  };
	};
	
	/**
	 * Writes data to socket.
	 *
	 * @param {Array} array of packets.
	 * @api private
	 */
	
	WS.prototype.write = function (packets) {
	  var self = this;
	  this.writable = false;
	
	  // encodePacket efficient as it uses WS framing
	  // no need for encodePayload
	  var total = packets.length;
	  for (var i = 0, l = total; i < l; i++) {
	    (function (packet) {
	      parser.encodePacket(packet, self.supportsBinary, function (data) {
	        if (!self.usingBrowserWebSocket) {
	          // always create a new object (GH-437)
	          var opts = {};
	          if (packet.options) {
	            opts.compress = packet.options.compress;
	          }
	
	          if (self.perMessageDeflate) {
	            var len = 'string' === typeof data ? Buffer.byteLength(data) : data.length;
	            if (len < self.perMessageDeflate.threshold) {
	              opts.compress = false;
	            }
	          }
	        }
	
	        // Sometimes the websocket has already been closed but the browser didn't
	        // have a chance of informing us about it yet, in that case send will
	        // throw an error
	        try {
	          if (self.usingBrowserWebSocket) {
	            // TypeError is thrown when passing the second argument on Safari
	            self.ws.send(data);
	          } else {
	            self.ws.send(data, opts);
	          }
	        } catch (e) {
	          debug('websocket closed before onclose event');
	        }
	
	        --total || done();
	      });
	    })(packets[i]);
	  }
	
	  function done () {
	    self.emit('flush');
	
	    // fake drain
	    // defer to next tick to allow Socket to clear writeBuffer
	    setTimeout(function () {
	      self.writable = true;
	      self.emit('drain');
	    }, 0);
	  }
	};
	
	/**
	 * Called upon close
	 *
	 * @api private
	 */
	
	WS.prototype.onClose = function () {
	  Transport.prototype.onClose.call(this);
	};
	
	/**
	 * Closes socket.
	 *
	 * @api private
	 */
	
	WS.prototype.doClose = function () {
	  if (typeof this.ws !== 'undefined') {
	    this.ws.onerror = function () {};
	    this.ws.close();
	  }
	};
	
	/**
	 * Generates uri for connection.
	 *
	 * @api private
	 */
	
	WS.prototype.uri = function () {
	  var query = this.query || {};
	  var schema = this.secure ? 'wss' : 'ws';
	  var port = '';
	
	  // avoid port if default for schema
	  if (this.port && (('wss' === schema && Number(this.port) !== 443) ||
	    ('ws' === schema && Number(this.port) !== 80))) {
	    port = ':' + this.port;
	  }
	
	  // append timestamp to URI
	  if (this.timestampRequests) {
	    query[this.timestampParam] = yeast();
	  }
	
	  // communicate binary support capabilities
	  if (!this.supportsBinary) {
	    query.b64 = 1;
	  }
	
	  query = parseqs.encode(query);
	
	  // prepend ? to query
	  if (query.length) {
	    query = '?' + query;
	  }
	
	  var ipv6 = this.hostname.indexOf(':') !== -1;
	  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
	};
	
	/**
	 * Feature detection for WebSocket.
	 *
	 * @return {Boolean} whether this transport is available.
	 * @api public
	 */
	
	WS.prototype.check = function () {
	  return !!WebSocketImpl && !('__initialize' in WebSocketImpl && this.name === WS.prototype.name);
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(714).Buffer))

/***/ }),

/***/ 744:
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),

/***/ 745:
/***/ (function(module, exports) {

	
	var indexOf = [].indexOf;
	
	module.exports = function(arr, obj){
	  if (indexOf) return arr.indexOf(obj);
	  for (var i = 0; i < arr.length; ++i) {
	    if (arr[i] === obj) return i;
	  }
	  return -1;
	};

/***/ }),

/***/ 746:
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var parser = __webpack_require__(709);
	var Emitter = __webpack_require__(710);
	var toArray = __webpack_require__(747);
	var on = __webpack_require__(748);
	var bind = __webpack_require__(749);
	var debug = __webpack_require__(706)('socket.io-client:socket');
	var parseqs = __webpack_require__(737);
	var hasBin = __webpack_require__(730);
	
	/**
	 * Module exports.
	 */
	
	module.exports = exports = Socket;
	
	/**
	 * Internal events (blacklisted).
	 * These events can't be emitted by the user.
	 *
	 * @api private
	 */
	
	var events = {
	  connect: 1,
	  connect_error: 1,
	  connect_timeout: 1,
	  connecting: 1,
	  disconnect: 1,
	  error: 1,
	  reconnect: 1,
	  reconnect_attempt: 1,
	  reconnect_failed: 1,
	  reconnect_error: 1,
	  reconnecting: 1,
	  ping: 1,
	  pong: 1
	};
	
	/**
	 * Shortcut to `Emitter#emit`.
	 */
	
	var emit = Emitter.prototype.emit;
	
	/**
	 * `Socket` constructor.
	 *
	 * @api public
	 */
	
	function Socket (io, nsp, opts) {
	  this.io = io;
	  this.nsp = nsp;
	  this.json = this; // compat
	  this.ids = 0;
	  this.acks = {};
	  this.receiveBuffer = [];
	  this.sendBuffer = [];
	  this.connected = false;
	  this.disconnected = true;
	  this.flags = {};
	  if (opts && opts.query) {
	    this.query = opts.query;
	  }
	  if (this.io.autoConnect) this.open();
	}
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Socket.prototype);
	
	/**
	 * Subscribe to open, close and packet events
	 *
	 * @api private
	 */
	
	Socket.prototype.subEvents = function () {
	  if (this.subs) return;
	
	  var io = this.io;
	  this.subs = [
	    on(io, 'open', bind(this, 'onopen')),
	    on(io, 'packet', bind(this, 'onpacket')),
	    on(io, 'close', bind(this, 'onclose'))
	  ];
	};
	
	/**
	 * "Opens" the socket.
	 *
	 * @api public
	 */
	
	Socket.prototype.open =
	Socket.prototype.connect = function () {
	  if (this.connected) return this;
	
	  this.subEvents();
	  if (!this.io.reconnecting) this.io.open(); // ensure open
	  if ('open' === this.io.readyState) this.onopen();
	  this.emit('connecting');
	  return this;
	};
	
	/**
	 * Sends a `message` event.
	 *
	 * @return {Socket} self
	 * @api public
	 */
	
	Socket.prototype.send = function () {
	  var args = toArray(arguments);
	  args.unshift('message');
	  this.emit.apply(this, args);
	  return this;
	};
	
	/**
	 * Override `emit`.
	 * If the event is in `events`, it's emitted normally.
	 *
	 * @param {String} event name
	 * @return {Socket} self
	 * @api public
	 */
	
	Socket.prototype.emit = function (ev) {
	  if (events.hasOwnProperty(ev)) {
	    emit.apply(this, arguments);
	    return this;
	  }
	
	  var args = toArray(arguments);
	  var packet = {
	    type: (this.flags.binary !== undefined ? this.flags.binary : hasBin(args)) ? parser.BINARY_EVENT : parser.EVENT,
	    data: args
	  };
	
	  packet.options = {};
	  packet.options.compress = !this.flags || false !== this.flags.compress;
	
	  // event ack callback
	  if ('function' === typeof args[args.length - 1]) {
	    debug('emitting packet with ack id %d', this.ids);
	    this.acks[this.ids] = args.pop();
	    packet.id = this.ids++;
	  }
	
	  if (this.connected) {
	    this.packet(packet);
	  } else {
	    this.sendBuffer.push(packet);
	  }
	
	  this.flags = {};
	
	  return this;
	};
	
	/**
	 * Sends a packet.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Socket.prototype.packet = function (packet) {
	  packet.nsp = this.nsp;
	  this.io.packet(packet);
	};
	
	/**
	 * Called upon engine `open`.
	 *
	 * @api private
	 */
	
	Socket.prototype.onopen = function () {
	  debug('transport is open - connecting');
	
	  // write connect packet if necessary
	  if ('/' !== this.nsp) {
	    if (this.query) {
	      var query = typeof this.query === 'object' ? parseqs.encode(this.query) : this.query;
	      debug('sending connect packet with query %s', query);
	      this.packet({type: parser.CONNECT, query: query});
	    } else {
	      this.packet({type: parser.CONNECT});
	    }
	  }
	};
	
	/**
	 * Called upon engine `close`.
	 *
	 * @param {String} reason
	 * @api private
	 */
	
	Socket.prototype.onclose = function (reason) {
	  debug('close (%s)', reason);
	  this.connected = false;
	  this.disconnected = true;
	  delete this.id;
	  this.emit('disconnect', reason);
	};
	
	/**
	 * Called with socket packet.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Socket.prototype.onpacket = function (packet) {
	  var sameNamespace = packet.nsp === this.nsp;
	  var rootNamespaceError = packet.type === parser.ERROR && packet.nsp === '/';
	
	  if (!sameNamespace && !rootNamespaceError) return;
	
	  switch (packet.type) {
	    case parser.CONNECT:
	      this.onconnect();
	      break;
	
	    case parser.EVENT:
	      this.onevent(packet);
	      break;
	
	    case parser.BINARY_EVENT:
	      this.onevent(packet);
	      break;
	
	    case parser.ACK:
	      this.onack(packet);
	      break;
	
	    case parser.BINARY_ACK:
	      this.onack(packet);
	      break;
	
	    case parser.DISCONNECT:
	      this.ondisconnect();
	      break;
	
	    case parser.ERROR:
	      this.emit('error', packet.data);
	      break;
	  }
	};
	
	/**
	 * Called upon a server event.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Socket.prototype.onevent = function (packet) {
	  var args = packet.data || [];
	  debug('emitting event %j', args);
	
	  if (null != packet.id) {
	    debug('attaching ack callback to event');
	    args.push(this.ack(packet.id));
	  }
	
	  if (this.connected) {
	    emit.apply(this, args);
	  } else {
	    this.receiveBuffer.push(args);
	  }
	};
	
	/**
	 * Produces an ack callback to emit with an event.
	 *
	 * @api private
	 */
	
	Socket.prototype.ack = function (id) {
	  var self = this;
	  var sent = false;
	  return function () {
	    // prevent double callbacks
	    if (sent) return;
	    sent = true;
	    var args = toArray(arguments);
	    debug('sending ack %j', args);
	
	    self.packet({
	      type: hasBin(args) ? parser.BINARY_ACK : parser.ACK,
	      id: id,
	      data: args
	    });
	  };
	};
	
	/**
	 * Called upon a server acknowlegement.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Socket.prototype.onack = function (packet) {
	  var ack = this.acks[packet.id];
	  if ('function' === typeof ack) {
	    debug('calling ack %s with %j', packet.id, packet.data);
	    ack.apply(this, packet.data);
	    delete this.acks[packet.id];
	  } else {
	    debug('bad ack %s', packet.id);
	  }
	};
	
	/**
	 * Called upon server connect.
	 *
	 * @api private
	 */
	
	Socket.prototype.onconnect = function () {
	  this.connected = true;
	  this.disconnected = false;
	  this.emitBuffered();
	  this.emit('connect');
	};
	
	/**
	 * Emit buffered events (received and emitted).
	 *
	 * @api private
	 */
	
	Socket.prototype.emitBuffered = function () {
	  var i;
	  for (i = 0; i < this.receiveBuffer.length; i++) {
	    emit.apply(this, this.receiveBuffer[i]);
	  }
	  this.receiveBuffer = [];
	
	  for (i = 0; i < this.sendBuffer.length; i++) {
	    this.packet(this.sendBuffer[i]);
	  }
	  this.sendBuffer = [];
	};
	
	/**
	 * Called upon server disconnect.
	 *
	 * @api private
	 */
	
	Socket.prototype.ondisconnect = function () {
	  debug('server disconnect (%s)', this.nsp);
	  this.destroy();
	  this.onclose('io server disconnect');
	};
	
	/**
	 * Called upon forced client/server side disconnections,
	 * this method ensures the manager stops tracking us and
	 * that reconnections don't get triggered for this.
	 *
	 * @api private.
	 */
	
	Socket.prototype.destroy = function () {
	  if (this.subs) {
	    // clean subscriptions to avoid reconnections
	    for (var i = 0; i < this.subs.length; i++) {
	      this.subs[i].destroy();
	    }
	    this.subs = null;
	  }
	
	  this.io.destroy(this);
	};
	
	/**
	 * Disconnects the socket manually.
	 *
	 * @return {Socket} self
	 * @api public
	 */
	
	Socket.prototype.close =
	Socket.prototype.disconnect = function () {
	  if (this.connected) {
	    debug('performing disconnect (%s)', this.nsp);
	    this.packet({ type: parser.DISCONNECT });
	  }
	
	  // remove socket from pool
	  this.destroy();
	
	  if (this.connected) {
	    // fire events
	    this.onclose('io client disconnect');
	  }
	  return this;
	};
	
	/**
	 * Sets the compress flag.
	 *
	 * @param {Boolean} if `true`, compresses the sending data
	 * @return {Socket} self
	 * @api public
	 */
	
	Socket.prototype.compress = function (compress) {
	  this.flags.compress = compress;
	  return this;
	};
	
	/**
	 * Sets the binary flag
	 *
	 * @param {Boolean} whether the emitted data contains binary
	 * @return {Socket} self
	 * @api public
	 */
	
	Socket.prototype.binary = function (binary) {
	  this.flags.binary = binary;
	  return this;
	};


/***/ }),

/***/ 747:
/***/ (function(module, exports) {

	module.exports = toArray
	
	function toArray(list, index) {
	    var array = []
	
	    index = index || 0
	
	    for (var i = index || 0; i < list.length; i++) {
	        array[i - index] = list[i]
	    }
	
	    return array
	}


/***/ }),

/***/ 748:
/***/ (function(module, exports) {

	
	/**
	 * Module exports.
	 */
	
	module.exports = on;
	
	/**
	 * Helper for subscriptions.
	 *
	 * @param {Object|EventEmitter} obj with `Emitter` mixin or `EventEmitter`
	 * @param {String} event name
	 * @param {Function} callback
	 * @api public
	 */
	
	function on (obj, ev, fn) {
	  obj.on(ev, fn);
	  return {
	    destroy: function () {
	      obj.removeListener(ev, fn);
	    }
	  };
	}


/***/ }),

/***/ 749:
/***/ (function(module, exports) {

	/**
	 * Slice reference.
	 */
	
	var slice = [].slice;
	
	/**
	 * Bind `obj` to `fn`.
	 *
	 * @param {Object} obj
	 * @param {Function|String} fn or string
	 * @return {Function}
	 * @api public
	 */
	
	module.exports = function(obj, fn){
	  if ('string' == typeof fn) fn = obj[fn];
	  if ('function' != typeof fn) throw new Error('bind() requires a function');
	  var args = slice.call(arguments, 2);
	  return function(){
	    return fn.apply(obj, args.concat(slice.call(arguments)));
	  }
	};


/***/ }),

/***/ 750:
/***/ (function(module, exports) {

	
	/**
	 * Expose `Backoff`.
	 */
	
	module.exports = Backoff;
	
	/**
	 * Initialize backoff timer with `opts`.
	 *
	 * - `min` initial timeout in milliseconds [100]
	 * - `max` max timeout [10000]
	 * - `jitter` [0]
	 * - `factor` [2]
	 *
	 * @param {Object} opts
	 * @api public
	 */
	
	function Backoff(opts) {
	  opts = opts || {};
	  this.ms = opts.min || 100;
	  this.max = opts.max || 10000;
	  this.factor = opts.factor || 2;
	  this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
	  this.attempts = 0;
	}
	
	/**
	 * Return the backoff duration.
	 *
	 * @return {Number}
	 * @api public
	 */
	
	Backoff.prototype.duration = function(){
	  var ms = this.ms * Math.pow(this.factor, this.attempts++);
	  if (this.jitter) {
	    var rand =  Math.random();
	    var deviation = Math.floor(rand * this.jitter * ms);
	    ms = (Math.floor(rand * 10) & 1) == 0  ? ms - deviation : ms + deviation;
	  }
	  return Math.min(ms, this.max) | 0;
	};
	
	/**
	 * Reset the number of attempts.
	 *
	 * @api public
	 */
	
	Backoff.prototype.reset = function(){
	  this.attempts = 0;
	};
	
	/**
	 * Set the minimum duration
	 *
	 * @api public
	 */
	
	Backoff.prototype.setMin = function(min){
	  this.ms = min;
	};
	
	/**
	 * Set the maximum duration
	 *
	 * @api public
	 */
	
	Backoff.prototype.setMax = function(max){
	  this.max = max;
	};
	
	/**
	 * Set the jitter
	 *
	 * @api public
	 */
	
	Backoff.prototype.setJitter = function(jitter){
	  this.jitter = jitter;
	};
	


/***/ }),

/***/ 751:
/***/ (function(module, exports) {

	module.exports = "\n<div #gmap style=\"width:100%;height:100%; position: absolute\"></div>";

/***/ }),

/***/ 752:
427,

/***/ 753:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var shared_1 = __webpack_require__(213);
	// Import components
	var ChildrenListComponent_1 = __webpack_require__(754);
	var ChildrenListRouting_1 = __webpack_require__(759);
	var ChildrenListModule = (function () {
	    function ChildrenListModule() {
	    }
	    return ChildrenListModule;
	}());
	ChildrenListModule = __decorate([
	    core_1.NgModule({
	        declarations: [
	            ChildrenListComponent_1.ChildrenListComponent
	        ],
	        imports: [
	            shared_1.SharedModule,
	            ChildrenListRouting_1.ChildrenListRouter
	        ]
	    })
	], ChildrenListModule);
	exports.ChildrenListModule = ChildrenListModule;


/***/ }),

/***/ 754:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var ChildrenServices_1 = __webpack_require__(696);
	var ChildrenListComponent = (function () {
	    function ChildrenListComponent(childrenServices, router) {
	        this.childrenServices = childrenServices;
	        this.router = router;
	        this.campsChildren = [];
	    }
	    ChildrenListComponent.prototype.ngOnInit = function () {
	        this.getChildren();
	    };
	    // End of Init
	    // Get all children
	    ChildrenListComponent.prototype.getChildren = function () {
	        var _this = this;
	        this.childrenServices.getChildren().subscribe(function (result) {
	            _this.campsChildren = result;
	        }, function (error) {
	        });
	    };
	    /**
	     *
	     * Click event on Child list
	     *
	     * @memberOf ChildrenListComponent
	     */
	    ChildrenListComponent.prototype.toChildAttendance = function (id) {
	        this.router.navigate(['/bus-attendance', id]);
	    };
	    return ChildrenListComponent;
	}());
	ChildrenListComponent = __decorate([
	    core_1.Component({
	        template: __webpack_require__(755),
	        styles: [__webpack_require__(758)]
	    }),
	    __metadata("design:paramtypes", [ChildrenServices_1.ChildrenServices,
	        router_1.Router])
	], ChildrenListComponent);
	exports.ChildrenListComponent = ChildrenListComponent;


/***/ }),

/***/ 755:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<main>\n    <div class=\"camp_section\">\n        <img src=\"" + __webpack_require__(756) + "\" alt=\"\">\n        <p>Please choose your child to view bus attendance</p>\n        <ul *ngIf=\"campsChildren\">\n            <li *ngFor=\"let campsChild of campsChildren\">\n                <p class=\"child_img\"><img src=\"" + __webpack_require__(757) + "\"></p>\n                <p class=\"child_info\">\n                    <span>{{ campsChild.pupilCode }}-</span>\n                    <span>{{ campsChild.foreName }}</span>\n                    <span>{{ campsChild.surName }} - </span>\n                    <span></span>\n                    <span>({{ campsChild.grade_class.name }})</span>\n                </p>\n                <button (click)=\"toChildAttendance(campsChild.pupilCode)\">Select</button>\n            </li>\n        </ul>\n    </div>\n</main>";

/***/ }),

/***/ 756:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/camp_list_children_image.96f2732c0223dd3a90107e487b1b183f.png";

/***/ }),

/***/ 757:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/camp_children_icon.9ccf1c39ba33deab3a314da9ee63f888.png";

/***/ }),

/***/ 758:
/***/ (function(module, exports) {

	module.exports = ".camp_section{text-align:center}.camp_section>img{margin-top:60px;margin-bottom:40px}.camp_section h3{color:#282828}.camp_section ul{margin-top:33px;margin-bottom:69px}.camp_section ul li{width:50%;border:1px solid #ddd;border-bottom:none;height:auto;margin:0 auto;box-sizing:border-box;padding:20px;overflow:hidden}.camp_section ul li>*{float:left}.camp_section ul li>p{margin-bottom:0}.camp_section ul>li:first-child{border-top-left-radius:5px;border-top-right-radius:5px}.camp_section ul>li:last-child{border-bottom-left-radius:5px;border-bottom-right-radius:5px;border-bottom:1px solid #ddd}.camp_section .child_info{line-height:36px;margin-left:25px;color:#282828;text-align:left;max-width:60%}.camp_section button{float:right !important;border:none;height:39px;width:96px;font-weight:500;border-radius:4px;color:#fff;background:#054181;margin:0;padding:0}.camp_section button:hover{background:#faa635;color:#054181}@media only screen and (max-width: 40em){.camp_section img{width:90px}.camp_section p{font-size:0.875rem;width:90%;margin:0 auto}.camp_section ul{width:100%;margin-right:0;margin-left:0;padding-left:1.25rem;padding-right:1.25rem}.camp_section ul li{width:100%;padding-left:3.5%;padding-right:3.5%}.camp_section ul li .child_img{margin-left:0}.camp_section ul li .child_img img{display:none}.camp_section ul li .child_info{width:80%;margin-left:0}.camp_section ul li .child_info span{float:left}.camp_section ul li button{width:70px;font-size:0.875rem;width:20%}}\n"

/***/ }),

/***/ 759:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var router_1 = __webpack_require__(26);
	// Import components
	var ChildrenListComponent_1 = __webpack_require__(754);
	var ChildrenListRoutes = [
	    {
	        path: 'booking/students',
	        component: ChildrenListComponent_1.ChildrenListComponent
	    }
	];
	exports.ChildrenListRouter = router_1.RouterModule.forChild(ChildrenListRoutes);


/***/ }),

/***/ 1022:
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = __webpack_require__(__webpack_module_template_argument_0__);
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = 'undefined' != typeof chrome
	               && 'undefined' != typeof chrome.storage
	                  ? chrome.storage.local
	                  : localstorage();
	
	/**
	 * Colors.
	 */
	
	exports.colors = [
	  '#0000CC', '#0000FF', '#0033CC', '#0033FF', '#0066CC', '#0066FF', '#0099CC',
	  '#0099FF', '#00CC00', '#00CC33', '#00CC66', '#00CC99', '#00CCCC', '#00CCFF',
	  '#3300CC', '#3300FF', '#3333CC', '#3333FF', '#3366CC', '#3366FF', '#3399CC',
	  '#3399FF', '#33CC00', '#33CC33', '#33CC66', '#33CC99', '#33CCCC', '#33CCFF',
	  '#6600CC', '#6600FF', '#6633CC', '#6633FF', '#66CC00', '#66CC33', '#9900CC',
	  '#9900FF', '#9933CC', '#9933FF', '#99CC00', '#99CC33', '#CC0000', '#CC0033',
	  '#CC0066', '#CC0099', '#CC00CC', '#CC00FF', '#CC3300', '#CC3333', '#CC3366',
	  '#CC3399', '#CC33CC', '#CC33FF', '#CC6600', '#CC6633', '#CC9900', '#CC9933',
	  '#CCCC00', '#CCCC33', '#FF0000', '#FF0033', '#FF0066', '#FF0099', '#FF00CC',
	  '#FF00FF', '#FF3300', '#FF3333', '#FF3366', '#FF3399', '#FF33CC', '#FF33FF',
	  '#FF6600', '#FF6633', '#FF9900', '#FF9933', '#FFCC00', '#FFCC33'
	];
	
	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */
	
	function useColors() {
	  // NB: In an Electron preload script, document will be defined but not fully
	  // initialized. Since we know we're in Chrome, we'll just detect this case
	  // explicitly
	  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
	    return true;
	  }
	
	  // Internet Explorer and Edge do not support colors.
	  if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
	    return false;
	  }
	
	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
	  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
	    // is firebug? http://stackoverflow.com/a/398120/376773
	    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
	    // is firefox >= v31?
	    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
	    // double check webkit in userAgent just in case we are in a worker
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
	}
	
	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */
	
	exports.formatters.j = function(v) {
	  try {
	    return JSON.stringify(v);
	  } catch (err) {
	    return '[UnexpectedJSONParseError]: ' + err.message;
	  }
	};
	
	
	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */
	
	function formatArgs(args) {
	  var useColors = this.useColors;
	
	  args[0] = (useColors ? '%c' : '')
	    + this.namespace
	    + (useColors ? ' %c' : ' ')
	    + args[0]
	    + (useColors ? '%c ' : ' ')
	    + '+' + exports.humanize(this.diff);
	
	  if (!useColors) return;
	
	  var c = 'color: ' + this.color;
	  args.splice(1, 0, c, 'color: inherit')
	
	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-zA-Z%]/g, function(match) {
	    if ('%%' === match) return;
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });
	
	  args.splice(lastC, 0, c);
	}
	
	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */
	
	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === typeof console
	    && console.log
	    && Function.prototype.apply.call(console.log, console, arguments);
	}
	
	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */
	
	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      exports.storage.removeItem('debug');
	    } else {
	      exports.storage.debug = namespaces;
	    }
	  } catch(e) {}
	}
	
	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */
	
	function load() {
	  var r;
	  try {
	    r = exports.storage.debug;
	  } catch(e) {}
	
	  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
	  if (!r && typeof process !== 'undefined' && 'env' in process) {
	    r = ({"ENV":"production"}).DEBUG;
	  }
	
	  return r;
	}
	
	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */
	
	exports.enable(load());
	
	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */
	
	function localstorage() {
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(644)))

/***/ })

});


// WEBPACK FOOTER //
// app.6db4178b553a604089b0.js